export default {
    Scrum: {
        stranded_head: "These {count} will stay in this sprint",
        stranded_hint: "They are unfinished, but their parent task is done — and a subtask moves with its parent. Finish them, or reopen the parent task, before completing the sprint.",
        sprint_settings: "Sprint settings",
        make_it_a_sprint: "Make it a sprint",
        make_it_a_plain_list: "Make it a plain list",
        preview_kind: "Sprint",
        preview_wants: "run “{title}” as a sprint",
        preview_days: "Runs",
        preview_days_now: "Runs now",
        run_as_sprint: "Run this list as a sprint",
        run_as_sprint_hint: "Gives it a start, an end and a goal, so it can be started, completed and reported on. Leave this off to keep it a plain list.",
        goal: "Sprint goal",
        goal_placeholder: "What is this sprint for?",
        start_date: "Start date",
        end_date: "End date",
        duration: "Duration",
        one_week: "1 week",
        two_weeks: "2 weeks",
        three_weeks: "3 weeks",
        four_weeks: "4 weeks",
        custom: "Custom",
        end_from_duration: "Set from the duration. Choose Custom to pick your own.",
        need_both_dates: "A sprint needs both a start date and an end date.",
        dates_unreadable: "Those dates could not be read.",
        end_after_start: "The end date must be after the start date.",
        save: "Save",
        sprint_saved: "Sprint updated",
        start_sprint: "Start sprint",
        sprint_started: "Sprint started",
        complete_sprint: "Complete sprint",
        sprint_completed: "Sprint completed",
        loading: "Loading…",
        completed: "Completed",
        not_completed: "Not completed",
        added_after_start: "Added after start",
        moving_these: "These will move",
        subtasks_travel: "Subtasks move with their parent task.",
        where_should_it_go: "Where should the unfinished work go?",
        into_named_sprint: "Next sprint — {name}",
        into_new_sprint: "A new sprint — {name}",
        into_backlog: "The backlog",
        new_sprint_dates: "It will run {from} to {to}.",
        everything_done: "Everything in this sprint is done. Nothing needs moving.",
        state_planned: "Planned",
        state_active: "Active",
        state_overdue: "Overdue",
        state_closed: "Closed",
        days_left: "{count} day left | {count} days left",
        last_day: "Last day",
        days_over: "{count} day over | {count} days over",
        report_committed: "Committed",
        report_completed: "Completed",
        report_unfinished: "Unfinished",
        report_scope_added: "Scope added",
        report_no_commitment: "This sprint was never started, so there is no commitment to measure against. The figures below are simply what is in it now.",
        report_pick_sprint: "Choose a sprint",
        report_none: "No sprints to report on yet.",
        report_moved_out: "moved out",
        points: "points",
        tasks: "tasks",
        story_points_empty: "Points",
        story_points_clear: "Clear",
    },
    generalErrorMessage: {
        fieldIsRequired: "field is required",
        field_required: "This field is required",
        something_went_wrong: "Something went wrong",
    },
    authErrorMessage: {
        emailError: "The email field must be a valid email",
        passwordValid: "The password field must be at least 8 characters",
        validPassRegex:
            "passwords must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character",
        confirmPasswordValid:
            "The confirm password confirmation does not match",
        validCharactersfirst:
            "The first name field may only contain alphabetic characters as well as spaces",
        validCharacterslast:
            "The last name field may only contain alphabetic characters as well as spaces",
        must_be_a_valid_email: "Must be a valid email",
        currentPassword:
            "current password must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character",
        newPassword:
            "new password must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character",
        currentPasswordValid:
            "The current password field must be at least 8 characters",
        newPasswordValid:
            "The new password field must be at least 8 characters",
    },
    companyErrorMessage: {
        phoneNumberValid:
            "The phone number field must be at least 10 characters",
    },
    errorPage: {
        project_name: "Project name",
        project_key: "Project key",
        project_category: "Project category",
        team_name: "team name",
        The: "The",
        field_must_be_a_valid: "field must be a valid",
        email: "email",
        password: "Password",
        first_name: "first name",
        last_name: "last name",
        company_name: "company name",
        file_extension: "file extension",
        milestone_status: "milestone status",
        name: "name",
        phone_number: "phone number",
        field_must_be_at_least: "field must be at least",
        number: "number",
        characters: "characters",
        digits: "digits",
        priority_name: "priority name",
        firstName: "first name",
        lastName: "last name",
        phoneNumber: "phone number",
        amount: "amount",
        phone: "phone",
        country: "Country",
        state: "State",
        city: "City",
        templatename: "templatename",
        description: "description",
        Template_name_is_required: "Template name is required",
        status: "status",
        zipcode: "zipcode",
        address2: "address2",
        address1: "address1",
        The_confirm_password_field_is_required:
            "The confirm password field is required",
        The_confirm_password_confirmation_does_not_match:
            "The confirm password confirmation does not match",
        terms_and_condition: "terms and condition",
        category_name: "Category Name",
        channel_name: "Channel Name",
        amount_per_hours: "amount per hours",
        refundamount: "refund amount",
        please_select_template: "Please select template",
        template_name_already_exists: "Template name is already exist",
        select_a_date: "Select a date",
        must_be_less_than: "must be less than ",
        project_duedate: "Project Due Date",
        project_lead_assignee: "Project Lead Assignee",
        current_password: "Current Password",
        new_password: "New Password",
        confirm_password: "Confirm Password",
        This_template_name_is_already_exists:
            "This template name is already exists.",
        card_name: "card name",
        topic: "topic",
        target_audience: "target audience",
        keywords: "keywords",
        content_purpose: "content purpose",
        "product/service": "product/service",
        campaign_goals: "campaign goals",
        value_proposition: "value proposition",
        objectives: "objectives",
        key_message: "key message",
        problem: "problem",
        context: "context",
        constraints: "constraints",
        main_keyword: "main keyword",
        secondary_keywords: "secondary keywords",
        content_goal: "content goal",
        keyword_list: "keyword list",
        questions: "questions",
        product_description: "product description",
        feedback_data: "feedback data",
        survey_questions: "survey questions",
        project: "project",
        progress_made: "progress made",
        next_steps: "next steps",
        key_features: "key features",
        client_type: "client type",
        challenges: "challenges",
        results: "results",
        event_type: "event type",
        cta: "cta",
        campaign_objectives: "campaign objectives",
        survey_objectives: "survey objectives",
        column_one_name: "column one name",
        column_two_name: "column two name",
        column_one_data: "column one data",
        column_two_data: "column two data",
        customer_name: "customer name",
        email_purpose: "email purpose",
        talking_points: "talking points",
        product_name: "product name",
        about_the_product: "about the product",
        core_problem_it_solves: "core problem it solves",
        what_makes_it_different: "what makes it different",
        the_product_is: "product is",
        core_differentiators: "core differentiators",
        "product/service_benefits": "product/service benefits",
        call_notes: "call notes",
        call_transcript: "call transcript",
        target_company: "target company",
        use_case: "use case",
        customer_challenges: "customer challenges",
        territories: "territories",
        target_industries: "target industries",
        sales_goals: "sales goals",
        sales_strategies: "sales strategies",
        transcript: "transcript",
        pain_points: "pain points",
        company_type: "company type",
        sales_cycle_stages: "sales cycle stages",
        sales_methodologies: "sales methodologies",
        key_skills: "key skills",
        training_formats: "training formats",
        participants: "participants",
        target_industry: "target industry",
        value_statement: "value statement",
        meeting_type: "meeting type",
        your_talking_points: "your talking points",
        goal: "goal",
        reasons_for_canceling: "reasons for canceling",
        incentive: "incentive",
        unique_selling_points: "unique selling points",
        desired_format: "desired format",
        topics: "topics",
        content: "content",
        stakeholders: "stakeholders",
        sales_notes: "sales notes",
        customer_goals: "customer goals",
        teams_impacted: "teams impacted",
        requirements: "requirements",
        goals_met: "goals met",
        project_stakeholders: "project stakeholders",
        opportunities: "opportunities",
        risks: "risks",
        customer_message: "customer message",
        date_range: "date range",
        project_notes: "project notes",
        project_description: "project description",
        name_of_project: "name of project",
        date_ranges: "date ranges",
        requestor: "requestor",
        requests: "requests",
        reason_for_the_change: "reason for the change",
        expected_impact_of_the_change: "expected impact of the change",
        project_goals: "project goals",
        participant_names: "participant names",
        meeting_time: "meeting time",
        timeline: "timeline",
        deliverables: "deliverables",
        project_goal: "project goal",
        project_scope: "project scope",
        main_task: "main task",
        new_format: "new format",
        original_text: "original text",
        stakeholder_titles: "stakeholder titles",
        article_title: "article title",
        focus_keywords: "focus keywords",
        title_of_the_blog_text: "title of the blog text",
        blog_topic: "blog topic",
        section_title: "section title",
        section_content: "section content",
        section: "section",
        title: "title",
        "title(faq_question)": "title(faq question)",
        issue_description: "issue description",
        code_section: "code section",
        concept: "concept",
        version: "version",
        changes: "changes",
        job_title: "job title",
        your_name: "your name",
        your_skills: "your skills",
        math_question: "math question",
        question: "question",
        thesis_topic: "thesis topic",
        text_to_proofread: "text to proofread",
        text_to_rephrase: "text to rephrase",
        text_to_improve: "text to improve",
        job_description: "job description",
        your_title: "your title",
        your_summary: "your summary",
        pain: "pain",
        agitation: "agitation",
        solution: "solution",
        post_content: "post content",
        product_or_service: "product or service",
        unique_selling_proposition: "unique selling proposition",
        email_to_reply_to: "email to reply to",
        audiences_objectives: "audience's objectives",
        sales_teams_roles: "sales team's roles",
    },
    Auth: {
        welcome_back: "Welcome back",
        login_to_workspace: "Log in to your workspace.",
        no_account_ask_admin: "Log in to your workspace. No account yet? Ask your workspace admin to invite you.",
        new_here: "New here?",
        continue_with: "Continue with {provider}",
        show_password: "Show password",
        hide_password: "Hide password",
        session_expired: "Your session expired. Log in again to pick up where you left off.",
        offline_sign_in: "You're offline. Sign in when your connection is back.",
        maintenance_login: "Sign-in is paused while the server is under maintenance. Try again in a few minutes.",
        google_unavailable: "Google sign-in didn't load. Check your connection or ad blocker and reload, or log in with your email.",
        continue_with_sso: "Continue with company sign-in (SAML / OIDC)",
        or_with_email: "or with email",
        email_placeholder: "owner{'@'}example.com",
        log_in: "Log in",
        email_me_link: "Email me a login link",
        keep_signed_in: "Keep me signed in on this device",
        keep_signed_in_hint: "Remembers your email on this device. Your password is never stored.",
        locked_out: "Locked out?",
        use_password_instead: "Use a password instead",
        email_required: "Enter your email address.",
        email_invalid: "That doesn't look like an email address.",
        password_required: "Enter your password.",
        password_mismatch: "That password doesn't match this email.",
        credentials_mismatch: "That email and password don't match. Check both, or reset your password.",
        account_blocked: "This account is blocked. Ask your administrator to unblock it.",
        attempts_left: "{n} attempts left.",
        account_unknown: "No account with that email. Check the spelling, or create one.",
        too_many_attempts: "Too many attempts. Wait a few minutes, then try again.",
        reset_required: "Your password must be reset. We've emailed you a link.",
        server_error: "Something went wrong on the server. Try again in a moment.",
        step_of: "Step {a} of {b}",
        two_factor_code_title: "Two-factor code",
        two_factor_code_placeholder: "xxxxx-xxxxx",
        two_factor_open_app: "Open your authenticator app and enter the 6-digit code for {email}.",
        two_factor_recovery_enter: "Enter one of your saved recovery codes for {email}.",
        code_expires_in: "Code expires in {t}",
        back: "Back",
        verify_first_title: "Verify your email first",
        verify_first_body: "We sent a link to {email}. Click it, then log in.",
        resend_email: "Resend email",
        resend_in: "You can resend in {t}",
        wrong_address: "Wrong address?",
        magic_sent_title: "Check your inbox",
        magic_sent_body: "A one-time login link is on its way to {email}. It works for 15 minutes on this device.",
        magic_nothing_yet: "Nothing yet? Check spam, or",
        send_again: "send again",
        magic_unavailable: "Login links aren't enabled on this server. Use your password.",
        magic_invalid: "That login link has expired or was already used. Request a new one.",
        sso_failed: "Single sign-on didn't complete. Try again, or use a password.",
        sso_not_allowed: "This account can't join this workspace through single sign-on. Ask a workspace admin to invite you.",
        choose_workspace: "Choose a workspace",
        belong_to: "You belong to {n}. We'll remember your pick.",
        create_workspace: "Create a new workspace",
        last_opened: "last opened {when}",
        members_count: "{n} members",
        workspace_disabled: "disabled",
        sso_title: "Sign in with SSO",
        sso_lead: "Enter your work email. We'll find your organisation's identity provider.",
        work_email: "Work email",
        continue: "Continue",
        back_to_options: "Back to all sign-in options",
        sso_uses: "{org} uses {idp}",
        sso_redirect: "You'll sign in on {host} and come straight back here.",
        sso_required: "SSO is required for this workspace.",
        sso_optional: "SSO is optional for this workspace.",
        continue_to_idp: "Continue to {idp}",
        sso_guests: "Guests are exempt and can use a password.",
        not_you: "Not {email}?",
        change: "Change",
        sso_none: "No company sign-in is set up for that domain. Use a password or ask your admin.",
        signing_in: "Signing you in…",
        signing_in_body: "{idp} confirmed your identity. Linking it to your {product} account.",
        taking_long: "Taking too long?",
        try_again: "Try again",
        proof_label: "Self-hosted · AGPL 3.0 · v{version}",
        proof_title: "Projects, tasks and time — on your own server.",
        proof_sub: "Unlimited users, no per-seat price, your data in your own database.",
        proof_task_1: "Redesign onboarding flow",
        proof_project_1: "Website Revamp",
        proof_task_2: "Fix payment alert retries",
        proof_project_2: "Mobile v2",
        proof_task_3: "Review what guests are allowed to do",
        proof_task_3_due: "Aug 29",
        email: "Email",
        password: "Password",
        firstName: "First Name",
        lastName: "Last Name",
        phoneNumber: "Phone Number",
        login_descriptioon: "See what is going on with your business",
        login_statement: "Login to your Account",
        email_id: "Email ID",
        Password: "Password",
        Conform_pass: "Confirm Password",
        RememberMeL: "Remember Me",
        Remember_password: "Remember password",
        Forgot_Password: "Forgot password?",
        loading: "Loading",
        loging: "Login",
        Register: "Register",
        NotR: "Not registered yet",
        createAcc: "Create an Account",
        alredyacc: "Already have an account?",
        ResendEmail: "Resend Email",
        pleasecheck:
            "Please check your email, If you didn't receive it or misplaced it, please click below to resend the email.",
        backlogin: "Back to login",
        two_factor_title: "Two-factor authentication",
        two_factor_hint: "Enter the 6-digit code from your authenticator app.",
        two_factor_recovery_hint: "Enter one of your saved recovery codes.",
        two_factor_code_label: "Authentication code",
        two_factor_recovery_label: "Recovery code",
        two_factor_verify: "Verify",
        two_factor_use_recovery: "Use a recovery code instead",
        two_factor_use_app: "Use your authenticator app instead",
        two_factor_enter_code: "Please enter your code",
        two_factor_invalid_code: "That code is not valid. Try again or use a recovery code.",
        two_factor_session_expired: "Your verification session expired. Please sign in again.",
        Welcome_Msg: "Welcome to BRAND_NAME",
        Welcome_Description:
            "Get access to exclusive features by creating an account",
        agree: "I agree to the",
        tearm: "Terms of Service",
        and: "and",
        Privacy_Policy: "Privacy Policy",
        forgatepasswordmsg:
            "Enter the email associated with your account and we’ll send an email with instructions to reset your password.",
        ltitle: "Work on big ideas, without the busywork.",
        time_format: "Time Format",
        timezone: "Timezone",
        selectLanguage: "Select Language",
        check_credentials: "Please check your credentials.",
        check_smtp_credentials: "Please check your SMTP credentials.",
        smtp_successfully_verified: "Your SMTP is successfully verified.",
        verification_code_invalid: "Your verification code is invalid.",
        verification_code_invalid_check_code:
            "Your verification code is invalid. Please check your code.",
        verification_mail_sent:
            "Verification mail has been sent successfully. Please check your inbox.",
        verify_email_and_try_again: "Verify your email and try again.",
        enter_new_password: "Please enter your new password",
        link_expired_resend_email: "Your link has expired.",
        reset_password: "Reset Password",
        resend_verification_email:
            "Please click on button to resend verification email",
        link_expired: "This link is expired",
        too_many_request:
            "You have sent too many requests in a given amount of time. Please wait and try again later.",
        previous_wasnot_valid:
            "Your previous password wasn't valid. Kindly verify and try again.",
        password_wasnot_valid:
            "Your new password wasn't valid. Please try again.",
        set_new_password: "Set New Password",
        verification_link_expired: "This verification link has expired.",
        verification_link_expired_message:
            "Please check your inbox for the latest verification email. If you haven't received it, try logging in again to request a new one.",
        oAuthGoogleBtnText: "Continue with Google",
        forgot_title: "Reset your password",
        forgot_lead: "Enter the email for your account and we'll send a reset link.",
        send_reset_link: "Send reset link",
        reset_sent_title: "Check your inbox",
        reset_sent_if_account: "If {email} has an account, a password reset link is on its way. It works for 10 minutes.",
        remembered: "Remembered it?",
        back_to_login: "Back to login",
        new_password_title: "Choose a new password",
        set_password_title: "Set your password",
        new_password_rule_range: "Use {min} to {max} characters, including an uppercase letter, a lowercase letter, a number and a symbol.",
        new_password: "New password",
        confirm_password: "Confirm password",
        save_password: "Save password",
        confirm_required: "Type the password again.",
        confirm_mismatch: "Those passwords don't match.",
        checking_link: "Checking your link…",
        link_expired_title: "This link has expired",
        link_expired_body: "Password links work once and for a limited time. Request a new one from the login page.",
        request_new_link: "Request a new link",
        verify_ok_title: "Email verified",
        verify_ok_body: "You can log in now.",
        verify_resent_if_needed: "If your address still needs verifying, a new link is on its way. Click it, then log in.",
        verify_expired_title: "This verification link has expired",
        verify_expired_body: "Check your inbox for the latest verification email, or resend it below.",
        verify_already_title: "Already verified",
        verify_already_body: "This email is already verified. Log in to continue.",
        invite_checking: "Checking your invitation…",
        invite_invalid_title: "This invitation isn't valid any more",
        invite_invalid_body: "Ask the person who invited you for a new link, or log in if you already have an account.",
        invite_accepted_title: "Invitation accepted",
        invite_accepted_body: "You're in. Log in to open the workspace.",
        invite_cancelled: "This invitation was cancelled.",
        invite_used: "This invitation was already used. Log in instead.",
        invite_sign_in_to_accept: "Sign in to accept",
        invite_accept_title: "Accept your invitation",
        invite_accept_body: "You're signed in as the invited address. Accept to join {workspace}.",
        invite_accept_body_plain: "You're signed in as the invited address. Accept to join the workspace.",
        invite_accept: "Accept invitation",
        invite_accept_failed: "This invitation can't be accepted. It may have been withdrawn or already used. Ask for a new link.",
        invite_wrong_account_title: "This invitation is for another account",
        invite_wrong_account_body: "It was sent to {invited}, but you're signed in as {current}. Switch to the invited account to accept it.",
        invite_switch_account: "Switch account",
        create_account: "Create your account",
        join_lead: "You're joining {workspace}.",
        full_name: "Full name",
        name_placeholder: "Priya Sharma",
        name_required: "Enter your name.",
        password_placeholder: "Password · 8+ characters",
        or: "or",
        terms_line: "By continuing you agree to the {terms} and {privacy}.",
        have_account: "Have an account?",
        email_in_use: "That email already has an account. Log in instead.",
        step: "{a} / {b}",
        name_workspace: "Name your workspace",
        name_workspace_lead: "Usually your company or team.",
        workspace_placeholder: "Acme Studio",
        workspace_required: "Give your workspace a name.",
        workspace_short: "Use at least 3 characters.",
        workspace_taken: "You already have a workspace with that name.",
        team_size: "Team size",
        size_just_me: "Just me",
        joining_team: "Joining a team?",
        use_invite_link: "Use your invite link",
        focus_title: "What does your team mainly do?",
        focus_lead: "Picks your sample project and which templates come first. Changeable later.",
        focus_software: "Software",
        focus_design: "Design / creative",
        focus_marketing: "Marketing",
        focus_agency: "Agency / client work",
        focus_operations: "Operations / HR",
        focus_support: "Support",
        focus_other: "Something else",
        open_workspace: "Open my workspace",
        skip_blank: "Skip — start blank",
        creating_workspace: "Creating your workspace…",
        seeding_sample: "Adding your sample project…",
        workspace_ready: "Ready. Opening your workspace…",
        workspace_failed: "Something went wrong creating the workspace. Try again, or contact your admin.",
        workspace_failed_reason: "The workspace was not made: {reason}",
        workspace_reason_invalid_details: "Some of the workspace's details are missing or not valid.",
        workspace_reason_not_prepared: "The server could not set up the workspace's storage and starting settings.",
        workspace_reason_not_finished: "The server could not finish making the workspace, so none of it was kept. Try again.",
        workspace_reason_server_error: "Something went wrong on the server.",
        free_limit: "You've already created a free workspace. Upgrade to add another.",
        referral_code: "Referral code (optional)",
        referral_invalid: "That referral code isn't valid. Continue without it?",
        tracker_title: "Authorize the desktop tracker",
        tracker_body: "Click Continue to sign in to the desktop tracker on this computer.",
        tracker_continue: "Continue",
        tracker_code_failed: "Couldn't start the tracker sign-in. Refresh this page and try again.",
        tracker_nothing_happened: "Nothing happened?",
        tracker_download: "Download the tracker",
        new_project: "New project",
        search_templates: "Search templates",
        for_focus: "For {focus}",
        all: "All",
        import: "Import",
        blank: "Blank",
        blank_desc: "To do · In progress · Done. Nothing else.",
        from_description: "Create from a description",
        from_description_desc: "Describe the project and AI drafts the lists and tasks.",
        import_row: "Import from Jira, ClickUp, Asana, Monday or CSV",
        import_row_desc: "Keeps assignees, statuses and dates.",
        template_meta: "{statuses} statuses · {tasks} sample tasks",
        preview: "Preview · {name}",
        sample_tasks_label: "List 1 · {n} sample task | List 1 · {n} sample tasks",
        more_tasks: "… {n} more, dated relative to your start",
        no_sample: "Starts empty. Add your first task after creating.",
        project_name: "Project name",
        project_key: "Key",
        visibility: "Visibility",
        everyone_in: "Everyone in {company}",
        private_project: "Only people I add",
        lead: "Lead",
        due_date: "Due date",
        include_samples: "Include the {n} sample task | Include the {n} sample tasks",
        include_samples_hint: "(one click to delete them later)",
        create_project: "Create project",
        creating_project: "Creating…",
        project_name_required: "Give the project a name.",
        project_name_short: "Use at least 3 characters.",
        key_required: "Add a short key.",
        key_taken: "That key is used by another project.",
        no_templates_match: "No template matches. Try another word, or start blank.",
        workspace_templates: "{company}'s templates",
        project_failed: "The project couldn't be created. Try again.",
        tour_step: "Step {a} of {b}",
        tour_next: "Next: {label}",
        tour_done: "Done",
        tour_skip: "Skip tour",
        tour_meta: "{n} steps · {s}s",
        tour_back: "Back",
        tour_next_stop: "Next",
        tour_first_rail_title: "The navigation goes everywhere",
        tour_first_rail_body: "Home, Projects and Inbox are one click away. The command palette reaches any of them, and any task, from wherever you are.",
        tour_first_rail_key: "opens the command palette",
        tour_first_tree_title: "Projects, folders and lists",
        tour_first_tree_body: "A project holds folders, a folder holds subfolders and lists, and a list holds tasks. The tree shows all of it.",
        tour_first_tree_key: "goes to Projects",
        tour_first_views_title: "One list, several views",
        tour_first_views_body: "The tabs show the same tasks as a list, a board, a table or a calendar. The ⋮ menu beside the list name renames, moves or archives it.",
        tour_first_views_key: "adds a task",
        tour_first_panel_title: "A task opens at the side",
        tour_first_panel_body: "Click a task to see its subtasks, fields, comments and time without leaving the list.",
        tour_first_panel_key: "closes the task",
        tour_shell_rail_title: "Everything lives in this rail",
        tour_shell_rail_body: "Home is your day. Projects and Inbox sit right here, Planner blocks time, and Chat and AI are one click away. Nothing is buried in a menu.",
        tour_shell_rail_next: "your tasks",
        tour_shell_work_title: "Today & Overdue is your day",
        tour_shell_work_body: "Tasks due today, anything late, and what's next — across every project. Tick one off here and it's done everywhere.",
        tour_shell_work_next: "the rest",
        tour_shell_more_title: "More holds the rest",
        tour_shell_more_body: "Reports, members, settings and the Trash live under More. Anything you delete can be brought back from there.",
        tour_shell_more_next: "the timer",
        tour_shell_timer_title: "One timer, everywhere",
        tour_shell_timer_body: "Start it on a task and it follows you. Stop it and the hour is logged against that task, ready for timesheets.",
        tour_project_header_title: "This is your project",
        tour_project_header_body: "The name, key and star are up here. Star it to keep it at the top of your Projects list.",
        tour_project_header_next: "views",
        tour_project_views_title: "Switch views any time",
        tour_project_views_body: "List, Board, Calendar and more all show the same tasks. Pick the one that fits the job.",
        tour_project_views_next: "creating lists",
        tour_project_new_title: "Add a list or folder",
        tour_project_new_body: "Lists group tasks by phase or by week; folders group lists. Both start from + New.",
        tour_project_new_next: "search",
        tour_project_search_title: "Find a task fast",
        tour_project_search_body: "Search by name, key or description, then narrow with filters.",
        tour_project_search_next: "the More menu",
        tour_project_more_title: "Everything else lives here",
        tour_project_more_body: "Burn-down, epics, docs, export, import and the project settings are grouped under this menu.",
        tour_board_columns_title: "Each column is a status",
        tour_board_columns_body: "Drag a card between columns to move it along. The count shows what's in progress.",
        tour_board_columns_next: "adding tasks",
        tour_board_add_title: "Add a task where it belongs",
        tour_board_add_body: "The plus at the top of a column creates a task already in that status.",
        tour_board_add_next: "limits",
        tour_board_wip_title: "Set a work-in-progress limit",
        tour_board_wip_body: "Click the count to cap a column. The chip turns red when the team is over it.",
        tour_board_wip_next: "cards",
        tour_board_cards_title: "Select cards to act in bulk",
        tour_board_cards_body: "Tick several cards and the bar at the top changes status, assignee, list or tags — or archives and deletes — in one go.",
        tour_list_columns_title: "Every task in one table",
        tour_list_columns_body: "Assignee, due date, priority and estimate are inline. Click a cell to change it.",
        tour_list_columns_next: "grouping",
        tour_list_group_title: "Group the list your way",
        tour_list_group_body: "Group by status, assignee, priority or list to see the work from a different angle.",
        tour_list_group_next: "subtasks",
        tour_list_subtasks_title: "Expand or collapse subtasks",
        tour_list_subtasks_body: "Keep the list tight or show every subtask under its parent.",
        tour_list_subtasks_next: "bulk actions",
        tour_list_bulk_title: "Select rows to act in bulk",
        tour_list_bulk_body: "Tick the boxes and the bar changes status, assignee, list or tags — or archives and deletes — for all of them at once.",
        gs_title: "Getting started",
        gs_sub: "Picks up where you left off",
        gs_take_tour: "Take the tour",
        gs_resume_tour: "Resume the tour",
        gs_invite: "Invite your team",
        gs_project: "Create your first project",
        gs_track: "Track an hour of work",
        gs_dismiss: "Dismiss for now",
        gs_docs: "Docs →"
    },
    WorkspaceImport: {
        title: "Bring your work in",
        close: "Close",
        step_source: "Where is your work now?",
        step_file: "Upload your ClickUp export.",
        step_target: "Choose where it goes.",
        step_preview: "Check what will be imported.",
        step_run: "Importing…",
        step_done: "Import finished.",
        clickup_how_1: "In ClickUp, open the Space, Folder or List you want to move.",
        clickup_how_2: "Choose Export view and pick CSV or Excel, with all columns and subtasks included.",
        clickup_how_3: "Upload the file here. Nothing is written until you confirm.",
        clickup_how_4: "A view export carries custom fields. The workspace export, under Settings and Imports / Exports, carries comments and checklists. Either file works here.",
        file_label: "ClickUp export (CSV or Excel)",
        reading: "Reading the file…",
        file_empty: "The file has no rows.",
        file_unreadable: "That file could not be read as a ClickUp export.",
        target_legend: "Where should the tasks go?",
        target_new: "A new project for each ClickUp list",
        target_new_hint: "{count} list(s) become {count} project(s), each with a list of the same name.",
        target_new_denied: "You do not have permission to create projects.",
        target_existing: "An existing project",
        target_existing_hint: "Every task goes into one list of a project you choose.",
        project_label: "Project",
        project_pick: "Choose a project",
        sprint_label: "List",
        sprint_loading: "Loading the project's lists…",
        sprint_load_failed: "The lists of this project could not be loaded.",
        sprint_retry: "Try again",
        sprint_none: "This project has no lists yet. Create one in the project, then import.",
        add_missing: "Add missing statuses and tags to the project",
        no_projects: "There are no projects to import into yet.",
        previewing: "Counting what the file holds…",
        preview_total: "{tasks} task(s) from {lists} list(s)",
        col_list: "ClickUp list",
        col_tasks: "Tasks",
        col_subtasks: "Subtasks",
        fact_statuses: "New statuses: {names}",
        fact_statuses_file: "Statuses in the file: {names}",
        fact_tags: "New tags: {names}",
        fact_fields: "Custom fields: {names}",
        fact_people: "{count} person(s) matched by email will be assigned.",
        fact_unmatched: "Not in this workspace, so left unassigned (nobody is invited): {names}",
        fact_skipped: "{count} row(s) will be skipped.",
        running: "Imported {done} of {total} list(s)",
        progress_label: "Import progress",
        summary_created: "{count} task(s) created.",
        summary_list: "{name}: {count} task(s)",
        summary_list_failed: "{name}: not imported. {reason}",
        summary_skipped: "{count} row(s) skipped",
        summary_skipped_row: "Row {row}: {reason}",
        skip_no_name: "the task has no name",
        summary_unmatched: "Left unassigned: {names}",
        summary_too_deep: "{count} subtask(s) were deeper than three levels and were placed under their nearest parent:",
        summary_parent_missing: "{count} row(s) named a parent that is not in the file and were imported as tasks:",
        summary_cycle: "{count} row(s) named parents that loop and were imported as tasks:",
        counts_caption_plan: "What this import will bring in",
        counts_caption_done: "What came in",
        counts_col_kind: "What",
        counts_col_in_plan: "Will come in",
        counts_col_in_done: "Came in",
        counts_col_out: "Left out",
        counts_tasks: "Tasks",
        counts_subtasks_2: "Subtasks",
        counts_subtasks_3: "Subtasks of subtasks",
        counts_comments: "Comments",
        counts_fields: "Custom fields",
        counts_fields_in: "{created} new, {reused} already in the project",
        counts_values: "Field values",
        counts_checklist: "Checklist items",
        counts_tags: "New tags",
        counts_links: "Attachments, as links",
        counts_people: "People",
        out_comments_no_permission: "{count}: you cannot comment in this project",
        out_comments_failed: "{count} could not be saved",
        out_fields_no_permission: "{count}: you cannot edit custom fields in this project",
        out_fields_failed: "{count} could not be created",
        out_values: "{count} did not fit their field",
        out_tags: "{count}: adding statuses and tags is switched off",
        out_people_unmatched: "{count} not in this workspace",
        out_people_cannot_open: "{count} cannot open this project",
        note_links_plan: "{count} attachment(s) will be added as links to ClickUp. No file is copied.",
        note_links_done: "{count} attachment(s) were added as links to ClickUp. No file was copied.",
        note_as_text: "Brought in as text, because the ClickUp field type has no match here: {names}",
        note_fields_skipped: "Custom fields left out: {names}",
        note_tags_skipped: "Tags left out: {names}",
        note_authors: "Their comments are kept under your name, with theirs in front: {names}",
        note_people_cannot_open: "Cannot open this project, so not assigned: {names}",
        skip_repeated_id: "a row above has the same task id",
        add_missing_denied: "You cannot edit this project's details, so missing statuses and tags will not be added.",
        existing_legend: "{count} task(s) of this file are already in the project.",
        existing_skip: "Leave them as they are",
        existing_skip_hint: "Only the tasks that are new are imported.",
        existing_update: "Update them from the file",
        existing_update_hint: "Name, status, dates, assignees, priority, tags, description and custom fields take the file's value wherever the file has one. No comment is added twice.",
        fact_duplicates_scope: "A task counts as already here only in the project it was imported into. Importing this file into another project creates its tasks again.",
        fact_unread_date: "Row {row}, {name}: \"{value}\" in {column} is not a date that could be read, so the task arrives without it.",
        fact_unread_dates_more: "And {count} more date(s) that could not be read.",
        fact_unread_columns: "Columns that are not imported: {names}",
        fact_ignored_columns: "Columns that are not recognised and are ignored: {names}",
        summary_updated: "{count} task(s) that were already here were updated.",
        summary_unread_dates: "{count} date(s) could not be read",
        summary_skipped_cells: "{count} status(es) were not applied",
        skipped_cell_UNKNOWN_STATUS: "{name}: this project has no status \"{value}\", so the task kept the status it had.",
        skipped_cell_STATUS_NOT_SAVED: "{name}: the status \"{value}\" could not be saved, so the task kept the status it had.",
        counts_existing: "Tasks already here",
        counts_existing_updated: "{count} updated",
        out_existing: "{count} left as they are",
        undo_start: "Undo this import",
        undo_confirm: "Move the {count} task(s) this import created to the trash? They can be restored from the trash.",
        undo_confirm_button: "Move them to the trash",
        undo_edited: "{count} of the imported task(s) have been worked on since the import:",
        undo_keep_edited: "Undo, and keep those tasks",
        undo_cancel: "Cancel",
        undo_done: "{count} task(s) moved to the trash.",
        undo_kept: "{count} task(s) were kept:",
        undo_failed: "The import could not be undone.",
        recent_title: "Recent imports",
        recent_failed: "Recent imports could not be loaded.",
        recent_counts: "{created} created, {updated} updated",
        recent_status_undone: "Undone",
        recent_status_failed: "Failed",
        recent_status_processing: "Running",
        back: "Back",
        next: "Next",
        run: "Import {count} task(s)",
        run_update: "Update {count} task(s)",
        run_and_update: "Import {created} and update {updated} task(s)",
        finish: "Done"
    },
    ImportExport: {
        nav: "Import & export",
        owners_only: "Only owners and admins can import or export the workspace.",
        import_title: "Bring your work in",
        import_lead: "Move tasks from ClickUp, Jira, Trello, Asana, Monday.com or a CSV file.",
        import_start: "Start an import",
        export_title: "Export workspace",
        export_lead: "Every task in every project, in one file. The file stays on this server, and only you can download your exports.",
        format_label: "Format",
        format_xlsx: "Excel (.xlsx)",
        format_csv: "CSV (.csv)",
        export_start: "Export workspace",
        no_exports: "No workspace exports yet.",
        status_queued: "Queued",
        status_processing: "Preparing",
        status_done: "Ready",
        status_failed: "Failed",
        rows: "{count} task(s)",
        download: "Download",
        download_named: "Download {name}",
        load_failed: "Exports could not be loaded.",
        start_failed: "The export could not be started.",
        download_failed: "The file could not be downloaded."
    },
    Home: {
        overdue: "Overdue",
        assigned_comments: "Assigned comments",
        assigned_comments_loading: "Loading assigned comments…",
        assigned_comments_empty: "No open comments are assigned to you.",
        card_assigned_comments_hint: "Open comments assigned to you, ready to resolve.",
        assigned_by: "From {name}",
        untitled_task: "Untitled task",
        unlock: "Unlock",
        lock: "Lock",
        dashboardLockSuccess: "Dashboard locked successfully",
        dashboardUnlockSuccess: "Dashboard unlocked successfully",
        Home: "Home",
        My_Work: "My Work",
        Done: "Done",
        To_Do: "To Do",
        no_task_found: "No task found",
        Confirm: "Confirm",
        tourclose:
            "Are you certain you want to close this tour? If you confirm, you will not be able to access this tour guide again.",
        Queue_List: "Queue List",
        AddtoQueue: "Add to Queue",
        noquelist: "No queue list found",
        Due_Date: "Due Date",
        createQueueTitle: "Create Queue",
        Today: "Today",
        Calendar: "Calendar",
        Hide: "Hide",
        Overdue: "Overdue",
        Next: "Next",
        Unscheduled: "Unscheduled",
        task_assign_to_you: "task assign to you",
        no: "No",
        yes: "Yes",
        add_task_type: "Add Task Type",
        inbox: "Inbox",
        replies_mentions: "Replies & mentions",
        chat_activity: "Chat activity",
        my_tasks: "My tasks",
        assigned_to_me: "Assigned to me",
        today_overdue: "Today & Overdue",
        personal_list: "Personal List",
        new_tag: "new",
        favorites: "Favorites",
        no_favorites: "Star a project to pin it here.",
        pin: "Add to favorites",
        unpin: "Remove from favorites",
        projects: "Projects",
        new_project: "New project",
        no_projects: "No projects yet. A project holds the tasks your team works on together.",
        create_first_project: "Create a project",
        customize_sidebar: "Customize sidebar",
        show_favorites: "Show favorites",
        show_projects: "Show projects",
        show_sidebar: "Show sidebar",
        hide_sidebar: "Hide sidebar",
        show_planner: "Planner",
        hide_planner: "Hide planner",
        manage_cards: "Manage cards",
        cards_on_home: "On Home",
        open_dashboards: "Dashboards",
        hide_card: "Hide this card",
        card_hidden: "Card hidden. Bring it back from Manage cards.",
        cards_save_failed: "Your Home cards could not be saved.",
        no_cards: "No cards on Home. Add one below.",
        add_cards: "Add cards",
        move_card_up: "Move {card} up",
        move_card_down: "Move {card} down",
        remove_card: "Remove {card} from Home",
        card_moved: "{card} moved to position {n}.",
        card_removed: "{card} removed from Home.",
        card_added: "{card} added to Home.",
        picker_lede: "Cards that fit a personal Home, including cards from the dashboard catalogue",
        picker_footer: "A card shows only what you can already see. Cards you add follow you to every device.",
        picker_family_home: "Home",
        picker_family_home_q: "What needs me now?",
        card_recents: "Recents",
        card_recents_hint: "What you opened last, so you can get back to it.",
        recents_loading: "Loading what you opened…",
        recents_failed: "Your recent items could not be loaded.",
        recents_retry: "Try again",
        recents_empty: "Nothing opened yet. Tasks, projects, docs and lists you open show up here.",
        recents_untitled: "Untitled",
        recents_type_task: "Task",
        recents_type_project: "Project",
        recents_type_doc: "Doc",
        recents_type_sprint: "List",
        card_goals: "Goals",
        card_goals_hint: "The goals you own or are named on, and how far each one is.",
        goals_all: "All goals",
        goals_loading: "Loading your goals…",
        goals_failed: "Your goals could not be loaded.",
        goals_empty: "No goals of yours yet. A goal you own, or one shared with you by name, shows up here.",
        goals_empty_guest: "No goals have been shared with you yet.",
        card_waiting: "Waiting on you",
        card_waiting_hint: "Agent proposals and workflow approvals you can decide.",
        waiting_approve_named: "Approve: {what}",
        waiting_review_parts: "Review parts",
        waiting_review_named: "Review the parts of: {what}",
        waiting_open_named: "Open in the AI Inbox: {what}",
        waiting_open_inbox: "Open in the Inbox",
        waiting_untitled: "A proposed change",
        waiting_approved: "Approved.",
        next_label: "What next",
        next_approvals: "One thing needs your approval. | {n} things need your approval.",
        next_approvals_action: "Review",
        next_team: "One waiting for the team | {n} waiting for the team",
        next_waiting: "One thing is waiting on you. | {n} things are waiting on you.",
        next_waiting_action: "Show me",
        next_overdue: "One of your tasks is overdue. | {n} of your tasks are overdue.",
        next_overdue_action: "Show overdue",
        next_today: "You have one task for today. | You have {n} tasks for today.",
        next_today_action: "Show today",
        next_soon: "One of your tasks is due within a week. | {n} of your tasks are due within a week.",
        next_soon_action: "Show your tasks",
        next_start_project: "Start with one project: name what you are working on and add the tasks you already know.",
        next_start_project_action: "Create a project",
        next_start_task: "Nothing is assigned to you yet. Add a task of your own for today.",
        next_start_task_action: "Add a task",
        next_clear: "Nothing is due today and nothing is waiting on you.",
        next_clear_action: "Add a task",
        card_standup: "Your standup",
        card_standup_hint: "Yesterday, today and what is blocked, from your own activity.",
        standup_refresh: "Build the standup again",
        standup_loading: "Reading your activity…",
        standup_failed: "Your standup could not be built.",
        standup_retry: "Try again",
        standup_empty: "Nothing to report yet: no task moved, finished or commented on since yesterday, and nothing due today or late.",
        standup_yesterday: "Yesterday",
        standup_since_friday: "Since Friday",
        standup_today: "Today",
        standup_blocked: "Blocked",
        standup_none: "Nothing here.",
        standup_more: "and {n} more",
        standup_source: "Built from your task activity. No AI model is used.",
        standup_kind_completed: "Done",
        standup_kind_moved: "Moved",
        standup_kind_commented: "Commented",
        standup_kind_tracking: "Tracking",
        standup_kind_due_today: "Due today",
        standup_kind_blocked: "Blocked",
        standup_kind_overdue: "{n}d late",
        new: "+ New",
        new_task: "New task",
        new_reminder: "New reminder",
        status_available: "Available",
        status_dnd: "Do not disturb",
        status_dnd_until: "Do not disturb · until {time}",
        dnd_30: "For 30 minutes",
        dnd_1h: "For 1 hour",
        dnd_2h: "For 2 hours",
        dnd_tomorrow: "Until tomorrow",
        set_available: "Set as available",
        my_work: "My Work",
        to_do: "To Do",
        done: "Done",
        delegated: "Delegated",
        group_today: "TODAY",
        group_overdue: "OVERDUE",
        group_next: "NEXT",
        group_unscheduled: "UNSCHEDULED",
        group_done: "DONE · LAST 30 DAYS",
        group_delegated: "DELEGATED",
        from_sample: "from the sample project",
        sort: "sort: {by}",
        sort_priority: "priority",
        sort_due: "due",
        sort_name: "name",
        set_date: "set date",
        today: "today",
        tomorrow: "tomorrow",
        empty_today_title: "Your day is clear",
        empty_today_action: "Add a task",
        empty_done_title: "Nothing finished yet",
        empty_delegated_title: "Nothing delegated",
        empty_today: "Nothing due today. Type a task below, or open {project} — sample tasks that teach assigning, priorities, comments, files and the timer.",
        empty_today_generic: "Nothing due today. Type a task below to add one to your Personal List.",
        empty_done: "Nothing completed in the last 30 days. Tick a task to see it here.",
        empty_delegated: "Tasks you lead but someone else works on show here.",
        empty_all: "No open tasks assigned to you. Type below to add one to your Personal List.",
        add_task_today: "Add a task for today…",
        loading: "Loading your work…",
        task_added: "Added to your Personal List",
        task_done: "Marked as done",
        task_update_failed: "Couldn't update the task. Try again.",
        priority_urgent: "Urgent",
        priority_high: "High",
        priority_medium: "Medium",
        priority_low: "Low",
        agenda: "Agenda",
        agenda_today: "TODAY",
        connect_calendar: "Connect Google or Outlook calendar",
        agenda_hint: "Your meetings show next to your tasks so the day is planned in one place.",
        agenda_empty: "Nothing scheduled for this day.",
        reminder_prefix: "Reminder: {title}",
        focus_prefix: "Focus: {title}",
        planner: "Planner",
        planner_drop: "Drop a task here to schedule",
        planner_footer: "Drag from My Work to block time. Syncs to your connected calendar.",
        open_planner: "Open the full Planner",
        tracking: "TRACKING · {task}",
        pause: "Pause",
        resume: "Resume",
        stop_log: "Stop & log",
        start_timer: "Start timer",
        timer_switched: "Stopped the timer on {task}",
        timer_logged: "Logged {duration} on {task}",
        timer_log_failed: "Couldn't log the tracked time. It is kept locally.",
        setup_title: "Set up {company}",
        setup_next: "Next:",
        setup_show_steps: "Show all steps",
        setup_hide_steps: "Hide steps",
        step_company: "Create company",
        step_sample: "Sample project",
        step_invite: "Invite your team",
        step_project: "Create a project",
        step_permissions: "Review member permissions",
        step_board: "Try the Board view",
        step_notifications: "Set your notifications",
        step_permissions_note: "(defaults applied)",
        invite_team: "Invite team",
        create_project: "Create project",
        review_permissions: "Review permissions",
        step_apps: "Choose project apps",
        step_remove_sample: "Remove the sample data",
        step_import: "Bring your work in",
        bring_work_in: "Import work",
        step_open_project: "Open a project",
        step_complete_task: "Complete a task",
        step_log_time: "Log some time",
        step_tour: "Take the tour",
        choose_apps: "Choose apps",
        remove_sample: "Remove sample data",
        open_project: "Open a project",
        take_tour: "Take the tour",
        member_setup_title: "Get going",
        step_start_project: "Create or import a project",
        step_task: "Add a task",
        step_look: "Pick a look: theme, contrast and accent",
        step_ai: "Turn on AI or connect an agent",
        step_connect_ai: "Connect your AI",
        connect_ai: "Connect your AI",
        skip_for_now: "Skip for now",
        step_skipped: "(skipped)",
        step_my_work: "Open My Work",
        step_shortcuts: "Learn the shortcuts: press ?",
        add_first_task: "Add a task",
        pick_look: "Pick a look",
        turn_on_ai: "Turn on AI",
        connect_agent: "Connect an agent",
        import_from: "Import from ClickUp, Trello, Jira, CSV",
        open_my_work: "Open My Work",
        see_shortcuts: "Show shortcuts",
        sample_note: "The Welcome project is sample data.",
        dismiss: "Dismiss",
        setup_label: "Workspace setup",
        personal_hint: "Private to you, with its own views. Somewhere to type before a project exists.",
        open: "Open",
        only_you: "Only you",
        list: "List",
        board: "Board",
        calendar: "Calendar",
        add_view: "+ View",
        filter: "Filter",
        group_none: "Group: none",
        add_task: "+ Task",
        col_name: "NAME",
        col_due: "DUE",
        col_priority: "PRIORITY",
        col_status: "STATUS",
        col_time: "TIME",
        new_task_row: "New task — press Enter to add another",
        add_hint: "↵ add · tab: date",
        personal_footer: "Move a task into any project when it's ready for the team. Nobody else can see this list.",
        personal_footer_short: "Nothing here appears in team views, reports or agent scans.",
        personal_loading: "Setting up your Personal List…",
        personal_empty: "Type above to add your first task.",
        personal_failed: "Couldn't open your Personal List. Reload to try again.",
        board_empty: "No tasks here.",
        unscheduled: "Unscheduled",
        mine: "Mine",
        overdue_tab: "Overdue",
        est: "est {value}",
        no_estimate: "no estimate",
        tray_footer: "Drag a card onto the week. Estimates set the block length.",
        tray_empty: "Everything is scheduled.",
        week: "Week",
        day: "Day",
        calendar_synced: "Calendar · synced",
        calendar_not_connected: "Calendar · not connected",
        working_hours: "Working hours {from}–{to}",
        planner_grid: "Planner hours. Scroll for earlier or later times.",
        focus_block: "Focus block",
        focus: "Focus",
        remove_focus: "Remove focus block",
        dropping: "dropping · {range}",
        scheduled: "Scheduled {task} for {when}",
        schedule_failed: "Couldn't schedule the task. Try again.",
        overdue_since: "Overdue · {date}",
        tracking_short: "tracking {time}",
        this_week: "This week",
        access_denied: "You don't have access to Home.",
        views_nav: "Views",
        show_lists: "Show lists in {project}",
        previous_day: "Previous day",
        next_day: "Next day",
    },
    Automations: {
        title: "Automations",
        home: "Home",
        new: "New automation",
        empty_title: "No automations yet",
        empty_sub: "Set up a rule and AlianHub will do the repetitive part for you.",
        on: "On",
        off: "Off",
        turn_on: "Turn on",
        turn_off: "Turn off",
        edit: "Edit",
        delete: "Delete",
        name_placeholder: "Name this automation",
        when: "When",
        in: "in",
        if: "If",
        then: "Then",
        all_projects: "any project",
        any_time: "no conditions — runs every time",
        add_condition: "+ condition",
        add_action: "+ action",
        remove: "Remove",
        value: "value",
        cancel: "Cancel",
        save_draft: "Save as draft",
        save_on: "Save and turn on",
        manage_owner_admin: "Only owners and admins can create, change or switch on automations.",
        runs_open: "History",
        runs_title: "Run history",
        runs_close: "Close run history",
        runs_loading: "Loading runs…",
        runs_error: "Could not load this automation's runs.",
        runs_empty: "This automation has not run yet.",
        runs_limit: "Showing the {n} most recent runs.",
        outcome_applied: "Actions applied",
        outcome_skipped: "Skipped",
        outcome_failed: "Failed",
        outcome_retrying: "Retrying",
        outcome_running: "Matched, running",
        outcome_queued: "Matched, queued",
        stopped_at_condition: "A condition in step {id} did not hold.",
        step_no_change: "no change needed",
        duration_ms: "{n} ms",
        duration_s: "{n} s",
        duration_min: "{n} min",
        dry_run: "Test on a task",
        dry_running: "Testing…",
        dry_run_on: "Test the saved rule on",
        dry_run_pick_project: "a project…",
        dry_run_pick_task: "a task…",
        dry_run_saved_only: "Tests the saved version of this rule against the task as it is now. Nothing is changed and no action runs.",
        dry_run_matched: "Would run",
        dry_run_matched_when_on: "Would run once the rule is switched on",
        dry_run_not_now: "Would not run now",
        dry_run_would_do: "It would: {actions}",
        issue_step_required: "Step {n}, {action}: {field} is missing.",
        issue_step_not_an_option: "Step {n}, {action}: choose one of the listed values for {field}.",
        issue_step_other: "Step {n}, {action}: {field}: {reason}",
        issue_no_steps: "Add at least one action.",
        react_to_automation: "Also run when another automation or an agent made the change",
        react_to_automation_help: "Automations can then start one another. A chain of changes made by automations or agents stops after three in a row, so two rules cannot keep starting each other.",
        dry_run_not_matched: "Would not run",
        dry_run_would_run: "would run",
        dry_run_would_not_run: "would not run",
        dry_run_failed: "Could not test this rule.",
        ai_draft_offer: "The sentence builder could not read all of that. AI can draft the rule for you to review.",
        ai_draft_button: "Draft with AI",
        ai_drafting: "Drafting…",
        ai_draft_banner: "Drafted by AI — review",
        ai_draft_banner_sub: "Check every part, test it on the last 30 days, then save. Nothing is saved until you do.",
        ai_unmapped: "I couldn't map “{text}” — {reason}",
        ai_unmapped_no_reason: "I couldn't map “{text}”.",
        ai_rejected: "The AI draft was not used, because it went outside what automations can do:",
        ai_draft_off: "AI is turned off, so this rule cannot be drafted with AI. Rephrase it using the shape above.",
        ai_draft_unconfigured: "No AI model is set up, so this rule cannot be drafted with AI. Rephrase it using the shape above.",
        ai_draft_not_permitted: "AI is not included in this workspace's plan, so this rule cannot be drafted with AI. Rephrase it using the shape above.",
        ai_draft_failed: "Could not draft a rule right now.",
        assign_mode: "How to assign",
        assign_mode_add: "add",
        assign_mode_replace: "replace with",
        assign_mode_remove: "remove",
        assign_mode_clear: "unassign everyone",
        assign_people: "People",
        assign_pick_people: "Choose people",
        assign_search: "Search people",
        assign_no_people: "No one matches.",
        assign_round_robin: "Take turns",
        assign_task_creator: "The task creator",
        assign_form_submitter: "The form submitter",
        assign_unknown_person: "Someone no longer in this workspace",
        assign_would_assign: "Would assign: {people}",
        assign_would_assign_nobody: "Would assign nobody.",
        assign_would_remove: "Would remove: {people}",
        assign_skipped: "Skipped: {people}",
        assign_skip_not_a_member: "not an active member",
        assign_skip_no_project_access: "cannot open this project",
        assign_skip_agent: "agents are not assigned",
        assign_skip_no_creator: "the task has no creator",
        assign_skip_no_submitter: "the submitter was not signed in",
        assign_backtest_people: "Assigns {people}",
        assign_backtest_turns: "Takes turns between {people}",
        assign_assigned: "assigned {people}",
        status_is: "is",
        status_is_not: "is not",
        status_pick: "Choose a status",
        status_type_default_active: "Open",
        status_type_active: "In progress",
        status_type_close: "Done",
        status_needs_review: "This condition names a status that doesn't exist: {status}",
        trigger_due_date_passed: "Task due date passes",
        trigger_due_date_passed_help: "Runs once for a task when its due date passes while the task is still open. Due dates are checked every few minutes, and a task whose due date is changed can run it again.",
        trigger_subtasks_all_done: "All subtasks of a task are done",
        trigger_subtasks_all_done_help: "Runs on a task when its last open subtask is closed. A task with no subtasks never runs it, and reopening a subtask and closing it again runs it again.",
        action_notify: "Send a notification",
        action_notify_help: "Each person is told in their Inbox, and by push or email where their notification settings ask for it. Only active members who can open the task are told, and the person who caused the event is left out unless you tick the box. A rule that keeps firing stops telling the same person after too many notices in one hour.",
        notify_recipients: "Recipients",
        notify_pick_recipients: "Choose who to notify",
        notify_search: "Search people",
        notify_no_people: "No one matches.",
        notify_message: "Message",
        notify_message_placeholder: "What should it say?",
        notify_include_actor: "Also notify the person who caused it",
        notify_role_task_assignees: "The assignees",
        notify_role_task_creator: "The task creator",
        notify_role_task_watchers: "The watchers",
        notify_would_notify: "Would notify: {people}",
        notify_would_notify_nobody: "Would notify nobody.",
        notify_backtest_people: "Notifies {people}",
        notify_notified: "notified {people}",
        assign_skip_no_task_access: "cannot open this task",
        assign_skip_caused_event: "caused the event",
        assign_skip_rate_limited: "already notified too often this hour",
        dry_run_trigger_due: "The due date has passed and the task is open, so this trigger applies to it.",
        dry_run_trigger_not_due_yet: "The due date has not passed yet, so this trigger would not run now.",
        dry_run_trigger_no_due_date: "This task has no due date, so this trigger never runs for it.",
        dry_run_trigger_task_closed: "This task is closed, so this trigger does not run for it.",
        dry_run_trigger_no_subtasks: "This task has no subtasks, so this trigger never runs for it.",
        dry_run_trigger_subtasks_open: "{open} of {total} subtasks are still open, so this trigger would not run now.",
        dry_run_trigger_subtasks_done: "All {total} subtasks are done, so this trigger applies to it.",
        backtest_basis_touched: "Tasks touched in the last {days} days whose current state matches these conditions.",
        backtest_basis_due_date_passed: "Open tasks whose due date passed in the last {days} days and whose current state matches these conditions.",
        backtest_basis_subtasks_all_done: "Tasks whose subtasks are all done, one of them touched in the last {days} days, and whose current state matches these conditions.",
    },
    AutomationTemplates: {
        open: "Templates",
        title: "Start from a template",
        sub: "Pick a recipe to open it in the builder. Nothing is saved until you review it and save.",
        search: "Search templates",
        project: "Use in",
        all_projects: "Any project",
        category_all: "All",
        category_status: "Status",
        category_assignment: "Assignment",
        category_dates: "Dates",
        category_priority: "Priority",
        category_subtasks: "Subtasks",
        category_forms: "Forms",
        use: "Use template",
        none: "No template matches that search.",
        close: "Close templates",
        done_back_to_creator_name: "Hand finished work back to its creator",
        done_back_to_creator_desc: "When a task moves to its done status, add the person who created it as an assignee, so they hear about it and can check it.",
        done_comment_name: "Leave a note when a task is done",
        done_comment_desc: "When a task moves to its done status, post a comment on it.",
        done_comment_text: "This task is done. Reopen it if anything is still missing.",
        done_notify_creator_name: "Tell the creator when their task is done",
        done_notify_creator_desc: "When a task moves to its done status, send a notification to the person who created it.",
        done_notify_creator_text: "A task you created is done.",
        reopened_priority_name: "Raise the priority of reopened work",
        reopened_priority_desc: "When a task leaves its done status, set its priority to high.",
        created_assign_name: "Assign new tasks to someone",
        created_assign_desc: "When a task is created, add the person you pick as an assignee.",
        created_take_turns_name: "Share new tasks out in turn",
        created_take_turns_desc: "When a task is created, assign it to the next person in a group you pick.",
        unassigned_comment_name: "Flag tasks left without an assignee",
        unassigned_comment_desc: "When the last assignee is removed from a task, post a comment so it is not forgotten.",
        unassigned_comment_text: "This task has nobody assigned to it now. Who is picking it up?",
        overdue_priority_name: "Raise the priority of overdue tasks",
        overdue_priority_desc: "When a task's due date passes and it is still open, set its priority to high.",
        due_date_moved_comment_name: "Ask why a due date moved",
        due_date_moved_comment_desc: "When a task's due date changes, post a comment asking for the reason.",
        due_date_moved_comment_text: "The due date for this task changed. Please add a note on why.",
        due_date_moved_priority_name: "Raise low-priority tasks whose due date moves",
        due_date_moved_priority_desc: "When the due date of a low-priority task changes, set its priority to medium.",
        high_priority_assign_name: "Bring someone in on high-priority work",
        high_priority_assign_desc: "When a task's priority changes to high, add the person you pick as an assignee.",
        subtasks_done_close_parent_name: "Close a task when all its subtasks are done",
        subtasks_done_close_parent_desc: "When the last open subtask of a task is closed, move the task to its done status.",
        status_close: "Done",
        parent_done_comment_name: "Check subtasks when a parent task is done",
        parent_done_comment_desc: "When a task that has subtasks moves to its done status, post a reminder to check them.",
        parent_done_comment_text: "This task is done. Check that its subtasks are finished too.",
        created_review_subtask_name: "Add a review step to every new task",
        created_review_subtask_desc: "When a task is created, add a subtask to review it.",
        created_review_subtask_text: "Review",
        form_assign_name: "Assign form submissions to someone",
        form_assign_desc: "When a form is submitted, add the person you pick as an assignee on the task it files.",
        form_priority_name: "Mark form submissions as high priority",
        form_priority_desc: "When a form is submitted, set the task it files to high priority.",
    },
    WorkflowBuilder: {
        nav: "Workflows",
        title: "Workflow builder",
        new: "New workflow",
        cancel: "Cancel",
        loading: "Loading…",
        n_on: "{n} on",
        n_steps: "{n} step | {n} steps",
        empty_title: "No workflows yet",
        empty_sub: "Compose the steps once, try it against a real task, then turn it on.",
        engine_off_title: "The workflow engine is not running",
        engine_off_sub: "Workflows are switched off on this server. The person who runs the server can switch them on.",
        manage_owner_admin: "Only owners and admins can compose workflows.",
        could_not_load: "Could not load workflows.",
        could_not_save: "Could not save this workflow.",
        could_not_dry_run: "Could not plan this dry run.",
        called: "Called",
        name_placeholder: "Name this workflow",
        within: "within",
        minutes: "minutes",
        spending_at_most: "spending at most",
        usd: "USD",
        unbounded: "no limit",
        unset: "not set",
        no_approved_clients: "no outside agent is approved here",
        first: "First",
        then: "Then",
        after: "after",
        add_step: "+ step",
        remove: "Remove",
        save: "Save",
        saving: "Saving…",
        saved_off_note: "Saved workflows start turned off. Turn one on from the list when you are ready for it to run.",
        turn_on: "Turn on",
        turn_off: "Turn off",
        edit: "Edit",
        delete: "Delete",
        try_against: "Try it against",
        no_input: "no input",
        whole_project: "the whole project",
        dry_run: "Dry run",
        dry_running: "Planning…",
        plan_title: "What it would do",
        plan_nothing_written: "A dry run plans the workflow and writes nothing: no run, no changes, no spend.",
        plan_input: "Against {name}.",
        plan_input_missing: "That input no longer exists.",
        plan_summary: "{steps} steps in {waves} rounds — {writes} that change something, {asks} that ask a person.",
        plan_wave: "round {n}",
        plan_unreachable: "never runs",
        effect_writes: "changes something",
        effect_asks: "asks a person",
        effect_none: "changes nothing",
    },
    IntegrationsHub: {
        title: "Integrations & Automation",
        home: "Home",
        untitled_project: "(untitled)",
        priority_low: "LOW",
        priority_medium: "MEDIUM",
        priority_high: "HIGH",
        slack_channel_ph: "#general",
        soon: "Coming soon",
        active: "Active",
        paused: "Paused",
        received: "received",
        copy: "Copy",
        pause: "Pause",
        resume: "Resume",
        delete: "Delete",
        creating: "Creating…",
        emailToTask: "Email to Task",
        emailToTask_sub: "Turn incoming email into tasks",
        automations: "Automations",
        automations_sub: "When-this-then-that rules",
        calendar: "Calendar",
        calendar_sub: "Sync due dates to your calendar",
        marketplace: "Marketplace",
        marketplace_sub: "Browse available integrations",
        slack: "Slack",
        slack_sub: "Slash commands & notifications",
        apps: "Apps",
        apps_sub: "Embed external tools",
        email_intro: "Create a unique email address for a project. Anything sent to it becomes a task — great for forwarding requests, bug reports or supplier emails.",
        email_pick_project: "Project",
        email_select: "Select a project…",
        email_create: "Create inbox",
        email_note: "Tasks land in the project's first list, created as the inbox owner.",
        email_none: "No inboxes yet. Pick a project above to create one.",
        email_change_by: "Only the person who made this inbox, an owner or an admin can pause or delete it.",
        email_not_filing: "Mail sent here is not being filed: the person who made this inbox can no longer open its project or list.",
        email_change_refused: "That did not save. Only the person who made this inbox, an owner or an admin can change it.",
        email_change_failed: "That did not save. Try again in a moment.",
        email_address: "Inbox email address",
        email_webhook: "Email provider callback address",
        email_help_title: "How to connect your email provider",
        email_help_1: "In your inbound email provider (Mailgun, SendGrid, SES, Postmark…), add a route/parse rule for the inbox address above.",
        email_help_2: "Point that route to send the parsed email to the provider callback address above.",
        email_help_3: "Send a test email — a task appears in the project within seconds.",
        cal_intro: "Subscribe to a live calendar of task due-dates in Google Calendar, Outlook or Apple Calendar. Read-only and always up to date.",
        cal_scope: "What to include",
        cal_my: "My tasks",
        cal_project: "A project's tasks",
        cal_create: "Create feed",
        cal_none: "No calendar feeds yet.",
        cal_url: "Calendar subscription URL (iCal)",
        cal_help_title: "How to subscribe",
        cal_help_1: "Copy the subscription URL above.",
        cal_help_2: "In Google/Outlook/Apple Calendar, choose 'Add from URL' (or 'Subscribe to calendar') and paste it.",
        cal_url_once: "Copy this link now. For your security it is shown only once.",
        cal_url_hidden: "The subscription link is hidden. Regenerate it to get a new one.",
        cal_regenerate: "Regenerate link",
        cal_regenerate_confirm: "Regenerate this link? Calendars subscribed to the current link will stop updating.",
        auto_intro: "Define a rule once, then apply it to every matching task in one click — e.g. bump all low-priority tasks in a project to high.",
        auto_name: "Rule name",
        auto_name_ph: "e.g. Escalate stale low-priority",
        auto_when: "When a task matches",
        auto_any_project: "Any project",
        auto_any_priority: "Any priority",
        auto_then: "Then set priority to",
        auto_create: "Create rule",
        auto_none: "No automation rules yet.",
        auto_affected: "affected last run",
        auto_apply: "Apply now",
        connected: "Connected",
        mp_intro: "Connect AlianHub to the tools your team already uses.",
        mp_search: "Search integrations…",
        mp_connect: "Connect",
        mp_reconfigure: "Reconfigure",
        mp_disconnect: "Disconnect",
        mp_save: "Save connection",
        mp_cancel: "Cancel",
        slack_url: "Slash command request URL",
        slack_hint: "In your Slack app → Slash Commands, create /alianhub and paste this Request URL. Put your app's Verification Token (Basic Information) in the field above.",
        slack_intro: "Run /alianhub commands from your Slack workspace. Just paste your app's verification code and add the request address below.",
        slack_token: "Slack verification token",
        slack_channel: "Default channel (optional)",
        slack_connect: "Connect Slack",
        slack_commands: "Available commands: /alianhub help · /alianhub projects",
        slack_help_title: "How to set it up",
        slack_help_1: "At api.slack.com/apps open (or create) your app → Basic Information → copy the Verification Token into the field above and save.",
        slack_help_2: "Features → Slash Commands → Create New Command: /alianhub, and paste the Request URL shown above.",
        slack_help_3: "In Slack, run /alianhub help to confirm it's connected.",
        apps_intro: "Embed an external tool (dashboard, docs, BI board) as an in-app panel. https URLs only.",
        apps_name: "App name",
        apps_url: "Embed URL (https://…)",
        apps_add: "Add app",
        apps_note: "The embedded site must allow being framed (some set X-Frame-Options / frame-ancestors to block it).",
        apps_none: "No embedded apps yet. Add one above.",
    },
    Palette: {
        title: "Command palette",
        more_lists: "+{n} list | +{n} lists",
        place_and_lists: "{place} · {lists}",
        input_label: "Search, go to or run a command",
        close: "Close the command palette",
        filter_label: "Show results of one type",
        results_label: "Results",
        chip_all: "All",
        chip_tasks: "Tasks",
        chip_projects: "Projects",
        chip_docs: "Docs",
        chip_people: "People",
        group_recent_opened: "Recently opened",
        group_comments: "Comments",
        sprint_in: "List in {project}",
        comment_on: "Comment on {task}",
        type_to_search: "Type to search {type}.",
        docs_company: "Company docs",
        actions_for: "Actions for {title}",
        action_open: "Open",
        action_new_tab: "Open in new tab",
        action_copy: "Copy link",
        action_ask: "Ask AI",
        link_copied: "Link copied",
        copy_failed: "Could not copy the link",
        hint_new_tab: "new tab",
        hint_actions: "actions",
        hint_close: "close",
        key_tab: "Tab",
        key_esc: "Esc",
        key_ctrl_enter: "Ctrl ↵",
        age_now: "just now",
        age_minutes: "{n}m ago",
        age_hours: "{n}h ago",
        age_days: "{n}d ago",
        age_months: "{n}mo ago",
        age_years: "{n}y ago",
        answer: "AI answer",
        answer_model: "Model that wrote the answer",
        ask_loading: "Finding an answer…",
        ask_failed: "AI could not answer that just now. Try again, or continue in Ask.",
        ask_no_model: "No AI model is connected, so there is no written answer. These are the sources it would have used.",
        ask_nothing: "Nothing you can open matches that question.",
        ask_continue: "Continue in Ask",
        group_sources: "Cited sources",
        hint_cancel: "cancel",
    },
    Shell: {
        home: "Home",
        planner: "Planner",
        chat: "Chat",
        ai: "AI",
        docs: "Docs",
        dash: "Dash",
        time: "Time",
        more: "More",
        work: "Work",
        tools: "Tools",
        workspace: "Workspace",
        help: "Help",
        search: "Search or ask AI",
        switch_workspace: "Switch workspace",
        theme_light: "Light theme",
        theme_dark: "Dark theme",
        status_dnd: "Do not disturb",
        my_profile: "My profile",
        logout: "Log out",
        install_app: "Install app",
        update_ready: "A new version is ready.",
        update_reload: "Reload",
        update_later: "Later",
        offline_start_body: "Your workspace needs a connection to load. This page reloads by itself when you're back online.",
        version: "Version",
        agents_running: "{n} running",
        skip_to_content: "Skip to content",
        palette_esc: "ESC",
        primary_nav: "Primary",
        inbox_unread: "Inbox, {n} unread",
        everything: "Everything",
        goals: "Goals",
        my_work: "My work",
        ask: "Ask",
        more_places: "More places",
    },
    Everything: {
        title: "Everything",
        count: "{n} task | {n} tasks",
        tasks_label: "Tasks across your projects",
        search: "Search tasks",
        me: "Me",
        filter_status: "Status",
        filter_assignee: "Assignee",
        filter_priority: "Priority",
        filter_due: "Due date",
        filter_type: "Type",
        filter_project: "Project",
        unassigned: "Unassigned",
        someone: "Someone",
        find_option: "Find",
        no_options: "Nothing matches",
        clear: "Clear",
        clear_filters: "Clear filters",
        group_by: "Group by",
        group_none: "No grouping",
        group_status: "Status",
        group_assignee: "Assignee",
        group_project: "Project",
        group_priority: "Priority",
        group_dueDate: "Due date",
        sort_by: "Sort by",
        sort_updated_desc: "Recently updated",
        sort_updated_asc: "Least recently updated",
        sort_due_asc: "Due soonest",
        sort_due_desc: "Due latest",
        show_subtasks: "Show subtasks",
        hide_done: "Hide done",
        include_closed: "Include closed projects",
        subtasks_n: "{n} subtask | {n} subtasks",
        load_more: "Load more",
        loading: "Loading tasks",
        retry: "Try again",
        error_title: "The tasks could not be loaded",
        group_failed: "These tasks could not be loaded.",
        empty_title: "No tasks match these filters",
        empty_hint: "Change or clear the filters to see more.",
        empty_none_title: "No tasks yet",
        empty_none_hint: "Tasks from every project you can open show up here.",
        mode_label: "View mode",
        mode_list: "List",
        mode_board: "Board",
        mode_table: "Table",
        board_label: "Tasks by status",
        column_empty: "No tasks here",
        drop_no_status: "{project} has no status called {status}, so the task stays where it is.",
        drop_no_permission: "You cannot change the status of tasks in this project.",
        col_name: "Name",
        col_updated: "Updated",
        sort_unavailable: "The list can be sorted by due date or by last update",
        views: "Views",
        views_none: "No saved views yet",
        view_none: "Leave this view",
        view_name: "View name",
        view_save: "Save view",
        view_save_changes: "Save changes to {name}",
        view_saved: "View saved",
        view_changed: "This view has unsaved changes",
        view_rename: "Rename",
        view_delete: "Delete",
        view_delete_ask: "Delete {name}?",
        view_default_set: "Set as my default",
        view_default_on: "This is my default view",
        view_failed: "The view could not be saved",
        save: "Save",
        cancel: "Cancel",
    },
    Goals: {
        title: "Goals",
        count: "{n} goal | {n} goals",
        new_goal: "New goal",
        scope_label: "Whose goals",
        scope_all: "All",
        scope_mine: "Mine",
        archived: "Archived",
        sort_by: "Sort",
        sort_name: "Name",
        sort_progress: "Progress",
        loading: "Loading goals",
        error_title: "The goals could not be loaded.",
        retry: "Try again",
        empty_title: "No goals yet",
        empty_hint: "A goal holds the targets you want to reach, and shows how far along they are.",
        empty_mine_title: "No goals of yours",
        empty_mine_hint: "Goals you own or are named on show here.",
        empty_archived_title: "Nothing archived",
        empty_archived_hint: "Archived goals show here, and can be restored.",
        back_to_goals: "Back to goals",
        empty_guest_title: "No goals are shared with you",
        empty_guest_hint: "A goal shows here when someone shares it with you by name.",
        group_current: "Current",
        group_upcoming: "Upcoming",
        group_past: "Past",
        group_none: "No dates",
        progress_of: "Progress of {name}",
        reached: "{done} of {total} targets reached",
        no_targets: "No targets yet",
        owner: "Owner",
        owned_by: "Owned by {name}",
        someone: "Someone",
        period: "Period",
        period_range: "{start} to {end}",
        period_from: "From {start}",
        period_until: "Until {end}",
        period_none: "No dates",
        period_start: "Starts",
        period_end: "Ends",
        visibility: "Who can see it",
        visibility_private: "Private",
        visibility_people: "Some people",
        visibility_workspace: "Workspace",
        effect_private: "Only you",
        effect_private_other: "Only {name}. It will leave your list.",
        effect_people: "You and {n} person | You and {n} people",
        effect_people_none: "Only you, until you pick someone",
        effect_people_other: "{name} and {n} person. It will leave your list. | {name} and {n} people. It will leave your list.",
        effect_workspace: "Everyone in the workspace",
        shared_with_you: "Shared with you",
        people_label: "People who can see this goal",
        people_search: "Find a person",
        people_none: "Nobody matches",
        guest: "Guest",
        save: "Save",
        cancel: "Cancel",
        close: "Close",
        details: "Goal details",
        name: "Name",
        name_placeholder: "What do you want to reach?",
        description: "Description",
        description_placeholder: "Add a description",
        color: "Colour",
        color_none: "No colour",
        color_pick: "Colour {n}",
        change_owner: "Change owner",
        new_owner: "New owner",
        owner_pick: "Choose a person",
        owner_confirm: "Make {name} the owner?",
        owner_effect_edit: "You will no longer be able to edit this goal.",
        owner_effect_sight: "You will no longer see this goal.",
        owner_effect_keep: "You can still edit this goal.",
        archive: "Archive",
        restore: "Restore",
        archived_note: "This goal is archived. Restore it to change it.",
        archived_note_reader: "This goal is archived.",
        summary_title: "Summary",
        summarise: "Summarise",
        summarising: "Summarising…",
        regenerate: "Regenerate",
        summary_from: "From {time}",
        summary_behind: "The goal has changed since this was written.",
        summary_budget: "This workspace's AI budget for the month is spent.",
        summary_budget_unavailable: "The workspace's AI budget could not be checked, so no summary was made. Try again in a moment.",
        summary_unavailable: "AI is not available right now.",
        summary_failed: "The summary could not be written. Try again.",
        targets: "Targets",
        add_target: "Add target",
        new_target: "New target",
        edit_target_title: "Edit target",
        targets_full: "A goal holds at most {n} targets.",
        kind: "Kind",
        kind_number: "Number",
        kind_currency: "Currency",
        kind_boolean: "True or false",
        kind_tasks: "Counted from tasks",
        kind_fixed: "A target's kind cannot be changed.",
        tasks_done: "{done} of {total} tasks done",
        counted_at: "Counted {when}",
        updating: "Updating…",
        count_failed: "The tasks could not be counted.",
        count_failed_wait: "The tasks could not be counted. It will be tried again shortly.",
        count_retry: "Try again",
        count_toward: "Count toward a goal…",
        link_title: "Count toward a goal",
        link_task_hint: "Pick the target whose progress should count the task {name}.",
        link_list_hint: "Pick the target whose progress should count the top-level tasks of the list {name}.",
        link_goal: "Goal",
        link_target: "Target",
        link_target_new: "New target…",
        link_target_already: "{name} (already counts it)",
        link_save: "Count it",
        link_done: "{name} now counts toward {target}.",
        link_loading: "Loading your goals…",
        link_failed: "Your goals could not be loaded.",
        link_no_goals: "You have no goals you can edit.",
        sources: "Lists and tasks",
        sources_hint: "Progress is the share of these tasks that are done. A list counts its top-level tasks.",
        sources_none: "No lists or tasks linked yet",
        link_sources: "Link lists or tasks",
        source_search: "Find a list or task",
        source_lists: "Lists",
        source_tasks: "Tasks",
        source_list: "List",
        source_task: "Task",
        source_no_lists: "No other list matches",
        source_tasks_idle: "Type two letters or more to find a task",
        source_tasks_searching: "Searching",
        source_tasks_done: "No other task matches",
        source_tasks_failed: "The tasks could not be searched. Try again.",
        source_list_unknown: "A list you cannot open",
        source_task_unknown: "A task you cannot open",
        source_remove: "Remove {name}",
        source_refused: "Not accepted",
        sources_lists_full: "A target counts at most 20 lists.",
        sources_tasks_full: "A target counts at most 100 tasks.",
        not_counted: "{n} linked list or task is not counted for this goal's readers. | {n} linked lists or tasks are not counted for this goal's readers.",
        drop_sources_save: "Remove these and save",
        target_name: "Target name",
        start: "Start",
        target: "Target",
        current: "Current value",
        current_hint: "Leave empty to begin at the start.",
        unit: "Unit",
        unit_placeholder: "customers, %, km",
        currency: "Currency",
        currency_pick: "Choose a currency",
        weight: "Weight",
        weight_hint: "How much this target counts towards the goal, from 1 to 100.",
        weight_n: "Weight {n}",
        range_up: "from {start} to {target}",
        range_down: "from {start} down to {target}",
        done: "Done",
        not_done: "Not done",
        reached_mark: "Reached",
        value_of: "Current value of {name}",
        save_value: "Save value",
        saving: "Saving",
        updated_by: "Updated by {name}, {when}",
        edit_target: "Edit {name}",
        remove_target: "Remove {name}",
        remove_confirm: "Remove this target? Its value is lost.",
        remove: "Remove",
        goal_missing_title: "This goal is not available",
        goal_missing_hint: "It may have been removed, or it is not shared with you.",
        goal_failed: "The goal could not be loaded.",
        goal_gone: "The goal is no longer in your list.",
        conflict: "This goal changed while you were working on it. It has been loaded again: try once more.",
        not_allowed: "You can no longer change this goal.",
        save_failed: "The change could not be saved. Try again.",
        error_name: "Give it a name of up to 120 characters.",
        error_name_server: "This name was not accepted. If it looks right, you may already own 200 goals: archive one to make room.",
        error_description: "Keep the description to 2000 characters.",
        error_periodStart: "Enter a valid start date.",
        error_periodEnd: "The end cannot be before the start.",
        error_visibility: "Choose who can see the goal.",
        error_sharedWith: "Someone on this list is no longer an active member. Untick them and save again.",
        error_color: "Pick one of the colours.",
        error_ownerUserId: "The owner must be an active member who is not a guest.",
        error_kind: "Choose a kind.",
        error_weight: "Use a whole number from 1 to 100.",
        error_start: "Enter a number.",
        error_target: "The target must differ from the start.",
        error_target_required: "Enter the target.",
        error_number: "Enter a number.",
        error_current: "Enter a number.",
        error_unit: "Keep the unit to 20 characters.",
        error_currencyCode: "Choose one of the workspace's currencies.",
        error_done: "Choose done or not done.",
        error_targets: "A goal holds at most 20 targets.",
        error_sources: "These lists and tasks were not accepted. Check them and save again.",
        error_source_not_found: "The marked list or task was not found, or you cannot open it. Remove it and save again.",
        error_source_not_shared: "Not everyone who can see this goal can open the marked lists or tasks. Remove them, or share the goal with fewer people.",
        error_sources_would_drop: "Not everyone who would then see this goal can open every list and task it is counted from. Remove those from its targets first.",
        error_counted_from_tasks: "This target is counted from its tasks, so its value cannot be set by hand.",
        error_generic: "This was not accepted. Check what you entered.",
    },
    Docs: {
        empty_title: "Docs hold what your team writes down",
        empty_msg: "Use a doc for a brief, a decision or meeting notes, then link the tasks that carry it out. Add the first one and it will appear here.",
        docs: "Docs",
        view_select: "Show docs",
        wiki: "Wiki",
        new_doc: "New doc",
        new_wiki_page: "New wiki page",
        search_docs: "Search docs",
        recent: "Recent",
        mine: "Created by me",
        by_project: "By project",
        workspace: "Workspace",
        agent_drafted: "Agent-drafted",
        templates: "Templates",
        trash: "Trash",
        needs_review: "Needs review",
        agent: "AGENT",
        agent_draft: "AGENT DRAFT",
        review: "Review",
        approve: "Approve",
        approved: "Approved",
        restore: "Restore",
        pages_count: "{n} PAGE | {n} PAGES",
        stale_count: "{n} STALE",
        edited_ago: "{who} · {when}",
        just_now: "just now",
        minutes_ago: "{n}m",
        hours_ago: "{n}h",
        yesterday: "yesterday",
        days_ago: "{n}d",
        untitled: "Untitled",
        no_recent_title: "Nothing written yet",
        no_recent_hint: "Start a doc for the brief, the decision or the notes — then link the tasks that carry it out.",
        no_mine: "You have not created a doc yet.",
        shared_with_me: "Shared with me",
        no_shared_with_me: "Nothing is shared with you yet",
        no_shared_with_me_hint: "A doc that someone shares with you by name shows up here.",
        see_recent: "See recent docs",
        shared_with_you: "Shared with you",
        view_only: "View only",
        view_only_hint: "You can read and comment on this doc. Changing it needs edit access.",
        shared_with_one: "Shared with 1 person",
        shared_with_n: "Shared with {n} people",
        share_people: "People",
        share_people_hint: "Share this doc with someone by name. They get this doc only, not its project.",
        share_add_people: "Add people",
        share_none: "Not shared with anyone by name yet.",
        share_role_viewer: "Can view",
        share_role_editor: "Can edit",
        share_role_label: "Access for {name}",
        share_remove: "Stop sharing with {name}",
        share_inactive: "No longer a member",
        share_limit: "A doc can be shared with at most {n} people.",
        share_failed: "Could not change who this doc is shared with.",
        no_project_docs: "No docs in this project yet.",
        no_project_docs_hint: "Briefs, decisions and notes written for this project are kept here.",
        no_agent_drafts_title: "No agent drafts waiting",
        no_agent_drafts_hint: "When an agent writes a page — release notes, a summary, a report — it lands here for your review.",
        no_review_due: "Every wiki page is within its review window.",
        no_trash: "Trash is empty.",
        trash_hint: "Deleted docs stay here until you restore them.",
        templates_hint: "Start from a structure instead of a blank page.",
        use_template: "Use template",
        template_spec: "Spec",
        template_spec_hint: "Goal, acceptance criteria, open questions, out of scope.",
        template_retro: "Sprint retro",
        template_retro_hint: "Went well, didn't, try next.",
        template_runbook: "Runbook",
        template_runbook_hint: "When to use, steps, how to undo, contacts.",
        template_meeting: "Meeting notes",
        template_meeting_hint: "Attendees, decisions, actions with owners.",
        template_release: "Release notes",
        template_release_hint: "What shipped, what changed, what to watch.",
        blank_doc: "Blank doc or from template",
        subpages: "{n} sub-pages",
        owner: "Owner",
        no_owner: "none",
        project: "Project",
        visibility: "Visibility",
        review_date: "Review date",
        reviewed: "Reviewed",
        state: "State",
        page: "Page",
        verified: "Verified",
        due_now: "Due now",
        stale: "Stale",
        not_reviewed: "Not reviewed yet",
        reviewed_by_next: "Reviewed by {who} · next review {when}",
        review_due_line: "Review due {when} · owner {who}",
        stale_banner: "This page is past its review date. Check it before trusting it.",
        mark_reviewed: "Mark reviewed",
        marked_reviewed: "Marked as reviewed",
        wiki_page: "Wiki page",
        wiki_toggle_hint: "Wiki pages get an owner and a review date so they stop rotting silently.",
        linked_to: "Linked to",
        updated: "Updated {when}",
        present: "Present",
        share: "Share",
        ask_about_doc: "Ask about this doc",
        on_this_page: "On this page",
        no_headings: "Add headings and they show up here.",
        breadcrumb_docs: "Docs",
        back_to_docs: "Back to docs",
        page_missing: "This doc could not be opened. It may have been deleted or made private.",
        slash_hint: "Type / for blocks",
        block_task: "Task",
        block_task_hint: "Live · one task from a project",
        block_task_list: "Task list",
        block_task_list_hint: "Live · edits sync to the project",
        block_callout: "Callout",
        block_image: "Image",
        block_image_hint: "Upload, paste or drop an image, or paste its URL",
        block_embed: "Embed",
        block_delimiter: "Divider",
        block_quote: "Quote",
        task_search: "Search a task by key or name…",
        task_pick_project: "Pick a project",
        task_no_results: "No task matches.",
        task_missing: "This task no longer exists.",
        task_loading: "Loading task…",
        task_list_status_open: "Open",
        task_list_status_close: "Done",
        task_list_status_all: "All",
        task_list_empty: "No tasks match this filter.",
        task_list_label: "LIVE TASK LIST",
        task_list_count: "{n} task | {n} tasks",
        open_task: "Open task",
        image_url: "Image URL",
        image_caption: "Caption",
        image_upload: "Upload image",
        image_uploading: "Uploading image…",
        image_upload_failed: "The image could not be uploaded. Try again.",
        image_type_refused: "Add a PNG, JPEG, GIF or WebP image.",
        image_too_large: "That image is too large to upload.",
        mention: "Mention",
        mention_picker: "Mention a person, doc or task",
        mention_people: "People",
        mention_docs: "Docs",
        mention_tasks: "Tasks",
        mention_searching: "Searching…",
        mention_no_results: "Nothing matches.",
        mention_unavailable: "That task could not be opened. It may have been deleted, or you may not have access.",
        callout_placeholder: "Something the reader must not miss…",
        quote_placeholder: "Quote",
        presenting_from: "Presenting from",
        headings_became_slides: "headings became slides",
        slide_of: "{n} / {total}",
        exit_present: "Exit",
        nothing_to_present: "Add a heading or two and Present will turn them into slides.",
        deleted_hint: "Deleted {when}",
        showing_trash: "Deleted docs",
        empty_page_excerpt: "Empty page",
        by_agent: "by {name}",
        release_agent: "Agent",
        live: "live",
        close: "Close",
        edit: "Edit",
        preview: "Preview",
        save: "Save",
        saving: "Saving…",
        saved: "Saved",
        unsaved: "Unsaved changes",
        save_now_hint: "The doc saves by itself. Save now without waiting.",
        autosave_offline: "Offline: changes kept on this device",
        autosave_not_saved: "Not saved: changes kept on this device",
        conflict_banner: "This doc was changed somewhere else after you opened it, so your changes were not saved over it. They are kept on this device.",
        conflict_keep_copy: "Keep mine as a copy",
        conflict_reload: "Reload the saved doc",
        conflict_copy_title: "{title} (my copy)",
        conflict_copy_kept: "Your text was kept as \"{title}\".",
        delete: "Delete",
        link_tasks: "Link tasks",
        linked_tasks: "Linked tasks",
        unlink: "Unlink",
        private: "Private",
        shared: "Shared",
        pages: "Pages",
        find_a_page: "Find a page…",
        add_nested_page: "Add a nested page",
        select_owner: "Select owner",
        set_review_date: "Set review date",
        wiki_pages: "Wiki pages",
        comments: "Comments",
        comments_title: "Comments",
        comments_open: "Open ({n})",
        comments_resolved: "Resolved ({n})",
        comments_loading: "Loading comments…",
        comments_empty: "No open comments. Start one below, on the whole doc or on a block.",
        comments_none_resolved: "No resolved comments yet.",
        comments_jump: "Show this block in the doc",
        comments_on_block: "On a block",
        comments_block_removed: "Its block was deleted, so this now sits on the whole doc.",
        comment_edited: "(edited)",
        comment_edit: "Edit",
        comment_delete: "Delete",
        comment_cancel: "Cancel",
        comment_save: "Save",
        comment_reply: "Reply",
        comment_resolve: "Resolve",
        comment_reopen: "Reopen",
        comment_send: "Comment",
        comment_placeholder: "Add a comment. Type {'@'} to mention someone.",
        comment_reply_placeholder: "Reply. Type {'@'} to mention someone.",
        comment_target_doc: "On the whole doc",
        comment_target_block: "On: {text}",
        comment_target_clear: "Comment on the whole doc instead",
        comment_on_block: "Use the selected block",
        comment_pick_block_first: "Click into a block in the doc first, then choose it here.",
        comment_someone: "Someone",
        comment_delete_confirm: "Delete this comment?",
        comment_delete_thread_confirm: "Delete this comment and all its replies?",
        comments_limit: "This doc has reached its limit of {n} comments. Delete some to add more.",
        comment_attach: "Attach a file",
        comment_file: "Attached file",
        comment_file_open: "Open this file",
        comment_file_remove: "Remove the file",
        comment_file_failed: "The file could not be uploaded.",
        comment_file_unavailable: "That file could not be opened.",
        history: "History",
        history_title: "Version history",
        history_versions: "Versions",
        history_loading: "Loading…",
        history_empty: "No versions yet. One is kept before someone else edits the doc, before a save removes or rewrites text, every ten minutes while the doc is being edited, and when you save one here.",
        history_unavailable: "This version could not be opened.",
        history_save_version: "Save a version",
        history_saved: "Version saved.",
        history_name_label: "Version name",
        history_name_placeholder: "Name (optional)",
        history_name_this: "Name this version",
        history_name_save: "Save name",
        history_named: "Version name saved.",
        history_restore: "Restore this version",
        history_restore_confirm: "Restore this version? The doc as it is now is kept as a version first.",
        history_restore_private_confirm: "This version is from when the doc was private. Restoring it shows it to everyone who can read the doc now. The doc as it is now is kept as a version first. Restore it?",
        history_restored: "Version restored.",
        history_back: "Back to the versions",
        history_read_only: "Read-only",
        history_compare_label: "Show what changed against",
        history_compare_previous: "The version before",
        history_compare_current: "The doc now",
        history_summary: "{added} added, {removed} removed, {changed} changed",
        history_no_changes: "Nothing changed.",
        history_first: "This is the earliest version kept, shown whole.",
        history_added: "Added",
        history_removed: "Removed",
        history_changed: "Changed",
        history_title_changed: "Title",
        history_private_time: "From when the doc was private",
        history_reason_author: "Kept before someone else edited",
        history_reason_interval: "Kept while editing",
        history_reason_rewrite: "Kept before text was removed or rewritten",
        history_reason_restore: "Kept before a restore",
        history_reason_manual: "Saved by hand",
        history_reason_legacy: "From the earlier history"
    },
    Common: {
        select_task: "Select task",
        select_task_named: "Select {name}",
        select_all_tasks: "Select all tasks in group",
        more_assignees: "{count} more assignee | {count} more assignees",
        country_code_of: "Country code: {country}",
        close: "Close",
        key_esc: "Esc",
        key_enter: "Enter",
        key_shift_enter: "Shift + Enter",
        key_tab: "Tab",
        server_busy: "The server is busy. Try again in a moment.",
        server_busy_retry_in: "The server is busy. Try again in {n} second. | The server is busy. Try again in {n} seconds.",
    },
    Time: {
        loading: "Loading…",
        back_to_summary: "Back to summary",
        when_custom: "Custom",
        when_today: "Today",
        when_yesterday: "Yesterday",
        my_timesheet: "My timesheet",
        tab_mine: "Mine",
        tab_project: "Project",
        tab_workload: "Workload",
        tab_tracker: "Tracker",
        export: "Export",
        exporting: "Exporting…",
        submit_week: "Submit week",
        resubmit_week: "Resubmit week",
        submitting: "Submitting…",
        submitted_ok: "Week submitted for approval.",
        col_task: "TASK",
        col_total: "TOTAL",
        total_capacity: "Total · capacity {h}h/day",
        me: "Me",
        all_projects: "All projects",
        status_draft: "Draft",
        status_submitted: "Submitted",
        status_approved: "Approved",
        status_rejected: "Rejected",
        awaiting_approval: "awaiting approval",
        awaiting_named: "awaiting {name}'s approval",
        approved_by: "approved by {name}",
        approved_by_own_week: "approved by {name} (own week)",
        approved_own_week: "Approved by {name} (own week)",
        own_week: "Your own week",
        own_week_hint: "If you approve it, the week shows that you approved your own.",
        rejected_by: "rejected by {name}",
        reopen_week: "Reopen",
        reopen_title: "Reopen this week?",
        reopen_text: "{name}'s week of {range} goes back to Submitted. Its time can be changed again, and it needs approving again.",
        reopening: "Reopening…",
        reopened_ok: "Week reopened",
        reopened_by: "Reopened by {name} on {date}",
        someone: "someone",
        reason: "Reason: {reason}",
        last_week: "Last week:",
        not_submitted: "not submitted",
        under_capacity_one: "{day} is {h} under capacity — log the missing time?",
        under_capacity_many: "{days} are {h} under capacity — log the missing time?",
        add_hours: "Add {h}",
        timer_running: "Timer running",
        stop: "Stop",
        start_timer: "Start timer",
        discard: "Discard",
        timer_stopped_prev: "Stopped {task} ({h}) to start this one.",
        billable: "Billable",
        non_billable: "Non-billable",
        toggle_billable: "Toggle billable for this task",
        empty_week_title: "No time logged this week",
        empty_week: "Nothing logged this week yet. Start a timer from a task, or log time by hand.",
        log_time: "Log time",
        prev_week: "Previous week",
        next_week: "Next week",
        running_desktop: "Running in the desktop tracker",
        load_failed: "Couldn't load the timesheet — try again.",
        so_far: "{day} · {h} so far",
        overnight_title: "Timer left running overnight",
        overnight_body: "Started {start} {when} on {task}. {recorded} recorded.",
        yesterday: "yesterday",
        today: "today",
        earlier: "earlier",
        trim_to: "Trim to 3h",
        trimming: "Trimming…",
        trimmed: "Trimmed to 3h.",
        trim_failed: "Couldn't trim that timer — try again.",
        edit: "Edit",
        task: "Task",
        pick_task: "Pick a task",
        task_not_open: "A task you cannot open",
        hours: "Hours",
        when: "When",
        tomorrow_blocked: "Only today or earlier.",
        pick_date: "Pick a date",
        note: "Note",
        optional: "optional",
        note_ph: "What did you work on?",
        round_15: "Round to 15",
        log_btn: "Log {h}",
        logging: "Logging…",
        entries_editable: "Entries stay editable until the week is submitted.",
        hours_required: "Enter the hours to log.",
        task_required: "Pick a task first.",
        log_failed: "Couldn't log time — try again.",
        period_locked: "That day is in an approved timesheet period, so time can't be added to it.",
        timer_kept_period_locked: "This day is in an approved week, so the time can't be logged yet. Your timer was not stopped and nothing is lost. Ask an approver to reopen the week, then stop it again.",
        timer_kept_log_failed: "Couldn't log the time. Your timer was not stopped, so nothing is lost — try again.",
        logged_ok: "Logged {h} on {task}.",
        search_tasks: "Search your tasks…",
        no_tasks: "No tasks match.",
        recent: "Recent",
        assigned: "Assigned to you",
        close: "Close",
        approvals: "Approvals",
        filter_all: "All",
        filter_time: "Time",
        filter_leave: "Leave",
        filter_ai: "AI",
        ts_card_title: "{name}'s timesheet",
        week_of: "Week of {date} · {h}",
        billable_h: "{h} billable",
        internal_h: "{h} internal",
        over_cap: "{h} over cap",
        approve: "Approve",
        approving: "Approving…",
        detail: "Detail",
        reject: "Reject",
        why: "Why?",
        why_title: "Why {name} proposes this",
        why_reason: "Reason",
        why_no_reason: "The agent gave no reason for this proposal.",
        why_changes: "What changes",
        why_permanent: "cannot be undone",
        why_close: "Close",
        agent_tag: "AGENT",
        approval_types: "Approval types",
        confirm_reject: "Confirm reject",
        cancel: "Cancel",
        reject_reason_ph: "Reason (the requester sees this)",
        reason_required: "A reason is required to reject.",
        leave_title: "{name} · {type}",
        leave_range: "{range} · {days} days",
        leave_one: "{range} · 1 day",
        leave_overlap: "{names} also off in this window.",
        agent_section: "Agent proposals",
        agent_empty: "No agent proposals yet. When an AI agent proposes a change that needs sign-off, it queues here.",
        agent_load_failed: "Agent proposals didn't load. Refresh to try again.",
        queue_empty_title: "Queue clear",
        queue_empty: "Nothing waiting for you. Submitted timesheets and leave requests show up here.",
        show_all_approvals: "Show all approvals",
        no_access: "Only owners and admins review approvals.",
        approved_ok: "Approved.",
        rejected_ok: "Rejected.",
        action_failed: "That didn't go through — try again.",
        bulk_select_one: "Select {name}'s timesheet",
        bulk_select_all: "Select all timesheets on this page",
        bulk_actions: "Actions for the selected timesheets",
        bulk_selected: "{n} selected",
        bulk_send_back: "Send back",
        bulk_note_label: "Note for everyone you send back",
        bulk_note_required: "Add a note so people know what to fix.",
        bulk_approved_n: "{n} approved",
        bulk_sent_back_n: "{n} sent back",
        bulk_skipped_n: "{n} skipped: {reason}",
        bulk_reason_already_reviewed: "already reviewed",
        bulk_reason_not_allowed: "not yours to review",
        bulk_reason_not_found: "not found",
        bulk_reason_failed: "could not be reviewed",
        reversible: "reversible",
        workload: "Workload",
        by_estimate: "By: estimate",
        by_logged: "By: logged",
        balance: "✦ Balance",
        per_day: "{h}h/day",
        pct_period: "{pct}% this period",
        pto_range: "PTO {range}",
        pto: "PTO",
        unavailable_range: "Unavailable {range}",
        unavailable: "Unavailable",
        legend_estimated: "estimated",
        legend_logged: "logged",
        legend_tentative: "next week, tentative",
        legend_over: "over capacity",
        drag_hint: "Drag a task chip onto another day or person to rebalance.",
        dragging: "Dragging \"{task} · {h}\" → drop on {name} {day}: {from} {fromPct}%, {name} {toPct}%",
        moved: "Moved {task} to {name} · {day}.",
        move_failed: "Couldn't move that — try again.",
        balance_hint: "✦ Move \"{task} · {h}\" from {from} {day} to {to}: {from} {fromPct}%, {to} {toPct}%",
        balance_none: "✦ Nobody is over capacity in this range.",
        apply: "Apply",
        workload_empty: "No planned work in this range. Add estimates to tasks to see workload.",
        desktop_only: "This view is desktop-only. Open it on a wider screen.",
        capacity_planning: "Capacity planning",
        by_team: "By team",
        all_teams: "All teams",
        fill_gap: "✦ Fill the gap",
        legend_committed: "committed",
        legend_pipeline: "upcoming, not confirmed",
        legend_over_avail: "over available",
        legend_line: "— black line = available hours after PTO",
        gap_title: "{month} gap:",
        gap_body: "{team} is committed to {committed}h against {available}h available",
        gap_pto: "{name} off {days}d",
        gap_unavailable: "{name} unavailable {days}d",
        gap_over: "{name} at {pct}% already",
        no_gaps: "No gaps — every team has room in every month shown.",
        options: "✦ Options:",
        option_contractor: "add a contractor for {month} (+{h}h)",
        option_shift: "move {h}h of {team} work to {month} (has room)",
        option_cut: "cut or postpone {h}h of {team} work in {month}",
        model_each: "Model each",
        contractor_row: "What-if · contractor",
        contractor_hint: "{h}h/month added to {team}",
        hours_per_month: "h/month",
        add_contractor: "Add contractor",
        remove_contractor: "Remove",
        unassigned_team: "No team",
        hours_per_day: "h/day",
        months_3: "3 months",
        months_4: "4 months",
        months_6: "6 months",
        capacity_empty: "No members or teams yet — add people to teams to plan capacity.",
        variance: "Variance",
        by_project: "By project",
        by_person: "By person",
        head_range: "{range} · EST {est}H · LOGGED {act}H · {pct}",
        section_project: "BY PROJECT · BAR = ACTUAL VS ESTIMATE",
        section_person: "BY PERSON · BAR = ACTUAL VS ESTIMATE",
        bar_hint: "Black line = estimate. Bar = logged.",
        drift_title: "WHERE ESTIMATES DRIFT MOST",
        driver_no_description: "Tasks with no description",
        driver_estimate_changed: "Tasks whose estimate was changed",
        driver_multi_assignee: "Tasks with more than one assignee",
        driver_large_estimate: "Tasks estimated at 2 days or more",
        largest_title: "LARGEST DELTAS",
        col_name: "TASK",
        col_project: "PROJECT",
        col_estimate: "EST",
        col_actual: "LOGGED",
        col_delta: "DELTA",
        takeaway: "✦ {project}'s {pct} is one task: \"{task}\", logged {actual} against a {estimate} estimate. Split it or make it a recurring overhead line.",
        takeaway_none: "✦ Nothing ran over its estimate in this window.",
        variance_empty: "No time logged in this window.",
        variance_own_only: "Showing only the time you logged",
        unknown_project: "No project",
        prev_month: "Previous month",
        next_month: "Next month",
        sort_hint: "Click a column to sort",
    },
    AiPreview: {
        title: "AI suggestion",
        replace: "Replace",
        insert: "Insert",
        copy: "Copy",
        copied: "Copied",
        retry: "Try again",
        cancel: "Cancel",
        working: "Working…",
    },
    NotesToTasks: {
        title: "Tasks from action items",
        reading: "Reading the action items…",
        create_n: "Create tasks ({n})",
        created: "Tasks created: {n}",
        undone: "Tasks moved to the trash: {n}",
        some_failed: "Items that could not be created: {n}",
        project: "Project",
        pick_project: "Choose a project",
        no_projects: "No project you can add tasks to",
        all_created: "Every action item is already a task.",
        none_found: "No action items found.",
        include: "Include “{title}”",
        task_title: "Task title",
        owner: "Owner",
        no_owner: "No owner",
        due: "Due date",
        due_said: "Mentioned: {text}",
    },
    TaskAi: {
        row_label: "AI for this task",
        ask: "Ask about this task",
        next_steps: "Suggest next steps",
        research: "Research this",
        ask_label: "Your question about this task",
        ask_placeholder: "What is blocking this? Who decided the pricing?",
        ask_submit: "Ask",
        ask_close: "Close",
        ask_scope: "Answers use this task, its comments, subtasks and linked docs you can open.",
        ask_empty: "Type a question first.",
        ask_sources: "Read",
        asking: "Reading this task…",
        steps_title: "Suggested next steps",
        steps_hint: "Untick any step you do not want.",
        add_checklist: "Add as checklist",
        add_subtasks: "Add as subtasks",
        checklist_name: "Next steps",
        checklist_added: "Added {n} step as a checklist. | Added {n} steps as a checklist.",
        subtasks_added: "Added {n} subtask. | Added {n} subtasks.",
        none_selected: "Tick at least one step.",
        research_title: "Research",
        research_sources: "Sources",
        add_comment: "Add as comment",
        comment_added: "Research added as a comment.",
        failed: "AI could not answer. Try again.",
        ai_off: "AI is turned off.",
        unconfigured: "No AI model is set up yet.",
        not_found: "This task is not available.",
    },
    AiSelection: {
        improve: "Improve with AI",
        turn_into_tasks: "Turn into tasks",
        panel_label: "AI for the selected text",
        selected: "Selected text",
        modes_label: "How to improve it",
        mode_rewrite: "Rewrite",
        mode_shorten: "Shorten",
        mode_expand: "Expand",
        mode_grammar: "Fix grammar",
        mode_translate: "Translate",
        language_label: "Translate into",
        language_placeholder: "Spanish",
        translate_submit: "Translate",
        cancel: "Cancel",
        improved_title: "Improved text",
        insert_below: "Insert below",
        replaced: "Selection replaced.",
        inserted: "Added below the selection.",
        selection_gone: "The selected text changed. Select it again.",
        tasks_title: "Tasks from the selection",
        tasks_hint: "Untick anything that is not a task.",
        list_label: "Create in",
        create_tasks: "Create {n} task | Create {n} tasks",
        tasks_created: "Created {n} task. | Created {n} tasks.",
        none_selected: "Tick at least one task.",
        working: "Working…",
        failed: "AI could not do that. Try again.",
    },
    UndoToast: {
        undo: "Undo",
        undo_hint: "Undo (Ctrl+Z or ⌘Z)",
        dismiss: "Dismiss",
    },
    AgentChange: {
        one: "{agent} changed {task}: {what}",
        one_unnamed: "{agent} made a change: {what}",
        many: "{agent} made {n} change | {agent} made {n} changes",
        many_mixed: "Your AI made {n} change | Your AI made {n} changes",
        show: "Show",
        undone: "Undone.",
        undone_some: "{done} of {n} changes were undone.",
        undo_failed: "That could not be undone.",
    },
    AdminOnly: {
        projects: "Only an admin can create projects. Ask {names} to create one or to change your role.",
        invite: "Only an admin can invite people. Ask {names} to invite them or to change your role.",
        an_admin: "an admin",
        either: "{first} or {second}",
    },
    AgentActions: {
        folder_create: "Make a folder",
        tag_create: "Add a tag to a project",
        list_sprint_set: "Give a list start and end dates",
        task_comment: "Add a comment",
        task_status_set: "Change the status",
        task_link: "Attach a link",
        task_assign: "Change who it is assigned to",
        task_update: "Edit the task",
        aifield_fill: "Fill in an AI field",
        task_sprint_move: "Move to another list",
        subtask_create: "Add a subtask",
        task_create: "Create a task",
        timelog_start: "Start a timer",
        timelog_stop: "Stop a timer",
        page_draft: "Draft a doc",
        chat_post: "Post a message in chat",
        reminder_create: "Set a reminder",
        deploy_staging: "Deploy to the test site",
        comment_create: "Add a comment",
        timelog_create: "Log time",
        task_edit: "Edit the task",
        task_assignees_set: "Change who it is assigned to",
        task_field_set: "Set a custom field",
        task_move: "Move to another list",
        task_archive: "Archive the task",
        task_restore: "Restore the task",
        task_status_change: "Change the status",
        task_add: "Create a task",
        subtask_add: "Add a subtask",
        comment_update: "Edit a comment",
        tasks_batch: "Make several changes together",
        page_create: "Create a doc",
        page_update: "Edit a doc",
        task_tags_add: "Add a tag",
        task_tags_remove: "Remove a tag",
        task_relation_add: "Link two tasks",
        task_relation_remove: "Unlink two tasks",
        list_create: "Create a list",
        list_rename: "Rename a list",
        list_move: "Move a list",
        page_comment_create: "Comment on a doc",
        page_comment_reply: "Reply to a comment on a doc",
        page_comment_assign: "Assign a comment on a doc",
        goal_target_set: "Update a goal's progress",
        goal_target_sources_add: "Count work toward a goal",
        goal_target_sources_remove: "Stop counting work toward a goal",
        task_lists_add: "Add to another list",
        task_lists_remove: "Take out of a list",
        slack_message_post: "Post a Slack message",
        automation_create: "Add an automation",
        project_create: "Create a project",
        project_duplicate: "Copy a project",
        project_setup: "Set up a project",
        queue_claim: "Take an item from the work queue",
        queue_release: "Give back an item from the work queue",
        fields_create: "Add custom fields",
        view_create: "Add a saved view",
        dashboard_card_add: "Add a card to a dashboard",
        timesheet_week_submit: "Send the timesheet week for approval",
        tasks_next: "Read the next assigned task",
        tasks_search: "Search tasks",
        task_get: "Read a task",
        docs_read: "Read a linked doc",
        performance_read: "Read a project's numbers",
        projects_list: "List projects",
        project_get: "Read a project",
        sprints_list: "List a project's lists",
        statuses_list: "List a project's statuses",
        views_list: "List a project's saved views",
        comments_list: "Read a task's comments",
        pages_search: "Search docs",
        page_get: "Read a doc",
        page_versions_list: "List a doc's versions",
        page_version_get: "Read an earlier version of a doc",
        timesheet_read: "Read time entries",
        timesheet_week: "Read where the timesheet week stands",
        fields_list: "List a project's custom fields",
        subtasks_list: "List a task's subtasks",
        members_list: "List members",
        task_history: "Read a task's history",
        task_links_list: "List a task's links",
        tags_list: "List a project's tags",
        task_relations_list: "List a task's linked tasks",
        lists_list: "List a project's lists and folders",
        page_comments_list: "Read a doc's comments",
        goals_list: "List goals",
        goal_get: "Read a goal",
        task_lists_list: "List the lists a task is in",
        slack_channel_read: "Read a Slack channel",
        automation_catalogue: "Read what an automation can do",
        person_me: "Check who it is working for",
        workdays_get: "Read the working days",
        task_fields_list: "Read a task's custom fields",
        chat_channels_list: "List chat channels",
        chat_messages_list: "Read chat messages",
        proposal_get: "Check on a proposal",
        pull_request_get: "Read a GitHub pull request",
        person_place: "Check where the person is working",
        queue_list: "List the work queue",
        screen_link: "Get a link to a screen"
    },
    TaskPanel: {
        dialog_label: "Task detail",
        action_items: "Action items ({n})",
        open_comment: "Go to the comment",
        open_in_desktop_tracker: "Open in desktop tracker",
        change_undone: "Change undone",
        tracker_start: "Start Tracker",
        tracker_start_accept: "Start tracking",
        tracker_working_on: "What are you working on?",
        tracker_comment_ph: "Add a comment for this session…",
        tracker_comment_required: "Please enter a comment",
        tracker_desktop_only: "Open this on a desktop with the AlianHub Tracker installed.",
        tracker_opening: "Opening the tracker…",
        tracker_task_incomplete: "Task details are incomplete to start the tracker.",
        tracker_open_failed: "Could not open the tracker.",
        story_points: "Story Points",
        story_points_updated: "Story points updated",
        story_points_not_updated: "Story points not updated",
        ai_estimate_generating: "Generating estimate…",
        ai_estimate_generating_label: "Generating estimate",
        ai_estimate_failed: "Could not generate estimate",
        ai_estimate_suggest: "Suggest",
        ai_estimate_suggest_hint: "Suggest an estimate with AI",
        ai_estimate_preview_title: "AI estimate",
        ai_estimate_apply: "Apply",
        ai_estimate_suggests: "AI suggests {time}",
        ai_estimate_range: "Likely between {low} and {high}",
        ai_estimate_reason: "AI estimate: {reasoning}",
        ai_estimate_undo_reason: "Undid the AI estimate",
        ai_estimate_applied: "Estimate set to {time}",
        ai_estimate_not_applied: "Could not apply the estimate",
        task_unavailable: "Task is not available",
        estimate_reason_title: "Reason for changing estimated hours",
        estimate_reason_ph: "Why are you changing the estimated hours?",
        estimate_reason_required: "Please enter a reason.",
        tray_label: "Minimized tasks",
        breadcrumb: "Task location",
        expand: "Expand",
        minimize: "Minimize to tray",
        close: "Close",
        untitled: "Untitled task",
        properties: "Properties",
        summary: "Summary",
        summary_meta: "from {n} comment · updated {time} | from {n} comments · updated {time}",
        summary_loading: "Reading the thread…",
        summary_failed: "Could not summarise this thread.",
        refresh_summary: "Refresh summary",
        summarise_thread: "Summarise this thread",
        summary_behind: "The thread has changed since this summary. Refresh it to bring it up to date.",
        description: "Description",
        subtasks: "Subtasks",
        files: "Files",
        relations_tab: "Relations",
        relations: "Relations",
        counts_toward: "Counts toward",
        counts_toward_goal: "{target}, a target of the goal {goal}, which is {pct}% reached",
        no_relations: "No relations yet — link a task",
        relations_note: "Gantt draws only blocks and waits on. \"Related\" is a reading aid and never moves a date.",
        activity: "Activity",
        comments: "Comments",
        history: "History",
        comment_placeholder: "Comment, {'@'}mention, /ai to draft…",
        send: "Send",
        ai_drafting: "Drafting with AI…",
        ai_default_intent: "Write a short status update for this task.",
        sprint: "List",
        type: "Type",
        tags: "Tags",
        tracking: "TRACKING",
        start_timer: "Start timer",
        pause: "Pause",
        resume: "Resume",
        stop_and_log: "Stop and log time",
        timer_log_description: "Timer",
        timer_assignee_only: "Only an assignee can track time on this task — assign yourself first.",
        timer_running_elsewhere: "A timer is already running on {key}. Starting here stops it.",
        timer_stopped_previous: "Stopped the timer on {key}",
        timer_logged: "Time logged",
        timer_too_short: "Timer under a minute — nothing logged",
        timer_task_done: "This task is done — reopen it to track time.",
        repeat: "Repeat",
        repeat_none: "Doesn't repeat",
        repeat_editor: "Repeat settings",
        repeat_no_permission: "You can't change this task's repeat.",
        repeat_frequency: "Repeats",
        repeat_daily: "Daily",
        repeat_weekly: "Weekly",
        repeat_monthly: "Monthly",
        repeat_every: "Every",
        repeat_unit_days: "day | days",
        repeat_unit_weeks: "week | weeks",
        repeat_unit_months: "month | months",
        repeat_on_days: "Repeat on",
        repeat_day_of_month: "Day of the month",
        repeat_ends: "Ends",
        repeat_ends_never: "Never",
        repeat_ends_on: "On",
        repeat_ends_after: "After",
        repeat_occurrences: "occurrences",
        repeat_when_open: "When the last one is still open",
        repeat_next: "Next: {dates}",
        repeat_no_next: "No more occurrences",
        repeat_hint: "Each occurrence creates a copy of this task. The project's Recurring tab lists this rule too.",
        repeat_pick_day: "Pick at least one day.",
        repeat_until_required: "Pick the end date.",
        repeat_save: "Save repeat",
        repeat_remove: "Stop repeating",
        repeat_cancel: "Cancel",
        repeat_saved: "Repeat saved",
        repeat_removed: "Repeat stopped",
        repeat_failed: "Could not save the repeat.",
        repeat_summary_daily: "Every day | Every {n} days",
        repeat_summary_weekly: "Weekly on {days} | Every {n} weeks on {days}",
        repeat_summary_monthly: "Monthly on day {day} | Every {n} months on day {day}",
        repeat_summary_until: "{rule}, until {date}",
        repeat_summary_times: "{rule}, {n} time | {rule}, {n} times",
        time: "Time",
        time_logged: "{logged} logged",
        time_logged_of: "{logged} of {estimate}",
        time_over: "{over} over the estimate",
        time_progress: "Time logged against the estimate",
        time_add: "Add time",
        time_edit: "Edit",
        time_edit_entry: "Edit time entry",
        time_delete_entry: "Delete time entry",
        time_confirm_delete: "Delete?",
        time_date: "Date",
        time_start: "Start",
        time_hours: "Hours",
        time_minutes: "Minutes",
        time_note: "Note",
        time_note_ph: "What did you work on?",
        time_billable: "Billable",
        time_save: "Save time",
        time_cancel: "Cancel",
        time_saved: "Time saved",
        time_deleted: "Time entry deleted",
        time_failed: "Could not save the time.",
        time_delete_failed: "Could not delete the time entry.",
        time_duration_required: "Enter a date and a duration above zero.",
        time_whole_numbers: "Enter whole hours from 0 to 23 and whole minutes from 0 to 59.",
        time_start_required: "Enter a start time.",
        time_past_midnight: "The entry has to end by midnight — pick an earlier start.",
        time_entries: "Time entries",
        time_no_entries: "No time logged yet",
        time_only_yours: "Showing your entries ({mine}); the total includes everyone's.",
        time_locked: "Locked — in an approved timesheet",
        time_running: "Running",
        time_tracker_entry: "From the desktop tracker",
        time_someone: "Someone",
        time_default_note: "Logged from the task",
        created_by: "Created {date} by {name}",
        watched_by: "watched by {n}",
        subtasks_rollup: "{done} of {total}",
        subtasks_hours_rollup: "{done} of {total}",
        subtask_keys_hint: "Enter adds the next subtask; Esc cancels.",
        no_subtasks_hint: "No subtasks yet — add the first step above.",
        subtask_children: "{done} of {total} subtasks done",
        subtask_depth_limit: "Subtasks go three levels deep, and this one is on the third.",
        parent_tasks: "Tasks above this one",
        agent: "Agent",
        agent_working: "Working on this task",
        agent_in_review: "Finished — waiting for review",
        agent_done: "Done",
        agent_failed: "Stopped with an error",
        agent_stop: "Stop",
        agent_tag: "AGENT",
        agent_stopped: "Run stopped.",
        agent_stop_failed: "That run could not be stopped.",
        agents_group: "Agents",
        agent_assigned: "{name} is starting on this task.",
        agent_assign_failed: "The agent could not start on this task.",
        my_ai: "My {name}",
        agent_handed: "Handed to {name}. The assignees stay as they are.",
        agent_hand_failed: "The task could not be handed to your AI.",
        agent_open_run: "View run",
        agent_open_proposal: "Review proposal",
        agent_outside_tag: "OUTSIDE AGENT",
        agent_activities: "Latest activity",
        agent_session_offered: "Delegated — waiting for the agent to start",
        agent_session_active: "Working on this task",
        agent_session_completed: "Finished",
        agent_session_failed: "Stopped with an error",
        agent_session_revoked: "Stopped — access was revoked",
        agent_session_unresponsive: "Did not start within ten seconds",
        agent_session_with_reason: "{state}: {reason}",
        agent_activity_thought: "Thinking",
        agent_activity_action: "Action",
        agent_activity_elicitation: "Question",
        agent_activity_response: "Answer",
        agent_activity_error: "Error",
        more_actions: "More actions",
        watchers: "Watchers ({n})",
        copy_title: "Copy task name",
        cancel_reply: "Cancel reply",
        nav_group: "Move through this view",
        nav_prev: "Previous task",
        nav_next: "Next task",
        nav_prev_hint: "Previous task (K)",
        nav_next_hint: "Next task (J)",
        nav_position: "{n} / {total}",
        copy_id: "Copy task ID {key}",
        copy_link: "Copy task link",
        complete: "Complete",
        complete_hint: "Move to {status}",
        reopen_hint: "Completed. Click to move back to {status}",
        quick_actions: "Quick actions",
        action_subtask: "Add subtask",
        action_relate: "Relate",
        action_relate_hint: "Link a related task or a dependency",
        action_checklist: "Checklist",
        action_checklist_hint: "Add a checklist",
        action_attach: "Attach",
        action_attach_hint: "Attach a file",
        relation_type: "Relation type",
        empty: "Empty"
    },
    AgentCatalogue: {
        close: "Close",
        builder_title: "Describe your new teammate",
        builder_placeholder: "For example: every morning, tell the Mobile app team which tasks are overdue or due in the next two days.",
        builder_hint: "AI drafts the setup. You review every step before anything is saved.",
        builder_draft: "Draft it",
        builder_drafting: "Drafting…",
        builder_off: "AI is turned off, so the builder is not available. Pick a template or start blank.",
        builder_no_model: "No AI model is set up yet, so the builder is not available. Pick a template or start blank.",
        draft_failed: "The draft could not be made. Try again or pick a template.",
        templates_title: "Or start from a template",
        search_placeholder: "Search templates",
        categories: "Template categories",
        category_all: "All",
        category_projects: "Projects",
        category_personal: "Personal",
        category_tasks: "Tasks",
        category_scheduling: "Scheduling",
        category_product: "Product & engineering",
        category_meetings: "Meetings",
        category_knowledge: "Knowledge",
        category_research: "Research",
        category_digests: "Digests",
        no_match: "No template matches. Try another word, or start blank.",
        team_filter: "Team",
        team_any: "Any team: show the templates",
        team_option: "{blueprint} · {team}",
        role_tools: "One tool | {n} tools",
        role_needs_key: "Needs a server key to run here; works now with your own AI.",
        role_open_packs: "Turn on as a team pack",
        role_open_packs_named: "Turn on {name} as part of a team pack",
        use: "Use template",
        use_named: "Use the {name} template",
        start_blank: "Start blank",
        browse_all: "Browse all templates",
        skills: "Skills",
        cadence_daily: "Runs daily",
        cadence_weekly: "Runs weekly",
        schedule_report: "runs the read-only {report} report on a schedule",
        schedule_in_settings: "add a schedule on the agent's page once it is at L3",
        schedule_on: "Run it on a schedule: {report}, {when}",
        schedule_on_hint: "Scheduling saves the agent at L3. The report runs as you, reads only what you can open, and writes nothing unless you allow it. Change or remove it on the agent's page.",
        need_rule: "an automation rule that starts it when a task is created",
        need_guide: "a project guide",
        need_mention: "a mention on the task",
        need_ai_field: "an AI field set up in the project",
        blocked_ai_fields: "Not available yet: needs AI fields.",
        blocked_mentions: "Not available yet: needs a skill that reads your mentions.",
        blocked_pages: "Not available yet: needs a skill that reads pages.",
        blocked_doc_drafting: "Not available yet: needs a skill that drafts documents.",
        blocked_unavailable: "Not available on this workspace: a skill it uses is turned off or missing.",
        why_adjusted_skills: "Left out skills this workspace does not have.",
        why_adjusted_actions: "Left out actions that do not exist or that only an owner or admin can add by hand.",
        why_adjusted_autonomy: "Starts at \"Suggests changes\": a person approves every change. You can raise it later.",
        why_adjusted_scope: "Kept to projects you can open.",
        why_adjusted_spendCap: "Capped at the limit for a new agent. You can change it.",
        tpl_status_reporter_name: "Status Reporter",
        tpl_status_reporter_about: "Posts a weekly digest of a project: what moved, what is stuck and what is at risk.",
        tpl_priorities_manager_name: "Priorities Manager",
        tpl_priorities_manager_about: "Reads the board and names what to look at first: overdue, blocked and due-soon work.",
        tpl_daily_briefing_name: "Daily Briefing",
        tpl_daily_briefing_about: "A short morning read on a project: open work, what is overdue and what needs you today.",
        tpl_work_breakdown_name: "Work Breakdown",
        tpl_work_breakdown_about: "Breaks a task's brief into subtasks with estimates and lists the open questions.",
        tpl_triage_new_tasks_name: "Triage New Tasks",
        tpl_triage_new_tasks_about: "Reads each new task's brief, asks what is unclear and suggests how to split it.",
        tpl_deadline_watch_name: "Deadline Watch",
        tpl_deadline_watch_about: "Flags overdue tasks and what is due in the next 48 hours, so nothing slips quietly.",
        tpl_release_notes_name: "Release Notes",
        tpl_release_notes_about: "Summarises the pull request linked to a task into a change note and flags risk.",
        tpl_qa_reviewer_name: "QA Reviewer",
        tpl_qa_reviewer_about: "Checks the page a task points to and files each defect as a subtask.",
        tpl_action_extractor_name: "Action Extractor",
        tpl_action_extractor_about: "Paste meeting notes into a task: it suggests the action items as subtasks and lists open questions.",
        tpl_task_insights_name: "Task Insights",
        tpl_task_insights_about: "Mention it on a task to get the next step, the reason for it and anything to flag, from the project's guide.",
        tpl_field_filler_name: "Field Filler",
        tpl_field_filler_about: "Fills a task's AI fields, such as a summary or a category, from the task's own text.",
        tpl_mentions_digest_name: "{'@'}Mentions Digest",
        tpl_mentions_digest_about: "Collects where you were mentioned and what is waiting on your reply.",
        tpl_wiki_upkeep_name: "Wiki Upkeep",
        tpl_wiki_upkeep_about: "Finds pages that have gone stale and suggests what to update.",
        tpl_prd_writer_name: "PRD Writer",
        tpl_prd_writer_about: "Drafts a product requirements document from a brief, as a page that stays a draft until approved."
    },
    Ai: {
        title: "AI",
        run_page_title: "Agent run",
        more: "More AI pages",
        agents: "AI Agents",
        agent: "Agent",
        inbox: "AI Inbox",
        skills: "Skill library",
        audit: "Audit log",
        group_setup: "Setup",
        usage_spend: "Usage & spend",
        agents_running: "{n} running",
        none_running: "No agents running",
        spend_of: "${used} of ${cap} this month",
        spend_month: "${used} this month",
        pause_all: "Pause all agents",
        loading: "Loading…",
        new_agent: "New agent",
        hub_lead: "Each agent is a set of skills, an allowed-action list and an autonomy level. Only the model is external — your data stays on your server.",
        empty_title: "No agents yet",
        empty_lead: "Start from a template. A new agent suggests changes for you to approve, and earns more freedom as you come to trust it.",
        open: "Open",
        run_now: "Run now",
        pause: "Pause",
        resume: "Resume",
        paused: "Paused",
        scope: "Projects",
        scope_lead: "Pick the projects this agent may change. With none picked it still reads, but every write is refused.",
        scope_none: "No project — reads only",
        scope_no_projects: "No projects to pick yet.",
        scope_projects_n: "{n} project | {n} projects",
        runs_when_started: "Runs when someone starts it",
        run_started: "{name} is running.",
        ladder: "Autonomy ladder",
        run_started_on: "{name} is running on {task}.",
        run_on_task: "Run {name} on a task",
        run_needs_task: "Every run works on one task. Pick the task this agent should look at.",
        find_task: "Find a task",
        find_task_hint: "Type a task key or a few words of its title",
        no_tasks_found: "No task matches that.",
        no_open_tasks: "No open task in this agent's projects.",
        starting: "Starting…",
        needs_line: "Needs: {what}",
        req_public_url: "a public URL in the task title or description (QA review)",
        req_pr_link: "a pull-request or branch link on the task (review)",
        req_brief: "a brief of at least 40 characters in the description (intake)",
        req_project_task: "any task in the project it should report on (digest)",
        req_linked_doc: "a document linked to the task",
        req_task: "a task to work on",
        close: "Close",
        remove: "Remove",
        none: "none",
        skill_new: "New skill",
        skill_new_title: "New skill",
        skill_edit_title: "Edit {name}",
        skill_show_retired: "Show retired",
        no_skills_title: "No skills yet",
        no_skills_body: "A skill says what an agent reads, what it asks the model, and what it may change. Write one and assign it to an agent — no deploy.",
        skill_source_yours: "Yours",
        skill_source_builtin: "Built in",
        skill_retired: "Retired",
        skill_unavailable: "Unavailable",
        skill_no_description: "No description yet.",
        skill_needs: "Needs {what}",
        skill_unresolved: "Not in the library",
        skill_dry_run: "Dry run",
        skill_dry_run_on: "Dry-run {name} on a task",
        skill_dry_run_title: "Dry run — {name}",
        skill_dry_run_lead: "What {task} would give this skill, and what it would ask. Nothing is written and no model is called.",
        skill_dry_run_note: "A dry run reads and renders only. The run itself still needs an agent, its allowed actions and your approval.",
        skill_dry_run_failed: "Could not dry-run this skill.",
        skill_risk_preview: "Risk and actions",
        skill_effective_actions: "This agent would allow: {list}",
        skill_outside_agent: "Outside the agent's allowed actions: {list}",
        skill_would_skip: "It would not start",
        skill_would_read: "What it would read",
        skill_would_ask: "What it would ask",
        skill_edit: "Edit",
        skill_retire: "Retire",
        skill_retire_confirm: "Agents and rules keep the key; the skill stops resolving and falls back to the built-in one, if there is one.",
        skill_retire_failed: "Could not retire this skill.",
        skill_save_failed: "Could not save this skill.",
        skill_editor_lead: "A skill is written in a closed vocabulary: the inputs it needs, what it reads, what it asks, and the actions it may emit. Nothing here runs as code.",
        skill_key: "Key",
        skill_key_hint: "team.standup",
        skill_name: "Name",
        skill_description: "Description",
        skill_model_pin: "Model",
        skill_model_inherit: "Whatever routing decides",
        skill_model_hint: "Pin a model for this skill only. A model with no price, or one whose provider is not configured, is refused here rather than at run time.",
        skill_risk_floor: "Risk floor",
        skill_risk_computed: "From the actions it emits",
        skill_risk_hint: "The actions it emits make this {risk}. A floor can only raise it.",
        skill_risk_now: "Risk from the actions: {risk}",
        skill_inputs: "What the task must carry",
        skill_inputs_hint: "A run skips when the task lacks one of these, with the reason on the run.",
        skill_gather: "What it reads first",
        skill_gather_hint: "Each reader is a call the engine already makes; the template reads its answer as {'{{'}gather.name.field{'}}'}.",
        skill_reader: "Reader",
        skill_gather_as: "Name",
        skill_gather_fields: "Fields: {fields}",
        skill_add_reader: "Add a reader",
        skill_partials: "Standing instructions",
        skill_instructions: "Instructions",
        skill_template: "The message it sends",
        skill_template_hint: "Task fields available: {fields}",
        skill_output: "The reply format it must follow",
        skill_emits: "What it may change",
        skill_emits_hint: "Each mapping turns part of the answer into one change. The agent's allowed actions still cut this down.",
        skill_each: "Repeat over",
        skill_each_hint: "answer.subtasks",
        skill_add_action: "Add an action",
        skill_summary: "How the run reads",
        skill_fallback: "What to post when the model says nothing",
        skill_fallback_hint: "Rendered from the gathered data alone, so a run still says what the board already knows. It cannot read the answer.",
        skill_grounded: "Hold the answer to the data",
        skill_grounded_hint: "Drops any sentence or item naming a task or a count the skill did not gather. Leave the first two empty to check nothing.",
        skill_grounded_keys: "Gathered task keys, e.g. gather.plan.keys",
        skill_grounded_numbers: "Gathered counts, e.g. gather.plan.counts",
        skill_grounded_fields: "Answer fields to check, comma separated",
        skill_grounded_must_name_key: "Answer lists that must name a gathered task",
        skill_grounded_allow_hours: "Hour windows the skill itself names, e.g. 24, 48",
        skill_enabled: "Available to agents",
        skill_read_lead: "This reader fetches from one host outside the workspace. The host must be on this workspace's egress allowlist, and it is checked again on every run.",
        skill_read_host: "Host",
        skill_read_host_placeholder: "api.example.com",
        skill_read_path_placeholder: "/repos/{'{{'}input.pr_link{'}}'}",
        skill_read_host_hint: "One exact host name, with a port when it is not 443. No scheme, path or wildcard.",
        skill_read_path: "Path",
        skill_read_path_hint: "Starts with a single \"/\". Each placeholder is filled from the task or a declared input and sent encoded as one value. Available: {placeholders}",
        skill_read_format: "Read the body as",
        skill_read_credential: "Credential",
        skill_read_credential_none: "None: read without a credential",
        skill_read_credential_hint: "A workspace read credential that names this host. Only its name and handle are shown here, never its value.",
        skill_read_credential_empty: "No read credential names {host}. An owner or admin adds one under Settings > Integrations > Secrets.",
        skill_read_caps: "Limits",
        skill_read_maxBytes: "Largest body, in bytes",
        skill_read_timeoutMs: "Time limit, in milliseconds",
        skill_read_maxRedirects: "Redirects followed",
        skill_read_cap_range: "From {min} to {max}",
        skill_read_chip_checking: "Checking the allowlist…",
        skill_read_chip_allowed: "On the allowlist",
        skill_read_chip_not_listed: "Not on the allowlist",
        skill_read_chip_not_declarable: "Not allowed as a declared host",
        skill_read_chip_unchecked: "Could not check the allowlist",
        skill_read_open_egress: "Add it under Instance > Egress",
        skill_read_ask_owner: "An instance owner adds hosts to the allowlist under Instance > Egress.",
        skill_read_host_invalid: "\"{host}\" is not a host name.",
        skill_read_host_address: "\"{host}\" is an address; declare a host name.",
        skill_read_host_private: "\"{host}\" is a private, local or internal host.",
        skill_read_host_scheme: "Declare the host alone, without a scheme such as https://.",
        skill_read_host_path: "Declare the host alone; the path goes in its own field.",
        skill_read_host_wildcard: "Declare one exact host, not a wildcard.",
        skill_read_host_port: "A port is between 1 and 65535.",
        skill_read_host_wildcard_dns: "\"{host}\" is under a wildcard-DNS service that answers with any address written into the name.",
        skill_read_err_host_not_allowed: "\"{host}\" is not on this workspace's egress allowlist. An instance owner adds it under Instance > Egress.",
        skill_read_err_invalid_path: "The path must start with a single \"/\" and hold no empty, \".\" or \"..\" segments, backslashes, spaces, control characters or \"#\".",
        skill_read_err_credential_invalid: "Choose a credential from the list; a secret value cannot be written here.",
        skill_read_err_credential_not_found: "That credential is not in this workspace.",
        skill_read_err_credential_wrong_kind: "That secret is not a read credential.",
        skill_read_err_credential_revoked: "That credential is revoked; choose a live one.",
        skill_read_err_credential_store_off: "The secrets store is off, so no credential can be chosen.",
        skill_read_err_credential_store_unavailable: "The secrets store could not be read, so the credential was not checked. Try again.",
        skill_read_err_credential_host_not_bound: "That credential may not be sent to this host. An owner or admin adds the host to it under Settings > Integrations > Secrets.",
        skill_read_err_allowlist_unreadable: "The workspace egress allowlist could not be read, so the declared reads were not checked. Try again.",
        skill_read_err_secret_in_body: "This looks like a secret. Keep it in a workspace secret and choose it as a read's credential.",
        skill_read_err_required: "Required.",
        skill_read_err_range: "Must be a number from {min} to {max}.",
        skill_read_link: "Read the task's link",
        skill_read_link_none: "None: build the URL from the host and path",
        skill_read_link_hint: "Reads the whole URL the task carries, in place of a path. The link must point at the host above or one of the other hosts; a link to any other host skips the run.",
        skill_read_link_none_declared: "To read a link from the task, tick one of these under \"What the task must carry\": {inputs}.",
        skill_read_hosts: "Other hosts",
        skill_read_hosts_hint: "Up to {max} more exact hosts this read may reach: where a redirect goes, or another host the task's link may point at. Each one is checked against the egress allowlist like the host above.",
        skill_read_hosts_placeholder: "other.example.com",
        skill_read_hosts_item: "Other host {n}",
        skill_read_hosts_remove: "Remove other host {n}",
        skill_read_hosts_add: "Add a host",
        skill_read_err_link_undeclared: "The skill does not ask the task for \"{input}\". Tick it under \"What the task must carry\", or choose another link.",
        skill_read_err_link_invalid: "This read cannot take that link; choose one from the list.",
        skill_read_err_hosts_max: "List at most {max} other hosts.",
        skill_read_err_path_or_link: "Give a path, or choose a link to read.",
        skills_effective_note: "The chips are what this agent would allow the skill to do: the skill's actions cut to the agent's allowed actions.",
        skills_open_library: "Open the skill library",
        available_actions_note: "Every action a skill may emit, and what the guard does with it.",
        no_runs_month: "No runs this month.",
        month_runs: "This month: {runs} run · ${usd} | This month: {runs} runs · ${usd}",
        paused_toast: "{name} paused.",
        resumed_toast: "{name} resumed.",
        all_paused: "All agents paused.",
        connected_paused: "Connected agents are paused",
        resume_connected: "Resume connected agents",
        connected_resumed: "Connected agents can work again. An agent made here stays paused until you resume it under AI Agents.",
        load_failed: "Could not load this page.",
        retry: "Try again",
        decision_failed: "That did not go through.",
        pause_failed: "The agent was not paused.",
        resume_failed: "The agent was not resumed.",
        stop_failed: "That run could not be stopped.",
        run_failed: "The run did not start.",
        save_failed: "The agent was not saved.",
        built_in_locked: "A built-in agent keeps its own settings. You can rename, pause or remove it.",
        delete_failed: "The agent was not deleted.",
        ladder_rule: "Money, production and deletes are always a human.",
        autonomy: "Autonomy",
        stop: "Stop",
        start_from: "Start from",
        no_template: "No template — pick actions yourself",
        autonomy_name_0: "Answers and suggests",
        autonomy_name_1: "Suggests changes",
        autonomy_name_2: "Acts, you approve the rest",
        autonomy_name_3: "Acts, also on a schedule",
        autonomy_about_0: "Reads and answers. Any change it finds waits in the AI Inbox for a person to approve.",
        autonomy_about_1: "Proposes every change. Nothing is written until a person approves it.",
        autonomy_about_2: "Makes low-risk, reversible changes to its own task directly. Anything riskier waits in the AI Inbox.",
        autonomy_about_3: "Acts like the level before, and may also run on a schedule without anyone starting it.",
        autonomy_tip: "Level {code}: {about}",
        never_label_project_delete: "Delete a project",
        never_label_task_delete: "Delete a task",
        never_label_billing: "Anything to do with billing",
        never_label_deploy_production: "Deploy to production",
        never_label_git_merge: "Merge code",
        never_label_member_remove: "Remove a member",
        never_label_permissions_edit: "Change permissions",
        never_label_status_set_done: "Mark a task Done",
        skill_label_brief_parse: "Break a brief into subtasks",
        skill_label_project_plan: "Plan the work in a brief",
        skill_label_pr_summary: "Summarise a pull request",
        skill_label_risk_flags: "Flag risks in a pull request",
        skill_label_digest_ceo: "Write a project digest",
        skill_label_risk_today: "Report today's risks",
        skill_label_project_guide: "Suggest what to do next",
        skill_label_qa_review: "Check a page for defects",
        skill_label_fields_fill: "Fill a task's AI fields",
        skill_label_prd_draft: "Draft a PRD from a brief",
        skill_label_wiki_upkeep: "Find pages that have gone stale",
        skill_label_slack_summary: "Summarise a Slack channel",
        action_label_task_sprint_move: "Move a task to another list",
        skill_about_slack_summary: "Reads the last day of one allowed Slack channel and proposes a one-paragraph summary to post back to it.",
        skill_about_brief_parse: "Reads a task brief and proposes subtasks with estimates, plus the open questions.",
        skill_about_project_plan: "Reads a task brief and proposes the plan as subtasks with estimates.",
        skill_about_pr_summary: "Reads the pull request a task links to, summarises the change and flags risk.",
        skill_about_risk_flags: "Reads the pull request a task links to and points out what could go wrong.",
        skill_about_digest_ceo: "Posts a short digest of the project: what moved, what is stuck, what is at risk.",
        skill_about_risk_today: "Posts what is at risk in the project today.",
        skill_about_project_guide: "Answers \"what next\" on a task from the project's guide and plan, and proposes the next tasks.",
        skill_about_qa_review: "Checks the page a task points to and files each defect as a subtask.",
        skill_about_fields_fill: "Picks the task's AI fields that are empty or out of date and fills each with its own prompt.",
        skill_about_prd_draft: "Reads a task brief and drafts a product requirements document as a page that stays a draft until approved.",
        skill_about_wiki_upkeep: "Lists the project's pages that are past their review date or months old, and suggests what each needs.",
        never_label: "Never available to any agent:",
        never_note: "These are not switches. They do not exist as actions, so a stolen token cannot reach them.",
        waiting: "Waiting",
        done_by_ai: "Done by AI",
        declined: "Declined",
        gate_chip: "Needs approval",
        gate_chip_owner_admin: "Needs an owner or admin",
        proposal_changes_on: "{skill} · {n} change on {on} | {skill} · {n} changes on {on}",
        proposal_findings_on: "File {n} QA finding on {on} | File {n} QA findings on {on}",
        proposal_first_and_more: "{label} and {n} more change | {label} and {n} more changes",
        proposal_untitled: "A change with no title",
        proposal_named: "{label}: “{name}”",
        back_to_waiting: "Back to Waiting",
        waiting_days: "Waiting {n} day | Waiting {n} days",
        sort_by: "Sort",
        sort_newest: "Newest first",
        sort_oldest: "Waiting longest first",
        pick_one: "Pick a proposal to see what it would change.",
        back_to_queue: "Back to the queue",
        why: "Why",
        what_changes: "What changes · {n} {unit} · {note}",
        action_one: "action",
        action_other: "actions",
        all_reversible: "all reversible",
        some_permanent: "some cannot be undone",
        not_reversible: "not reversible",
        drop: "Drop",
        gate_note: "This one needs an Owner or Admin. Production is never offered.",
        gate_locked: "Only an Owner or Admin can decide this one.",
        rights_locked: "You cannot approve this one, because you may not make this change yourself. It waits for someone who can.",
        decided_line: "{status} {at}",
        status_pending: "waiting",
        status_approved: "approved",
        status_edited: "approved with edits",
        status_declined: "declined",
        status_undone: "reverted",
        applied_with_failures: "Approved, but {n} change(s) could not be carried out: {error}",
        not_made_title: "Not made",
        not_made_line: "{name}: {why}",
        slack_post_title: "Slack message",
        slack_post_outside: "leaves the workspace",
        slack_post_channel: "Channel",
        slack_post_text: "Message",
        slack_post_note: "This is exactly what will be posted, as the workspace's Slack app. Nothing is sent until an Owner or Admin approves.",
        slack_post_sent: "Posted to Slack (message {ts}).",
        slack_post_failed: "Not posted: {error}",
        empty_done_title: "Nothing done by AI yet",
        empty_done_body: "Approved proposals show here once a person accepts one.",
        empty_declined_title: "Nothing declined",
        empty_declined_body: "Declined proposals show here. A decline is a normal outcome, not an error.",
        approve: "Approve",
        edit_then_approve: "Edit then approve",
        done_editing: "Done editing",
        decline: "Decline",
        applied: "Applied.",
        approved: "Approved",
        declined_done: "Declined.",
        undo: "Undo",
        open_made: "Open it",
        undone: "Reverted.",
        queue_clear: "Queue clear",
        queue_clear_body: "{approved} approved, {declined} declined. Nothing is waiting on you.",
        run_n: "run #{n}",
        cost_line: "{tokens} tokens · ${usd} · logged to audit",
        logged_to_audit: "Logged to audit",
        skills_actions: "Skills & allowed actions",
        role: "Role",
        role_lead: "The role this agent plays. The dispatcher hands a role's tasks to the least loaded agent that plays it.",
        role_none: "No role",
        role_hint: "Saved with the other settings. Changing it changes who receives routed work.",
        role_option: "{name} · {department}",
        skills_lead: "A skill is a playbook plus the short list of actions it may take. Nothing outside this list can ever run.",
        off: "off",
        low_risk_note: "Low risk = comment, nudge, status within a list, reports. Moves between lists and assignments still go to the AI Inbox.",
        project_may_be_stricter: "A project may be stricter than this. Its own settings can keep closing a task, or every change from a connected agent, for a person's approval.",
        runs_limits: "Runs & limits",
        runs_manual_note: "Runs start from a task, a mention or an assignment, and for an L3 agent also from a schedule below.",
        rate_limit: "Rate limit (actions per day)",
        rate_limit_hint: "0 means no daily limit.",
        spend_cap: "Spend cap (USD per month)",
        cap_hint: "The agent pauses itself at the cap.",
        model_pin: "Pinned model",
        model_pin_none: "Follow the workspace routing policy",
        model_pin_hint: "Every run of this agent uses the pinned model. Only models with a price on file can be pinned.",
        model_pin_empty: "No priced model is available on this instance yet, so this agent follows the workspace routing policy.",
        spent_this_month: "${usd} this month across {runs} runs",
        recent_audit: "Recent runs",
        no_runs: "This agent has not run yet.",
        run: "run",
        refused_n: "{n} refused",
        stop_agent: "Stop this agent",
        settings_read_only: "Read only. An owner or admin changes this agent's settings.",
        stopped: "Agent stopped.",
        delete_agent: "Delete agent",
        delete_body: "Removes the agent and its settings. Past runs, proposals and audit rows stay.",
        delete_blocked_open_runs: "Stop its open run before deleting this agent. | Stop its {n} open runs before deleting this agent.",
        delete_confirm_label: "Type {name} to confirm",
        deleted: "{name} deleted.",
        save: "Save",
        saving: "Saving…",
        saved: "Saved.",
        nothing_changed: "Nothing changed, so nothing was saved.",
        cancel: "Cancel",
        back: "Back",
        next: "Next",
        step_of: "Step {a} of {b}",
        job_name: "What is this agent's job?",
        job_desc: "Describe it in a sentence",
        job_desc_hint: "e.g. Post a standup every weekday and nudge stale tasks.",
        name_required: "Give the agent a name.",
        actions_lead: "Pick what it may do. You can widen this later — start narrow.",
        create_agent: "Create agent",
        creating: "Creating…",
        start_suggesting: "Start with an agent that suggests changes. Let it act on its own once you trust its work.",
        skills_library_lead: "Every action an agent can take in this workspace, and the ones it never can.",
        available_actions: "Available actions",
        action: "Action",
        what_it_does: "What it does",
        risk: "Risk",
        risk_level_medium: "Medium risk",
        risk_level_high: "High risk",
        undoable: "Undoable",
        yes: "Yes",
        no: "No",
        never_available: "Never available",
        cli_agents: "CLI coding agents",
        cli_lead: "Claude Code, Cursor, Codex and Antigravity can work with AlianHub through MCP using a personal token limited to chosen projects.",
        cli_tools: "Tools: {tools}",
        acts_preview_title: "What it will do without asking, once it may act",
        l2_preview_lead: "Read off this agent's allowed actions and each action's risk rating. Reads always run. A write runs on its own only when this agent is scoped to the project and the change can be undone, stays inside one task and moves no money; everything else goes to the AI Inbox first.",
        l2_acts: "Acts without asking",
        l2_proposes: "Proposes first",
        l2_none_act: "Nothing — every allowed write goes to the AI Inbox.",
        l2_none_propose: "Nothing — every allowed action is safe to run on its own.",
        l2_reason_read: "read only",
        l2_reason_safe: "reversible, one task, no money",
        l2_reason_irreversible: "cannot be undone",
        l2_reason_scope: "reaches beyond one task",
        l2_reason_money: "moves money",
        l2_reason_unrated: "not rated yet",
        run_details: "Details",
        hide_details: "Hide",
        run_status_queued: "Queued",
        run_status_running: "Running",
        run_status_waiting_approval: "Waiting for approval",
        run_status_done: "Done",
        run_status_skipped: "Skipped",
        run_status_failed: "Failed",
        run_status_stopped: "Stopped",
        run_status_abandoned: "Abandoned",
        decisions_title: "Decisions",
        no_decisions: "No decisions were recorded for this run.",
        decision_act: "acted",
        decision_propose: "proposed",
        decision_refuse: "refused",
        revert_run: "Revert this run",
        reverting: "Reverting…",
        reverted_chip: "Reverted",
        reverted_at: "Reverted {at}",
        reverted_count: "Reverted {n} action. | Reverted {n} actions.",
        revert_partial_count: "{n} action did not revert: | {n} actions did not revert:",
        undo_until: "Undo until {at}",
        undo_window_closed_at: "The undo window closed at {at}",
        undo_window_passed: "The undo window has passed.",
        revert_failed: "The run was not reverted.",
        run_load_failed: "Could not load this run."
        ,no_actions_title: "No actions registered",
        no_actions_body: "The server returned an empty action registry, so no agent can do anything yet.",
        decline_reason_title: "Why decline?",
        decline_reason_lead: "Optional. The agents learn from it, and three declines for the same reason become a suggestion in My Settings.",
        decline_reason_too_many_changes: "Too many changes",
        decline_reason_wrong_tone: "Wrong tone",
        decline_reason_needs_person: "Needs a person",
        decline_reason_not_now: "Not now",
        decline_reason_other: "Another reason",
        decline_reason_placeholder: "Or say it in your own words",
        decline_no_reason: "Decline without a reason",
        episode_title: "Outcome",
        episode_proposed: "proposed {n}",
        episode_acted: "acted {n}",
        episode_approved: "approved {n}",
        episode_declined: "declined {n}",
        episode_declined_reason: "declined {n} ({reason})",
        episode_reverted_yes: "reverted",
        episode_reverted_no: "not reverted",
        episode_waiting: "Continues when a person decides.",
        episode_not_reached: "Run ended before review",
        revisions_title: "Revision history",
        revisions_lead: "Every save is a numbered revision. A run pins the revision that was live when it started, so it can always name the configuration that produced it.",
        revisions_load_failed: "Could not load the revision history.",
        revision_promote_failed: "Could not promote the revision.",
        revision_rollback_failed: "Could not roll back.",
        revision_col_from: "From",
        revision_col_to: "To",
        revision_col_n: "Revision",
        revision_col_state: "State",
        revision_col_who: "Who / when",
        revision_col_what: "What changed",
        revision_pick_from: "Compare from revision {n}",
        revision_pick_to: "Compare to revision {n}",
        revision_state_draft: "draft",
        revision_state_candidate: "candidate",
        revision_state_live: "live",
        revision_state_superseded: "superseded",
        revision_promote: "Promote #{n} — replaces live #{live}",
        revision_rollback: "Roll back to #{n} — creates #{next} as a copy and makes it live",
        revision_promoted: "Revision {n} is live.",
        revision_rolled_back: "Rolled back to revision {n} as revision {live}.",
        revision_n: "#{n}",
        revision_nothing: "nothing",
        revision_by_system: "system",
        revision_what_first: "First revision",
        revision_what_same: "No run-affecting change",
        revision_what_changed: "Changed {fields}",
        revision_what_rollback: "Rolled back to #{n}",
        revision_diff_title: "Difference: {from} → {to}",
        revision_diff_none: "These revisions are identical.",
        revision_diff_field: "Field",
        revision_value_empty: "—",
        revision_value_true: "yes",
        revision_value_false: "no",
        revision_skill_off: "{key} (off)",
        run_pinned_title: "Pinned",
        run_revision: "Agent revision #{n}",
        run_revision_zero: "Before revisions (revision 0)",
        run_skill_identity: "{key} @ {hash}",
        run_skill_identity_n: "{key} revision {n}",
        run_skill_identity_nohash: "{key}",
        run_skill_source_code: "Built-in (code)",
        run_skill_source_seed: "Built-in (data)",
        run_skill_source_workspace: "Your workspace's copy (v{n})",
        failure_title: "Why it failed",
        failure_code: "Code",
        failure_provider: "Provider",
        failure_request_id: "Request ID",
        failure_copy_request_id: "Copy request ID",
        failure_request_id_copied: "Request ID copied",
        failure_type_rate_limit: "Rate limited",
        failure_type_quota: "Out of credits",
        failure_type_auth: "Invalid API key",
        failure_type_permission: "Access denied",
        failure_type_invalid_request: "Invalid request",
        failure_type_context_length: "Prompt too long",
        failure_type_content_filter: "Blocked by content filter",
        failure_type_not_found: "Model not found",
        failure_type_overloaded: "Provider overloaded",
        failure_type_server: "Provider error",
        failure_type_timeout: "Timed out",
        failure_type_network: "Network error",
        failure_type_unknown: "Unknown error",
        replay_title: "Replay",
        replay_policy: "Prompts and responses are redacted per the replay policy: email addresses, tokens and secrets are masked.",
        replay_loading: "Loading model calls…",
        replay_load_failed: "Could not load the replay.",
        replay_none: "No model calls were recorded for this run.",
        replay_call: "Call {n}",
        replay_tokens: "{input} in · {output} out",
        replay_cost: "{usd}",
        replay_cost_unpriced: "unpriced",
        replay_duration: "{ms} ms",
        replay_status_ok: "ok",
        replay_status_error: "error",
        replay_error_code: "Error code: {code}",
        replay_show: "Show the prompt and response",
        replay_hide: "Hide the prompt and response",
        replay_system: "System prompt",
        replay_system_empty: "No system prompt was sent.",
        replay_messages: "Messages",
        replay_passages: "Retrieved passages",
        replay_passages_empty: "No passages were retrieved for this call.",
        replay_response: "Raw response",
        replay_response_empty: "No response was recorded.",
        replay_truncated: "Content over 200 KB was cut.",
        replay_prompt_hash: "Prompt hash {hash}",
        replay_fetch_status: "HTTP {status}",
        replay_fetch_bytes: "{bytes} bytes",
        replay_fetch_hash: "Body sha256 {hash}",
        replay_fetch_show: "Show the fetched body",
        replay_fetch_hide: "Hide the fetched body",
        replay_fetch_hops: "Hops",
        replay_fetch_body: "Fetched body (redacted)",
        replay_fetch_body_empty: "The body was empty.",
        replay_fetch_truncated: "Only the first 32 KB of the body is kept; the hash covers all of it.",
        trace_title: "Trace",
        trace_copy: "Copy",
        trace_copy_label: "Copy the trace id",
        trace_copied: "Trace id copied.",
        trace_copy_failed: "The trace id could not be copied.",
        trace_view_replay: "View replay",
        trace_empty: "No steps were recorded for this run.",
        trace_kind_step: "step",
        trace_kind_tool: "tool call",
        trace_status_ok: "ok",
        trace_status_error: "error",
        trace_status_interrupted: "waiting",
        trace_status_pending: "pending",
        trace_status_applied: "applied",
        trace_status_failed: "failed",
        trace_status_refused: "refused",
        trace_decision_act: "acted",
        trace_decision_propose: "proposed",
        trace_decision_refuse: "refused",
        trace_decision_approved: "approved",
        trace_decision_declined: "declined",
        trace_decision_edited: "edited",
        trace_decision_undone: "undone",
        trace_duration_ms: "{n} ms",
        trace_duration_s: "{n} s",
        trace_tokens: "{n} token | {n} tokens",
        trace_cost: "${usd}",
        schedule_title: "Schedule",
        schedule_needs_l3: "Only an agent at L3 can run on a schedule. Set its autonomy to L3 and save, then add a schedule here.",
        schedule_lead: "The agent runs a read-only report on this rhythm and puts it in the Inbox of the person it runs as. It reads only what that person can open.",
        schedule_empty: "No schedules yet.",
        schedule_runs_as_you: "Runs as you",
        schedule_runs_as_other: "Runs as someone else",
        schedule_email_on: "Also emailed",
        schedule_email_no_mail: "Email is not set up on this server",
        schedule_comment_on: "Posts a comment",
        schedule_comment_read_only: "Comment off: the agent may not comment",
        schedule_page_on: "Drafts a page",
        schedule_page_read_only: "Page off: the agent may not draft pages",
        schedule_last_open: "Open the last run",
        schedule_pause: "Pause",
        schedule_resume: "Resume",
        schedule_edit: "Edit",
        schedule_remove: "Remove",
        schedule_report: "Report",
        schedule_every: "How often",
        schedule_every_option_daily: "Every day",
        schedule_every_option_weekdays: "Monday to Friday",
        schedule_every_option_weekly: "Once a week",
        schedule_weekday: "Day",
        schedule_weekday_0: "Sunday",
        schedule_weekday_1: "Monday",
        schedule_weekday_2: "Tuesday",
        schedule_weekday_3: "Wednesday",
        schedule_weekday_4: "Thursday",
        schedule_weekday_5: "Friday",
        schedule_weekday_6: "Saturday",
        schedule_at: "Time",
        schedule_timezone: "Time zone",
        schedule_timezone_hint: "A time zone name such as Europe/Berlin. It starts as yours.",
        schedule_days: "Days ahead",
        schedule_deliver: "Deliver to",
        schedule_deliver_inbox: "The Inbox of the person it runs as, always.",
        schedule_deliver_email: "Also email it, when this server can send email",
        schedule_deliver_task: "Post as a comment on a task",
        schedule_task_chosen: "A task is chosen",
        schedule_task_none: "No task",
        schedule_pick_task: "Choose a task",
        schedule_pick_task_cta: "Use this task",
        schedule_task_clear: "Clear",
        schedule_deliver_page: "Draft a page in a project",
        schedule_page_none: "No page",
        schedule_writes_note: "A comment or a page is a write. It happens only when the agent's allowed actions include it; otherwise the report stays read-only.",
        schedule_shared_scope_note: "Posted to a task or a page, the report only includes what its readers can see: that project, without private lists, and without the summary written from your wider view.",
        schedule_save: "Save schedule",
        schedule_add: "Add a schedule",
        schedule_save_failed: "The schedule could not be saved.",
        schedule_error_report: "Choose a report.",
        schedule_error_every: "Choose how often it runs.",
        schedule_error_time: "Enter a time as HH:MM.",
        schedule_error_timezone: "Enter a time zone name such as Europe/Berlin.",
        schedule_error_weekday: "Choose a day of the week.",
        schedule_error_days: "Days ahead must be a whole number from 1 to 30.",
        schedule_error_task: "That task cannot be used.",
        schedule_every_daily: "Every day at {at} ({zone})",
        schedule_every_weekdays: "Monday to Friday at {at} ({zone})",
        schedule_every_weekly: "Every {day} at {at} ({zone})",
        schedule_off: "Paused: it will not run",
        schedule_next_unknown: "Next run not worked out yet",
        schedule_next_run: "Next run {when}",
        schedule_never_ran: "Has not run yet",
        schedule_result_done: "Last run delivered",
        schedule_result_failed: "Last run failed",
        schedule_result_skipped: "Last run skipped",
        schedule_result_missed: "Last run missed",
        schedule_result_deduplicated: "Last run already delivered",
        report_daily_briefing: "Daily briefing",
        report_deadline_watch: "Deadline watch",
        report_mentions_digest: "{'@'}mentions digest",
        report_weekly_status: "Weekly status",
        report_daily_briefing_about: "Your tasks due today, overdue work, new assignments and mentions since yesterday.",
        report_deadline_watch_about: "Tasks due in the next few days and tasks at risk, across the projects you can open.",
        report_mentions_digest_about: "Mentions from the past week you have not replied to yet.",
        report_weekly_status_about: "Per project: done this week, in progress, blocked and slipped.",
        reports_tab: "Reports",
        reports_empty_title: "No reports yet",
        reports_empty_body: "Reports from scheduled agents that run as you appear here.",
        reports_empty_action: "See AI teammates",
        report_pick_one: "Pick a report to read it.",
        report_no_summary: "No summary this time; the facts are below.",
        report_section_due_today: "Due today",
        report_section_overdue: "Overdue",
        report_section_new_assignments: "New assignments",
        report_section_mentions: "Mentions",
        report_section_due_soon: "Due in the next {days} days",
        report_section_at_risk: "At risk",
        report_section_unanswered: "Waiting for your reply",
        report_section_project: "Project",
        report_section_empty: "Nothing here.",
        report_project_counts: "{done} done · {in_progress} in progress · {blocked} blocked · {slipped} slipped",
        report_days_late: "{n} day late | {n} days late",
        report_reason_overdue: "Overdue",
        report_reason_blocked: "Blocked",
        report_reason_stalled: "Not started",
        report_reason_slipped: "Slipped",
        report_more: "and {n} more | and {n} more",
        report_channel_inbox: "Inbox",
        report_channel_email: "email",
        report_channel_comment: "a task comment",
        report_channel_page: "a draft page",
        report_delivered_to: "Delivered to {list}."
    },
    AiProject: {
        title: "Create project with AI",
        step_describe: "Describe",
        step_clarify: "Clarify",
        step_brief: "Brief",
        step_plan: "Review plan",
        step_create: "Create",
        describe_label: "What is the project about?",
        min_chars: "{count} / {min} minimum characters",
        source_required: "Choose a source to continue — every project records where it came from.",
        continue: "Continue →",
        analyzing: "Analyzing your brief…",
        analyzing_sub: "Checking which of the five points your description already covers.",
        coverage_title: "What the brief already covers",
        coverage_met: "Covered",
        coverage_missing: "Missing",
        point_what_for_whom: "What and for whom",
        point_done_when: "Done when",
        point_existing: "What already exists",
        point_constraints: "Constraints",
        point_team: "Team",
        round_of: "Round {round} of {max} · only the missing points are asked",
        unknown_yet: "I don't know yet",
        unknown_hint: "\"I don't know yet\" and skipped questions become stated assumptions in the brief and the plan.",
        brief_title: "Your brief, drafted",
        brief_lead: "Edit the draft until it says what you mean. The plan is built from the approved text only.",
        brief_original: "Original description",
        brief_draft: "Drafted brief",
        brief_drafting: "Drafting the brief…",
        brief_drafting_sub: "Rewriting your description and answers into the five points. This takes a moment.",
        brief_failed: "Couldn't draft the brief",
        brief_skip: "Skip and plan from the description",
        brief_redraft: "Redraft",
        approve_brief: "Approve brief",
        brief_approved: "Brief approved",
        brief_reapprove: "You edited the brief after approving it — approve it again to generate the plan.",
        generate_plan: "Generate plan",
        generating_plan: "Generating project plan…",
        generating_plan_sub: "Building your lists and tasks — usually 15–30 seconds. Please wait.",
        assumptions_title: "Assumptions",
        assumptions_lead: "Stated where a question was skipped or answered \"I don't know yet\".",
        no_assumptions: "No assumptions — every point was answered.",
        split_agent: "Agent",
        split_agent_after: "Agent after: {need}",
        split_person: "Person",
        split_summary: "{agent} tasks an agent can start · {person} need a person · {agentAfter} need a person first",
        guide_title: "Project guide",
        guide_lead: "A Guide agent is created with these instructions. Mention it on any task in the project to get the clearest next step.",
        guide_loading: "Drafting the project guide…",
        guide_failed: "Couldn't draft the guide",
        guide_stages: "Stages",
        guide_essentials: "Essentials to flag",
        guide_escalations: "Escalations",
        guide_edit: "Edit guide instructions",
        try_again: "Try again",
        back: "← Back",
        rules_title: "Automations",
        rule_off: "Off until you switch it on",
        rules_dropped_title: "Automations left out of the plan",
        rules_made_title: "Automations added, switched off",
        rules_turn_on: "Turn them on in Automations when you are ready.",
        rules_not_made_title: "Automations not added",
        rule_note: "{name} — {reason}",
        rule_reason_too_many: "a plan holds at most {n} automations",
        rule_reason_steps: "it has more steps than a starter automation may have",
        rule_reason_name_missing: "it has no name",
        rule_reason_trigger: "it starts from something an automation here cannot start from",
        rule_reason_step: "it does something only a person can set up, such as sending an email",
        rule_reason_fit: "it names a status or a person this project does not have",
        rule_reason_admin: "only an owner or an admin can add automations",
        rule_reason_permission: "you may not add automations to this project",
        rule_reason_off: "automations are switched off on this server",
        rule_reason_other: "it could not be added",
        runs_queued: "{n} agent run queued | {n} agent runs queued",
        runs_refused_title: "Not queued — needs a person",
        open_guide_agent: "Open the Guide agent →",
        views_title: "Views",
        keep_one_list: "Keep at least one list ticked.",
        left_out: "Left out",
        views_dropped_title: "Left out of the plan",
        views_made_title: "Views made",
        views_not_made_title: "Views not made",
        dashboard_dropped_name_missing: "The dashboard was left out of the plan: it had no name.",
        dashboard_dropped_no_cards: "The dashboard “{name}” was left out of the plan: none of its cards can be added as they are.",
        dashboard_made_shared: "Dashboard “{name}” made, shown to everyone on the project.",
        dashboard_made_private: "Dashboard “{name}” made, private to you.",
        dashboard_not_made: "Dashboard “{name}” was not made. You can add one under Dashboards.",
        view_kind_list: "List",
        view_kind_board: "Board",
        view_kind_table: "Table",
        view_kind_calendar: "Calendar",
        view_kind_workload: "Workload",
        view_reason_permission: "You may not add views to this project.",
        view_reason_name_taken: "Another view already has this name.",
        view_reason_name_missing: "The view had no name.",
        view_reason_look: "Its grouping, sorting or filters could not be used.",
        view_reason_kind: "This kind of view is not available.",
        view_reason_too_many: "A plan can hold at most {n} views.",
        view_reason_no_source: "The project has no tab of this kind to start from.",
        view_reason_other: "The view could not be made.",
        open_project: "Open project →",
        all_done: "All done!",
        building: "Building your project…",
        starting: "Starting…",
        create_everything: "✓ Create everything",
        describe_placeholder: "e.g. \"A 3-month SaaS launch for a 5-person team building an invoicing tool with Stripe billing. Kanban workflow. GitHub + Slack integrations. MVP in 6 weeks; full launch in 12.\"",
        workspace_label: "Workspace",
        workspace_hint: "Choose who can see this project once it's created.",
        privacy_public: "Public",
        privacy_public_sub: "Everyone in the workspace can view",
        privacy_private: "Private",
        privacy_private_sub: "Only you and invited members",
        attach_brief: "Attach a brief",
        attach_hint: "PDF, DOCX, TXT, or MD — up to 10 MB.",
        reading_file: "Reading file…",
        remove: "Remove",
        choose_file: "Click to choose a file",
        retry_hint: "Click {action} again — the AI will retry from your description.",
        regenerate_plan: "Re-Generate Plan",
        regenerate_questions: "Re-Generate Questions",
        next: "Next →",
        sprint_count: "{n} list | {n} lists",
        task_count: "{n} task | {n} tasks",
        token_count: "{n} token | {n} tokens",
        usage_split: "{input} in · {output} out",
        usage_no_price: "no price on file for this model",
        task_description: "Description",
        progress_project: "Project",
        progress_sprints: "Lists",
        progress_tasks: "Tasks",
        status_done: "Done",
        status_in_progress: "In progress",
        status_pending: "Pending",
        error_title: "Something went wrong",
        unknown_error: "Unknown error",
        rolled_back: "All partial creates have been rolled back.",
        close: "Close",
        back_to_plan: "Back to plan",
        upload_failed: "Brief upload failed",
        plan_failed: "Plan generation failed. Please try again.",
        plan_empty: "The AI did not return a plan. Please try again.",
        plan_expired: "This plan has expired. Generate it again.",
        generate_again: "Generate again",
        plan_in_use: "This plan is already being built. Wait for it to finish.",
        plans_busy: "Your last plans are all being built. Wait for one to finish, then generate again.",
        execute_failed: "Execution failed",
        clarify_failed: "Couldn't draft clarifying questions",
        clarify_skip_all: "Skip and generate plan",
        required: "Required",
        recommended: "Recommended",
        other: "Other",
        other_placeholder: "Type your own answer here",
        custom_placeholder: "Type your answer here",
        text_placeholder: "Type your answer here…",
        option_yes: "Yes",
        option_no: "No",
        previous: "Previous",
        back_plain: "Back",
        let_ai_decide: "Let AI decide",
        skip: "Skip",
        clarify_next: "Next",
        key_enter: "Enter",
    },
    AiTask: {
        plan_expired: "This plan has expired. Generate it again.",
        plan_in_use: "These items are already being created. Wait for it to finish.",
        title: "Plan with AI",
        subtitle: "Draft lists and tasks for this project from your requirements — you review before anything is created.",
        close: "Close",
        mode_full: "Lists + tasks",
        mode_tasks: "Tasks only",
        mode_sprints: "Lists only",
        no_sprints_hint: "This project has no lists yet — create a list first",
        target_sprint: "Add tasks to list",
        input_label_tasks: "What tasks should I add?",
        input_label_sprints: "What lists should I create?",
        input_label_full: "What should this project include?",
        placeholder_tasks: "e.g. Add the sign-in API calls — login, signup, refresh, logout — each with validation and tests.",
        placeholder_sprints: "e.g. Break this project into delivery phases: setup, core features, polish, and launch.",
        placeholder_full: "e.g. Build a customer onboarding flow — signup, email verification, profile setup, and a welcome dashboard. Node + Vue.",
        try: "Try:",
        example_shopify: "Shopify store",
        example_shopify_prompt: "Build a Shopify clothing store: home, collection, product, cart and checkout pages, plus store policies and theme setup.",
        example_mobile: "Mobile app MVP",
        example_mobile_prompt: "Mobile app MVP: onboarding, signup/login, home feed, profile and settings — design + build per screen, with the supporting API calls.",
        example_api: "REST API",
        example_api_prompt: "REST API for a tasks service: sign-in and sign-up calls and full CRUD for tasks and projects, with validation and tests.",
        example_marketing: "Marketing campaign",
        example_marketing_prompt: "Marketing launch campaign: landing page, email sequence, social content calendar and analytics setup.",
        advanced: "Advanced (optional)",
        opt_subtasks: "Break tasks into sub-tasks",
        opt_links: "Link related tasks",
        opt_epics: "Organize into epics",
        cancel: "Cancel",
        generate_tasks: "Generate tasks",
        generate_sprints: "Generate lists",
        generate_plan: "Generate plan",
        progress_label: "{label}…",
        generating: "Generating…",
        generating_sub: "This can take up to a minute for a detailed plan.",
        review_hint: "Review — uncheck anything you don't want.",
        selected: "{n} selected",
        token_count: "{n} token | {n} tokens",
        usage_split: "{input} in · {output} out",
        usage_no_price: "no price on file for this model",
        links_note: "{n} task link will be created | {n} task links will be created",
        epics_note: "{n} epic will be created | {n} epics will be created",
        fields_note: "{n} custom field will be created | {n} custom fields will be created",
        adding_to: "Adding to: {sprint}",
        sprint_fallback: "list",
        back: "Back",
        create_tasks: "Create {n} task | Create {n} tasks",
        create_sprints: "Create {n} list | Create {n} lists",
        creating: "Creating…",
        creating_sprints: "Creating lists…",
        creating_tasks: "Creating tasks… {done}/{total}",
        empty_plan: "The AI did not return anything. Try rephrasing your requirements.",
        generate_failed: "Generation failed. Please try again.",
        start_failed: "Could not start creation.",
        create_failed: "Creation failed. Please try again.",
        task_count: "{n} task | {n} tasks",
        sprint_count: "{n} list | {n} lists",
        success_tasks: "Created {n} task with AI | Created {n} tasks with AI",
        success_sprints: "Created {n} list with AI | Created {n} lists with AI",
        success_full: "Created {tasks} in {sprints} with AI",
    },
    BulkActions: {
        move_denied: "No permission to move",
        convert_subtask_title: "Make selected tasks subtasks of one task",
        convert_task_title: "Promote selected subtasks to tasks",
        convert_denied: "No permission to convert",
        clear_selection: "Clear selection",
        result_skipped: "{n} skipped ({reason})",
        result_failed: "{n} failed",
        reason_permission: "insufficient permission",
        reason_not_found_or_cross_tenant: "not found or access denied",
        reason_project_not_found: "project not found",
        reason_invalid_id: "invalid id",
        reason_invalid_type: "invalid operation",
        reason_already_in_target: "already there",
        reason_is_the_chosen_parent: "it is the parent you chose",
        reason_already_a_subtask_of_this_parent: "already a subtask of that task",
        reason_carried_with_its_parent: "carried by a selected task above it",
        reason_subtree_too_deep: "its subtasks would go past the third level",
        reason_parent_at_max_depth: "that parent is already on the third level",
        reason_parent_is_descendant: "a task cannot go under its own subtask",
        result_failed_reason: "{n} failed ({reason})",
        reason_already_a_top_level_task: "already a task, not a subtask",
        reason_subtask_moves_with_its_parent: "a subtask moves with its parent — use Convert to Task or Convert to Subtask",
        reason_skipped: "skipped",
        subtask_moves_hint: "A subtask moves with its parent — use Convert to Task or Convert to Subtask",
    },
    Trash: {
        title: "Trash",
        lead: "Deleted work stays here until you restore it. Nothing is removed for good.",
        projects: "Projects",
        folders: "Folders",
        lists: "Lists",
        tasks: "Tasks",
        docs: "Docs",
        col_name: "Name",
        col_project: "Project",
        col_when: "Deleted",
        restore: "Restore",
        restore_named: "Restore {name}",
        restored: "Restored.",
        restore_failed: "Could not restore that item.",
        load_failed: "Could not load the trash.",
        empty_title: "Nothing in the trash",
        empty_message: "Deleted {kind} will show up here.",
        empty_projects: "projects",
        empty_folders: "folders",
        empty_lists: "lists",
        empty_tasks: "tasks",
        empty_docs: "docs",
        loading: "Loading…",
        unknown_project: "—"
    },
    List: {
        unread_comments: "{count} unread comments",
        col_task: "Task",
        col_assignee: "Assignee",
        col_due: "Due",
        col_priority: "Priority",
        col_est: "Est",
        col_risk: "Risk",
        col_owner: "Owner",
        col_summary: "Summary",
        col_area: "Area",
        col_tags: "Tags",
        sort_by: "Sort by {column}",
        toggle_subtasks: "Show subtasks",
        tracking_now: "Tracking now",
        agent_working: "working on this",
        wip: "In progress {used}/{limit}",
        sprint_total_hint: "Every task in this list, subtasks included. Reports and the burndown count parent tasks only.",
        add_task_to: "Add task to {group}…",
        group_empty: "Nothing in this group yet.",
        group_total: "Total",
        group_total_of: "Sum of {field}: {value}",
        select_group: "Select every task in this group",
        select_group_loaded: "Select the {n} loaded tasks in this group ({total} in all)",
        load_more: "Load more ({n} left)",
        loading_more: "Loading…",
        load_more_sorted: "Only the {n} loaded tasks are sorted.",
        select_task: "Select {name}",
        select_subtask: "Select subtask {name}",
        selected: "{n} selected",
        status: "Status",
        assignee: "Assignee",
        sprint: "List",
        tags: "Tags",
        ask_ai: "Ask AI to…",
        esc: "Esc",
        bulk_region: "Bulk task actions",
        bulk_no_options: "Nothing to choose from here.",
        bulk_failed: "That bulk change did not go through.",
        bulk_done: "Updated {n} task. | Updated {n} tasks.",
        bulk_undo: "Undo",
        bulk_undone: "Change undone.",
        bulk_undo_failed: "That change could not be undone.",
        bulk_due_pick: "Pick a date…",
        bulk_due_clear: "Clear due date",
        bulk_move_project: "Another project…",
        bulk_convert: "Convert",
        bulk_more: "More",
        bulk_no_subtasks: "Select a subtask to turn it into a task.",
        ai_summarise: "Summarise the selected tasks",
        ai_scope_note: "Runs on up to 10 tasks at a time.",
        ai_unavailable: "AI is not set up for this workspace.",
        ai_summarised: "Summarised {n} task. | Summarised {n} tasks.",
        ai_loading: "Summarising…",
        ai_nothing_to_summarise: "No discussion yet — nothing to summarise",
        ai_not_configured: "AI is not set up",
        ai_generate: "Generate",
        ai_generate_rows: "Generate for {n} row | Generate for {n} rows",
        ai_generate_rows_hint: "Asks AI once for each row shown that has no value yet, at most 50 at a time.",
        ai_generate_rows_confirm: "This asks AI once for this task, and it counts toward the workspace AI spend. | This asks AI once for each of {n} tasks, and each one counts toward the workspace AI spend.",
        ai_regenerate: "Regenerate",
        ai_regenerate_hint: "Ask AI for this value again",
        ai_from: "from {time}",
        ai_from_hint: "The task has changed since this was written. Regenerate to bring it up to date.",
        ai_pin: "Pin",
        ai_unpin: "Unpin",
        ai_pinned: "Pinned",
        ai_source: "summary · updated {time}",
        ai_fields_note: "✦ fields are generated from the task thread and saved.",
        ai_source_hint: "✦ values are written by AI when you ask for them, and kept. Hover a cell to see when it was written, to pin it or to write it again.",
        not_generated: "Not generated",
        area_hint: "No category model is configured, so this field has no value to show.",
        risk_low: "Low",
        risk_med: "Med",
        risk_high: "High",
        risk_none: "Nothing at risk here",
        risk_score: "Risk {score}",
        risk_formula: "Risk adds up late work, time stuck, time over the plan, quiet days and unfinished subtasks.",
        risk_factor_overdue: "Late by {days} days",
        risk_factor_blocked: "Stuck, and quiet for {days} days",
        risk_factor_burn: "{pct}% more time than planned",
        risk_factor_silence: "No updates for {days} days",
        risk_factor_subtasks: "Only {done} of {total} subtask finished | Only {done} of {total} subtasks finished",
        due_group_overdue: "Overdue",
        due_group_today: "Today",
        due_group_tomorrow: "Tomorrow",
        due_group_this_week: "This week",
        due_group_later: "Later",
        due_group_none: "No due date",
        col_select: "Select",
        due_date: "Due date",
        priority: "Priority",
        cell_change: "{field}: {value}, change",
        cell_set: "{field}: none, set",
        cell_value: "{field}: {value}",
        cell_none: "{field}: none",
        status_group_todo: "To do",
        status_group_active: "Active",
        status_group_done: "Done",
        rename_label: "Task name",
        action_rename: "Rename {name}",
        action_subtask: "Add a subtask to {name}",
        action_copy_link: "Copy the link to {name}",
        action_new_tab: "Open {name} in a new tab",
        action_menu: "More actions for {name}",
        menu_rename: "Rename",
        menu_subtask: "Add subtask",
        menu_copy_link: "Copy link",
        menu_copy_key: "Copy task ID",
        menu_new_tab: "Open in new tab",
        menu_open: "Open task",
        menu_archive: "Archive",
        menu_delete: "Delete",
        menu_move: "Move to project…",
        menu_duplicate: "Duplicate",
        menu_duplicate_subtasks: "Duplicate with subtasks",
        copy_of: "Copy of {name}",
        row_archived: "Task archived.",
        row_restored: "Task restored.",
        row_deleted: "Task moved to the trash.",
        row_moved: "Task moved to {project}.",
        row_duplicated: "Created “{name}”.",
        sort: "Sort",
        sort_title: "Sort tasks by",
        sort_order: "Order",
        sort_asc: "Ascending",
        sort_desc: "Descending",
        sort_drag_off: "Sorted, so dragging is off. Choose Manual to reorder.",
        sort_manual: "Manual",
        sort_due: "Due date",
        sort_priority: "Priority",
        sort_created: "Created",
        sort_updated: "Updated",
        sort_name: "Name",
        sort_status: "Status",
        sort_assignee: "Assignee",
        sort_points: "Points",
        sort_estimate: "Estimate",
        sort_fields: "Custom fields"
    },
    ViewGroups: {
        no_value: "No value",
        number_below: "Below {to}",
        number_between: "{from} to {to}",
        number_from: "{from} and above",
        number_any: "Has a value",
        has_value: "Has a value",
        checked: "Checked",
        unchecked: "Not checked",
        date_past: "Past",
    },
    ViewColumns: {
        title: "Columns",
        card_fields: "Card fields",
        none: "There are no columns to choose from.",
        field_badge: "Field",
        move_up: "Move {name} up",
        move_down: "Move {name} down",
        reset: "Reset to default",
        col_start: "Start",
        col_points: "Points",
        col_created: "Created",
        col_updated: "Updated",
        points_total: "{n} pts",
        points_none: "–",
        field_none: "None",
        field_invalid: "That is not a valid value for {field}.",
        estimate_label: "Estimate",
        estimate_placeholder: "1h 30m",
        estimate_undo_reason: "Undid an estimate change from the task list.",
        field_not_for_type: "{field} is not used for this task type"
    },
    ViewDensity: {
        title: "Row density",
        comfortable: "Comfortable",
        compact: "Compact"
    },
    Views: {
        desktop_only_title: "Open this on a desktop",
        desktop_only_gantt: "The Gantt chart needs a wider screen. Open the project on a desktop to plan dates and dependencies.",
        desktop_only_workload: "Workload needs a wider screen. Open the project on a desktop to balance the week.",
        desktop_only_forms: "The form builder needs a wider screen. Open it on a desktop to edit fields and rules.",
        today: "TODAY",
        close: "Close",
        review: "Review",
        remove: "Remove",
        unscheduled: "Unscheduled",
        schedule: "Schedule",
        untitled: "Untitled",
        milestone: "Milestone",
        sprint_fallback: "List",
        unassigned: "unassigned",
        loading: "Loading…",
        show: "Show",
        filter_due: "due",
        filter_pto: "PTO",
        filter_sprints: "lists",
        pto: "PTO",
        unavailable: "Unavailable",
        teammate: "Teammate",
        more_count: "+{n} more",
        drop_here: "drop here → due {date}",
        subtask_title: "{name} · subtask of {parent}",
        subtask_of: "Subtask of {parent}",
        tray_empty: "Nothing unscheduled. Tasks without a due date land here.",
        col_task: "Task",
        zoom_days: "Days",
        zoom_weeks: "Weeks",
        zoom_months: "Months",
        critical_path: "Critical path",
        baseline: "Baseline",
        view_only: "View only",
        scheduled_count: "{n} scheduled",
        unscheduled_count: "{n} unscheduled",
        replan: "Replan",
        gantt_empty: "Give a task a start and a due date, or choose Schedule on one in the Unscheduled list.",
        gantt_empty_title: "No tasks have dates yet",
        gantt_no_tasks_title: "The Gantt chart shows your plan in time",
        gantt_no_tasks_msg: "Each task is a bar from its start date to its due date. Add a task and give it dates, and it appears here.",
        calendar_no_tasks_title: "The calendar shows tasks by date",
        calendar_no_tasks_msg: "A task with a due date appears on its day. Add a task and give it a date, and it lands here.",
        add_a_task: "Add a task",
        gantt_module_missing: "The Gantt module could not load. Install the dependency and reload:",
        timeline_title: "Timeline",
        timeline_empty: "No scheduled tasks yet — give a task a start & due date to see it on the timeline.",
        unscheduled_tray: "Unscheduled ({n})",
        whiteboard_title: "Whiteboard",
        whiteboard_cards: "{n} cards",
        auto_arrange: "Auto-arrange",
        whiteboard_empty: "No tasks yet — tasks appear here as movable cards.",
        whiteboard_untitled: "Untitled",
        whiteboard_loading: "Loading…",
        whiteboard_saved: "Saved",
        whiteboard_saving: "Saving…",
        whiteboard_offline: "Offline: changes kept on this device",
        whiteboard_not_saved: "Not saved: changes kept on this device",
        whiteboard_load_failed: "This board could not be loaded. Try again in a moment.",
        whiteboard_local_state: "Kept in this browser only",
        whiteboard_local_offer: "This board is kept in this browser only. Save it to the workspace so everyone who can open this list sees the same board, on any device.",
        whiteboard_local_only: "This board is kept in this browser only, and you cannot change this list's board in the workspace.",
        whiteboard_upload: "Save this board to the workspace",
        whiteboard_local_unused: "The workspace already has a board for this list, so the copy kept in this browser is not used.",
        whiteboard_local_remove: "Remove the copy in this browser",
        whiteboard_card_withheld: "A task you cannot open",
        whiteboard_history: "History",
        whiteboard_history_close: "Close",
        whiteboard_history_empty: "No earlier states yet.",
        whiteboard_history_failed: "The history could not be loaded.",
        whiteboard_restore: "Restore",
        whiteboard_restore_failed: "This state could not be restored.",
        whiteboard_items: "{n} item | {n} items",
        whiteboard_add_note: "Add note",
        whiteboard_add_text: "Add text",
        whiteboard_notes_full: "This board holds as many notes and texts as it can.",
        whiteboard_note: "Note",
        whiteboard_text: "Text",
        whiteboard_note_input: "Note text",
        whiteboard_text_input: "Text",
        whiteboard_note_placeholder: "Write a note",
        whiteboard_text_placeholder: "Write text",
        whiteboard_note_edit: "Edit",
        whiteboard_note_delete: "Delete",
        whiteboard_note_resize: "Drag to resize",
        whiteboard_tone_amber: "Amber",
        whiteboard_tone_green: "Green",
        whiteboard_tone_red: "Red",
        whiteboard_tone_violet: "Violet",
        whiteboard_tone_brand: "Brand colour",
        whiteboard_tone_grey: "Grey",
        canvas_title: "Canvas",
        canvas_empty: "No tasks yet — widgets fill in as the project grows.",
        canvas_pct_complete: "{pct}% complete",
        canvas_overdue_open: "overdue & open",
        canvas_nothing_due: "Nothing due in the next 7 days.",
        mindmap_title: "Mind Map",
        mindmap_nodes: "{n} nodes",
        mindmap_empty: "No tasks yet — add tasks to see the project mind map.",
        map_placed: "{n} placed",
        map_to_place: "{n} to place",
        map_click_to_place: "Click anywhere on the map to place {task}",
        map_cancel: "cancel",
        map_clear_all: "Clear all",
        map_empty: "No tasks in this list yet.",
        map_remove: "Remove from map",
        map_to_place_title: "To place ({n})",
        map_placing: "Placing…",
        map_place: "Place",
        map_all_placed: "All tasks placed.",
        replan_none: "Nothing on the critical path yet — link tasks with blocks / blocked by to see one.",
        replan_chain: "{n} linked task sets the end date: {days}, ending {date}. | {n} linked tasks in a row set the end date: {days}, ending {date}.",
        replan_chain_working: "{n} linked task sets the end date: {days}, ending {date}. | {n} linked tasks in a row set the end date: {days}, ending {date}.",
        days_count: "{n} day | {n} days",
        working_days_count: "{n} working day | {n} working days",
        replan_late: "{task} is past its due date, so everything after it moves.",
        shift_title: "{task} now ends later",
        shift_intro: "{n} task that waits on it would move later: | {n} tasks that wait on it would move later:",
        shift_days: "+{n} day | +{n} days",
        shift_working_days: "+{n} working day | +{n} working days",
        shift_working_note: "Shifted tasks start and end on working days ({days}).",
        shift_locked: "You can't edit these, so they stay where they are:",
        shift_needs: "needs {days}",
        shift_cycle: "These tasks block each other in a loop, so shifting stops there: {chain}.",
        shift_earlier: "Moving a task earlier never pulls the tasks it blocks back.",
        shift_apply: "Shift dependants",
        shift_only: "Move only this task",
        shift_cancel: "Cancel",
        shift_done: "Moved {task} and shifted {n} task. | Moved {task} and shifted {n} tasks.",
        shift_failed: "Those dates could not be saved, so nothing moved.",
        drag_snapped_back: "The bar went back because this scale moves it a week or more at a time. Switch to Days to move it by a day.",
        shift_undo_failed: "The earlier dates could not be put back.",
        by_estimate: "By estimate",
        by_logged: "By logged",
        balance: "Balance",
        total: "TOTAL",
        apply: "Apply",
        workload_empty: "No planned or logged hours in this range.",
        load_failed: "That range could not be loaded.",
        move_failed: "That work could not be moved.",
        moved: "Moved {task} to {name}, {day}.",
        dragging: "Dragging {task} · {h} → drop on {name} {day}: {from} {fromPct}%, {name} {toPct}%",
        balance_none: "Nothing to rebalance — no day is over capacity with room elsewhere.",
        balance_hint: "Move {task} · {h} from {from} {day} to {to}: {from} {fromPct}%, {to} {toPct}%",
        drag_hint: "Drag a task chip onto another person or day to rebalance.",
        legend_estimated: "estimated",
        legend_logged: "logged",
        legend_tentative: "next week, tentative",
        legend_over: "over capacity",
        pct_period: "{pct}% this period",
        pto_range: "PTO {range}",
        unavailable_range: "Unavailable {range}",
        per_day: "{h}h/day",
        workload_unit: "Measure workload in",
        unit_hours: "Hours",
        unit_points: "Points",
        unit_count: "Tasks",
        points_short: "{n} pt | {n} pts",
        tasks_short: "{n} task | {n} tasks",
        legend_points: "story points",
        legend_tasks: "open tasks",
        points_per_day: "{n} pts/day",
        points_per_week: "{n} pts/week",
        tasks_per_day: "{n} tasks/day",
        tasks_per_week: "{n} tasks/week",
        unpointed_note: "{n} task has no points and counts as 0 | {n} tasks have no points and count as 0",
        workload_empty_tasks: "No open tasks due or planned in this range.",
        fields_drag_in: "FIELDS · DRAG IN",
        task_properties: "TASK PROPERTIES",
        mapped_fields_note: "Fields mapped to a task property fill it on submit.",
        drop_field_here: "Drop a field here",
        on_submit: "On submit",
        then_automations: "Then automations run",
        no_submit_rules: "No automation runs on a task from this form yet.",
        open_automations: "Open Automations",
        sharing: "Sharing",
        copy: "copy",
        copied: "copied",
        share_note: "Public, no login needed. Logo and brand colour come from the workspace.",
        publish_to_share: "Publish the form to get a shareable link.",
        submission_count: "{n} submissions so far"
    },
    Reports: {
        tab_portfolio: "Portfolio",
        tab_sprint: "Sprint",
        tab_velocity: "Velocity",
        tab_milestones: "Milestones",
        tab_variance: "Variance",
        tab_custom: "Custom",
        template_name_tasks_by_status: "Tasks by status",
        template_name_tasks_by_project: "Tasks by project",
        template_name_tasks_by_sprint: "Tasks by list",
        template_name_points_by_sprint: "Story points by list",
        template_name_points_by_project: "Story points by project",

        project: "Project",
        sprint: "Sprint",
        untitled_project: "Untitled project",
        all_projects: "All projects",
        load_failed: "That report could not be loaded.",
        nothing_here: "Nothing in this group.",
        pts: "pts",
        n_tasks: "{n} task | {n} tasks",
        points_n: "{n} pts",
        remaining: "Remaining",
        ideal: "Ideal",

        sprint_title: "Sprint report",
        sprint_none_title: "No sprint to report on yet",
        sprint_none_body: "A sprint has to be started before there is a commitment to measure against. Start one from the project's backlog.",
        state_planned: "Planned",
        state_active: "Running",
        state_overdue: "Overdue",
        state_closed: "Closed",
        committed: "Committed",
        completed: "Completed",
        added_mid: "Added mid-sprint",
        carry_over: "Carry-over",
        logged_est: "Logged / est",
        takeaway: "Finished {done} of {committed} committed points ({pct}). The work grew by {growth} after the start and {carry} points carried over.",
        focus_committed: "Committed work",
        focus_completed: "Finished this sprint",
        focus_added: "Added after the start",
        focus_carry: "Carry-over to the next sprint",
        focus_hours: "Hours",
        scope_added: "Added mid-sprint",
        scope_created_by: "Created by {who}",
        scope_moved_by: "Moved in by {who}",
        moved_out: "Moved out",
        not_started: "Not started",
        blocked: "Blocked",
        blocked_note: "Waiting on someone",
        blocked_days: "blocked {days}d",
        burndown: "Burn-down",
        burndown_note: "Planned vs actual, added work marked",
        burndown_empty: "No burn-down yet — this sprint has no dated task history.",
        burndown_select_sprint: "Select a sprint…",
        burndown_points: "Points",
        burndown_tasks: "Tasks",
        burndown_pick_sprint: "Pick a sprint to see its burndown.",
        burndown_no_data: "No data for this sprint yet.",
        burndown_load_failed: "Could not load burndown.",
        burndown_ideal: "Ideal",
        burndown_remaining_points: "Remaining points",
        burndown_remaining_tasks: "Remaining tasks",
        burndown_points_remaining: "Points remaining",
        burndown_tasks_remaining: "Tasks remaining",
        burndown_chart_title: "Burndown — {sprint}",
        burndown_chart_title_default: "Sprint burndown",
        burndown_pdf_title: "Sprint Burndown",
        burndown_pdf_metric_points: "Metric: Story points",
        burndown_pdf_metric_tasks: "Metric: Task count",
        burndown_pdf_total_points: "Total points: {n}",
        burndown_pdf_total_tasks: "Total tasks: {n}",
        retro_title: "Retro notes",
        retro_blocked: "{n} task is blocked, for {days}. | {n} tasks are blocked, the oldest for {days}.",
        days_count: "{n} day | {n} days",
        retro_scope: "Scope grew {pct} after the start, {points} points added.",
        retro_over_hours: "Logged hours ran {pct} over the plan.",
        retro_under_hours: "Logged hours came in {pct} under the plan.",
        retro_clean: "Nothing blocked, no scope added, hours matched the plan.",

        velocity_title: "Velocity and flow",
        velocity: "Velocity",
        last_n_sprints: "last {n} sprint | last {n} sprints",
        human_only: "Human only",
        human_only_note: "Showing points finished by people, agent-built work excluded.",
        completed_n: "{n} completed",
        committed_n: "{n} committed",
        next: "Next",
        avg_next: "avg {avg} · next {low}–{high}",
        avg_only: "avg {avg}",
        legend_completed: "completed",
        legend_committed: "committed",
        legend_forecast: "forecast",
        velocity_empty_title: "No completed sprints yet",
        velocity_empty_body: "Velocity is measured from what a sprint committed to when it started, so a sprint has to be started and completed before it appears here.",
        forecast_line: "Based on the last {n} sprints, the next one should land between {low} and {high} points.",
        forecast_none: "Not enough history to forecast: {n} measured sprint(s), {min} needed. Complete another sprint and a range will appear here.",
        cfd: "Cumulative flow",
        cfd_note: "Where work piles up",
        cfd_empty: "No task history in this project yet.",
        cfd_last_days: "Cumulative flow — last {days} day | Cumulative flow — last {days} days",
        cfd_no_history: "No task history yet.",
        velocity_last_sprints: "Last {n} completed sprints — committed vs completed (points)",
        velocity_skipped: "{n} older sprint(s) skipped — no commitment was recorded when they ran.",
        velocity_empty: "No completed sprints yet. Velocity is measured from what a sprint committed to when it started, so a sprint has to be started and completed before it appears here.",
        velocity_series_committed: "Committed",
        velocity_series_completed: "Completed",
        velocity_series_rolling_avg: "Avg (3-sprint)",
        velocity_axis_points: "Story points",
        velocity_table_rolling_avg: "Avg (3)",
        cfd_chart_title: "Cumulative Flow Diagram",
        cfd_axis_tasks: "Tasks",
        cfd_band_done: "Done",
        cfd_band_on_hold: "On hold",
        cfd_band_in_progress: "In progress",
        cfd_band_to_do: "To do",
        export_pdf: "Export PDF",
        loading: "Loading…",
        band_done: "done",
        band_progress: "in progress",
        band_blocked: "blocked",
        band_todo: "to do",

        milestones_title: "Milestones",
        milestones_summary: "{total} dated · {risk} at risk · {missed} missed",
        col_milestone: "Milestone",
        col_baseline: "Baseline",
        col_now: "Now",
        col_slip: "Slip",
        col_state: "State",
        state_on_track: "On track",
        state_at_risk: "At risk",
        state_missed: "Missed",
        state_done: "Signed off",
        missed: "missed",
        moved_by: "moved by {who} on {when}",
        milestones_empty_title: "No dated milestones yet",
        milestones_empty_body: "A milestone appears here once it has a due or end date to be judged on.",
        milestones_footnote: "Slip is measured against the first date recorded for the milestone. Every change is in the activity log with who moved it.",

        new_report: "New report",
        source: "Source",
        src_tasks: "Tasks",
        src_timelogs: "Time logs",
        filters: "Filters",
        add_filter: "Add a filter",
        remove_filter: "Remove filter",
        f_date: "Date",
        f_billable: "Billable",
        yes: "Yes",
        no: "No",
        range_1m: "last month",
        range_3m: "last 3 months",
        range_6m: "last 6 months",
        range_12m: "last 12 months",
        group_by: "Group by",
        dim_status: "Status",
        status_type_active: "In progress",
        status_type_close: "Closed",
        status_type_default_active: "To do",
        dim_project: "Project",
        dim_sprint: "List",
        dim_person: "Person",
        dim_month: "Month",
        measure: "Measure",
        metric_count: "Task count",
        metric_points: "Story points",
        metric_hours: "Hours logged",
        metric_entries: "Entries",
        metric_revenue: "Billable amount",
        chart: "Chart",
        chart_table: "Table",
        chart_bar: "Bars",
        chart_line: "Line",
        chart_pie: "Pie",
        saved: "Saved",
        saved_pick: "Open a saved report",
        template_pick: "Start from a template",
        name_ph: "Name this report",
        save: "Save",
        saving: "Saving…",
        saved_ok: "Saved. It is now in the saved list and can be scheduled.",
        save_failed: "That could not be saved.",
        save_first: "Save the report first, then it can be emailed on a schedule.",
        schedule_email: "Schedule email",
        schedule_it: "Schedule it",
        recipients_ph: "Email addresses, comma separated",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        remove: "Remove",
        total: "Total",
        groups: "Groups",
        largest: "Largest",
        preview_meta: "{groups} groups · {metric} · live",
        preview_source: "Reading from {source}, live at every change.",
        drill_hint: "Click a group to narrow to it.",
        drill_hint_none: "Group by project to drill into a single one.",
        no_data_title: "Nothing matches this report yet",
        no_data_body: "Loosen a filter or pick a different source.",
        clear_filters: "Clear filters",
        desktop_only_title: "Open the report builder on a desktop",
        desktop_only_body: "The builder needs the width for the settings panel and the live preview side by side.",

        portfolio_title: "Portfolio",
        portfolio_head: "{n} projects · week of {week}",
        portfolio_pick: "Portfolio",
        new_portfolio: "New portfolio",
        edit_portfolio: "Edit portfolio",
        portfolio_name: "Name",
        portfolio_name_ph: "What is this group of projects called?",
        no_company_projects: "No active projects to group yet.",
        portfolio_none_title: "No portfolio yet",
        portfolio_none_body: "Group the projects you are accountable for and this page rolls them up: health, burn-down, capacity and what is at risk.",
        edit: "Edit",
        cancel: "Cancel",
        delete: "Delete",
        on_track: "On track",
        at_risk: "At risk",
        off_track: "Off track",
        team_load: "Team load",
        h_on_track: "On track",
        h_at_risk: "At risk",
        h_off_track: "Off track",
        at_risk_now: "What is at risk",
        nothing_at_risk: "Nothing is at risk this week.",
        n_overdue: "{n} overdue",
        no_active_sprint: "No sprint running in these projects.",
        days_left: "{n}d left",
        sprint_over: "Sprint ended",
        digest_title: "Portfolio digest",
        digest_no_provider: "No AI provider is configured, so there is no written digest. The figures on this page are the whole picture.",
        digest_no_projects: "Add projects to this portfolio and a written digest will appear here.",
        digest_unavailable: "The digest could not be written just now. The figures on this page are unaffected.",
        capacity_week: "Capacity this week",
        n_people: "{n} person | {n} people",
        no_capacity: "No capacity recorded for this week.",
        pto_h: "PTO {h}h",
        unavailable_h: "Unavailable {h}h"
    },
    Dash: {
        dashboards: "Dashboards",
        dashboard: "Dashboard",
        all_dashboards: "All dashboards",
        tab_all: "All",
        tab_mine: "Mine",
        tab_shared: "Shared with me",
        shared_empty_title: "Nothing is shared with you yet",
        shared_empty_msg: "A dashboard that a teammate shares with everyone shows up here.",
        shared_empty_action: "See all dashboards",
        new_dashboard: "+ Dashboard",
        n_cards: "{n} CARD | {n} CARDS",
        more: "More",
        open: "Open",
        duplicate: "Duplicate",
        delete: "Delete",
        cancel: "Cancel",
        create: "Create",
        save: "Save",
        no_cards_yet: "No cards yet",
        preview_label: "Cards on this dashboard",
        preview_more: "+{n} more",
        preview_other: "{n} cards from the earlier set",
        start_from_template: "Start from a template",
        template_lede: "My work, or a team overview. Add more cards any time, and every card opens the view behind it.",
        name: "Name",
        name_placeholder: "Leadership weekly",
        name_required: "Give the dashboard a name.",
        visibility: "Who can see it",
        vis_private: "Only me",
        vis_workspace: "Everyone in the workspace",
        vis_project: "Project members",
        project: "Project",
        choose_project: "Choose a project",
        start_with: "Start with",
        tpl_blank: "Empty",
        tpl_blank_desc: "Add cards yourself.",
        tpl_mine: "My work",
        tpl_mine_desc: "What is due, and my hours against my plan.",
        tpl_team: "Team overview",
        tpl_team_desc: "Project pulse, tasks by status, logged vs estimate and free capacity.",
        shared_workspace: "shared with the workspace",
        shared_project: "project members",
        shared_only_me: "only me",
        a_teammate: "A teammate",
        owned_by_you: "Yours",
        owned_by: "{name}",
        updated_never: "not saved yet",
        updated_today: "updated today",
        updated_yesterday: "updated yesterday",
        updated_days: "updated {n}d ago",
        locked: "Locked",
        unlocked: "Unlocked",
        add_card_short: "+ Card",
        dashboard_settings: "Dashboard settings",
        empty_dashboard: "This dashboard has no cards yet.",
        add_first_card: "Add your first card",
        hidden_cards: "{n} saved cards are not part of the new card set yet, so they are not shown here.",
        no_access: "You do not have access to this dashboard.",
        load_failed: "That could not be loaded.",
        save_failed: "That could not be saved.",
        add_card: "Add a card",
        picker_lede: "{built} built of {total}, grouped by what they answer, not by chart type",
        search_cards: "Search cards",
        close: "Close",
        add: "Add",
        add_again: "Add again",
        on_already: "Added",
        not_built: "Not built yet",
        no_cards_match: "No card matches {q}.",
        picker_footer: "Cards keep their project filter when a dashboard is copied. A card the viewer may not see shows nothing instead of an error.",
        family_mine: "My work",
        family_mine_q: "What am I doing?",
        family_team: "Team and project",
        family_team_q: "How are the team and the work?",
        family_charts: "Charts and tables",
        family_charts_q: "Where does the work sit?",
        family_ai: "AI",
        family_ai_q: "What should I know today?",
        scope_mine: "Mine",
        scope_team: "My team",
        scope_workspace: "Workspace",
        period: "Time period",
        period_auto: "Auto",
        period_today: "Today",
        period_this_week: "This week",
        period_last_week: "Last week",
        period_this_month: "This month",
        period_last_month: "Last month",
        period_last_30: "Last 30 days",
        refresh: "Refresh",
        card_settings: "Card settings",
        remove_card: "Remove card",
        card_removed: "{card} was removed from this dashboard.",
        delete_title: "Delete {name}?",
        delete_text: "The dashboard and its cards are removed for everyone who can open it. This cannot be undone.",
        deleted: "{name} was deleted.",
        delete_failed: "The dashboard was not deleted. Try again.",
        card_error: "This card could not load its data.",
        try_again: "Try again",
        live: "LIVE",
        live_data: "live",
        updated_just_now: "updated just now",
        updated_min: "updated {n}m ago",
        updated_hours: "updated {n}h ago",
        link_my_tasks: "My tasks",
        link_timesheet: "Timesheet",
        link_projects: "Projects",
        link_capacity: "Capacity",
        link_agents: "Agents",
        empty_at_risk: "Nothing looks likely to slip: no late or blocked work, and nothing due soon that has not started.",
        empty_agent_spend: "No agents yet, so nothing has been spent this month.",
        action_open_agents: "Open agents",
        risk_summary: "at risk · {overdue} late · {blocked} blocked · {stalled} not started",
        risk_overdue_days: "{n}d late",
        risk_blocked: "Blocked",
        risk_stalled: "Not started",
        risk_note: "from rules, not AI",
        risk_note_more: "{shown} of {total}, from rules, not AI",
        spend_of_caps: "of {cap} in caps this month",
        spend_no_caps: "this month, no caps set",
        spend_bar_label: "{name}: {used} of {cap}",
        spend_bar_uncapped: "{name}: {used}, no cap",
        spend_over_cap: "At cap",
        spend_paused: "Paused",
        spend_ai_off: "AI is off in this workspace, so agents are not spending.",
        spend_note: "month {month}",
        scope_project: "Project",
        link_sprint_report: "Sprint report",
        link_velocity: "Velocity",
        link_ask: "Ask",
        card_settings_for: "{name} settings",
        action_card_settings: "Set up this card",
        settings_required: "Fill in the required fields first.",
        settings_sprint: "Sprint",
        settings_choose_sprint: "Choose a sprint",
        settings_loading: "Loading…",
        settings_no_sprints: "This project has no sprints or lists yet.",
        settings_metric: "Measure",
        settings_sprint_count: "Sprints to show",
        settings_question: "Question",
        settings_question_placeholder: "Which tasks in the current sprint are blocked?",
        settings_question_hint: "Everyone who opens this dashboard gets their own answer, built only from what they can open. Each answer uses AI and counts toward the workspace AI spend.",
        settings_ask_project: "Search in",
        settings_refresh_after: "Ask again when the answer is older than",
        settings_refresh_after_hint: "The answer is kept and shown each time the dashboard opens. Past this age, opening the dashboard asks once for a new one. The refresh button on the card always asks again.",
        refresh_after_hour: "1 hour",
        refresh_after_6_hours: "6 hours",
        refresh_after_day: "1 day",
        refresh_after_week: "7 days",
        refresh_after_never: "Never ask again automatically",
        settings_all_projects: "Every project the viewer can open",
        metric_points: "Points",
        metric_tasks: "Tasks",
        burndown_pick_sprint: "Choose a sprint to chart its burndown.",
        burndown_no_tasks: "This sprint has no tasks yet, so there is nothing to burn down.",
        burndown_no_access: "You cannot open this sprint, so its burndown is not shown.",
        burndown_points_left: "points left of {total}",
        burndown_tasks_left: "tasks left of {total}",
        velocity_pick_project: "Choose a project to see its velocity.",
        velocity_no_sprints: "No sprint in this project has closed yet.",
        velocity_no_access: "You cannot open this project, so its velocity is not shown.",
        velocity_avg: "average points over {n} sprint | average points over {n} sprints",
        velocity_next: "average points · next sprint {low}–{high}",
        ask_pick_question: "Save a question in the card settings and its answer shows here.",
        ask_not_permitted: "Your plan or role does not include AI, so this question is not asked for you.",
        ask_no_answer: "Ask found no answer to this question.",
        ask_budget_exhausted: "The workspace has reached its AI spending cap, so this question was not asked. It is asked again once the cap resets or is raised.",
        ask_budget_unavailable: "The workspace's AI budget could not be checked, so this question was not asked. Try again in a moment.",
        ask_note: "from what you can open",
        ask_note_asked: "asked {n}m ago, from what you can open",
        ask_note_from: "This answer is from {when}",
        ask_availability_unknown: "Could not check whether AI is available here, so this question was not asked.",
        card_DueSoonCard_title: "My work",
        card_DueSoonCard_answer: "What is late, due today, and due this week.",
        card_MyTimeCard_title: "My time",
        card_MyTimeCard_answer: "Hours I logged against the hours I planned.",
        card_NextUpCard_title: "Next up",
        card_NextUpCard_answer: "The next few tasks by priority, then date.",
        card_MyAchievementsCard_title: "My month",
        card_MyAchievementsCard_answer: "My own trend: completed, logged and on-time.",
        card_MyLeaveCard_title: "My leave",
        card_MyLeaveCard_answer: "Days left, and what is booked next.",
        card_SavedSearchCard_title: "Saved search",
        card_SavedSearchCard_answer: "Any filter you can build, as a live count.",
        card_ProjectPulseCard_title: "Project pulse",
        card_ProjectPulseCard_answer: "How many projects are live, and which were worked on.",
        card_TeamLoggedVsEtaCard_title: "Logged vs estimate",
        card_TeamLoggedVsEtaCard_answer: "Who is over or under the estimate, per team and person.",
        card_FreeResourcesCard_title: "Free capacity",
        card_FreeResourcesCard_answer: "Who has room today, and how many hours.",
        card_LiveWorkTableCard_title: "Working right now",
        card_LiveWorkTableCard_answer: "Who has a timer running, on what.",
        card_OnLeaveCard_title: "Who is off",
        card_OnLeaveCard_answer: "Approved leave that overlaps the window.",
        card_TeamCategoryBreakdownCard_title: "By category",
        card_TeamCategoryBreakdownCard_answer: "Where a team's hours went, by task type.",
        card_EmployeeWorkloadReportCard_title: "Workload report",
        card_EmployeeWorkloadReportCard_answer: "Planned, logged and overdue per person.",
        card_TasksByStatusCard_title: "Tasks by status",
        card_TasksByStatusCard_answer: "Where the work sits, stacked per project.",
        card_TaskStatusSummaryCard_title: "Status table",
        card_TaskStatusSummaryCard_answer: "Who has what, per status, with hours.",
        card_WorkedTasksTableCard_title: "Worked on",
        card_WorkedTasksTableCard_answer: "The tasks that took the hours this week.",
        card_BurndownCard_title: "Burndown",
        card_BurndownCard_answer: "Remaining work against the days left in the sprint.",
        card_VelocityCard_title: "Velocity",
        card_VelocityCard_answer: "What the team actually finished, sprint by sprint.",
        card_MilestoneReportCard_title: "Milestones",
        card_MilestoneReportCard_answer: "Billing milestones by status and amount.",
        card_TasksByAssigneeCard_title: "Tasks by assignee",
        card_TasksByAssigneeCard_answer: "How open work is spread across people.",
        card_AtRiskTodayCard_title: "What is at risk today",
        card_AtRiskTodayCard_answer: "Tasks likely to slip: late, blocked, or due within two days and not started.",
        card_AgentSpendCard_title: "Agent spend",
        card_AgentSpendCard_answer: "What the agents cost this month, per agent.",
        card_AskAQuestionCard_title: "Ask a question",
        card_AskAQuestionCard_answer: "A saved question, answered for each viewer from what they can open.",
        due_summary: "overdue · {today} today · {week} this week",
        due_chart_label: "Tasks due per day",
        due_day_labels: "OVR,TODAY",
        due_late: "{n}d late",
        due_today: "Today",
        due_tomorrow: "Tomorrow",
        due_in_days: "{n}d",
        due_note: "soonest first",
        due_note_more: "{shown} of {total}, soonest first",
        empty_due_soon: "Nothing is due in this window. Pick up something from your list.",
        action_open_my_work: "Open my work",
        logged: "Logged",
        planned: "Planned",
        vs_plan: "vs plan",
        of_planned: "of {hours} planned",
        no_plan_set: "no plan set for this period",
        my_time_note: "your own hours only",
        empty_my_time: "No hours planned or logged in this period yet.",
        action_log_time: "Log time",
        pulse_active: "active",
        pulse_working: "worked on",
        pulse_idle: "quiet",
        pulse_mix: "Project type mix",
        pulse_no_types: "No project types are set.",
        pulse_note: "point-in-time, except the worked-on count",
        empty_project_pulse: "No active projects here. Create one to see the pulse.",
        action_open_projects: "Open projects",
        lve_note: "the dark line is the estimate",
        empty_logged_vs_eta: "No hours logged against an estimate in this period.",
        free_headline: "unassigned capacity across {n} person | unassigned capacity across {n} people",
        free_rule: "free = under {planned}h planned and at most {logged}h logged today",
        free_note: "today, approved leave excluded",
        empty_free_capacity: "Everybody has work planned today.",
        action_open_capacity: "Open capacity",
        tbs_sub: "{tasks} across {n} project | {tasks} across {n} projects",
        tbs_tasks: "task | tasks",
        tbs_unknown_status: "Unknown",
        tbs_note_company: "every project you can see",
        tbs_note_self: "your own tasks",
        empty_tasks_by_status: "No tasks were planned or worked on in this period."
    },
    Fields: {
        title: "Custom fields",
        scope_workspace: "Workspace",
        new_field: "Field",
        col_field: "Field",
        col_type: "Type",
        col_shown_in: "Shown in",
        col_required: "Required",
        read_only: "read-only",
        empty_list: "No custom fields yet. Pick a type below to add the first one.",
        pick_a_type: "Pick a type",
        type_note: "A field can be required, shown on board cards, or filtered on. Archive a field to hide it and keep its values; deleting it removes its values for good.",
        actions_for: "Actions for {field}",
        choose_projects: "Choose projects",
        archive: "Archive",
        restore: "Restore",
        delete: "Delete",
        archived: "Archived",
        archived_toast: "{field} is archived. Its values are kept.",
        restored_toast: "{field} is back on its tasks.",
        deleted_toast: "{field} was deleted.",
        delete_title: "Delete {field}?",
        delete_counting: "Counting the tasks that hold a value…",
        delete_with_values: "{n} task holds a value for this field. The field and that value are removed for good. | {n} tasks hold a value for this field. The field and those values are removed for good.",
        delete_no_values: "No task holds a value for this field. The field is removed for good.",
        delete_archive_hint: "To hide the field and keep its values, archive it instead.",
        delete_read_by: "{fields} reads this field. Change or delete that field first. | {fields} read this field. Change or delete those fields first.",
        delete_read_elsewhere: "A field of a project you cannot open reads this field. Ask an owner or an admin to change or delete that field first.",
        delete_counted_open: "Only the tasks you can open are counted. The value goes from every task that holds one.",
        archive_instead: "Archive instead",
        close: "Close",
        projects_title: "Where {field} shows",
        projects_every: "Every project",
        projects_chosen: "Only the projects I choose",
        projects_empty: "There is no project to choose yet.",
        projects_none: "Choose at least one project.",
        projects_save: "Save",
        projects_saved: "Saved where {field} shows.",
        formula_label: "Formula",
        fewer_fields: "Show fewer",
        rollup_rules: "A rollup is worked out on the server each time a subtask under the task changes.",
        untitled: "Untitled field",
        editor: "Editor",
        editor_empty: "Select a formula or rollup field to edit it, or pick a type to add a new one.",
        field_label: "Field label",
        field_label_placeholder: "Billable value",
        expression_placeholder: "{'{'}logged_hours{'}'} * {'{'}Billable rate{'}'} — click a field below to insert it",
        more_fields: "+ {count} more",
        preview: "Preview:",
        no_expression: "No expression yet",
        of: "of",
        rollup_source: "Roll up which field",
        rollup_source_count: "Number of subtasks",
        rollup_function: "Aggregate",
        rollup_scope_subtasks: "Subtasks",
        rollup_help: "A rollup counts every subtask under the task, on every level, once each. On a subtask it counts the subtasks under that one. A source field counts only on the task types it is for.",
        show_as: "Show as",
        format_money: "Money",
        format_number: "Number",
        format_text: "Text",
        formula_rules: "Formulas are evaluated on the server and recompute when their inputs change. Circular references are refused at save.",
        plain_field_note: "This field is edited on the task. Required and visibility settings live in the field sidebar.",
        saving: "Saving…",
        save_field: "Save field",
        save_and_add_another: "Save and add another",
        test: "Test",
        cancel: "Cancel",
        surface_task_view: "Task view",
        surface_list: "List",
        surface_table: "Table",
        surface_board_card: "Board card",
        error_title_required: "Give the field a label.",
        error_title_taken: "Another field already uses this label.",
        error_expression_required: "A formula field needs an expression.",
        type_text: "Text",
        hint_text: "short label, one line",
        type_long_text: "Long text",
        hint_long_text: "notes, no formatting",
        type_number: "Number",
        hint_number: "units, decimals",
        type_money: "Money",
        hint_money: "currency, rounds properly",
        type_date: "Date",
        hint_date: "can drive reminders",
        type_dropdown: "Dropdown",
        hint_dropdown: "fixed options, colours",
        type_checkbox: "Checkbox",
        hint_checkbox: "yes / no",
        type_email: "Email",
        hint_email: "validated, clickable",
        type_phone: "Phone",
        hint_phone: "validated, clickable",
        type_people: "People",
        hint_people: "one or several members",
        type_url: "Link",
        hint_url: "a web address that opens in a new tab",
        type_rating: "Rating",
        hint_rating: "stars, 1 to 5 or your own scale",
        type_progress: "Progress",
        hint_progress: "a bar from 0 to 100%",
        type_files: "Files",
        hint_files: "up to 20 files kept on the task",
        type_relationship: "Relationship",
        hint_relationship: "named links to other tasks",
        type_voting: "Voting",
        hint_voting: "one vote per person, counted on the task",
        type_formula: "Formula",
        hint_formula: "computed from other fields",
        type_rollup: "Rollup",
        hint_rollup: "sums up the subtasks under a task",
        type_ai: "AI field",
        hint_ai: "filled by AI from the task",
        task_types_label: "Show for task types",
        task_types_hint: "Leave every type unticked to show this field on all tasks.",
        task_types_empty: "This workspace has no task types yet.",
        task_type_missing: "Removed type {key}",
        task_types_shown: "Only {types}",
    },
    FieldTypes: {
        builder_note: "This field is edited on the task: in the task panel and in List and Table cells.",
        edit_field: "Edit the field {field}",
        people_multiple_label: "Allow several people",
        people_multiple_hint: "Untick to hold one person at a time.",
        rating_max_label: "Highest rating",
        rating_max_hint: "A whole number from {min} to {max}.",
        rating_max_error: "The highest rating must be a whole number from 3 to 10.",
        rating_of: "{value} of {max}",
        rating_value: "{field}: {value} of {max}",
        rating_clear: "Clear the rating",
        progress_none: "Not set",
        progress_type: "{field}, percent",
        url_placeholder: "example.com/page",
        url_edit: "Change the link",
        url_not_a_link: "This is not an http or https link, so it is not shown as one.",
        files_add: "Add file",
        files_uploading: "Uploading…",
        files_count: "{n} file | {n} files",
        files_open: "Open {name}",
        files_remove: "Remove {name}",
        files_remove_confirm: "Remove this file?",
        files_remove_yes: "Remove",
        files_remove_no: "Keep",
        files_full: "This field holds at most {max} files.",
        files_kind_refused_images: "Only images can be added here.",
        files_kind_refused_documents: "Only documents can be added here.",
        files_upload_failed: "The file could not be uploaded.",
        files_max_label: "Most files",
        files_max_hint: "A whole number from {min} to {max}.",
        files_kind_label: "Allowed files",
        files_kind_any: "Any file",
        files_kind_images: "Images",
        files_kind_documents: "Documents",
        files_settings_error: "The most files a field holds must be a whole number from 1 to 20.",
        relationship_open: "Open {task}",
        relationship_edit: "Change the tasks linked in {field}",
        relationship_picker: "Tasks linked in {field}",
        relationship_remove: "Remove the link to {task}",
        relationship_full: "This field links at most {max} tasks.",
        relationship_max_label: "Most linked tasks",
        relationship_max_hint: "A whole number from {min} to {max}.",
        relationship_scope_label: "Tasks come from",
        relationship_scope_any: "Any project you can open",
        relationship_scope_project: "One project",
        relationship_scope_list: "One list of a project",
        relationship_project_label: "Project",
        relationship_list_label: "List",
        relationship_choose: "Choose…",
        relationship_settings_error: "Set the most linked tasks to a whole number from 1 to 20, and choose the project or the list the field is limited to.",
        voting_vote: "Vote on {field}, {n} so far",
        voting_withdraw: "Withdraw your vote on {field}, {n} so far",
        voting_voters: "People who voted",
        voting_failed: "Your vote could not be saved.",
        voting_shown_label: "Show who voted",
        voting_shown_hint: "Untick to show only the number of votes.",
        size_b: "{n} B",
        size_kb: "{n} KB",
        size_mb: "{n} MB",
    },
    Import: {
        title: "Import tasks",
        close: "Close",
        step_file: "File",
        step_header: "Header row",
        step_map: "Map",
        step_review: "Review",
        headline: "{rows} rows · into {target}",
        headline_empty: "Pick a CSV export to start",
        drop_title: "Drop a CSV here",
        drop_hint: "or click to choose one",
        file_note: "Exports from Jira, Trello, Asana and Monday all work. Nothing is read from the file until you pick it.",
        error_not_csv: "That is not a CSV file.",
        error_empty: "That file has no rows.",
        error_too_many: "At most {max} rows per import. Split the file and run it twice.",
        error_unreadable: "That file could not be read.",
        header_row: "Which row holds the column names?",
        header_use_this: "Use this row",
        header_is_this: "Header row",
        header_note: "Rows above the header row are ignored.",
        columns_found: "Columns · {found} found, {mapped} mapped",
        skip_column: "Skip this column",
        map_column: "Map the column {column}",
        unmapped_count: "{count} column unmapped. | {count} columns unmapped.",
        unmapped_note: "Unmapped data is dropped, not stored. Map a column to a text field if you need it later.",
        filled: "{count} filled",
        empty_column: "no values",
        review: "Review",
        row: "Row",
        stat_importable: "will import",
        stat_skipped: "skipped",
        stat_rows_with_errors: "rows with errors",
        progress: "Import progress",
        no_issues: "Every row parses cleanly.",
        statuses_heading: "Statuses · {from} to {to}",
        status_default: "First project status",
        create_missing: "Create it",
        no_status_column: "No column is mapped to Status.",
        create_missing_statuses: "Create statuses this project does not have",
        people_heading: "People · {from} found, {matched} matched",
        leave_unassigned: "Leave unassigned",
        no_people_column: "No column is mapped to Assignee.",
        tags_heading: "Tags",
        create_missing_tags: "Bring tags across onto the imported tasks",
        preset_note: "Mappings are saved with the import, so the next export of the same shape maps itself.",
        foot_nothing_written: "Nothing is written until you confirm the review. A failed import rolls back completely.",
        foot_review: "Confirm to write these rows. Rows with a fatal error are skipped, not guessed.",
        back: "Back",
        next: "Next",
        review_rows: "Review {count} row | Review {count} rows",
        import_rows: "Import {count} row | Import {count} rows",
        importing: "Importing…",
        import_done: "Imported {created} task, {skipped} skipped. | Imported {created} tasks, {skipped} skipped.",
        import_failed: "Import failed: {reason}",
        target_task_title: "Task title",
        target_description: "Description",
        target_status: "Status",
        target_priority: "Priority",
        target_assignee: "Assignee",
        target_due_date: "Due date",
        target_start_date: "Start date",
        target_estimate: "Estimate (hours)",
        target_logged_time: "Logged time (hours)",
        target_tags: "Tags",
        target_task_key: "Task key or ID",
        target_parent: "Parent task (key or title)",
        dropped_field_values: "{count} field value(s) did not fit their field and were left out.",
        adjusted_too_deep: "{count} subtask(s) were deeper than three levels and were placed under their nearest parent:",
        adjusted_parent_missing: "{count} row(s) named a parent that is not in the file and were imported as tasks:",
        adjusted_cycle: "{count} row(s) named parents that loop and were imported as tasks:",
    },
    Language: {
        title: "Language & region",
        subtitle: "Per person. The workspace only sets a default.",
        language_heading: "Language · {count} available",
        date_format: "Date format",
        week_starts: "Week starts",
        numbers: "Numbers",
        numerals: "Numerals",
        currency: "Currency",
        preview_rtl: "RTL · العربية",
        sample_task_en: "Redesign onboarding flow",
        sample_status_en: "In progress",
        sample_priority_en: "High",
        timer_never_flips: "Timer",
        rtl_flips_label: "What RTL flips:",
        rtl_flips: "the rail moves right, panels mirror, progress bars fill right-to-left, chevrons reverse.",
        rtl_keeps_label: "What never flips:",
        rtl_keeps: "the timer, code, IDs, and charts with a time axis — time always runs left to right.",
        save: "Save",
        saving: "Saving…",
        saved: "Saved",
        error_language: "That language file could not be loaded.",
        error_save: "Your language could not be saved.",
        monday: "Monday",
        sunday: "Sunday",
        saturday: "Saturday",
        rtl_tag: "RTL",
        preview_ltr: "LTR",
    },
    Parity: {
        nav_connections: "Connections",
        agent_tag: "AGENT",
        agents: "Agents",
        people: "People",
        loading: "Loading…",
        cancel: "Cancel",
        saving: "Saving…",
        assigning: "Assigning…",
        starting: "Starting…",
        stopping: "Stopping…",
        stop: "Stop",
        paused: "paused",
        idle: "idle",
        and: "and",
        you: "You",
        all_projects: "All projects",
        nav_teammates: "Teammates",
        nav_routing: "Routing",
        nav_ask: "Ask",

        teammates_title: "Agents as teammates",
        teammates_lead: "An agent is a member with an owner, a run budget and a permission scope — not a seat. It shows as a rounded square with an AGENT tag everywhere it speaks or acts, so it can never be mistaken for a person.",
        assign_to_agent: "Assign an agent",
        find_task: "Find a task",
        find_task_hint: "Type at least two characters, then press Enter",
        no_tasks_found: "No task matched that. Try the task key.",
        pick_a_task: "Pick a task to see who fits it.",
        untitled_task: "Untitled task",
        no_status: "No status",
        what_happens: "What happens when you assign an agent",
        what_happens_body: "It runs its skills against this task, posts findings as a comment, and hands back to a person with a proposed next assignee. It never marks a task Done.",
        comment_label: "Comment",
        comment_placeholder: "Type a comment. Start a word with {'@'} to bring in an agent.",
        comment: "Comment",
        comment_and_run: "Comment and run",
        mention_hint: "Mentioning an agent starts a run on this task.",
        mention_will_run: "{name} will start a run on this task when you send this.",
        mention_no_match: "No agent by that name. Pick one from the list to mention it.",
        run_started: "{name} is running.",
        run_stopped: "Run stopped. Everything it had done so far is kept.",
        person_assigned: "Assigned.",
        assign_failed: "The assignee was not updated.",
        agent_needs: "Needs: {what}",
        cap_usd: "Cap (USD)",

        members: "Members",
        people_agents: "{p} people · {a} agents",
        tab_all: "All",
        tab_people: "People",
        tab_agents: "Agents",
        col_member: "MEMBER",
        col_role: "ROLE",
        col_access: "ACCESS",
        col_active: "ACTIVE",
        role_owner: "Owner",
        role_admin: "Admin",
        role_member: "Member",
        role_guest: "Guest",
        role_agent: "Agent",
        built_in_tag: "Built in",
        guide_add: "Add the Workspace Guide",
        guide_adding: "Adding…",
        guide_add_hint: "A built-in agent anyone can @mention on a task to ask what to do next. It only reads, comments and proposes, and costs nothing until it is mentioned.",
        guide_added: "Workspace Guide added.",
        guide_add_failed: "The Workspace Guide could not be added.",
        everything: "Everything",
        access_member: "Their projects",
        access_guest: "What's shared with them",
        owned_by: "owned by {name}",
        assignable: "assignable",
        n_projects: "{n} project | {n} projects",
        no_project_scope: "No project scope",
        n_skills: "{n} skill | {n} skills",
        n_actions: "{n} things it can do",
        read_only: "read only",
        no_members: "Nobody here yet.",
        no_seat: "Agents do not take a seat. They have an owner, a run budget, and the same permissions as a role, minus anything destructive.",

        picker_title: "Who should take this",
        picker_note: "ranked by what each is allowed to do, its skills, and its own runs here",
        assignee: "Assignee",
        search_people_agents: "Search people or agents",
        best_fit: "BEST FIT FOR THIS TASK",
        ranked_by: "ranked by skills, past runs, allowed actions",
        no_agents_yet: "No agents in this workspace yet.",
        no_people_match: "No one matches that.",
        not_eligible: "not eligible",
        no_history_yet: "no history yet",
        percent_fit: "{n}% fit",
        about_minutes: "~{n} min",
        about_usd: "~${usd}",
        time_unknown: "time unknown",
        cost_unknown: "cost unknown",
        comment_only: "comment only",
        cannot_finish: "cannot finish this alone",
        away_until: "away until {date}",
        percent_loaded: "{n}% loaded",
        free_hours: "{n}h free this week",
        fit_made_of: "WHAT FIT IS MADE OF",
        fit_explainer: "The skills the agent declares, the actions it is allowed (an agent without repo write cannot be a 92% fit for a code task), and its own history on similar tasks in this workspace — not a vendor benchmark.",
        fit_no_history_note: "A new agent shows \"no history yet\" instead of a made-up percentage.",
        before_confirm: "BEFORE YOU CONFIRM",
        pick_someone: "Pick someone to see exactly what will happen.",
        runs_as: "Runs as",
        runs_personal: "the owner's personal account",
        runs_workspace: "the workspace key",
        cost_to_you: "Cost to you",
        starts: "Starts",
        starts_now: "as soon as you assign",
        will_set: "Will",
        wont: "Won't",
        nothing_yet: "nothing until you widen its actions",
        handback_note: "It hands the task back to a person when it is done or stuck. It never closes it.",
        also_set: "ALSO SET",
        notify_me: "Notify me when it finishes",
        stop_over_cap: "Stop it if it exceeds ${usd}",
        assign: "Assign",

        outcomes_title: "How an assignment ends",
        n_runs: "{n} run | {n} runs",
        declined_tag: "1 · DECLINED",
        declined_title: "The agent says no before starting",
        failed_generic: "It could not finish, and reported why.",
        no_declines: "No agent has refused a task here yet.",
        no_handbacks: "Nothing has been handed back yet.",
        declined_rule: "Status stays where it was, the task returns to whoever assigned it, and no time or money was spent. A decline is a normal outcome, not an error state.",
        handback_tag: "2 · HANDED BACK",
        handback_title: "It got partway and hit a judgement call",
        handback_generic: "It did part of the work and left the rest to a person.",
        handback_rule: "The work so far is posted, hours are logged and the task moves to a person. This counts as a good run.",
        stop_tag: "3 · GOING WRONG",
        stop_title: "Too long, too expensive, or off track",
        no_open_runs: "Nothing is running right now.",
        stop_rule: "Stopping pauses the agent and keeps what it had done. Nothing is discarded — the partial comment posts, and the task goes back to a person with the cost shown.",
        law_label: "The rule underneath all three:",
        law_body: "an assignment can always come back to a person, at any point, with the work so far preserved and the cost visible.",

        routing_title: "Route tasks to agents",
        routing_lead: "Select the tasks you would otherwise assign one at a time. The router proposes an agent per task and refuses the ones that need a person.",
        bulk_route: "Route many at once",
        open_tasks: "Open tasks",
        nothing_open: "Nothing open to route.",
        select_all: "Select all",
        clear_all: "Clear",
        n_selected: "{n} SELECTED",
        route_to_agents: "Route to agents",
        proposed_routing: "PROPOSED ROUTING · EDIT ANY ROW",
        assign_n: "Assign {n}",
        route_cost_line: "{cost} total · {n} left for a person to pick up",
        routed_n: "{n} routed.",
        routed_partial: "Routed {n} before this stopped it: {error}",
        stop_by_hand: "Or stop doing this by hand",
        rule_tag: "RULE",
        no_rule_yet: "Route at least one task to see the rule it would become.",
        rule_sentence: "When a task is created, if the title contains \"{kind}\", run the {skill} agent.",
        save_rule: "Save rule",
        rule_name: "Routing rule",
        rule_saved: "Saved, switched off. Turn it on when you have read it.",
        compile_failed: "That sentence did not compile.",
        rules_live_with: "Routing rules live with automations and obey the same autonomy ladder — the rule assigns, the agent still proposes.",
        router_trust: "The tasks it refuses to route are the point. A router that assigns everything to an agent is a router nobody trusts twice.",
        test_30_days: "Test on last 30 days",
        backtest_result: "{n} in the last {days} days",

        n_active: "{n} ACTIVE",
        sentence_placeholder: "When a task status changes to Blocked, post a comment saying \"needs help\".",
        grammar_shape: "Shape: {shape}",
        ambiguous: "ONE THING IS AMBIGUOUS",
        compiled_rule: "COMPILED RULE · EDIT ANY PART",
        save_automation: "Save automation",
        fired_n: "fired {n}×",

        connections: "Connections",
        connections_lead: "Everything this workspace is connected to, and exactly what agents may read and do through each one.",
        conn_tab_all: "All",
        conn_tab_apps: "Apps",
        conn_tab_mcp: "MCP servers",
        conn_tab_agents: "External agents",
        connect: "Connect",
        mcp_self_name: "AlianHub MCP server",
        badge_served_here: "SERVED HERE",
        badge_workspace: "WORKSPACE",
        badge_personal: "OWNER'S ACCOUNT",
        badge_external: "EXTERNAL",
        cli_agent: "CLI agent",
        mcp_setup: "SET UP A CLI AGENT",
        mint_token: "Create a token",
        minting: "Minting…",
        mint_failed: "The token was not created.",
        mint_on_accounts: "Create a token with an expiry",
        copy_now: "COPY IT NOW",
        token_once: "This is the only time the token is shown.",
        mcp_tools_count: "{n} tools exposed",
        token_sub: "Agent API · {mode} account",
        grant_mcp: "Agents may call {n} read and write tools. Done, delete, merge and deploy are absent from the tool list, not merely disabled.",
        grant_token: "Scoped to {n}. Every write lands in the AI Inbox first unless autonomy allows it.",
        grant_slack: "Search: messages · Agents: post digests to the default channel · Automations: slash commands",
        grant_github: "Search: commits, pull requests · Agents: read PR context · Automations: link commit to task",
        grant_gitlab: "Search: merge requests · Agents: read MR context · Automations: link commit to task",
        grant_calendar: "Read: events · Agents: read your agenda · Automations: none",
        grant_teams: "Post: task updates to one channel · Agents: post digests · Read: nothing",
        grant_zapier: "Send: task events out to Zapier · Agents: none · Read: nothing",
        grant_iframe: "Embed only. Agents cannot read anything inside the embedded tool.",
        grant_generic: "Read and write scoped to this connection's own settings.",
        or_any_mcp: "Or any MCP server by URL. You choose which tools agents can call.",
        everything_connected: "Everything in the catalogue is connected.",
        never_label: "NEVER AVAILABLE TO AN AGENT",
        never_body: "These actions do not exist for agents, they are not just switched off. A stolen token has nothing to turn on.",

        team: "Team",
        team_headline: "{p} PEOPLE · {a} AGENTS · {load}% LOAD",
        team_headline_no_load: "{p} PEOPLE · {a} AGENTS",
        team_empty: "Nobody on the board yet.",
        team_failed: "The team board could not be loaded.",
        generate_standup: "Generate standup",
        balance_workload: "Balance workload",
        standup: "Standup",
        standup_empty: "Nothing to report — no timers, tasks or runs today.",
        standup_source: "Composed from running timers, open tasks, approved leave and live agent runs. No model was asked.",
        balance: "Workload balance",
        balance_even: "Load is even. Nothing to move.",
        over_loaded: "Over capacity: {names}",
        has_room: "Has room: {names}",
        col_person: "PERSON",
        col_now: "WORKING ON NOW",
        col_week: "THIS WEEK",
        col_status: "STATUS",
        status_working: "Working",
        status_available: "Available",
        status_away: "Away",
        status_offline: "Offline",
        status_running: "Running",
        status_idle: "Idle",
        status_paused: "Paused",
        nothing_in_progress: "Nothing in progress",
        busy_on_task: "Busy on a task",
        hours_not_shared: "Hours not shared with you",
        pto_until: "PTO until {date}",
        agent_on: "{task} · {min} min in",
        agent_idle: "Waiting for work",
        agent_paused: "Paused",
        activity_live: "ACTIVITY · LIVE",
        no_activity: "No agent activity yet.",
        time_off: "TIME OFF",
        pto_line: "{name} is away until {to}",

        ask_title: "Ask",
        ask_lead: "Answers cite the tasks and docs they used. Nothing is changed unless you ask.",
        your_question: "Your question",
        ask_placeholder: "What's blocking this list and who can unblock it?",
        ask_go: "Ask",
        research_go: "Research",
        thinking: "Reading…",
        ask_failed: "That question could not be answered.",
        mode_ask: "Ask",
        mode_research: "Research",
        scope_note: "Only projects you can already open. Ask never widens what you can see.",
        n_projects_searchable: "{n} projects in scope",
        answer: "Answer",
        report: "Report",
        cited: "CITED",
        no_model_title: "No model configured",
        no_model_body: "An owner or admin has to connect a model provider before Ask can answer. Until then, here is exactly what it would have searched.",
        would_search: "WHAT IT WOULD HAVE READ",
        nothing_to_search: "Nothing in your projects matches that yet.",
        quick_actions: "QUICK ACTIONS",
        qa_standup: "Write my standup",
        qa_standup_sub: "From yesterday's activity and today's plan",
        qa_standup_prompt: "What did I work on yesterday and what is open for me today?",
        qa_tasks_from: "What needs breaking down",
        qa_tasks_from_sub: "Tasks with no subtasks and no estimate",
        qa_tasks_from_prompt: "Which open tasks have no estimate and no subtasks?",
        qa_summarize: "Summarize a thread",
        qa_summarize_sub: "Any task or doc you can open",
        qa_summarize_prompt: "Summarize what has been decided on the most recently updated tasks.",
        qa_who_knows: "Find who knows about…",
        qa_who_knows_sub: "By assignee, comments and time logged",
        qa_who_knows_prompt: "Who has worked on authentication recently?",
        qa_dashboard: "What changed this week",
        qa_dashboard_sub: "Across the projects you can open",
        qa_dashboard_prompt: "What moved this week, and what is stuck?",
        qa_research: "Research report",
        qa_research_sub: "Multi-source, cited, longer answer",
        qa_research_prompt: "Write a report on where this workspace is behind and why.",
        recent: "Recent:",
        model_line: "Model: whichever provider this workspace has configured"
        ,work_human_decision: "a judgement call",
        work_human_talk: "talking to someone",
        work_code: "change code and hand back a branch",
        work_review: "find the problems and report them",
        work_write: "draft something for a person to approve",
        work_plan: "break the work down",
        work_general: "read it and comment",
        why_human_decision: "It asks for a decision, and a decision needs someone accountable for it.",
        why_human_talk: "It happens outside the tool, with a person on the other end.",
        fit_needs_person: "This needs a person — {why}",
        fit_paused: "Paused ({reason}).",
        fit_cap_reached: "Spend cap reached — ${spent} of ${cap} this month.",
        fit_not_scoped: "Not scoped to this project.",
        fit_cannot_read: "It cannot read a task.",
        fit_no_action: "It has no allowed action that would {work}.",
        fit_allowed: "Allowed to {work}.",
        fit_partial: "Can start, but it may only do part of this — you would get a list, not a fix.",
        fit_read_only: "Can start, but it may only read and comment — you would get a list, not a fix.",
        fit_history: "{n} run(s) here, {good} finished clean.",
        fit_history_similar: "{n} similar run(s) here, {good} finished clean.",
        fit_no_history: "No history in this workspace yet.",
        fit_history_skipped: "{n} skipped for missing input.",
        fit_lacks_input: "This task lacks what it needs — {need}.",
        fit_needs_input: "needs a person — this task lacks {need}",
        fit_no_agent: "no agent here is allowed to do this"
    },
    AiLanding: {
        title: "AI",
        tab_ask: "Ask",
        tab_agents: "Agents",
        headline: "What should we get done?",
        sub: "Ask about anything in the projects you can open, or hand an agent work it can finish. Whatever an agent proposes comes back to you before it lands.",
        question_label: "Your question",
        placeholder: "Ask about a project, or describe the work you want started…",
        send: "Ask",
        send_research: "Research",
        sending: "Thinking…",

        ctl_scope_label: "Where to look",
        ctl_scope_all: "Everything you can open",
        ctl_depth: "Research",
        ctl_depth_hint: "Research reads twice as many sources and answers at report length.",
        ctl_skills: "Skills",
        ctl_model: "Model",
        ctl_voice: "Dictate",
        transcribing: "Transcribing…",
        transcribe_failed: "That recording could not be transcribed.",

        skills_title: "Skills the agents here can run",
        skills_none: "No skills in this workspace yet.",
        skill_needs: "Needs {need}",
        skill_needs_nothing: "Needs only the task.",
        skill_scope_project: "whole project",
        skill_reach: "{n} of {total} open",
        skill_reach_none: "nothing open carries it",
        skills_note: "A skill only starts once the task carries what it needs. That check belongs to the engine, not to this screen.",

        models_title: "Models this workspace can use",
        models_none: "No model is connected, so nothing can be asked yet.",
        model_priced: "${usdIn} in · ${usdOut} out per million tokens",
        model_unpriced: "Not priced — a run on it is refused by name.",
        models_note: "Which model answers is set by the workspace routing policy, not here.",
        models_open_policy: "Open routing policy",
        no_model_chip: "No model",
        unpriced_chip: "Model not priced",
        no_model_note: "Asking needs a connected model. The read below still holds — it is a query, not a guess.",

        read_line: "{n} open tasks you can see — {parts}.",
        read_line_capped: "Your {n} most recently updated open tasks — {parts}.",
        read_line_plain: "{n} open tasks you can see.",
        read_line_capped_plain: "Your {n} most recently updated open tasks.",
        read_part: "{n} {work}",
        read_join: ", ",
        read_sub: "Classified the way the router classifies them: a scoped query and a set of rules. No model was called to draw this.",
        kind_review: "read like review work",
        kind_code: "read like code changes",
        kind_write: "read like drafting",
        kind_plan: "read like breaking work down",
        kind_general: "have no obvious shape yet",
        kind_person: "need a person",
        n_tasks: "{n} task(s)",
        rest_line: "{n} more {work}, so no agent is offered for them. Give one a brief and it joins the work above.",
        why_mixed: "for more than one reason — each task says which",

        panel_title: "Tasks that {kind}",
        panel_showing: "{n} of {total}, most recently updated",
        before_start: "Before you start",
        will_touch: "Will touch",
        wont_touch: "Will not touch",
        est_cost: "Estimated cost",
        for_people: "Left for a person",
        nothing_listed: "Nothing",
        approval_note: "Each agent posts what it found and proposes its writes; you approve them in the AI inbox, and a whole run can be reverted afterwards.",
        start_n: "Start {n} run(s)",
        started_n: "{n} run(s) started.",
        started_partial: "{n} started, then it stopped: {error}",
        open_router: "Open the router",
        revert_note: "A run can be stopped or reverted whole.",

        people_title: "These need a person",
        people_note: "No agent is offered for these. A decision needs someone accountable for it, and a conversation happens outside the tool.",

        no_backlog_title: "Nothing open to read yet",
        no_backlog_body: "Once there are open tasks in a project you can see, this page opens on them — sorted into the work an agent can take and the work that needs you. Ask works in the meantime.",
        no_backlog_action: "Go to projects",

        no_agents_title: "No agents here yet",
        no_agents_body: "An agent is a member with a skill, a budget and a permission scope. It reads a task, does the part it is allowed to do, and hands back with everything it changed on the record.",
        no_agents_action: "Create the first agent",
        no_agents_member: "An owner or an admin creates agents. Ask works without one.",
        no_agents_promise: "A ready-made one takes about two minutes.",
        agent_will: "Writes: {what}",
        agent_reads_only: "Reads and comments only.",
        manage_agents: "Manage agents",
        open_inbox: "Approvals inbox",
        agents_note: "Every write an agent proposes waits for a person."
    },
    AskMemory: {
        open: "Memory",
        title: "Your AI memory",
        close: "Close",
        lead: "What Ask and the agents you start should know about you. Only you can see it, admins included, and it is never used for anyone else's questions.",
        loading: "Loading your memory…",
        use_label: "Use my memory",
        use_on: "Ask and the agents you start read it.",
        use_off: "Off: it is kept, but nothing reads it.",
        nickname: "What to call you",
        nickname_hint: "A first name or nickname",
        role: "Your role",
        role_hint: "For example: delivery lead for the mobile team",
        preferences: "Your preferences",
        preferences_hint: "Tone, length, format and how you like to work. For example: short answers, bullet points first, UK spelling.",
        facts_title: "Things to remember",
        facts_count: "{n} of {max} saved",
        facts_empty: "Nothing yet. Add short facts about you or your work.",
        fact_label: "Thing to remember {n}",
        fact_imported: "Imported",
        fact_delete: "Delete \"{text}\"",
        fact_new: "New thing to remember",
        fact_new_hint: "For example: I run the Ops board",
        fact_add: "Add",
        forget: "Forget everything",
        forget_confirm_text: "Delete your whole memory? This cannot be undone.",
        forget_confirm: "Delete it",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving…",
        saved: "Saved.",
        saved_stripped: "Saved. {n} item(s) that looked like a password, key or card number were left out.",
        forgotten: "Your memory is deleted.",
        imported: "Added {n} item(s) to your memory.",
        imported_skipped: "Added {n} item(s). {skipped} did not fit under the limit.",
        import_title: "Bring your memories from another AI",
        import_lead: "Copy the prompt into ChatGPT, Gemini or Claude, then paste its answer here. You choose what to keep before anything is saved.",
        copy_prompt: "Copy prompt",
        prompt_copied: "Copied",
        show_prompt: "Show the prompt",
        import_prompt: "I am moving to a new assistant. Please list what you know or remember about me that would help it work with me: what I like to be called, my role and work, the projects I care about, and how I like answers (tone, length, format, language). Write each item as one short bullet. Leave out passwords, keys, account or card numbers and anything else private.",
        copy_failed: "Could not copy. Open \"Show the prompt\" and copy it from there.",
        import_off: "AI is off in this workspace, so a paste cannot be read. You can still edit your memory by hand.",
        import_unconfigured: "No model is connected, so a paste cannot be read. You can still edit your memory by hand.",
        import_not_permitted: "Your plan or role does not include AI, so a paste cannot be read. You can still edit your memory by hand.",
        paste_label: "Paste the answer",
        paste_hint: "Paste what the other assistant said about you",
        read_paste: "Read it",
        reading: "Reading…",
        read_note: "Anything that looks like a password, key or card number is removed before the model sees it.",
        preview_lead: "Tick what to keep. Nothing is saved until you add it.",
        preview_empty: "The paste had nothing about you to keep.",
        preview_stripped: "{n} item(s) that looked like a password, key or card number were removed.",
        kind_fact: "Fact",
        kind_preference: "Preference",
        preview_confirm: "Add {n} to my memory",
        preview_discard: "Discard",
        error_token_limited_to_projects: "This token is limited to some projects, so it cannot open your memory.",
        error_text_required: "Paste the other assistant's answer first.",
        error_no_model: "No model is connected, so the paste cannot be read. You can still add items by hand.",
        error_import_unreadable: "The model did not return a list. Try again, or add the items by hand.",
        error_items_required: "Tick at least one item to keep.",
        error_ai_off: "AI is off in this workspace, so a paste cannot be read.",
        error_unauthenticated: "Sign in again to open your memory.",
        error_generic: "Something went wrong. Try again.",
        settings_title: "AI memory",
        settings_hint: "Your nickname, role, preferences and things to remember. Ask and the agents you start use them; only you can see them."
    },
    Ask: {
        why_open: "Why this answer",
        plan_toggle: "Plan changes",
        plan_hint: "Turn a sentence into tasks, fields, views or an automation to approve. Nothing is made until you approve it.",
        plan_send: "Plan it",
        plan_working: "Planning with the workspace model…",
        plan_ready: "A plan is ready for your approval.",
        plan_waits: "Nothing is made yet. It also waits in your Inbox.",
        plan_approved: "Approved and made. You can undo it from the Inbox.",
        plan_declined: "Declined. Nothing was made.",
        plan_approve: "Approve",
        plan_working_on_it: "Making it…",
        plan_decline: "Decline",
        plan_cannot_item: "Not planned: {text} ({reason})",
        plan_step_task: "Create a task",
        plan_step_fields: "Add custom fields",
        plan_step_view: "Add a saved view",
        plan_step_automation: "Add an automation",
        plan_step_other: "A step",
        plan_reason_other_project: "it is about another project; ask for it in a sentence of its own",
        plan_reason_no_project: "it names no project; ask again and name the project",
        plan_reason_not_allowed: "you do not have permission to make this change",
        plan_reason_not_found: "the project, list or person it names was not found",
        plan_reason_incomplete: "a detail it needs is missing or not valid",
        plan_reason_refused: "a project rule or setting stopped it",
        plan_decide_failed: "That could not be decided just now. Try again from the Inbox.",
        plan_ai_off: "AI is turned off, so a sentence cannot be planned.",
        plan_needs_key: "Planning needs an AI key on this server, or your own AI connected to AlianHub.",
        plan_unpriced: "The model set up on this server has no price on file, so a sentence cannot be planned with it.",
        plan_nothing: "Nothing could be planned from that sentence. Try naming the project, the list or the person.",
        plan_too_long: "Keep the sentence shorter.",
        plan_project_not_found: "That project was not found.",
        plan_failed: "The sentence could not be planned just now. Try again.",
        why_title: "Why this answer",
        why_close: "Close",
        why_lead: "The passages Ask retrieved for your question. The answer may cite these and nothing else.",
        why_empty: "Ask retrieved no passages for this question, so the answer has nothing to cite.",
        why_no_permission: "No permission detail was recorded for these passages. Each one comes from a project you can already open.",
        why_cited: "Cited",
        why_updated: "Updated {date}",
        why_no_project: "No project",
        kind_task: "Task",
        kind_page: "Page",
        kind_comment: "Comment",
        kind_transcript: "Call transcript",
        reason_project_member: "You can see this as a member of the project.",
        reason_private_owner: "Private page, visible only to you.",
        reason_company_page: "Company-wide page, visible to everyone in the workspace.",
        reason_call_participant: "You can see this because you took part in the call.",
        reason_owner_admin: "You can see this as an owner or admin of the workspace.",
        empty_no_match: "Nothing in the projects you can open matches that. Try naming the project or the task.",
        note_scope: "Only projects you can already open. Ask never widens what you can see.",
        error_question_required: "Ask a question first.",
        error_unauthenticated: "Ask needs a signed-in member of this workspace.",
        error_thread_not_found: "That thread is gone, or it is not yours.",
        conversation_label: "Conversation",
        you_asked: "You asked:",
        new_question: "New question",
        follow_up_placeholder: "Ask a follow-up…",
        answering: "Answering…",
        stop: "Stop",
        stopped: "Stopped. This answer was not saved.",
        answer_ready: "Answer ready.",
        answer_stopped: "Answer stopped.",
        stream_failed: "The answer stopped before it finished. Try again.",
        copy: "Copy",
        copied: "Answer copied.",
        copy_failed: "Could not copy the answer.",
        make_task: "Make a task",
        post_to_chat: "Post to chat",
        post_title: "Post this answer to chat",
        post_lead: "It is posted as an AI answer written for you, with its sources as links. Only what everyone in the conversation can open is posted.",
        post_where: "Post in",
        post_channels: "Channels",
        post_directs: "Direct messages",
        post_loading: "Loading your conversations…",
        post_none: "You have no channel or direct message to post in.",
        post_load_failed: "Could not load your conversations.",
        post_action: "Post",
        post_posting: "Posting…",
        post_done: "Posted to {name}.",
        post_held: "{n} of the items this answer was built from cannot be opened by everyone in {name}, so it was not posted.",
        post_held_cited: "It cites {refs}, which not everyone there can open.",
        post_held_choice: "You can post only the lines that rest on what everyone there can open, or cancel.",
        post_only_shared: "Post only what everyone can open",
        post_nothing_shared: "Nothing in this answer can be opened by everyone there, so it cannot be posted.",
        post_expired: "This answer can no longer be posted. Ask again, then post the new answer.",
        post_too_many_readers: "More than {n} people can read this channel, so what they can all open is not worked out and an answer with sources cannot be posted here. Pick a smaller channel or a direct message.",
        post_failed: "Could not post the answer.",
        cite_unavailable: "Not available to open",
        history_title: "Your threads",
        history_empty: "No saved threads yet. Each new question starts one.",
        history_untitled: "Untitled thread",
        history_note: "Only you can see your threads. Ask keeps your last {threads}, with up to {turns} questions each.",
        thread_turns: "{n} question | {n} questions",
        thread_delete: "Delete thread {title}",
        thread_delete_confirm: "Delete this thread? This cannot be undone.",
        thread_deleted: "Thread deleted.",
        thread_delete_failed: "Could not delete the thread.",
        thread_load_failed: "Could not open that thread.",
        kind_project: "Project",
        composer_placeholder: "Ask, plan or build. Type / for a skill, {'@'} to add a task, doc or project.",
        chip_remove: "Remove {name}",
        menu_skills: "Skills",
        menu_context: "Add context",
        menu_context_hint: "Type two letters to search tasks, docs and projects you can open.",
        menu_searching: "Searching…",
        menu_context_none: "Nothing you can open matches that.",
        starters_label: "Start with",
        starter_status_title: "Project status update",
        starter_status_body: "What moved, what is stuck and what comes next.",
        starter_status_body_project: "What moved in {project}, what is stuck and what comes next.",
        starter_status_prompt: "Write a status update for {project}: what moved this week, what is blocked or overdue, and what comes next.",
        starter_status_prompt_all: "Write a status update across my projects: what moved this week, what is blocked or overdue, and what comes next.",
        starter_task_title: "Create a task",
        starter_task_body: "Describe the work and get a well-formed task to create.",
        starter_task_prompt: "Turn this into a task with a clear title, the goal, acceptance criteria and next steps: ",
        starter_urgent_title: "Find my urgent work",
        starter_urgent_body: "Your open tasks that are overdue, due soon or high priority.",
        starter_urgent_prompt: "Which of my open tasks are overdue, due soon or high priority? List the most urgent first.",
        starter_message_title: "Draft a message",
        starter_message_body: "An email or chat message, grounded in your work.",
        starter_message_prompt: "Draft a short email or chat message to the team about: ",
        build_tasks_open: "Create tasks ({n})…",
        build_doc_open: "Create a doc…",
        build_tasks_title: "Create tasks from this answer",
        build_tasks_lead: "Check each task before it is created. Untick what you do not want, and edit the title, due date or assignee.",
        build_close: "Close",
        build_project: "Project",
        build_list: "List",
        build_not_allowed: "You cannot create tasks in this project. Pick another project.",
        build_include: "Create {title}",
        build_untitled: "untitled task",
        build_title_label: "Title of task {n}",
        build_due_label: "Due date of task {n}",
        build_assignee_label: "Assignee of task {n}",
        build_unassigned: "Unassigned",
        build_undo_note: "You can undo this right after.",
        build_cancel: "Cancel",
        build_creating: "Creating…",
        build_create_n: "Create {n} task | Create {n} tasks",
        build_tasks_created: "{n} task created. | {n} tasks created.",
        build_tasks_undone: "The new tasks were moved to the trash.",
        build_undo_failed: "Could not undo. Try again from the trash.",
        build_error_title_invalid: "A title needs 3 to 250 characters.",
        build_error_due_invalid: "That due date is not valid.",
        build_error_assignee_not_allowed: "You cannot assign this person in this project.",
        build_error_plan_limit: "This list has reached your plan's task limit.",
        build_error_refused: "This task was refused. Check its details.",
        build_error_not_permitted: "You cannot create tasks in this project.",
        build_error_project_not_found: "That project is not one you can open.",
        build_error_project_closed: "That project is closed.",
        build_error_no_list: "That project has no list to add tasks to.",
        build_error_list_not_found: "That list is not in this project.",
        build_error_too_many_items: "Create at most 20 tasks at a time.",
        build_error_create_failed: "Could not create this task. Try again.",
        build_doc_title: "Save the answer as a doc",
        build_doc_lead: "The doc is saved as a draft in the project you choose, for you to review and edit.",
        build_doc_name: "Doc title",
        build_doc_preview: "Doc preview",
        build_doc_note: "Saved as a draft. You can undo this right after.",
        build_doc_create: "Create draft doc",
        build_doc_author: "Ask",
        build_doc_failed: "Could not create the doc. Try again.",
        build_doc_created: "Draft doc created.",
        build_doc_undone: "The draft doc was moved to the trash.",
        build_doc_saved: "Saved as a draft doc:"
    },
    RolePlaybooks: {
        title: "Role playbooks",
        lead: "Each role works from a written playbook. Edit the text for this workspace, for example to name the brand voice document to read, the lengths to keep or the review rules. The built-in text stays as the default and can be restored.",
        read_only: "READ ONLY, AN OWNER OR ADMIN EDITS THIS",
        you_can_edit: "YOU CAN EDIT THIS",
        role_label: "Role",
        text_label: "Playbook text",
        edited_chip: "Edited for this workspace",
        default_chip: "Built-in text",
        save: "Save playbook",
        restore: "Restore built-in text",
        saved: "Saved.",
        restored: "Restored the built-in text.",
        count: "{used} of {max} characters",
        empty: "No roles are available on this server.",
        load_failed: "The roles could not be loaded.",
        save_failed: "The playbook could not be saved.",
        restore_failed: "The built-in text could not be restored."
    },
    Accounts: {
        title: "Coding accounts",
        nav: "Accounts",
        tab_modes: "Modes",
        tab_link: "My account",
        tab_attribution: "Attribution",
        tab_rules: "Decided rules",
        tab_connected: "Connected apps",
        not_linked: "NO ACCOUNT LINKED",
        active: "Active",
        yours: "YOURS",
        not_permitted: "NOT PERMITTED",
        copy: "Copy",
        copied: "Copied",
        cancel: "Cancel",
        revoke: "Revoke",
        revoked: "REVOKED",
        renew: "Renew",
        renew_confirm: "Renew {name}? It keeps its settings and gets a new secret and a new end date. The secret in use now stops working at once.",
        renew_failed: "The token was not renewed.",

        modes_lead: "Three ways an agent can run in this workspace. A workspace can allow more than one, and every screen shows which one did the work.",
        mode_workspace: "Workspace key",
        mode_workspace_sub: "One API key in settings, shared by everyone",
        mode_personal: "Personal CLI account",
        mode_personal_sub: "Their own Claude Code. AlianHub never holds a key",
        mode_local: "Self-hosted model",
        mode_local_sub: "Ollama or vLLM on your GPU, no external account",

        row_pays: "Who pays",
        row_pays_workspace: "The company. One bill, predictable, capped per agent.",
        row_pays_personal: "The developer's own subscription. Workspace spend for this work is $0.",
        row_pays_local: "Nobody, per run. Electricity and one GPU.",
        row_where: "Where the model call happens",
        row_where_workspace: "Server-side, from AlianHub. Needed for scheduled agents that run with nobody logged in.",
        row_where_personal: "On the developer's machine. AlianHub only receives the result of the work: comments, status, PR link, hours.",
        row_where_local: "Inside your network. Nothing leaves.",
        row_can: "What it can do",
        row_can_workspace: "Everything in the allow-list, including unattended and scheduled runs.",
        row_can_personal: "Only what that person can do, only while they are at the keyboard. No scheduled runs.",
        row_can_local: "Everything in the allow-list, but slower and weaker on hard reasoning.",
        row_offboarding: "On offboarding",
        row_offboarding_workspace: "Nothing to do. The key is the company's.",
        row_offboarding_personal: "Revoke their AlianHub token and the link dies. Their subscription and history stay theirs.",
        row_offboarding_local: "Nothing to do.",
        row_best: "Best for",
        row_best_workspace: "Scheduled agents: daily PM, reporter, smart assign.",
        row_best_personal: "Hands-on coding work: your developers, on their own terms.",
        row_best_local: "Regulated teams, air-gapped installs, or anyone who will not send work data out.",

        policy_title: "Modes this workspace permits",
        policy_you_can_edit: "OWNER AND ADMIN",
        policy_read_only: "READ ONLY, AN OWNER OR ADMIN SETS THIS",
        policy_workspace_effect: "Server-side runs on the workspace key, including scheduled agents.",
        policy_personal_effect: "Members may link their own CLI account and mint a scoped token.",
        policy_local_effect: "Runs against a model inside your own network.",
        save_policy: "Save policy",
        policy_saved: "Saved.",
        policy_need_one: "At least one mode has to stay allowed.",
        done_check_title: "A person checks before Done",
        done_check_label: "A person checks an agent's work before a task is closed",
        done_check_effect: "While this is on, no agent closes a task in any project. A person closes it, whatever the project has chosen.",
        connected_pause_title: "Connected agents",
        connected_pause_label: "Pause every connected agent in this workspace",
        connected_pause_effect: "While this is on, no connected agent takes work or changes anything, in any project. “Pause all agents” turns it on. A change a person approves is still made.",
        policy_refusal_note: "A mode that is off is refused with the reason shown, not hidden: linking an account and minting a token both check this policy before anything is written.",
        recommended_label: "Recommended default:",
        recommended_body: "workspace key for the scheduled agents, because they are cheap and predictable; personal accounts for hands-on CLI coding work; and the self-hosted option available so a customer who refuses external models still gets the whole product. All three can run at once.",

        link_lead: "Use your own Claude Code, Antigravity, Cursor or Codex account for work in AlianHub, then paste one command into your CLI.",
        my_account: "My coding agent",
        link_form_lead: "Pick how your agent work should run. This records the mode and provider against your user; it never asks for, stores or proxies a key.",
        sees_title: "ALIANHUB SEES",
        sees_1: "That a run happened, and which task it was on",
        sees_2: "Elapsed time, and the hours written to your timesheet",
        sees_3: "Every action taken through the allow-list, as an audit row",
        sees_4: "The comments, subtasks, status moves and PR links your agent created",
        sees_5: "Which account type produced each of them",
        yours_title: "STAYS YOURS",
        stays_1: "Your API key or subscription. AlianHub never receives it.",
        stays_2: "Your prompts and chat history. Only the result reaches the server.",
        stays_3: "Anything outside the projects your token is scoped to.",
        stays_4: "Your provider spend and invoice. Nothing here reads them.",
        boundary_source: "These are not promises added to a page. The left column is what the audit, run and timesheet rows actually store; the right column is what the code has no field for.",
        always_1: "Every timer an agent starts is logged against you and stamped as agent time, not your own hours.",
        always_1_where: "Modules/Agents/actions.js — timelog.start writes actorType, viaAccount and runId",
        always_2: "Every allowed request and every refusal is saved in the audit log with the account type and the token behind it.",
        always_2_where: "Modules/Agents/agentAudit.js — recordAction and recordRefusal",
        always_3: "A token scoped to projects can only see tasks in those projects.",
        always_3_where: "Modules/Mcp/tools.js — scopeFilter restricts every tool to the token's projectIds",
        unlink: "Unlink",
        unlink_body: "stops all agent work through your account and deactivates every agent token you hold here. Past comments, PRs and hours stay on their tasks; nothing is deleted.",
        switch_workspace: "Switch to workspace key",

        field_mode: "Mode",
        field_provider: "Provider",
        field_label: "Label",
        field_label_hint: "laptop CLI",
        field_email: "Provider account email",
        field_email_hint: "The address on your own provider account",
        link_account: "Link account",
        no_modes_allowed: "No mode is currently permitted for linking. Ask an owner or admin to change the policy.",
        provider_claude_code: "Claude Code",
        provider_cursor: "Cursor",
        provider_codex: "Codex",
        provider_antigravity: "Antigravity",
        provider_ollama: "Ollama",
        provider_vllm: "vLLM",
        provider_other: "Other",
        linked_on: "linked {d}",
        created_on: "created {d}",
        used_on: "used {d}",
        never_used: "never used",
        no_expiry: "no expiry",
        expires_on: "expires {d}",
        expired_on: "expired {d}",
        scoped_projects: "scoped to {n} project | scoped to {n} projects",

        summary_title: "This month, through your account",
        stat_tasks: "tasks worked",
        stat_hours: "agent time logged",
        stat_prs: "PRs opened",
        stat_company: "to the company",
        summary_note: "Counted from your own timesheet rows, runs and task links inside AlianHub. Your own spend sits on your provider account and nothing here reads it.",

        cli_title: "Developer tools",
        cli_breadcrumb: "AI AND AGENTS / CLI",
        cli_comment_add: "add AlianHub as an MCP server (any CLI agent)",
        cli_connected: "connected · {n} tools · protocol {v}",
        cli_url_minted: "This is the exact URL and token the server just returned. The token is not shown again.",
        cli_url_guess: "The token appears here once you mint one, and the server returns the exact URL with it.",
        cli_others_note: "Other tools: give them the same URL and Authorization header — check your tool's docs for its exact command.",

        tokens_title: "Personal access token",
        new_token: "New token",
        token_once: "Copy this now. It is not shown again — only a scrambled copy of it is stored.",
        copy_token: "Copy token",
        copy_command: "Copy setup command",
        hide_token: "Done",
        field_token_name: "Token name",
        field_token_name_hint: "laptop CLI",
        field_scope: "Project scope",
        scope_all: "Every project you can already open",
        scope_hint: "A token scoped to one project cannot reach tasks outside it, whatever the CLI asks for.",
        create_token: "Create token",
        token_name_required: "Give the token a name so you can recognise it later.",
        field_expiry: "Expires after",
        expiry_choose: "Choose how long it lasts",
        expiry_hint: "You are told in your Inbox three days before it ends, and can renew it here.",
        expiry_days: "{n} day | {n} days",
        field_scopes: "What it may do",
        token_scope_read: "Read",
        token_scope_read_effect: "See the projects, tasks and pages you can already open.",
        token_scope_write: "Write",
        token_scope_write_effect: "Make the changes your own role allows.",
        token_expiry_required: "Choose when the token expires. Tokens without an expiry are no longer issued.",
        token_scope_required: "Tick read, write or both.",
        token_grant_tasks: "Let this agent manage tasks",
        token_grant_tasks_effect: "It can edit, assign, move, archive and close the tasks your own role lets you change, several at a time. Without this it can comment, set an in-progress status and file new tasks only.",
        token_grant_tasks_short: "manages tasks",
        token_grant_docs: "Let this agent write docs",
        token_grant_docs_effect: "It can create docs and change the ones you can edit. A doc it creates is marked as its draft, and every change keeps the version it replaced.",
        token_grant_docs_short: "writes docs",
        token_grant_chat: "Let this agent read chat",
        token_grant_chat_effect: "It can read messages in channels you are in. It never reads your direct messages. Without this it reads no chat at all.",
        token_grant_chat_short: "reads chat",
        strict_note: "Every new token needs an expiry and at least one scope. A token without an expiry keeps working for {n} days from when this rule was turned on, or from when the token was made if that is later. Replace it before then.",
        grace_works_until: "no expiry · works until {d}",
        grace_stopped_on: "no expiry · stopped on {d}",
        expiry_list_title: "Tokens that still need an expiry",
        expiry_list_count: "{n} TO REPLACE",
        expiry_list_lead: "Every active token in this workspace that has no expiry, with the day it stops working. Only the owner of a token can replace it: ask them to create a new token with an expiry, then revoke this one.",
        expiry_list_empty: "Every active token in this workspace has an expiry.",
        expiry_list_owner_unknown: "owner unknown",
        expiry_list_unchecked: "no expiry · grace cannot be checked right now",
        expiry_list_over_max_lead: "Tokens made to last longer than the maximum of {n} days stop working {n} days after the maximum took effect. Their owners should create a new token with a shorter expiry, then revoke the old one.",
        token_expiry_over_max: "A token can last at most {n} days. Choose a shorter expiry.",
        lifetime_capped_until: "exceeds the maximum lifetime · works until {d}",
        lifetime_stopped_on: "exceeds the maximum lifetime · stopped on {d}",
        lifetime_unchecked: "exceeds the maximum lifetime · cannot be checked right now",
        step_scoped: "step-scoped",
        step_scoped_title: "Step-scoped credentials",
        step_scoped_count: "{n} LIVE",
        step_scoped_lead: "Credentials the workflow engine minted for steps that are running right now. Each one is tied to one step of one run, is replaced by a fresh one each time the engine extends the step's lease, and stops working when that step settles or its lease runs out. The credential itself is never shown or stored; owners and admins see every run, everyone else the runs they started.",
        step_scoped_empty: "No step is running under a credential right now.",
        step_scoped_step: "step {s}",
        step_scoped_first_issued: "first issued {d}",
        step_scoped_current_expires: "current credential expires {d}, renewed while the step keeps running",
        step_scoped_started_by: "started by {who}",
        no_tokens: "No tokens yet. Mint one to connect a CLI agent.",
        allow_list: "What this token may call",
        token_inherits: "A token starts with your permissions and can only narrow them. It can never do more than you can, and deleting, billing and member management are not available to it at all.",
        self_hosted_note: "Self-hosted means the MCP address is on your network. Your code and task data never leave it. Only the call to the AI model does, and that can point at your own GPU.",

        attrib_lead: "Person, tool, then account type — in that order, everywhere.",
        attrib_title: "How it reads on the task",
        attrib_count: "{n} RECENT RUNS",
        attrib_empty: "No agent has run here yet. Start one from the agents list and it will appear with its account type.",
        attrib_member: "Member",
        attrib_agent: "Agent",
        attrib_via: "{who} via {tool}",
        tag_human: "HUMAN",
        tag_personal: "PERSONAL",
        tag_workspace: "WORKSPACE",
        tag_local: "LOCAL",
        elapsed: "{n}m",
        by_source_title: "Agent time by account",
        by_source_total: "{n}H OF RUNS",
        by_source_source: "Elapsed time on agent runs recorded in this workspace, split by the account each run went through. Human hours are counted separately on the timesheet.",
        why_split_label: "Why split them:",
        why_split_body: "velocity that quietly includes agent hours is a lie you will plan next quarter on. Keep the split visible and your estimates stay usable.",
        billing_q_label: "The billing question this settles:",
        billing_q_body: "when a client asks what the agent hours were, you can show the tasks, the links and who supervised them, and whether the run was billed to the workspace at all.",

        rules_lead: "The awkward cases, decided in code rather than left to a conversation. Each rule names where it is enforced.",
        rules_people: "People",
        rules_policy: "Policy",
        rules_money: "Money",
        rule_leaves: "Someone leaves.",
        rule_leaves_body: "Unlinking clears their account and deactivates every agent token they hold in this workspace. Their comments, PRs and logged hours stay on the tasks, attributed to them. Nothing is deleted.",
        rule_leaves_where: "Modules/Agents/accounts.js — unlink sets active false on their agent tokens and unsets agentAccount",
        rule_lapses: "Their subscription lapses.",
        rule_lapses_body: "A personal-mode CLI fails on their machine, and AlianHub never sees it: a CLI session creates no run record, so the task simply stays assigned to them with no new activity. Workspace-mode runs do record a failed status with the reason.",
        rule_lapses_where: "Modules/Agents/runs.js — a failed status is written by the server-side run engine only",
        rule_contractor: "A contractor wants their own account.",
        rule_contractor_body: "Allowed, but their token can be scoped to the projects they are in. Then even the next-task and search tools only return tasks from those projects.",
        rule_contractor_where: "Modules/Mcp/tools.js — scopeFilter adds the token's projectIds to every tool query",
        rule_two_people: "Two people, one task.",
        rule_two_people_body: "Both can run agents on it. Each comment is stamped with the actor type, the agent and the account it came through, so a duplicate PR is obvious rather than mysterious.",
        rule_two_people_where: "Modules/Agents/actions.js — task.comment stamps actorType, agentId and viaAccount on the comment",
        rule_require_mode: "An admin can require a mode.",
        rule_require_mode_body: "A regulated customer allows local only, and linking or minting anything else is refused with the reason shown rather than the option quietly disappearing.",
        rule_require_mode_where: "Modules/Agents/accounts.js link and Modules/ApiTokens/controller.js createMcpToken both check the policy first",
        rule_unattended: "Personal accounts cannot run unattended.",
        rule_unattended_body: "A scheduled run through a personal account is refused, because nobody should be billed for a run they did not trigger while their laptop was shut.",
        rule_unattended_where: "Modules/Agents/runs.js — canStart refuses a scheduled trigger when the account is personal",
        rule_allow_list: "The allow-list does not change.",
        rule_allow_list_body: "A personal account gets exactly the tools listed on the setup panel. The registry decision takes no account mode as an argument, so paying for your own model does not buy extra permissions.",
        rule_allow_list_where: "Modules/Agents/registry.js — evaluate takes an action key and its details, never a mode",
        rule_reimbursement: "Reimbursement is a report, not a feature.",
        rule_reimbursement_body: "AlianHub counts tasks and hours through each person's account from its own rows. It never reads a provider invoice, and has no field to store one.",
        rule_reimbursement_where: "Modules/Agents/accounts.js — monthlySummary reads timesheet, run and task-link rows only",
        rule_personal_spend: "Personal spend is never the workspace's.",
        rule_personal_spend_body: "A run through a personal account records the workspace cost as $0, keeps the estimate separately, and returns before touching the agent's monthly total.",
        rule_personal_spend_where: "Modules/Agents/runs.js — recordSpend marks the run as not billed to the workspace",
        rule_local_spend: "Local runs cost the workspace nothing.",
        rule_local_spend_body: "Self-hosted runs are treated the same way as personal ones for billing: no workspace dollars, and no contribution to a cap.",
        rule_local_spend_where: "Modules/Agents/runs.js — recordSpend excludes both personal and local from billing",
        rule_revoke: "Revoking stops future runs and keeps the history.",
        rule_revoke_body: "Revoke here deactivates the token, so it stops authenticating immediately. Every audit row, comment and time log it already wrote stays exactly where it is.",
        rule_revoke_where: "Modules/ApiTokens/controller.js — verifyToken only accepts an active token; audit rows live in their own collection",
        rule_caps: "A cap pauses the agent, it does not fail quietly.",
        rule_caps_body: "When workspace-billed spend reaches an agent's monthly cap the agent is paused with the reason recorded, and the next run is refused with that same reason.",
        rule_caps_where: "Modules/Agents/runs.js — recordSpend pauses at the cap and canStart refuses once it is reached",

        never_title: "Absent from the registry, in every mode",
        never_source: "LIVE FROM THE MCP LIST",
        never_body: "These are not permissions that were switched off. They are not on the action list at all, so a stolen token has nothing to switch on, and an attempt is refused with an audit id.",
        undecided_title: "Not decided in code yet",
        undecided_1: "Exporting the monthly summary.",
        undecided_1_body: "The numbers above are computed on request and there is no export option, so a reimbursement claim is currently a manual read rather than a file.",
        undecided_2: "Per-person visibility of the full call list.",
        undecided_2_body: "Every call is audited, but who may read those rows is governed by the existing audit permissions. There is no per-member setting to share or hide the detail.",
        why_shape_body: "The alternative — the company buys keys for everyone and proxies every call — puts AlianHub in the middle of every prompt a developer writes. That is a privacy problem, a cost problem and a support problem, and developers work around it by using their own CLI outside the tool anyway. Let them keep their own account and their own habits; AlianHub's job is to hand over a good brief and to record what came back."
    },
    Pipeline: {
        nav_pipeline: "Pipeline",
        nav_release: "Release & deploy",
        title: "The pipeline",
        release_title: "Release & deploy",
        lead: "One task, five stages, one hard stop. What an agent may do, what it may only propose and what it cannot reach are read from the action registry — not written down here.",
        loading: "Loading…",
        pick_task: "TASK",
        empty_title: "No agent has worked a task yet",
        empty_body: "The pipeline draws itself from real runs and proposals. Start a run from an agent and this fills in.",
        empty_cta: "Go to agents",
        no_key: "no key",
        activity_meta: "{runs} runs · {proposals} proposals",
        open_task: "Open task",
        hard_stop: "HARD STOP",
        agent_tag: "AGENT",
        audit: "AUDIT",
        audit_restricted: "Audit rows are visible to Owners and Admins.",
        actor_person: "actor: person",
        actor_agent: "actor: agent",
        actor_proposes: "actor: agent proposes",
        actor_person_only: "actor: person only",
        actor_none: "actor: nobody",
        human_approves: "human approves",
        attempts_logged: "attempts are logged",
        unassigned_agent: "no agent yet",
        s1_title: "Task",
        s1_body: "A person writes the brief and assigns it.",
        s1_none: "This task has no brief yet.",
        brief_written: "Brief written",
        status_now: "status {status}",
        s2_title: "Branch & work",
        s2_body: "The agent reads the brief, works, and keeps the task and the timer current. It may set In progress or In review — never Done.",
        s2_none: "No run on this task yet.",
        run_line: "{status} · {elapsed} · ${usd}",
        s3_title: "PR & CI",
        s3_body: "The agent attaches the PR and posts what it found. CI keeps running wherever it runs today — AlianHub reads the result, it never builds.",
        s3_none: "Nothing linked to this task, and no CI source is connected.",
        link_action: "task.link",
        linked: "linked {what}",
        s4_title: "Staging",
        s4_body: "{actions} is propose-only: an agent may ask, {gate} decides in the AI Inbox.",
        s4_body_none: "The registry has no gated action right now, so nothing can be proposed for staging.",
        s4_none: "No staging deploy has been proposed for this task.",
        s4_none_registry: "No gated action exists in the registry.",
        s5_title: "Production",
        s5_body: "{keys} are absent from the registry. Not disabled — absent, so there is no flag to switch on.",
        s5_body_reachable: "A deploy or merge action is present in the registry. Review it: production is meant to be unreachable for agents.",
        s5_none: "{n} actions are named as never reachable.",
        awaiting: "waiting for {gate}",
        decided: "{status} {at}",
        gate_owner_admin: "an Owner or Admin",
        gate_human: "a person",
        gate_none: "no gate",
        note_a_title: "What AlianHub contributes at each stage.",
        note_a_body: "Stage 1 gives the agent a brief instead of a ticket. Stages 2 and 3 keep the task, timesheet and burndown current without anyone typing an update. Stage 4 turns \"who approved that deploy?\" into a row in the audit log. Stage 5 is outside the agent's reach, so the answer to \"can it ship to prod?\" is no, structurally.",
        note_b_title: "Where your existing CI fits.",
        note_b_body: "Nothing changes in your build process. AlianHub would read status from the pull request and the deploy alert. It never runs your builds.",
        note_b_link: "Connect an integration",
        since: "since {at}",
        candidate: "Candidate release · on {version}",
        candidate_meta: "SINCE v{last} · {n} TASKS DONE",
        on_staging: "On staging",
        stat_done: "TASKS DONE",
        stat_done_sub: "{n} an agent worked on",
        stat_agents: "AGENTS",
        stat_agents_sub: "across {n} project | across {n} projects",
        stat_ci: "CI",
        stat_ci_sub: "No CI source is connected",
        stat_staging: "ON STAGING",
        not_connected: "not connected",
        connected: "connected",
        none: "none",
        staging_by: "proposed by {agent}",
        staging_never: "No staging deploy has been approved",
        notes_title: "Release notes",
        draft: "DRAFT",
        review_draft: "Review the draft",
        notes_none: "No agent has drafted release notes. A drafting skill would file one here as a proposal you approve — until then, this is what has been marked Done.",
        agent_worked: "AGENT",
        no_done_tasks: "Nothing has been marked Done since the last release.",
        staging_title: "Deploy to staging",
        staging_rule: "{keys} is propose-only in the registry: an agent may ask, {gate} approves it, and the decision lands in the audit log.",
        staging_rule_none: "The registry has no gated action, so no agent can propose a staging deploy.",
        staging_none: "No staging deploy has been proposed.",
        approve_in_inbox: "Review in AI Inbox",
        prod_title: "Deploy to production",
        human_only: "HUMAN ONLY",
        check_done: "{n} task marked Done | {n} tasks marked Done",
        check_human: "Every Done was set by a person — agents cannot set Done",
        check_staging_ok: "Staging deploy approved {at}",
        check_staging_todo: "No staging deploy approved yet",
        check_ci: "CI result unknown — no CI source is connected",
        no_target_title: "No deploy target configured",
        no_target_body: "AlianHub has no deploy integration, so there is no production button to press here. Deploying stays in whatever tool you deploy with today; this screen records who decided what.",
        never_line: "Not offered to any agent: {keys}",
        rel_foot: "Agents can get you a branch, findings and a clean staging run. The last step stays a decision with a name on it — and the name lands in the audit log next to the version.",
        environments: "ENVIRONMENTS",
        env_production: "production",
        env_staging: "staging",
        env_prod_meta: "running v{version}",
        env_none: "not reported",
        deploy_history: "DEPLOY HISTORY",
        hist_staging: "staging proposed by {agent} — {status}",
        hist_refused: "refused — {who}, {action} not in registry",
        hist_none: "Nothing has been proposed or refused yet.",
        hist_none_restricted: "Nothing proposed yet. Refused attempts are visible to Owners and Admins.",
        code_providers: "CODE PROVIDERS",
        side_note: "This screen reads what AlianHub already records. It does not run builds, and it cannot deploy.",
        live: "LIVE",
        live_on: "is on {what}",
        live_running: "is running",
        live_agents: "{n} agent working | {n} agents working",
        live_mixed: "{n} working now",
        pause_all: "Pause all agents",
        toast_finished: "{agent} finished",
        now: "now",
        toast_no_outcome: "The run ended {status}.",
        toast_review: "Review",
        toast_open_pipeline: "Open pipeline",
        toast_dismiss: "Dismiss"
    },
    ActivityLog: {
        agent_mark: "AGENT",
        agent_mark_title: "Made by {agent}, an agent",
        filter_label: "Which changes to show",
        filter_all: "All",
        filter_agents: "Made by an agent",
        no_agent_activity: "No changes made by an agent"
    },
    AppConnections: {
        nav: "App connections",
        title: "App connections",
        lead: "Every app this workspace can connect to, when it was last read, what went wrong, and which projects it feeds. Secrets are never shown.",
        off: "App connections are switched off on this server. Ask whoever runs it to turn them on.",
        connect: "Connect",
        disconnect: "Disconnect",
        confirm_disconnect: "Click again to disconnect",
        pause: "Pause",
        resume: "Resume",
        save: "Save",
        cancel: "Cancel",
        state_connected: "Connected",
        state_paused: "Paused",
        state_error: "Needs attention",
        last_sync: "Last sync",
        last_error: "Last error",
        retry_at: "Next try",
        never: "Not yet",
        none: "None",
        projects: "Projects",
        no_projects: "No project linked yet, so nothing is read.",
        link_projects: "Link projects",
        hidden_project: "A project you cannot open",
        hidden_projects: "{count} more project you cannot open | {count} more projects you cannot open",
        read_only: "Only an owner or admin can connect, pause or disconnect apps.",
        desc_slack: "Slash commands (/alianhub) from your Slack workspace.",
        desc_github: "Link commits and pull requests to tasks.",
        desc_gitlab: "Link merge requests and commits to tasks.",
        desc_google_calendar: "2-way calendar sync (OAuth). The read-only iCal feed needs no setup.",
        desc_microsoft_teams: "Post task updates to a Teams channel.",
        desc_zapier: "Connect to 6000+ apps via a catch hook.",
        desc_custom_iframe: "Embed an external tool as an app panel.",
        field_slack_verification_token: "Slack verification token",
        field_slack_default_channel: "Default channel",
        field_github_token: "Personal access token",
        field_github_repo: "Repository (owner/repo)",
        field_gitlab_token: "Access token",
        field_gitlab_project: "Project path",
        field_google_calendar_client_id: "OAuth client ID",
        field_google_calendar_client_secret: "OAuth client secret",
        field_microsoft_teams_webhook_url: "Incoming webhook URL",
        field_zapier_hook_url: "Zapier catch hook URL",
        field_custom_iframe_name: "App name",
        field_custom_iframe_url: "Embed URL (https)",
        failed: "Something went wrong. Try again.",
        github_setup_title: "GitHub sign-in isn't set up on this server yet",
        github_setup_register: "Register a GitHub OAuth App (GitHub Settings, Developer settings, OAuth Apps, New OAuth App) with these two addresses:",
        github_setup_homepage: "Homepage URL",
        github_setup_callback: "Authorization callback URL",
        github_setup_env: "Put its client ID and a new client secret in the server's .env as {idName} and {secretName}.",
        github_setup_restart: "Restart the server, then click Connect again.",
        github_use_token: "Use a personal access token instead",
        github_ask_admin: "Ask an admin to set up GitHub sign-in.",
        copy: "Copy",
        copied: "Copied",
        github_connected: "GitHub is connected. Pick the repository it reads, then link projects.",
        github_expired: "The GitHub sign-in expired or was already used. Click Connect again.",
        github_denied: "GitHub sign-in was cancelled, so nothing changed.",
        github_rights: "Only an owner or admin can connect GitHub.",
        github_off: "One-click GitHub is not set up on this server.",
        github_failed: "GitHub could not be connected. Try again.",
        pick_repo: "Pick repository",
        change_repo: "Change repository",
        repo_needed: "No repository picked yet, so nothing is read.",
        repo_label: "Repository",
        more_repos: "Show more",
        no_repos: "This GitHub account cannot see any repository.",
        repo_filter: "Search repositories",
        no_repo_match: "No repository matches that search.",
        egress_blocked: "AlianHub isn't allowed to reach {host} yet.",
        egress_allow: "Allow {host}",
        egress_settings: "Open Settings > Instance > Egress",
        egress_ask_owner: "Ask the instance owner to allow {host}.",
        egress_allowed: "{host} is allowed now.",
        egress_allow_failed: "{host} could not be allowed from here. Add it under Settings > Instance > Egress.",
        github_connected_projects: "GitHub is connected. Add a repository to each project that should read it.",
        repo_table_title: "Projects and repositories",
        repo_table_project: "Project",
        repo_table_repo: "Repository",
        repo_add: "Add repository",
        repo_remove: "Remove",
        repo_remove_label: "Remove {repo} from {project}",
        repo_choose_project: "Choose a project",
        repo_none_mapped: "No repository is linked to a project yet, so nothing is read."
    },
    ProjectGithub: {
        title: "GitHub repositories",
        hint: "A pull request whose title or branch carries a task key is linked to that task, and its merge moves the task to In review.",
        connect: "Connect GitHub",
        ask_admin: "Ask an admin to connect GitHub.",
        set_up: "Set up GitHub on App connections",
        none: "No repository is linked to this project yet.",
        add: "Add repository",
        remove: "Remove",
        remove_label: "Remove {repo} from this project",
        unreachable: "The person who connected GitHub cannot open this project, so nothing would be read. Add them to the project, or connect GitHub again as someone who can.",
        paused: "GitHub is paused for this workspace.",
        connected: "GitHub is connected. Pick the repository this project reads.",
        added: "{repo} now feeds this project.",
        removed: "{repo} no longer feeds this project.",
        failed: "Something went wrong. Try again.",
        chip_one: "GitHub: {repo}",
        chip_many: "GitHub: {count} repositories",
        chip_title: "Open this project's GitHub repositories"
    },
    Provenance: {
        nav_external_data: "External data",
        col_done_by: "Done by",
        badge_human: "HUMAN",
        badge_agent: "AGENT",
        badge_mixed: "MIXED",
        badge_unchecked: "UNCHECKED",
        badge_human_hint: "People did the work.",
        badge_agent_hint: "An agent did the work and a person checked it.",
        badge_mixed_hint: "A person and an agent both worked on it.",
        badge_unchecked_hint: "An agent did the work and nobody has checked it.",
        checked_by: "checked {name}",
        closed_by: "closed {name}",
        not_checked: "not checked",
        via: "{name} via {agent}",
        cli_agent: "a CLI agent",
        an_agent: "an agent",
        someone: "someone",
        work_join: ", then ",
        done_by: "Done by: {value}",
        filter_label: "Filter · done by",
        filter_hint: "Agent-built and unchecked is the one worth pinning to a dashboard.",
        opt_all: "All",
        opt_human: "Human",
        opt_agent: "Agent",
        opt_mixed: "Mixed",
        opt_unchecked: "Unchecked",
        rollup_title: "{name} · who finished what",
        this_project: "This project",
        tasks_closed: "{n} task closed | {n} tasks closed",
        points: "{n} POINTS",
        legend_human: "human",
        legend_agent: "agent-built",
        legend_mixed: "mixed",
        legend_unchecked: "unchecked",
        pass_agent: "Agent-built tasks",
        pass_human: "Human tasks",
        first_pass_value: "{pct}% first-pass",
        first_pass_note: "First-pass = closed without going back to In progress. Agent work needs a second pass more often; that is useful to know, not a reason to stop.",
        downstream: "What this changes downstream",
        velocity_line: "Velocity reads two ways: {total} points closed in all, {human} by people alone. Plan ahead on the people's figure if your agent access might change.",
        margin_line: "Cost per closed task: {cost} overall, {human} where only people worked, {agent} where an agent did.",
        margin_no_rate: "Set a blended cost rate on the project contract to see cost per closed task.",
        unchecked_line: "{n} closed with agent work nobody checked.",
        why: "Every field here is filled by an action someone already took — the work log, the review, the close. In a year, teams that can say which work an agent did, and who checked it, will be able to answer a client, an auditor and their own retro.",
        loading: "Reading the completion records…",
        load_failed: "Could not load the rollup.",
        empty_title: "Nothing closed here yet.",
        empty_sub: "The split appears as tasks are finished.",
        ext_title: "External data & agents",
        ext_meta: "{sources} CONNECTED · {agents} AGENTS",
        ext_connect: "Connect",
        ext_sources: "Where data comes in",
        ext_sources_sub: "what an agent may read from each",
        ext_not_connected: "Not connected",
        ext_connected: "connected",
        ext_no_mirror: "AlianHub does not mirror external tables. A linked row stays in its source — comment on it, link tasks to it and filter on it here; edits happen where the data lives.",
        ext_hand_off: "Hand a task to a coding agent",
        ext_external: "EXTERNAL",
        ext_mcp_name: "This workspace's MCP server",
        ext_tools: "{n} tools",
        ext_account_sub: "{mode} account · reports back here",
        ext_month: "{tasks} tasks · {hours}h · {prs} PRs this month",
        ext_no_account: "No coding agent linked",
        ext_no_account_sub: "Link one to hand tasks to Claude Code, Cursor or your own CLI.",
        ext_link_account: "Link",
        ext_agent_sub: "{account} account",
        ext_paused: "Paused",
        ext_handed: "Handed to {agent} · {when}",
        ext_handed_note: "Status moves to In progress and findings land as a comment. Merging is still a human's job.",
        ext_never: "Never available to an agent",
        ext_same_treatment: "External agents get the same treatment as yours: allow-listed actions, everything through the AI Inbox, full audit.",
        mob_tap_slot: "Tap a time to place {task}",
        mob_cancel: "Cancel",
        ext_mcp_mark: "MCP",
    },
    Gaps: {
        wip_note: "Saved for everyone on this project. Over the limit warns, it never blocks a move.",
        wip_over: "Over the in-progress limit of {limit}",
        wip_save_failed: "That limit could not be saved. Try again.",
        on_submit_rules: "Then, automatically",
        add_submit_rule: "Add a rule",
        submit_rule_when: "When an answer",
        submit_rule_any: "Any submission",
        submit_rule_is: "is",
        submit_rule_then: "then",
        submit_rule_value: "Value",
        submit_rule_save: "Save rule",
        submit_rule_cancel: "Cancel",
        submit_rule_name: "On submit: {action}",
        submit_rule_saved: "Rule saved. It runs on the next submission.",
        submit_rule_failed: "That rule could not be saved.",
        submit_rule_needs_task: "Turn on \"Create task\" first — these rules act on the task a submission files.",
        submit_rule_needs_project: "Open this form inside a project to add a rule.",
        submit_rule_remove: "Remove",
        submit_rule_on: "On",
        submit_rule_off: "Off",
        no_submit_rules_v2: "Nothing runs after a submission yet."
    },
    Org: {
        tab_directory: "Directory",
        tab_org: "Org chart",
        reports_to: "Reports to",
        reports_to_name: "Reports to {name}",
        no_manager: "No manager",
        reports_count: "{count} REPORT | {count} REPORTS",
        empty_title: "No reporting lines yet",
        empty_editable: "Nobody in this workspace has a manager recorded. Open someone in the directory and set who they report to, and the chart builds itself from there.",
        empty_readonly: "Nobody in this workspace has a manager recorded. An owner or an admin can set who reports to whom.",
        empty_action: "Back to the directory",
        org_note: "A reporting line is set by an owner or an admin and is separate from team membership. Guests, invitations that are still pending and agents never appear here.",
        save_failed: "That reporting line could not be saved."
    },
    Header: {
        help: "Help",
        wordmark_start: "Alian",
        wordmark_end: "Hub",
        open_advance_filter: "Open Advance Filter",
        search_shortcut: "(Ctrl + K)",
        Project_Forecasting: "Project Forecasting (Coming soon)",
        Resource_Planning: "Resource Planning (Coming soon)",
        Projects: "Projects",
        Pages: "Pages",
        Portfolio: "Portfolio",
        Custom_Report: "Custom Report",
        Variance_Report: "Variance Report",
        Capacity_Planning: "Capacity Planning",
        Integrations: "Integrations",
        Workspace: "Workspace",
        Time_Sheet: "Time Sheet",
        User_Timesheet: "User Timesheet",
        project_Timesheet: "Project Timesheet",
        Workload_Timesheet: "Workload Timesheet",
        Tracker_Timesheet: "Tracker Timesheet",
        Time_Forcasting: "Time Forecasting",
        Reports: "Reports",
        Milestone_Report: "Milestone Report",
        Chat: "Chat",
        Notification: "Notification",
        mention: "Mention",
        Tours: "Tours",
        Logout: "Logout",
        Mark_all_as_read: "Mark all as read",
        Mark_all_as_complete: "Mark all as Complete",
        View_Archive: "View Archive",
        View_Unread: "View Unread",
        designation: "Designation",
        upgrade_now: "Upgrade Now",
        load_more: "Load more",
        take_tour: "Take a Tour",
        task_details: "Task Details",
        Comments: "Comments",
        activity_log: "Activity Log",
        time_log: "Time Log",
        mentions: "Mentions",
        Notifications: "Notifications",
        no_data_found: "No Data Found",
        search_results: "Search results",
        my_profile: "My Profile",
        billing_history: "Billing History",
        Assignee: "Assignee",
        "Due Date": "Due Date",
        Priority: "Priority",
        Key: "Key",
        "Created Date": "Created Date",
        "Created By": "Created By",
        advance_search: "Advance Search",
        for_advance_search: "For Advance Search",
        get_more: "Get more?",
        to_unlock_activity_view: "To Unlock Activity View",
        AssigneeUserId: "Assignee",
        DueDate: "Due Date",
        TaskKey: "Key",
        Task_Priority: "Priority",
        commentCounts: "Chat",
        created_by: "Created By",
        created_date: "Created Date",
        create_project: "Create Project",
        Company: "Company",
    },
    ProjectDetails: {
        select_project_category: "Select Project Category",
        select_currency: "Select Currency",
        description: "Description",
        details: "Details",
        status: "Status",
        assignee: "Assignee",
        key: "Key",
        category: "Category",
        source: "Source",
        type: "Type",
        billing_period: "Billing Period",
        currency: "Currency",
        amount: "Amount",
        proposal_id: "Proposal ID",
        skills: "Skills",
        no_skills: "No Skills",
        no_skills_configured: "No skills have been added in company settings yet.",
        working_days: "Working days",
        working_days_company: "Use the company's working days",
        skills_limit: "Up to {count} skills per project.",
        start_date: "Start Date",
        end_date: "End Date",
        no_start_date: "No Start Date",
        no_end_date: "No End Date",
        no_due_date: "No Due Date",
        msg: "The start date can't be modify because it is already",
        msgbr: "within a milestone range.",
        startdatemsg0: "The start date can't be modify because it is already",
        startdatemsg1: "within a milestone range.",
        ok: "ok",
        lead: "Lead",
        browse_by_category: "Browse by category",
        subtask: "Subtask",
        details_project_setup: "Details of the Project set up",
        avatar: "Avatar",
        shared_with: "Shared with",
        no_user_selected: "No Users Selected",
        required_view: "Required views",
        set_the_require:
            "Set the view(s) you require. These views will be automatically when you are navigating to Projects, Folders, and Lists in BRAND_NAME instead of manually creating them. Once created, views cannot be deleted.",
        always_required: "Always Required",
        make_default: "Make Default",
        view_actions: "View actions",
        show_hide_columns: "Show or hide columns",
        reporter: "Reporter",
        copy_task_link: "Copy Task Link",
        copy_task_key: "Copy Task Key",
        remind_me: "Remind me",
        reminder_when: "Remind me at",
        reminder_note: "Note (optional)",
        reminder_set: "Reminder set",
        reminder_failed: "Could not set reminder",
        add_que_list: "Add to Queue List",
        remove_que_list: "Remove to Queue List",
        convert_list: "Convert to List",
        convert_subtask: "Convert to Subtask",
        convert_subtree_too_deep: "Subtasks go three levels deep, and this task's subtasks already fill two. Move them out before putting it under another task.",
        merge: "Merge",
        move: "Move",
        convert_task: "Convert to Task",
        no_currency_found: "no currency found",
        remove_from_queue_list: "Remove from Queue List",
        convert: "Convert",
        DUPLICATE_AND_OPEN: "Duplicate and Open",
        MOVE_AND_OPEN: "Move and Open",
        CONVERT_AND_OPEN: "Convert and Open",
        MERGE_AND_OPEN: "Merge and Open",
    },
    ProjectSlider: {
        new_project: "New Project",
        no_archived: "No Archived Data Found",
        you_dont: "You don't have any projects",
        archived_list: "Archived List",
        project_name: "Project Name",
        show_archive: "Show Archive",
        hide_archive: "Hide Archive",
        no_result_found: "No Results found",
        select_project_status: "Select Project Status",
        no_activity_log_found: "No activity log found",
    },
    Projects: {
        not_available: "N/A",
        filters: "Filters",
        filters_active: "Filters, {n} active",
        filters_close: "Close filters",
        actions_for_item: "Actions for {name}",
        status_actions: "Status actions",
        select_source: "Select Source",
        source_upwork: "Upwork",
        source_fiverr: "Fiverr",
        source_other: "Other",
        source_required: "Select where this project came from.",
        proposal_id_required_upwork: "A proposal ID is required for Upwork projects.",
        proposal_id_format_hint: "Paste the id from the proposal URL — the '~' prefix and trailing '/' are removed for you.",
        proposal_id_format_warning: "That doesn't look like an Upwork proposal ID. It will still be saved.",
        sprint: "List",
        folder: "Folder",
        task_view: "Task View",
        default_view: "Default View",
        add_view: "Add View",
        rename: "Rename",
        pin: "Pin",
        edit_code: "Edit Code",
        copy_link: "Copy Link",
        watchers: "Watchers",
        watchers_count: "{n} watcher | {n} watchers",
        automate: "Automate",
        automate_title: "Set up an automation for this project",
        stop_watching: "Stop watching",
        list_actions: "List actions",
        active_members: "People active in this project",
        files_links: "Files & Links",
        audio_files: "Audio Files",
        project_permissions: "Project Permissions",
        color_avatar: "Color & Avatar",
        duplicate: "Duplicate",
        search_in: "Search In",
        expanded: "Expanded",
        collapsed: "Collapsed",
        me: "Me",
        status: "Status",
        priority: "Priority",
        due_date: "Due Date",
        assignee: "Assignee",
        unassigned: "Unassigned",
        group_by: "Group by",
        subtask: "Subtask",
        task_name: "Task Name",
        task_key: "Task key",
        everyone: "Everyone",
        private: "Private",
        share_with: "Share With",
        create_new_list: "Create new list",
        create_new_folder: "Create New Folder",
        unpin: "Unpin View",
        pinview: "Pin View",
        deleteview: "Delete View",
        cancel: "Cancel",
        tasks: "Tasks",
        save: "Save",
        create_project: "Create Project",
        use_template: "Use Template",
        blank_project: "Blank Project",
        no_category_found: "No category found",
        template: "Template",
        save_create: "Save & Create",
        save_tamplete: "Save as Template",
        previous: "Previous",
        new_task: "New Task",
        sprint_planned: "Planned",
        sprint_logged: "Logged",
        sprint_overdue: "Overdue",
        sprint_planned_hint: "Hours planned across every task in this list, subtasks included",
        sprint_logged_hint: "Hours logged across every task in this list, subtasks included",
        sprint_overdue_hint: "How far this list is on course to run past its plan. Finished tasks count what they actually logged; unfinished ones count their plan, or the time already spent if that is more.",
        add_subtask: "Add Subtask",
        linked_tasks: "Linked Tasks",
        add_link: "Link Task",
        remove_link: "Remove link",
        no_linked_tasks: "No linked tasks yet",
        search_task_to_link: "Search task by name...",
        no_task_found: "No matching task found",
        searching: "Searching...",
        link_task_deleted: "deleted",
        link_task_unavailable: "Task unavailable",
        relation_blocks: "Blocks",
        relation_blocked_by: "Blocked by",
        relation_duplicates: "Duplicates",
        relation_duplicated_by: "Duplicated by",
        relation_relates_to: "Relates to",
        blocked_warning: "Blocked by {count} open task(s):",
        add_reaction: "Add reaction",
        burndown: "Burn-down",
        select_sprint: "List",
        no_burndown_data: "No data for this list yet",
        recent_tasks: "Recent",
        no_recent_tasks: "No recently visited tasks",
        global_search: "Search all",
        search_everything: "Search tasks, projects and comments...",
        no_search_results: "Nothing found",
        epics: "Epics",
        add_epic: "Add",
        epic_name_placeholder: "New epic name...",
        no_epics: "No epics yet",
        select_epic: "Add to epic",
        epic_priority: "Priority",
        priority_low: "Low",
        priority_medium: "Medium",
        priority_high: "High",
        epic_start_date: "Start",
        epic_due_date: "Due",
        epic_owner: "Owner",
        epic_unassigned: "Unassigned",
        epic_status_open: "Open",
        epic_status_in_progress: "In progress",
        epic_status_done: "Done",
        remove_from_epic: "Remove from epic",
        export_tasks: "Export",
        export_preparing: "Export started — preparing your file...",
        export_ready: "Export ready — downloading",
        export_failed: "Export failed",
        pages: "Pages",
        add_page: "New page",
        add_sub_page: "Add a nested page",
        search_pages: "Find a page…",
        no_pages: "No pages yet",
        no_pages_match: "Nothing matches that search.",
        select_page: "Open a page from the index, or start a new one.",
        save_page: "Save",
        page_saving: "Saving…",
        page_saved: "Saved",
        pages_space_kicker: "Workspace pages",
        pages_compose_placeholder: "Ask for a draft, an outline, a tighter cut…",
        pages_compose: "Compose",
        pages_composing: "Composing…",
        pages_compose_draft: "Draft",
        pages_compose_expand: "Expand",
        pages_compose_summarize: "Tighten",
        pages_compose_outline: "Outline",
        pages_compose_rewrite: "Rewrite",
        pages_compose_ask: "Ask",
        pages_ai_missing: "Connect an AI model in your setup to write from here. You can still write by hand.",
        pages_ai_applied: "Inserted into the page",
        pages_ai_answer: "Answer",
        pages_ai_insert_below: "Insert below",
        pages_ai_replaced: "Replaced the page with the AI result",
        pages_ai_added: "Added the AI result below the page",
        pages_ai_added_top: "Added the summary at the top of the page",
        pages_ai_summarise_page: "Summarise this page",
        pages_ai_extract_items: "Extract action items",
        pages_ai_insert_top: "Insert at top",
        pages_ai_summary: "Summary",
        pages_blank_hint: "A page can hold the brief, the decision, the notes — then link the tasks that carry it out.",
        untitled_page: "Untitled page",
        doc_private: "Private",
        doc_shared: "Shared",
        doc_private_hint: "Only you and the people you share it with can see this doc",
        doc_private_hint_reader: "Only its author and the people it is shared with can see this doc",
        doc_shared_hint: "Everyone on this project can see this doc",
        doc_private_author_only: "Only the author can make this doc private",
        doc_share_title: "Share this doc",
        doc_share_scope: "Shared with this project",
        doc_share_scope_off_hint: "Off: only you and the people you share it with can see this doc",
        doc_share_scope_off_hint_reader: "Off: only its author and the people it is shared with can see this doc",
        doc_public_link: "Share link with anyone",
        doc_public_link_hint: "Anyone with the link can read this doc — no login needed",
        doc_public_needs_shared: "Set the doc to Shared first",
        doc_copy_public_link: "Copy public link",
        doc_link_tasks: "Link tasks",
        doc_linked_tasks: "Linked tasks",
        doc_unlink: "Unlink",
        doc_no_linked_tasks: "Not linked to any task yet",
        linked_docs: "Linked Docs",
        task_no_docs: "No docs linked to this task",
        task_link_doc: "Link a doc",
        doc_all_linked: "Every doc in this project is already linked.",
        page_title_placeholder: "Doc title",
        doc_create_hint: "The doc is linked to this task and opens for editing.",
        create: "Create",
        page_unsaved: "Unsaved changes",
        page_edited_by_ago: "Edited by {who} · {when}",
        forms: "Forms",
        add_form: "New form",
        no_forms: "No forms yet.",
        no_forms_hint: "Create a form to start collecting requests as tasks.",
        select_form: "Pick a form on the left, or create a new one.",
        form_untitled: "Untitled form",
        form_draft: "Draft",
        form_live: "Live",
        form_target_sprint: "Submissions go to",
        form_pick_sprint: "Choose a list…",
        form_task_type: "Create tasks as",
        form_default_task_type: "Project default",
        form_view_submissions: "View Submissions",
        form_refresh: "Refresh",
        form_export: "Export to Excel",
        form_open_file: "Open the attached file",
        form_export_truncated: "Only the first 5000 submissions were exported.",
        form_search_submissions: "Search submissions…",
        form_no_matches: "No submissions match that search.",
        form_page_of: "Page {page} of {pages}",
        form_prev_page: "Previous",
        form_next_page: "Next",
        form_remove_question: "Remove question",
        form_close_edit: "Close editing",
        form_edit_question: "Edit question",
        form_drag_to_reorder: "Drag to reorder",
        form_back_to_form: "Back to form",
        form_submissions_title: "Submissions",
        form_submissions_count: "{count} submitted",
        form_no_submissions: "No submissions yet. Share the form link to start collecting responses.",
        form_submitted_at: "Submitted",
        form_task: "Task",
        form_open_task: "Open the task this response created",
        form_question_removed: "This question is no longer on the form",
        form_create_task: "Create a task for each submission",
        form_needs_task_name: "This form creates a task for each submission, so one question must be mapped to Task Name.",
        form_turn_off_tasks: "Only collect responses",
        form_create_task_hint: "Turn this off to only collect responses. Answers are always saved to the submissions table.",
        form_save: "Save",
        form_saved: "Saved",
        form_delete: "Delete form",
        form_delete_title: "Are you sure you want to delete \"{title}\"?",
        form_delete_desc: "This action cannot be undone. Its submissions will no longer be viewable. Tasks already created from it are kept.",
        form_delete_live_blocked: "This form is published. Unpublish it first, then delete it.",
        form_deleted: "Form deleted.",
        form_discard_confirm: "You have unsaved changes. Leave without saving?",
        form_tab_build: "Build",
        form_tab_preview: "Preview",
        form_open: "Open form",
        form_submit: "Submit",
        form_hide: "Hide from the form",
        form_question_help: "Add question description (optional)",
        form_option: "Option",
        form_add_option: "Add option",
        form_scale: "Stars",
        form_done: "Done",
        form_question_types: "Questions type",
        form_create_field: "Create new field",
        form_map_task: "Map to a task field",
        form_width: "Width",
        form_width_12: "Full",
        form_width_6: "1/2",
        form_width_4: "1/3",
        form_width_3: "1/4",
        form_colors: "Colors",
        form_title_align: "Title alignment",
        form_title_divider: "Divider under the title",
        form_align_left: "Align left",
        form_align_center: "Align centre",
        form_align_right: "Align right",
        form_theme_light: "Light",
        form_theme_dark: "Dark",
        form_background: "Background",
        form_button_color: "Buttons color",
        form_select_option: "Select option...",
        form_enter_text: "Enter text",
        form_drop_hint: "Drop your files here to upload",
        form_enter_email: "Enter email",
        form_enter_url: "https://",
        form_enter_phone: "Enter phone",
        form_answersInDescription: "Add answers to the task description",
        form_hideBranding: "Hide AlianHub branding",
        form_publish: "Publish",
        form_unpublish: "Unpublish",
        form_no_questions: "No questions yet. Add one to start.",
        form_add_question: "Add question",
        form_question_label: "Question",
        form_fills: "Fills",
        form_task_fields: "Task fields",
        form_custom_fields: "Custom fields",
        form_required: "Required",
        form_all_fields_used: "Every available field already has a question.",
        form_logic_add: "Show this question when…",
        form_logic_title: "Show this question when",
        form_logic_mode_label: "How the conditions combine",
        form_logic_mode_all: "all of these are true",
        form_logic_mode_any: "any of these is true",
        form_logic_question_label: "Question to check",
        form_logic_pick_question: "Pick a question",
        form_logic_operator_label: "Comparison",
        form_logic_value_label: "Value to compare with",
        form_logic_pick_option: "Pick an option",
        form_logic_add_condition: "Add condition",
        form_logic_remove_condition: "Remove condition",
        form_logic_limit: "A rule holds at most {n} conditions.",
        form_logic_no_sources: "Add a question above this one to show it only for some answers.",
        form_logic_always_named: "The question that names the task is always shown.",
        form_logic_unfinished: "Finish this condition or remove it. An unfinished condition is not saved.",
        form_logic_stale: "This rule refers to a question or option that was deleted, hidden or moved below this one. It will be removed when you save.",
        form_logic_dropped: "Rule removed from {questions}: it referred to a question or option that is no longer above it.",
        form_logic_missing_question: "a question that is gone",
        form_logic_missing_option: "an option that is gone",
        form_logic_summary: "Shown when {conditions}",
        form_logic_and: "and",
        form_logic_or: "or",
        form_logic_group: "({conditions})",
        form_logic_list_join: ", ",
        form_logic_says_equals: "{question} is {value}",
        form_logic_says_not_equals: "{question} is not {value}",
        form_logic_says_contains: "{question} contains {value}",
        form_logic_says_includes: "{question} includes {value}",
        form_logic_says_one_of: "{question} is one of {value}",
        form_logic_says_any_of: "{question} includes any of {value}",
        form_logic_says_is_empty: "{question} is empty",
        form_logic_says_is_not_empty: "{question} is answered",
        form_logic_says_greater_than: "{question} is more than {value}",
        form_logic_says_less_than: "{question} is less than {value}",
        form_logic_says_after: "{question} is after {value}",
        form_logic_says_before: "{question} is before {value}",
        form_logic_op_equals: "is",
        form_logic_op_not_equals: "is not",
        form_logic_op_contains: "contains",
        form_logic_op_includes: "includes",
        form_logic_op_one_of: "is one of",
        form_logic_op_any_of: "includes any of",
        form_logic_op_is_empty: "is empty",
        form_logic_op_is_not_empty: "is answered",
        form_logic_op_greater_than: "is more than",
        form_logic_op_less_than: "is less than",
        form_logic_op_after: "is after",
        form_logic_op_before: "is before",
        form_logic_more: "More questions appeared below.",
        form_logic_preview_note: "On the public form, a question that depends on an answer is added after the visitor presses Submit.",
        move_up: "Move up",
        move_down: "Move down",
        copy: "Copy",
        copied: "Copied",
        loading: "Loading…",
        page_delete_confirm: "Delete this doc? This cannot be undone.",
        page_delete_with_children: "The doc and every sub-page under it go to the Trash in Docs. You can restore them from there.",
        edit: "Edit",
        preview: "Preview",
        search_task: "Search task by name or key...",
        no_tasks_found: "No tasks found",
        unknown_status: "Unknown",
        public_link: "Public link",
        create_public_link: "Create public link",
        move_to_folder: "Move to folder",
        no_folder_root: "No folder (root)",
        select_folder: "Select a folder to move this list into",
        link_enabled: "Link enabled",
        allow_intake: "Accept public requests",
        expires_optional: "Expires (optional)",
        password_optional: "Password (optional)",
        delete_link: "Delete link",
        public_link_deleted: "Public link deleted",
        password_protected: "Password protected",
        share_expires_on: "Expires",
        intake_inbox: "Requests",
        no_intake: "No pending requests",
        anonymous: "Anonymous",
        accept: "Accept",
        reject: "Reject",
        import_jira: "Import Jira",
        import_jira_hint: "Upload a Jira CSV export (Summary, Status, Priority, Due date, Description). Tasks land in the selected list with mapped statuses.",
        import_rows_found: "{count} row detected | {count} rows detected",
        import_no_rows: "No rows found in that file",
        importing: "Importing...",
        start_import: "Import",
        download_sample: "Download sample file",
        import_csv: "Import CSV",
        import_csv_hint: "Upload a CSV/XLSX file, map your columns, and tasks land in the selected list.",
        import_trello: "Import Trello",
        import_trello_hint: "Upload a Trello board JSON export (board Menu → Print/Export → Export as JSON). Lists map to statuses; cards become tasks.",
        import_trello_found: "{lists} lists, {cards} cards detected",
        import_trello_invalid: "That does not look like a Trello board JSON export",
        import_asana: "Import Asana",
        import_asana_hint: "Upload an Asana project JSON export (Project menu → Export/Print → JSON). Sections map to statuses; tasks land in the selected list. Subtasks are skipped.",
        import_asana_found: "{tasks} tasks detected",
        import_asana_invalid: "That does not look like an Asana JSON export",
        import_monday: "Import Monday.com",
        import_monday_hint: "Upload a Monday.com board export (Board menu → Export board to Excel), map your columns, and tasks land in the selected list.",
        map_columns: "Map your columns",
        col_task_name: "Task name",
        col_status: "Status",
        col_priority: "Priority",
        col_due: "Due date",
        col_description: "Description",
        col_none: "— none —",
        auto_archive: "Auto-archive",
        more_features: "More",
        view_toolbar: "Task view options",
        export_hint: "Download this project's tasks as a file.",
        auto_archive_hint: "Completed tasks untouched for the chosen number of days are archived automatically every night.",
        auto_archive_enable: "Enable auto-archive for this project",
        auto_archive_after: "Archive after",
        days: "days",
        list_of_user: "List Of User",
        choose_people: "Choose people",
        list_of_project_status: "List of Project Status",
        list_of_task_type: "List of Task Type",
        list_of_task_status: "List of Task Status",
        list_cc: "List cc",
        category_list: "Category List",
        created_by: "Created by",
        tags: "Tags",
        task_type: "Task Type",
        workspace: "Workspace",
        project_color: "Project Color",
        search: "Search",
        add_task_need: "Add the type of tasks you need",
        what_task_want: "What task type do you want",
        no_sub_tasks_found: "No sub tasks found",
        all_project: "All Project",
        closed_project: "Closed Project",
        go_to_project: "Go to Projects",
        reopen_project: "Reopen Project",
        required_view: "Required Views",
        project_status: "Add the statuses for the project",
        what_project: "What project status do you want",
        active_status: "Active Status",
        done_status: "Done Status",
        add_status: "Add Status",
        close_status: "Close Status",
        submit: "Submit",
        Audio_Files: "Audio Files",
        "Files_&_Links": "Files & Links",
        no_audio_file: "No audio files found",
        change_color: "Change color & avatar",
        files: "Files",
        links: "Links",
        about: "About",
        result: "results",
        seconds: "seconds",
        sort_by: "Sort by",
        relevance: "Relevance",
        last_update: "Last Updated",
        last_created: "Last Created",
        issue: "Issue",
        update: "Update",
        date: "Date",
        time: "Time",
        duration: "Duration",
        duplicate_task: "Duplicate Task",
        projects: "Projects",
        browse_projects: "Browse Projects",
        location: "Location",
        add_new: "Add New",
        create_compnay: "Create Company",
        company_name: "Company Name",
        archived_project: "Archived Project",
        all_views: "All Views",
        archived_notice: "Project is currently archived",
        assignee_teams: "Teams",
        assignee_user: "Users",
        all: "All",
        restore_project: "Restore Project",
        delete_project: "Delete Project",
        items_per_page: "Items Per Page",
        showing_entries: "Showing {from} to {to} of {total} entries",
        Assignee: "Assignee",
        Project_Created_Date: "Project Created Date",
        Project_Status: "Project Status",
        Project_Type: "Project Type",
        Comments_Counts: "Comments Counts",
        Created_Date: "Created Date",
        Name: "Name",
        Running_Time_Tracker: "Running Time Tracker",
        Assigned_to: "Assigned to",
        Project: "Project",
        Currency: "Currency",
        Milestone_Type: "Milestone Type",
        Project_Category: "Project Category",
        Comment_Type: "Comment Type",
        results_in_time: "Results in",
        create_blank_project: "Create Blank Project",
        create_project_using_template: "Create Project Using Template",
        choose_apps: "Choose Apps",
        title: "Projects",
        counts: "{active} ACTIVE · {archived} ARCHIVED",
        filter: "Filter",
        show: "Show",
        active_only: "Active projects",
        archived_only: "Archived projects",
        favourites_only: "Favourites only",
        portfolio_view: "Portfolio view",
        new_project: "New project",
        col_project: "Project",
        col_health: "Health",
        col_sprint: "List",
        col_progress: "Progress",
        col_owner: "Owner",
        favourite: "Favourite",
        unfavourite: "Remove from favourites",
        sample: "SAMPLE",
        archived: "Archived",
        open: "Open",
        restore: "Restore",
        archive: "Archive",
        close_project: "Close project",
        project_actions: "Actions for {name}",
        delete: "Delete",
        row_menu: "Project actions",
        confirm_message: "This affects {name} and everything in it.",
        days_left: "{n}d left",
        days_left_short: "{n}D LEFT",
        progress_title: "{done} of {total} tasks closed ({pct}%)",
        health_on_track: "On track",
        health_at_risk: "At risk",
        health_blocked: "Blocked",
        health_unknown: "Reading…",
        health_by_agent: "Set by the Daily PM agent",
        health_by_signals: "From overdue tasks and how far the current list is behind its dates",
        why_overdue: "{n} task(s) past their due date",
        why_sprint_over: "The current list's end date has passed with work still open",
        why_burndown: "Work is {drift}% behind where the dates say it should be ({done}% done, {elapsed}% of the time gone)",
        why_clear: "Nothing is overdue and the work is keeping up with its dates",
        health_note: "Health comes from the Daily PM agent where it has run. Otherwise it comes from how many tasks are overdue and whether the current list is behind its dates. Hover a chip to see why.",
        empty_archived: "Nothing archived yet.",
        empty_title: "Start with a template",
        empty_lead: "Pick a template and the statuses, views and a few sample tasks come with it.",
        pick_template: "Choose a template",
        create_with_ai: "Create with AI",
        back: "Back",
        view: "View",
        task: "Task",
        ai_assist: "AI Assist",
        review: "review",
        switch_project: "Switch project",
        views_tablist: "Project views",
        wip_chip: "In progress {n}/{limit}",
        wip_limit: "In-progress limit",
        wip_set: "Set an in-progress limit",
        wip_none: "No limit",
        more_count: "+{n} more",
        task_actions: "Task actions",
        show_hide_columns: "Show or hide columns",
        embed_view_actions: "Embed view actions",
        unread_comments_open: "Unread comments: {n}, open",
        column_empty_drop: "Drop a task here",
        add_task_to_column: "Add a task to {name}",
        subtasks_progress: "Subtasks: {done} of {total} done",
        subtasks_total: "Subtasks: {n}",
        add_subtask_to: "Add a subtask to {name}",
        archive_task: "Archive task",
        delete_task: "Delete task",
        confirm_word_archive: "archive",
        confirm_word_delete: "delete",
        close: "Close",
        new: "New",
        new_list: "New list",
        new_folder: "New folder",
        new_subfolder: "New subfolder",
        new_subfolder_in: "New subfolder in {folder}",
        new_list_in: "New list in {folder}",
        move_to_folder_menu: "Move to folder…",
        move_list_hint: "Choose where {list} goes",
        list_moved: "List moved",
        copy_list_link: "Copy link",
        rename_list: "Rename list",
        rename_list_hint: "Press Enter to save, Esc to cancel.",
        list_plain_title: "Make {list} a plain list?",
        list_plain_text: "Its sprint dates are cleared. Its tasks stay where they are.",
        list_is_plain: "{list} is a plain list now",
        list_archive_title: "Archive {list}?",
        list_archive_text: "Its tasks are archived with it. To get it back, open More in this project, choose Show Archive and press Restore.",
        list_delete_title: "Delete {list}?",
        list_delete_text: "The list and its tasks move to the trash.",
        list_archived: "{list} archived",
        list_deleted: "{list} deleted",
        list_restored: "{list} restored",
        archived_lists: "Archived lists",
        restore_list: "Restore {list}",
        archived_list_tasks: "{n} task | {n} tasks",
        archived_list_tasks_hint: "Tasks in this list that you can open",
        search_failed_title: "The search did not work",
        search_failed_msg: "No tasks are shown because the search could not be run. Check your connection and try again.",
        search_try_again: "Try again",
        page_delete_title: "Delete this doc?",
        page_deleted_to_trash: "The doc is in the Trash in Docs. You can restore it from there.",
        list_name_short: "A list name needs at least {n} characters.",
        move_folder: "Move folder",
        move_folder_hint: "Choose where {folder} goes",
        top_level: "Top level of the project",
        duplicate_project: "Duplicate project",
        duplicate_copy_name: "{name} (copy)",
        duplicate_name: "Name of the copy",
        duplicate_name_required: "Give the copy a name.",
        duplicate_also: "Also copy",
        duplicate_tasks: "Tasks",
        duplicate_tasks_hint: "With subtasks, checklists and field values. Comments, files and logged time stay behind.",
        duplicate_assignees: "Assignees of the tasks",
        duplicate_dates: "Dates",
        duplicate_always: "Folders, lists, statuses, views and custom fields always come along. Automations are copied switched off.",
        duplicate_fields_shared: "The copy uses the same custom fields as the original, so a change to a field applies to both projects.",
        duplicate_working: "Duplicating…",
        duplicate_progress: "Copying tasks: {done} of {total}",
        duplicate_progress_hint: "The copy opens when its tasks are in. You can hide this; the tasks keep arriving.",
        duplicate_hide: "Hide",
        duplicate_failed: "The project could not be duplicated.",
        duplicate_tasks_failed: "The project was copied, but only {created} of {total} tasks made it across.",
        duplicate_done: "{name} is ready.",
        duplicate_automations_off: "Automations copied switched off: {count}. Turn on the ones you want.",
        template_save_entry: "Save as template",
        template_save: "Save project as a template",
        template_name: "Name of the template",
        template_name_required: "Give the template a name.",
        template_description: "Description",
        template_also: "Also keep",
        template_tasks_hint: "With subtasks, checklists and field values, each task back in its first status. Comments, files and logged time are never kept.",
        template_dates_hint: "Kept as days from the start of the project, so a new project gets them from its own start.",
        template_automations: "Automations",
        template_automations_hint: "They arrive switched off in a project made from the template.",
        template_always: "Folders, lists, statuses, views and custom fields are always kept. A private list is kept only if you are on it.",
        template_everyone: "Available to everyone who can create projects",
        template_everyone_hint: "Otherwise only you, owners and admins see it.",
        template_private_lists: "Private lists are included only in a template that stays with you",
        template_saving: "Saving…",
        template_save_action: "Save template",
        template_save_failed: "The template could not be saved.",
        template_saved: "{name} is saved as a template.",
        template_note_private_lists_left: "Private lists were left out: {count}.",
        template_note_automations_skipped: "Automations were left out, because only owners and admins manage them: {count}.",
        template_note_tasks_left_out: "Tasks below the third level, or under a deleted task, were left out: {count}.",
        template_note_people_skipped: "People who are no longer in the workspace were left off: {count}.",
        template_note_statuses_skipped: "Statuses the workspace no longer has were left out: {count}.",
        template_note_fields_skipped: "Custom fields that no longer exist were left out: {count}.",
        template_saved_group: "Saved from projects",
        template_folders: "{n} folder | {n} folders",
        template_lists: "{n} list | {n} lists",
        template_tasks: "{n} task | {n} tasks",
        template_by: "by {name}",
        template_holds: "This template holds",
        template_start: "Start date",
        template_include_tasks: "Include the tasks",
        template_include_assignees: "Keep the assignees",
        template_include_dates: "Keep the dates, counted from the start date",
        template_include_automations: "Include the automations, switched off",
        template_edit: "Edit",
        template_edit_label: "Edit {name}",
        template_delete: "Delete",
        template_delete_label: "Delete {name}",
        template_delete_confirm: "Delete this template",
        template_change_failed: "The template could not be changed.",
        template_save_changes: "Save",
        template_progress_hint: "The project opens when its tasks are in. You can hide this; the tasks keep arriving.",
        folder_name_short: "A folder name needs at least {n} characters.",
        folder_archive_title: "Archive {folder}?",
        folder_archive_with: "{parts} will be archived with it. You can restore the folder later from the archived items.",
        folder_archive_empty: "The folder is empty. You can restore it later from the archived items.",
        folder_delete_title: "Delete {folder}?",
        folder_delete_with: "{parts} will go to the Trash with it. You can restore the folder from the Trash.",
        folder_delete_empty: "The folder is empty. You can restore the folder from the Trash.",
        count_subfolders: "{n} subfolder | {n} subfolders",
        count_lists: "{n} list | {n} lists",
        count_tasks: "{n} task | {n} tasks",
        their_tasks: "their tasks",
        folder_archived: "{folder} archived",
        folder_deleted: "{folder} moved to the Trash",
        new_menu_task: "Task",
        menu_view: "View",
        menu_find: "Find",
        menu_insights: "Insights",
        menu_share: "Share & export",
        menu_import: "Import",
        menu_settings: "Project settings",
        menu_popular: "Popular",
        menu_integrations: "Integrations",
        menu_more_views: "More views",
        expand_subtasks: "Expand subtasks",
        collapse_subtasks: "Collapse subtasks",
        assignee_count: "Assignee: {n} selected",
        import_any: "Import tasks…",
        estimation_scale: "Estimation scale",
        estimation_scale_title: "Story point scale",
        estimation_scale_hint: "Choose the point values the estimation picker offers for this project.",
        estimation_scale_fibonacci: "Fibonacci (1, 2, 3, 5, 8, 13, 21)",
        estimation_scale_linear: "Linear (1 – 10)",
        estimation_scale_tshirt: "T-shirt (1, 2, 3, 5, 8)",
        estimation_scale_hours: "Hours (1, 2, 4, 8, 16, 24, 40)",
        estimation_scale_saving: "Saving…",
        estimation_scale_updated: "Estimation scale updated",
        estimation_scale_failed: "Could not update the scale",
        import_title: "Import tasks",
        import_lead: "Bring work in from a file or another tool. Nothing is written until you confirm.",
        import_csv_title: "CSV file",
        import_csv_desc: "Any spreadsheet export — map the columns yourself.",
        import_jira_title: "Jira",
        import_jira_desc: "Issues from a Jira project export.",
        import_trello_title: "Trello",
        import_trello_desc: "Cards from a Trello board export.",
        import_asana_title: "Asana",
        import_asana_desc: "Tasks from an Asana project export.",
        import_monday_title: "Monday.com",
        import_monday_desc: "Items from a Monday board export.",
        import_clickup_title: "ClickUp",
        import_clickup_desc: "Tasks, subtasks, statuses and tags from a ClickUp export.",
        bulk_archive: "Archive",
        bulk_delete: "Delete",
        bulk_archive_confirm: "Archive {n} task(s)? They leave the board and list but stay in the project. You can bring them back from Show archived.",
        bulk_delete_confirm: "Delete {n} task(s)? They move to the Trash, where you can restore them.",
        remove_sample: "Remove sample data",
        remove_sample_confirm: "Move the welcome project and its tasks to the Trash? You can restore them from Workspace → Trash.",
        remove_sample_done: "Sample data moved to the Trash.",
        prev_month: "Previous month",
        next_month: "Next month",
        this_month: "This month",
        view_options: "Options for the {view} view",
        search_views: "Search or describe a view to create",
        no_views_match: "No view matches that search.",
        private_view: "Private view",
        select_billing_period: "Select Billing Period",
        sprint_data_required: "Choose a list first",
        export_csv: "CSV",
        export_xlsx: "XLSX",
        just_now: "Just now",
        private_project: "Private project",
        points_total: "{n} pts",
        col_title: "Title",
    },
    Watcher: {
        list_of_watcher: "List of Watcher",
        owner: "Owner",
    },
    ViewList: {
        List: "List",
        Board: "Board",
        "Project Details": "Project Details",
        Comments: "Comments",
        Calendar: "Calendar",
        Activity: "Activity",
        Workload: "Workload",
        Dashboard: "Dashboard",
        Gantt: "Gantt",
        Table: "Table",
        Timeline: "Timeline",
        Embed: "Embed",
        Reports: "Reports",
        GanttView: "Gantt",
        RecurringTasks: "Recurring Tasks",
        TimelineView: "Timeline",
        MindMapView: "Mind Map",
        WhiteboardView: "Whiteboard",
        CanvasView: "Canvas",
        MapView: "Map",
        // The catalog/tab labels key off the DB record's `name` field
        // ($t(`ViewList.${item.name}`)), so the KEYS must match those names verbatim.
        // The VALUES are the short display labels (no "View" suffix).
        "Gantt View": "Gantt",
        "Recurring Tasks": "Recurring Tasks",
        "Timeline View": "Timeline",
        "Mind Map View": "Mind Map",
        "Whiteboard View": "Whiteboard",
        "Canvas View": "Canvas",
        "Map View": "Map",
        Docs: "Docs",
        Forms: "Forms",
        Comment: "Comment",
        to_unlock_list_view: "To Unlock List View",
        error_message_for_empty: "Please select at least one view",
        set_as_default: "Set as Default",
        remove_as_default: "Remove as Default",
        active_of_min: "Active {active} of {total} min",
    },
    ViewListTag: {
        ProjectListView: "List",
        ProjectKanban: "Kanban",
        TableView: "Table",
        Calendar: "Calendar",
        GanttView: "Chart",
        TimelineView: "Timeline",
        ProjectDashboard: "Report",
        Workload: "Capacity",
        ActivityLog: "Feed",
        Comments: "Discussion",
        DocsView: "Wiki",
        FormsView: "Survey",
        MindMapView: "Map",
        WhiteboardView: "Canvas",
        CanvasView: "Canvas",
        MapView: "Map",
        RecurringTasks: "Schedule",
        Reports: "Report",
        Embed: "Embed",
        ProjectDetail: "Details",
    },
    SavedViews: {
        region: "View settings",
        unsaved: "Unsaved changes",
        save: "Save",
        save_hint: "Save these settings on the view for everyone",
        save_private_hint: "Save these settings on your private view",
        save_for_me: "Save for me",
        save_for_me_hint: "Keep these settings in a private view only you see",
        save_as_new: "Save as new view",
        reset: "Reset",
        reset_hint: "Go back to the view's saved settings",
        new_name: "View name",
        new_name_placeholder: "Name the new view",
        only_me: "Only me",
        create: "Create view",
        cancel: "Cancel",
        saving: "Saving…",
        saved: "View saved",
        created: "View added",
        failed: "The view could not be saved",
        rename: "Rename",
        rename_label: "Rename the view {name}",
        rename_failed: "The view could not be renamed",
    },
    ViewTemplates: {
        from_template: "From a template",
        show_all: "Show the {n} template | Show all {n} templates",
        show_fewer: "Show fewer templates",
        save_as: "Save as template",
        save_title: "Save this view as a template",
        name: "Template name",
        name_required: "Give the template a name",
        save_hint: "Keeps the view's saved group, sort, filters and columns, so a view like it can be added to any project. Unsaved changes are not included.",
        save: "Save",
        saving: "Saving…",
        cancel: "Cancel",
        saved: "Saved the template {name}",
        save_failed: "The template could not be saved",
        rename: "Rename",
        rename_label: "Rename the template {name}",
        rename_failed: "The template could not be renamed",
        delete: "Delete",
        delete_label: "Delete the template {name}",
        delete_confirm: "Delete for everyone?",
        delete_failed: "The template could not be deleted",
        add_failed: "The view could not be added",
        added_left_out: "View added. This project does not have everything the template uses, so these were left out: {parts}",
        part_group: "grouping",
        part_sort: "sorting",
        part_filters: "some filters",
        part_columns: "some columns",
    },
    Apps: {
        tags: "Tags",
        Priority: "Priority",
        TimeEstimates: "Time Estimate",
        Milestones: "Milestones",
        MultipleAssignees: "Multiple Assignees",
        CustomFields: "Custom Fields",
        TimeTracking: "Time Tracking",
        AI: "AI",
        pick_title: "Apps",
        pick_hint: "Switch on what this project needs. You can change this later under Settings → Projects.",
        none: "No apps available",
        enable: "Enable",
        enable_in_settings: "Enable in settings",
        location: "Settings → Projects → Apps",
        enable_under: "{desc} — enable under {location}",
        Priority_title: "Priority",
        Priority_desc: "Flag tasks as urgent, high, normal or low.",
        MultipleAssignees_title: "Multiple assignees",
        MultipleAssignees_desc: "Let more than one person own a task.",
        TimeEstimates_title: "Time estimates",
        TimeEstimates_desc: "Estimate hours per task and compare against logged time.",
        Milestones_title: "Milestones",
        Milestones_desc: "Group work toward dated goals and track progress.",
        tags_title: "Tags",
        tags_desc: "Label and filter tasks across the project.",
        CustomFields_title: "Custom fields",
        CustomFields_desc: "Add your own fields to capture what matters on tasks.",
        TimeTracking_title: "Time tracking",
        TimeTracking_desc: "Log time against tasks and see where hours go.",
        AI_title: "AI",
        AI_desc: "Draft tasks, summaries and plans with AI."
    },
    Tags: {
        no_tags_found: "No Tags Found",
        search_or_create_new: "Search or Create New",
        change_color: "Change Color",
        tag_actions: "Actions for the {name} tag",
        delete_tag: "Delete Tag",
        delete_tag_desc:
            "Are you sure you want to delete the tag everywhere in this Space?",
        note_msg: "Press Enter to create a new tag",
        This_tag_has_already_been_added: "This tag has already been added",
        Tag_name_required: "Tag name required",
        add_tag: "Add tag",
        more_tags: "{count} more: {names}",
    },
    Embeded: {
        The_name_is_required: "The name is required",
        The_name_should_be_at_least_3_characters_long:
            "The name should be at least 3 characters long",
        The_url_is_required: "The url is required",
        Please_enter_valid_url: "Please enter valid url",
        URL_already_exists: "URL already exists",
        The_Html_code_is_required: "The Html code is required",
        name_already_exists: "This name already exists",
        to_unlock_embed_view: "To Unlock Embed View",
    },
    ViewListdescription: {
        timeline_view:
            "See your scheduled tasks laid out on a shared date axis to spot overlaps and gaps at a glance.",
        mindmap_view:
            "Visualize the project as a mind map — parent tasks branching into their subtasks.",
        whiteboard_view:
            "Arrange tasks as free-floating cards on a board — drag them anywhere to map out your thinking.",
        canvas_view:
            "A configurable dashboard of project widgets — status, priority, progress, overdue and upcoming work.",
        map_view:
            "Pin tasks onto a world map to see where your work happens — placements are saved to your browser.",
        dashboard_view:
            "A project overview at a glance — task totals, completion, and estimated vs remaining hours, scoped to your role.",
        docs_view:
            "Write and organise the project's documents — a page tree on the left, the document you are editing on the right.",
        forms_view:
            "Collect requests through a shareable form — every submission arrives as a task in the list you choose.",
        list_view:
            "Use List view to organize your tasks in anyway imaginable – sort, filter, group, and customize columns.",
        kanban_view:
            "Build your perfect Board and easily drag-and-drop tasks between columns.",
        projectdetail_view:
            "Add Initial requirements, Checklist and attachments for your team to understand in details.",
        Comments_view:
            "Add comments in real-time about anything with your team so they get notified and can reply with the response.",
        calender_view:
            "Calendar view is your place for planning, scheduling, and resource management.",
        table_view:
            "Easily manage, update, and organize your tasks with Table view.",
        workload_view:
            "See your team's capacity, who is over or under and reassign tasks accordingly.",
        activitylog_view:
            "Get an aggregated view of all activity across a location. Filter for people and type to get granular with the activity you see.",
        reports_view:
            "Track progress with burndown, velocity, and cumulative flow charts — and export them as branded PDFs.",
        gantt_view:
            "Plan and schedule work on a timeline — drag bars to reschedule, link task dependencies, and see the whole project at a glance.",
        recurring_view:
            "Automate repeating work — define tasks that recreate themselves on a daily, weekly, or monthly schedule.",
        add_msg1: "Add apps and websites alongside your tasks with Embed view",
        add_msg2: "to save time and reduce context switching.",
        view_name: "View Name",
        embed_URL: "Embed URL",
        embed_HTML: "Embed HTML",
        private_view: "Private view",
    },
    projectDashboard: {
        total_tasks: "Total Tasks",
        completed_tasks: "Completed Tasks",
        unassigned_tasks: "Unassigned Tasks",
        completion_ratio: "Task Completion",
        completed: "Completed",
        remaining: "Remaining",
        overall_completion: "Overall Completion",
        by_effort: "By logged vs estimated hours",
        estimate_hours: "Estimate Hours",
        logged: "Logged",
        failed: "Couldn't load the dashboard",
        retry: "Retry",
        by_person: "By Person",
        person: "Person",
        tasks: "Tasks",
        estimated: "Estimated",
        overdue: "Overdue",
        completion: "Completion",
        showing: "Showing",
        click_to_filter: "Click a person to filter",
        clear: "Clear",
        calc_note: "Counts include tasks and subtasks, and each task is counted once in the totals. In the By-Person breakdown a task shared by several people appears under each of them, so those rows can add up to more than the total. Unassigned tasks are grouped under \"Unassigned\". Estimated / Logged / Remaining hours roll up from parent tasks.",
    },
    TalkToText: {
        title: "Talk to Text",
        microphone: "Microphone",
        default_mic: "Default microphone",
        mic_n: "Microphone {n}",
        start: "Start Recording",
        stop: "Stop",
        cancel: "Cancel",
        transcribing: "Transcribing…",
        complete: "Transcription complete!",
        failed: "Couldn't transcribe",
        failed_hint: "Transcription failed. Please try again.",
        copy: "Copy text",
        copied: "Copied to clipboard",
        create_task: "Create a task",
        record_again: "Record again",
        task_name: "Task name",
        project: "Project",
        sprint: "List",
        select_project: "Select a project",
        select_sprint: "Select a list",
        loading: "Loading…",
        back: "Back",
        create: "Create",
        creating: "Creating…",
        name_length: "Task name must be 3–250 characters.",
        pick_project_sprint: "Please select a project and a list.",
        project_not_ready: "This project isn't set up for tasks yet.",
        mic_denied: "Microphone access was denied or is unavailable.",
        no_audio: "No audio captured. Please try again.",
        unsupported: "Recording isn't supported in this browser.",
        select_project_first: "Select a project first.",
    },
    // Main Chat module (components/organisms/MainChat). Kept in its own namespace
    // so the chat UI owns its strings instead of borrowing from Comments.
    call: {
        start_audio: "Start an audio call",
        start_video: "Start a video call",
        incoming_audio: "Incoming audio call",
        incoming_video: "Incoming video call",
        accept: "Accept",
        decline: "Decline",
        hang_up: "Hang up",
        mute: "Mute",
        unmute: "Unmute",
        camera_off: "Turn camera off",
        camera_on: "Turn camera on",
        peer_muted: "Their microphone is off",
        sound_off: "Silence the ringer",
        sound_on: "Turn the ringer back on",
        share_screen: "Share your screen",
        stop_share: "Stop sharing",
        maximize: "Maximise",
        restore: "Restore",
        no_turn_warning: "No TURN relay is configured. Calls may fail to connect on restrictive networks.",
    },
    MainChat: {
        search: "Search in conversation",
        user_info: "View profile",
        channel_info: "Channel details",
        message_channel: "Message #{name}",
        message_direct: "Message {name}",
        send: "Send",
        attach: "Attach a file",
        reply: "Reply",
        copy: "Copy text",
        copied: "Copied to clipboard",
        delete: "Delete message",
        cancel: "Cancel",
        not_sent: "Not sent",
        retry: "Retry",
        load_older: "Load earlier messages",
        loading: "Loading…",
        new_messages: "new",
        jump_latest: "Jump to latest message",
        typing: "typing",
        typing_one: "{name} is typing",
        typing_two: "{first} and {second} are typing",
        typing_many: "{count} people are typing",
        pinned_messages: "Pinned messages",
        pinned_none: "Nothing is pinned in this conversation yet. Pin a message from its ⋮ menu to keep it here.",
        pinned_count: "{count} pinned",
        record: "Record a voice note",
        microphone: "Microphone",
        start_recording: "Start recording",
        recording: "Recording",
        paused: "Paused",
        pause: "Pause",
        resume: "Resume",
        stop_attach: "Stop & attach",
        record_hint: "Stop to attach it, then press Send. Closing this discards the recording.",
        record_unsupported: "Recording is not supported in this browser.",
        mic_denied: "Microphone access was blocked. Allow it in your browser settings and try again.",
        no_audio: "Nothing was recorded. Please try again.",
        read_only: "You cannot post here",
        read_only_channel: "Sending is turned off for this channel. Only owners and admins can post.",
        read_only_direct: "You have read-only access to direct messages.",
        enter_send: "send",
        shift_enter: "new line",
        empty_channel: "No messages in this channel yet",
        empty_direct: "No messages yet",
        empty_hint: "Type below to start the conversation.",
        deleted_by_you: "You deleted this message",
        deleted: "This message was deleted",
        confirm_delete: "Delete this message?",
        confirm_delete_yes: "Delete",
        failed: "Something went wrong. Please try again.",
        you: "You",
        today: "Today",
        yesterday: "Yesterday",
        private_channel: "Private channel",
        photos_media: "Photos & media",
        documents: "Documents",
        nothing_shared: "Nothing shared yet",
        members: "Members",
        email: "Email",
        phone: "Phone",
        timezone: "Time zone",
        start_conversation: "Start a conversation",
        channels: "Channels",
        more: "More actions",
        edit: "Edit message",
        editing: "Editing message",
        save: "Save",
        pin: "Pin message",
        unpin: "Unpin message",
        pinned: "Pinned",
        pinned_ok: "Message pinned",
        unpinned_ok: "Message unpinned",
        mark_unread: "Mark as unread",
        edited: "edited",
        // `@` must be escaped as {'@'}: a bare @ starts vue-i18n's linked-message
        // syntax and fails to compile ("Unexpected empty linked key").
        mention_hint: "Type {'@'} to mention",
        add_reaction: "Add reaction",
        no_matches: "Nothing matches your search",
        // The two tabs search different fields, so each says what it matches on.
        search_people: "Search people by name",
        search_channels: "Search channels or categories",
        // Shown as the author of messages left by someone who has since been
        // removed from the company. Their messages are kept; only the identity is
        // anonymised, so the "Ghost User" placeholder never surfaces in chat.
        former_member: "Former member",
        search_placeholder: "Search messages and files...",
        search_hint: "Search this conversation — message text, or an attachment by its file name.",
        search_none: "No messages or files match your search",
        // Two explicit keys rather than vue-i18n's `a | b` plural form, which needs
        // the count passed as the choice argument and silently picks the wrong
        // branch when it is passed as a named value instead.
        search_result_one: "1 result",
        search_result_many: "{count} results",
        search_not_loaded: "That message is further back in this conversation — load earlier messages to jump to it.",
        unread_one: "1 unread message",
        unread_many: "{count} unread messages",
        marked_unread: "Marked as unread from here",
        reply_in_thread: "Reply in thread",
        thread_title: "Thread",
        thread_close: "Close thread",
        thread_replies_one: "1 reply",
        thread_replies_many: "{count} replies",
        thread_open_one: "Open the thread, 1 reply",
        thread_open_many: "Open the thread, {count} replies",
        thread_last_reply: "Last reply {when}",
        thread_failed: "This thread could not be opened. It may have been deleted, or you may not have access to it.",
    },
    Filters: {
        filter: "Filters",
        learnmorefilter: "Learn more about filters",
        pleaseselectvalid: "Please select all valid options",
        confirm: "Confirm",
        are_you_sure: "Are you sure want to delete",
        clearall: "Clear all",
        addfilter: "Add Filter",
        where: "Where",
        filtering_field: "Filtering Field",
        no_date_found: "No date found",
        save_this_filters: "Save this Filters",
        save_filter: "Save Filter",
        save: "Save",
        update_filter: "Update filter",
        my_filter: "My Filter",
        no_data_found: "No data found",
        show_result: "Show Result",
        save_filters: "Save Filters",
        filter_by: "Filter by",
        projects: "Projects",
        teams: "Teams",
        user: "User",
        no_comment_found: "No comment found",
        no_project_found: "No project found",
        no_file_found: "No file found",
        no_link_found: "No link found",
        filter_operator: "Filter Operator",
        options: "Options",
        priorities: "Priorities",
        select_all: "Select All",
        milestone_type: "milestone type",
        comment_type: "Comment Type",
        a_to_z: "A to Z",
        more_users: "{count} more user | {count} more users",
        no_files_found: "No files found",
        no_links_found: "No links found",
        no_links_or_files_found: "No links or files found",
        z_to_a: "Z to A",
        sort_by: "Sort By",
        "A-Z": "A-Z",
        Ascending: "Ascending",
        Descending: "Descending",
        No: "No",
        Yes: "Yes",
        "Z-A": "Z-A",
        Save_this_Filter: "Save this Filter",
        Enter_Filter_Name: "Enter Filter Name",
        Select_Options: "Select Options",
        Equal_To: "Equal To",
        Greater_Than: "Greater Than",
        Is: "Is",
        Less_Than: "Less Than",
        Clear_All: "Clear All",
        select_assignee: "Select Assignee",
        select_project_types: "Select Project Types",
        unselect_all: "Unselect All",
        are_you_suredelete: "Are you sure you want to delete?",
        Not_Equals_To: "Is Not",
        cf_contains: "Contains",
        cf_on: "Is on",
        cf_before: "Is before",
        cf_after: "Is after",
        cf_is_set: "Is set",
        cf_is_empty: "Is empty",
        cf_has_task: "Contains task",
        cf_i_voted: "I voted",
        cf_value: "Value",
        cf_choose: "Choose one or more options",
    },
    conformationmsg: {
        archive:
            "A List can be archived to hide it from view but be restored at any time. All tasks are kept and remain searchable when you archive a List.",
        delete: "This Project's tasks and templates will all be erased. Type project name to confirm that you really do wish to delete all tasks, templates, and this project.",
        delete_task: "This task goes to the Trash. You can restore it from there.",
        delete_task_with_subtasks: "This task and its subtasks go to the Trash. You can restore them from there.",
        archive_task: "This task is hidden from its list and nothing in it is lost. Turn on Show Archive to see it or to restore it.",
        archive0mesg:
            "Type project name to confirm that you really do wish to close this project",
        sprintclosemsg:
            "Type the word below to confirm that you really do wish to close this list",
        type: "Type",
        are_you_sure: "Are you sure?",
        no_revert_msg: "You won't able to revert this!",
        yes_delete: "Yes, delete it!",
        task_moves_under: "{task} will become a subtask of {parent}.",
        task_and_subtasks_move_under: "{task} will become a subtask of {parent}. Its own subtasks stay under it and move with it.",
        Are_you_sure_you_want_to_delete: "Are you sure you want to delete",
        unlock_board_view: "To Unlock Board View",
        unlock_project_detail_view: "To Unlock Project Detail View",
        unlock_table_view: "To Unlock Table View",
        unlock_workload_view: "To Unlock WorkLoad View",
        to_unlock_tracker_timesheet: "To Unlock Tracker Timesheet",
        to_unlock_user_timesheet: "To Unlock User TimeSheet",
        unlock_calendar_view: "To Unlock the Calendar View",
    },
    Description: {
        description: "Description",
        edit: "Edit",
        add_description: "Add a Description",
        add_description_prompt: "Add a Description...",
        add_description_ph: "Add description...",
        cancel: "Cancel",
        save: "Save",
        show_more: "Show More",
        show_less: "Show Less",
        description_placeholder:
            "Write something or type '/' for commands and AI action",
        saved: "Saved",
    },
    Checklist: {
        checklist: "Checklist",
        add_checklist: "Add a checklist",
        suggest_checklists: "Suggest Checklists",
        Checklists: "Checklists",
        to_unlock_checklist: "To Unlock Checklist",
    },
    Attachments: {
        attachments: "Attachments",
        drag_file: "Here, you can also drag and drop files.",
        see_all: "See All",
        drop_file: "Drop files here to attach or",
        browse: "Browse",
        no_preview_found: "No preview found",
        no_preview_available: "No preview available",
        open_in_new_tab: "Open in new tab",
        download: "Download",
        actions: "Actions",
        video_not_supported: "Your browser does not support the video tag.",
        show_all_pages: "Show all pages",
        drop_here: "Drop Here",
        // AHE-3838 — cloud attachments (Google Drive / Dropbox)
        upload_from_computer: "Upload from computer",
        attach_from: "Attach from",
        connect_provider: "Connect {provider}",
        provider_not_configured: "{provider} is not set up for this workspace yet. An admin can add it under Settings → Integrations.",
        cloud_link_missing: "This file has no link saved. It may have been removed from the cloud drive.",
        cloud_skipped_in_zip: "{count} linked cloud file(s) were skipped — open them in their drive to download.",
        cloud_linked: "Linked from {provider}",
        cloud_attached: "Attached from {provider}",
        cloud_attach_failed: "Could not attach the selected file(s). Please try again.",
        cloud_picker_loading: "Opening Google Drive…",
        cloud_picker_failed: "Google Drive could not be opened. Please try again.",
        cloud_popup_blocked: "Your browser blocked the Google Drive window. Allow pop-ups for this site and try again.",
        picker_blocked: "The picker window was blocked. Please allow pop-ups for this site and try again.",
        import_copy: "Import a copy",
        link_file: "Link the file",
        importing: "Importing...",
        import_done: "Imported {name}",
        import_failed: "Could not import from {provider}.",
        download_all: "Download All",
    },
    ClipRecorder: {
        record_clip: "Record clip",
        voice: "Voice",
        screen: "Screen",
        screen_mic: "Screen + mic",
        start: "Start",
        stop: "Stop",
        re_record: "Re-record",
        permission_denied: "Could not access your camera, microphone or screen. Please grant permission and try again.",
        unsupported: "Recording is not supported in this browser.",
        screen_https_hint: "Screen recording requires a secure (HTTPS) connection. Voice recording is still available.",
        close: "Close",
        discard_confirm: "Recording in progress. Discard this clip?",
        save: "Save",
        title_label: "Title",
        title_placeholder: "Clip title",
        saving: "Saving...",
        save_failed: "Could not save the clip. Please try again.",
        saved: "Clip saved",
    },
    Clips: {
        title: "Clips",
        my_clips: "My Clips",
        library: "Clip library",
        record_new: "Record new clip",
        play: "Play",
        loading: "Loading clips...",
        empty: "No clips yet. Record one to get started.",
        rename: "Rename",
        rename_placeholder: "Clip title",
        delete: "Delete",
        delete_confirm: "Delete this clip? This cannot be undone.",
        copy_link: "Copy link",
        copied: "Link copied",
        copy_failed: "Could not copy the link.",
        options: "Options",
        video_badge: "Video",
        audio_badge: "Audio",
        deleted: "Clip deleted",
        delete_failed: "Could not delete the clip.",
        rename_failed: "Could not rename the clip.",
        untitled: "Untitled clip",
        hide: "Hide player",
        search: "Search clips",
        search_placeholder: "Search clips…",
        no_results: "No clips match your search.",
        convert_action: "Convert to task",
        convert_title: "Convert clip to task",
        converted_badge: "Converted",
        confirm_delete_title: "Are you sure you want to delete this clip?",
    },
    Milestone: {
        home_link: "Home",
        toggle_rows: "Show or hide the rows under {name}",
        public_project: "Public project",
        no_filter: "No filter",
        milestone: "Milestone",
        milestone_name: "Milestone Name",
        status_date: "Status Date",
        total_amount: "Total Amount",
        are_you_sure: "Are you sure want to delete milestone",
        add_new: "Add a New",
        mileston_status: "Milestone Status",
        project_name: "Project Name",
        end_date: "End Date",
        start_date: "Start Date",
        estimated_release: "Estimated Release",
        release_request_sent: "Release Request Sent",
        released: "Released",
        not_funded: "Not Funded",
        funded: "Funded",
        project_milestone_Status: "Project Milestone Status",
        milestone_status_name: "Milestone Status Name",
        date_displaye: "Date Displayed in Calendar",
        past: "Past",
        feature: "Future",
        status_actions: "Actions for {name}",
        milestone_weekly_range: "Milestone Weekly Range",
        file_extensions: "File Extensions",
        avatar: "Avatar",
        adding_estimated: "Add Estimated Hours",
        range: "Range",
        user: "User",
        refunded_amount: "Refunded Amount",
        Max_2_decimal_places_allowed: "Max 2 decimal places allowed",
        The_refunded_amount_field_should_not_be_more_then_amount:
            "The refunded amount field should not be more then amount",
        Amount_field_should_not_be_smaller_than_the_refunded_amount:
            "Amount field should not be smaller than the refunded amount",
        The_minute_field_must_be_59_or_less:
            "The minute field must be 59 or less",
        The_hours_field_is_required: "The hours field is required",
        Name_already_exists: "Name already exists",
        The_milestone_status_field_is_required:
            "The milestone status field is required",
        The_milestone_status_field_must_be_at_leat_characters:
            "The milestone status field must be at least 3 characters",
        actual_amount: "Actual Amount",
        partially_refunded: "Partially refunded",
        refund_details: "Refund details",
        status_history: "Status history",
        time_logged_by_member: "Time logged by each member",
        refunded_amount_should_not_exceed_amount:
            "The refunded amount field should not be more than the amount",
        total_partially_refunded: "Total partially refunded",
        all_amount_refunded: "All amount refunded",
        refund_amount: "Refund Amount",
        refund: "Refund",
        date_range: "{start} to {end}",
        field_should_not_be_smaller_than_refund_amount:
            "Field should not be smaller than refund amount",
        white_color_not_allowed:
            "White color is not allowed. Please select a valid color",
        billing: "Billing",
        per_hour: "Per Hour",
        adding_taskPlanning: "Add Task Planning",
        hh_placeholder: "hh",
        mm_placeholder: "mm",
        hh_mm_placeholder: "hh:mm",
    },
    Comment: {
        created_by: "Created by",
        enter_task_name: "Enter task name",
        task_name: "Task name",
    },
    UserTimesheet: {
        back_projects: "Back to Projects",
        project_estimate_changed: "A task in this project had its estimated hours changed",
        user_timesheet: "User Timesheet",
        back: "Back",
        tracked_time: "Tracked Time",
        manual_time: "Manual Time",
        time_split: "Tracked and manual time",
        users: "Users",
        logged: "Logged",
        hours: "Hours",
        estimated: "Estimated",
        no_records_found: "No records found",
        project_timesheet: "Project Timesheet",
        tracker_timesheet: "Tracker Timesheet",
        workload_timesheet: "Workload Timesheet",
        milestone_reports: "Milestone Reports",
        add_time: "Add Time",
        add_time_log: "Add Time Log",
        edit_time_log: "Edit Time Log",
        Teams: "Teams",
        Users: "Users",
        Projects: "Projects",
        task_planning: "Task Planning",
        task_remaining_planning: "Remaining Hours",
        planned: "Planned",
        views_nav: "Timesheet views",
    },
    ProjectWorkplace: {
        msg1: "Project can be shared with members. You can add guests to Folders, Lists, and tasks after creating a Project.",
        msg2: "Currently, there are no plans in place to create private or public projects. If you'd like to initiate a project, upgrading your plan would be necessary.",
    },
    CustomField: {
        custom_field: "Custom Field",
        create_custom_field: "Create Custom Field",
        edit_custom_field: "Edit Custom Field",
        back: "Back",
        back_to_types: "Back to the field types",
        min_value: "{field} must be at least {min}.",
        max_value: "{field} must be less than or equal to {max}.",
        must_be_valid_email: "{field} must be a valid email",
        select_field: "Select {field}",
        formula_expression: "Formula",
        formula_expression_placeholder: "e.g. {Estimate} * 2 + {Buffer}",
        referenceable_fields: "Available fields",
        rollup_function: "Aggregate function",
        rollup_source_field: "Source field",
        select_source_field: "Select a field",
        no_numeric_field_found: "No numeric field found",
        lable: "Label",
        action: "Action",
        add_custom_field: "Add Custom Field",
        add_new_custom_field: "Add New Custom Field",
        field_name: "Field Name",
        date_created: "Date Created",
        add_another_item: "Add another item",
        options_keyboard_hint: "Press Enter for the next option. Enter on an empty option saves the field. Pasting several lines makes one option per line.",
        choose_ready_made_list:
            "Choose a ready-made list of option (e.g., days, months, etc.)",
        predefined_options: "Predefined Options",
        selected_by_default: "Selected By Default",
        allow_time_with_date: "Allow users to specify a time with date.",
        date_format: "Date Format",
        days_of_week: "Days of the week",
        past_and_future: "Past & Future",
        select_date_format:
            "Select a date format. D stands for day, M for month, and Y for year.",
        select_dates_past_future:
            "Let users select dates in the past or future",
        select_time_format: "Select a time format",
        time_format: "Time Format",
        unchecking_day_calendar:
            "Unchecking a day will make it unavailable in the calendar",
        future: "Future",
        past: "Past",
        enter_maximum_limit: "Enter Maximum Limit",
        enter_minimum_limit: "Enter Minimum Limit",
        limit_minimum_or_maximum_value:
            "Limit the minimum or maximum value allowed for this field",
        maximum_limit_type_not_allowed_value:
            "The entered value for Maximum Limit Type is not an allowed value.",
        maximum_value_should_be_greater_than_minimum_value:
            "Maximum value should be greater than Minimum value",
        minimum_limit_type_not_allowed_value:
            "The entered value for Minimum Limit Type is not an allowed value.",
        minimum_value_should_not_be_greater_than_maximum_value:
            "Minimum value should not be greater than Maximum value",
        no_country_found: "No country found",
        country_code: "Country code",
        enter_maximum_limit_type: "Enter Maximum Limit Type",
        enter_minimum_limit_type: "Enter Minimum Limit Type",
        limit_minimum_or_maximum_text_allowed:
            "Limit the minimum or maximum amount of text allowed in this field",
        max_should_be_greater_than_min: "Max should be greater than Min",
        min_should_be_less_than_max: "Min should be less than Max",
        separator: "Separator",
        countryCode: "Turn it on to modify the country code.",
        field_is_required: "{field} is required",
        all_projects: "All Projects",
        no_record_found: "No record found",
    },
    Category: {
        cateory_name: "Category Name",
        create_category: "Create Category",
        create_channel: "Create Channel",
        edit_category: "Edit Category",
        no_chat_found: "No chats found",
        upgradeplanemsg: "To access this feature please upgrade your plan.",
        loading: "Filing…",
        empty_no_fit: "No label fits",
        empty_no_vocabulary: "No labels to file under",
        why_no_fit: "None of this project's labels fit this task, so nothing was filed.",
        why_no_vocabulary: "This project has no tags, task types or category field to file tasks under. Add project tags, then generate the column.",
        chip_hint: "Filed under a label this project already uses, from {from}.",
        chip_source: "{from} · filed {time}",
        source_tag: "project tags",
        source_task_type: "task types",
        source_custom_field: "a category field",
        by_source_title: "Hours by source",
        by_source_total: "{n}H TOTAL",
        by_source_source: "Logged hours from the timesheet, and elapsed time on agent runs split by the account each run was billed to. People are counted together on purpose: that account is an AI subscription, so a run has one and a person's hours do not. Nothing recorded on a time log says which client it was entered from, and a split drawn from a guess would be worse than none.",
        source_people: "people"
    },
    Channel: {
        create_channel: "Create Channel",
        msg1: "You reached the maximum public and private channel creation limit. To access this feature please upgrade your plan",
        channel_name: "Channel Name",
        icons: "Icons",
        or: "or",
        only_share_with: "Only Share with",
        private_channel: "Private Channel",
        msg2: "Only selected members and roles will be able to view this channel",
        allowmsg2: "Allows members to send messages in this channel",
        send_messages: "Send Messages",
        choose_to_upload: "Choose an Image to Upload",
        private_channel_limit_reached:
            "You have reached the limit for private channel creation. You can only create public channels. If you want to create a private channel, please upgrade your plan.",
        public_channel_limit_reached:
            "You have reached the limit for public channel creation. You can only create private channels. If you want to create a public channel, please upgrade your plan.",
        edit_channel: "Edit Channel",
        delete_channel: "Delete Channel",
        public_members_hint: "Everyone in the company can see this channel.",
        confirm_delete_channel: "Delete this channel?",
        confirm_delete_channel_note: "The channel is removed from the list. Its messages are kept and it can be restored.",
    },
    Templates: {
        delete_template: "Delete Template",
        project_status: "Project Status",
        task_status: "Task Status",
        no_app_selected: "No Apps Selected",
        default_views: "Default Setting for Views",
        apps: "Apps",
        templates: "Templates",
        s: "s",
        template_name: "Template Name",
        upload_image: "Upload Image",
        all_good: "All good",
        create_template: "Create Template",
        new_template: "New Template",
        remove: "Remove",
        item_actions: "Actions for {name}",
        Turn: "Turn",
        all_apps: "all Apps",
        off: "off",
        on: "on",
        upload: "Upload",
        save_template: "Save Template",
        setup_status: "Set up the statuses for tasks",
        what_task: "What task status do you want",
        select_task_status: "Select Task Status",
        delete_template_confirmation:
            "Are you sure you want to delete the template?",
        ai_sidebar_title: "Create Template With AI",
        ai_label_category: "Category",
        ai_label_description: "Description",
        ai_button_text_requested_changes: "Request Changes",
        ai_min_view_msg_text: "At least one view required",
        ai_before_desc_placeholder:
            "Enter use case description for generate template",
        ai_after_desc_placeholder:
            "Here you can continue to ask anything for relevant changes",
        msg_search_result_found:
            "Here are some suggested templates relevant to your requirements. You can select any one or to create using AI, simply click",
        msg_search_result_not_found:
            "No relevant templates found. To create one using AI, simply click",
        back_to_templates: "Back to templates",
    },
    Settings: {
        add_new_projects: "Add New Project",
        task_priority: "Task Priority",
        project_skills: "Project Skills",
        project_skills_hint: "Skills that can be assigned to projects to record what a project needs.",
        skill_name_too_short: "The skill name must be at least 2 characters.",
        skill_name_invalid: "Enter a valid skill name.",
        skill_already_exists: "That skill already exists.",
        deactivate_skill: "Deactivate skill",
        deactivate_skill_confirm: "This skill will no longer be available for new projects. Projects already using it keep it.",
        auto_close_heading: "Auto-close inactive projects",
        auto_close_subtitle: "When enabled, a project with no logged time and no task activity for the selected period is automatically closed every night. Closing is reversible — you can reopen a project any time.",
        auto_close_toggle_label: "Enable auto-close",
        auto_close_toggle_hint: "Off by default. Inactive projects are closed on the next nightly run.",
        auto_close_window_label: "Inactivity period",
        auto_close_window_hint: "How long a project must be quiet (no time logs, no task changes) before it auto-closes.",
        auto_close_months_option: "{n} month | {n} months",
        auto_close_last_run: "Last run {when} — closed {count} project. | Last run {when} — closed {count} projects.",
        auto_close_not_run_yet: "Enabled — the nightly run hasn't closed any projects yet.",
        auto_close_saved: "Auto-close settings saved",
        auto_close_save_failed: "Could not save auto-close settings",
        auto_close_today: "today",
        auto_close_yesterday: "yesterday",
        auto_close_days_ago: "{n} day ago | {n} days ago",
        auto_close_months_ago: "{n} month ago | {n} months ago",
        restore: "Restore",
        maximum_image_size: "Maximum image size",
        warning: "Warning",
        cant_delete: "can't delete",
        priority_in_use:
            "The user cannot delete the PRIORITY_NAME priority as it is already in use.",
        company_name: "Company Name",
        phone: "Phone",
        country: "Country",
        state: "State",
        city: "City",
        tracker_estimate_limit: "Limit tracker to estimated hours",
        tracker_estimate_limit_hint: "When on, a task needs estimated hours before the tracker can start and it stops automatically once the estimate is used up. When off, the tracker runs without an estimate limit.",
        working_days: "Working days",
        working_days_hint: "The days your company works. The Gantt moves dependent tasks onto these days, and time off and capacity count only these days. A project can set its own.",
        working_days_min: "Keep at least one working day.",
        select_date_format:"Select Date Format",
        two_factor_auth: "Two-Factor Authentication",
        two_factor_desc: "Add an extra layer of security to your account by requiring a code from your authenticator app at sign-in.",
        two_factor_status_enabled: "Two-factor authentication is ON.",
        two_factor_status_disabled: "Two-factor authentication is OFF.",
        two_factor_enable: "Enable",
        two_factor_disable: "Disable",
        two_factor_scan: "Scan this QR code with your authenticator app (Google Authenticator, Authy, 1Password, …).",
        two_factor_manual_key: "Can't scan? Enter this key manually:",
        two_factor_enter_code_enable: "Enter the 6-digit code to confirm",
        two_factor_verify_enable: "Verify & Enable",
        two_factor_recovery_title: "Save your recovery codes",
        two_factor_recovery_desc: "Each code works once. Keep them somewhere safe — you won't see them again. Use one if you lose access to your authenticator app.",
        two_factor_copy: "Copy",
        two_factor_download: "Download",
        two_factor_done: "Done",
        two_factor_disable_label: "Enter a current code or a recovery code to disable",
        two_factor_cancel: "Cancel",
        currencies: "Currencies",
        add_remove_cur: "Add/Remove Currencies",
        change_image: "Change Image",
        Priorities_already_Exists: "Priorities already Exists",
        The_priority_image_field_is_required:
            "The priority image field is required",
        The_priority_name_field_is_required:
            "The priority name field is required",
        The_priority_name_field_must_be_at_least:
            "The priority name field must be at least 3 characters",
        "The file extension field is required":
            "The file extension field is required",
        The_file_extension_field_must_be_at_least:
            "The file extension field must be at least 3 characters",
        file_extension_is_not_supported: "file extension is not supported",
        file_extension_already_Exists: "file extension already Exists",
        The_file_extension_field_is_required:
            "The file extension field is required.",
        access_denied: "You don't have access to this page.",
        agent_activity: "Agent activity",
        agent_activity_hint: "Approvals agents need from you and actions they took on their own. One switch for all agent noise.",
        agent_never: "never",
        agent_proposes: "proposes",
        agent_read: "read",
        api_keys: "API keys",
        available: "Available",
        browser_alerts: "Browser notifications",
        browser_alerts_blocked: "Blocked in this browser. Allow notifications for this site in the browser's settings, then reload.",
        browser_alerts_hint: "Get an alert on this device when something needs you, even with AlianHub in the background.",
        browser_alerts_on: "On in this browser.",
        browser_alerts_turn_on: "Turn on",
        built_in: "Built-in",
        built_in_count: "{n} built-in",
        capacity: "Capacity",
        capacity_count: "Tasks",
        capacity_invalid: "Capacity must be a number from 0 to 1000.",
        capacity_per_day: "per day",
        capacity_per_week: "per week",
        capacity_period: "Capacity period",
        capacity_points: "Points",
        capacity_unit: "h/day",
        carry_agents: "Agents & skills",
        carry_apps: "Apps",
        carry_custom_fields: "Custom fields",
        carry_project_statuses: "Project statuses",
        carry_statuses: "Statuses",
        carry_task_types: "Task types",
        carry_views: "Views",
        ch_chat: "Chat",
        ch_email: "Email",
        ch_inbox: "Inbox",
        ch_push: "Push",
        change_photo: "Change photo",
        close: "Close",
        col_contains: "Contains",
        col_event: "Event",
        col_owner: "Owner",
        col_permission: "Permission",
        col_template: "Template",
        col_views: "Views",
        configure: "Configure",
        confirm_destructive: "\"{permission}\" is destructive. Grant it to {role}?",
        connected_count: "{n} connected",
        copied: "Copied",
        copy: "copy",
        copy_codes: "Copy codes",
        daily_digest: "Daily digest instead",
        daily_digest_hint: "One email at 08:00 with everything non-urgent from the last day.",
        days: "Days",
        days_before: "{n} day before | {n} days before",
        days_letters: "M T W T F S S",
        days_names: "Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday",
        days_required: "Pick at least one working day.",
        destructive_note: "Red rows are destructive — never available to agents or external connections. Agents get an allow-list; destructive actions are absent from the registry.",
        download_codes: "Download codes",
        from_description: "From a description",
        group_personal: "Personal",
        group_workspace: "Workspace",
        hours: "Hours",
        hours_12: "12 hours",
        hours_24: "24 hours",
        hours_before: "{n} hour before | {n} hours before",
        hours_end: "End of day",
        hours_invalid: "End time must be after start time.",
        integrations_agent_note: "Agents can only use a connection if it's listed in their allowed actions. Connecting an app does not grant agent access.",
        integrations_empty: "Nothing connected yet. Pick something from Available below.",
        job_title: "Job title",
        job_title_hint: "Set by an admin in Members",
        job_title_none: "Not set",
        joined: "joined {date}",
        matrix_empty: "No permissions match. Clear the search or switch to Advanced.",
        minutes_before: "{n} minute before | {n} minutes before",
        mode_advanced: "Advanced",
        mode_simple: "Simple",
        nav_aria: "Settings navigation",
        nav_billing: "Billing",
        nav_general: "General",
        nav_my_settings: "My settings",
        nav_notifications: "Notifications",
        nav_security_permissions: "Security & permissions",
        nav_signin_security: "Sign-in & security",
        nav_signin_sso: "Sign-in & SSO",
        nav_agent_clients: "Agent clients",
        new_team: "Team",
        new_template: "New",
        no_sessions: "No other sessions.",
        notifications_empty: "No notification settings yet — they are created the first time you sign in to this workspace.",
        notifications_subtitle: "Defaults for everything you're watching. Any single task can override these.",
        notifications_title: "Notifications",
        notify_all: "All",
        notify_assigned: "Assigned to me",
        notify_for: "Notify for",
        notify_when: "Notify when",
        now: "now",
        open_menu: "Open settings menu",
        people_count: "{n} person | {n} people",
        prefs_error: "Could not save your preferences.",
        quiet_from: "Quiet from",
        quiet_hours: "Quiet hours",
        quiet_hours_and: "and",
        quiet_hours_between: "No push between",
        quiet_hours_respect: "Also respect my time off and Do not disturb",
        quiet_hours_urgent: "Urgent {'@'}mentions still come through",
        quiet_to: "Quiet until",
        required_field: "This field is required.",
        role_admin: "Admin",
        role_admin_desc: "Manage members, projects and settings. Not billing.",
        role_agents: "Agents",
        role_custom_desc: "Custom role.",
        role_guest_desc: "View and comment on what's shared with them. Not required to use company sign-in.",
        role_member_desc: "See projects they're in, create and edit their own tasks, comment, track time.",
        role_owner: "Owner",
        role_owner_desc: "Everything, including billing and deleting the workspace.",
        save_changes: "Save changes",
        saved: "Saved",
        security_subtitle: "{permissions} permissions across {objects} objects. Change a role here and it applies everywhere immediately.",
        security_title: "Security & permissions",
        sessions: "Active sessions",
        sessions_error: "Could not load sessions.",
        sessions_hint: "Every device signed in to this account.",
        set_up_provider: "Set up {provider}",
        sign_out: "Sign out",
        sso_acs_url: "ACS URL",
        sso_attributes: "Attributes",
        sso_callback_url: "Callback URL",
        sso_card_title: "SAML / OIDC single sign-on",
        sso_connected: "connected",
        sso_default_role: "Role for new people",
        sso_display_name: "Display name",
        sso_display_name_ph: "Okta, Entra, Google Workspace…",
        sso_domain_invalid: "{d} is not a valid domain.",
        sso_domain_unverified: "Not verified",
        sso_domain_failing: "TXT record missing on {n} daily check(s)",
        sso_domain_failing_hint: "Keep the TXT record published. After three missed daily checks in a row the domain is no longer verified.",
        sso_domain_lapsed: "Verification lapsed {date}",
        sso_domain_lapsed_hint: "The DNS record was missing on three daily checks in a row, so company sign-in stopped adding people from this domain. Add the record again, then verify.",
        sso_domain_verified: "Verified",
        sso_domain_verified_toast: "{d} is verified.",
        sso_domain_ph: "acme.studio — press Enter",
        sso_domains: "Email domains",
        sso_domains_hint: "People on a verified domain can sign in with SSO. Everyone else needs an invitation.",
        sso_email_hint: "2FA available per person",
        sso_email_password: "Email & password",
        sso_enable: "Enable single sign-on",
        sso_enf_optional: "Optional",
        sso_enf_optional_hint: "SSO is one more button on the login screen.",
        sso_enf_required: "Required for everyone",
        sso_enf_required_except: "Required, except guests",
        sso_enf_required_except_hint: "Members and admins must use SSO. Guests keep email or Google.",
        sso_enf_required_hint: "Every sign-in goes through your identity provider.",
        sso_enf_warn: "Members who never signed in with SSO will be asked to link on their next login. The owner keeps a password fallback so you can't lock yourself out.",
        sso_enforcement: "Enforcement",
        sso_entity_id: "Entity ID",
        sso_env_hint: "Google, GitHub and GitLab are switched on by setting each one's client ID and client secret in the server's .env file (and the client ID again for the web app).",
        sso_env_on: "on",
        sso_hidden_from_login: "off · hidden from login",
        sso_metadata_url: "Metadata URL",
        sso_not_configured: "not configured",
        sso_preview_login: "Preview login page",
        sso_provisioning: "Provisioning",
        sso_remove: "Remove {d}",
        sso_saved: "Saved — the login screen updates immediately.",
        sso_subtitle: "What appears on the login screen for {host}, and whether members must use it.",
        sso_test: "Test sign-in",
        sso_title: "Sign-in & SSO",
        sso_txt_name: "TXT name",
        sso_txt_value: "TXT value",
        sso_verify: "Verify",
        sso_verify_failed: "The TXT record for {d} wasn't found yet. DNS changes can take a while to appear.",
        sso_verify_hint: "Company sign-in adds people to this workspace only from verified domains. Add the DNS record at your domain provider, then verify.",
        sso_verifying: "Checking…",
        statuses_count: "{n} status | {n} statuses",
        task_types_count: "{n} task type | {n} task types",
        team_color: "Team colour",
        team_name: "Team name",
        teams_empty_title: "Group people into teams",
        teams_empty: "No teams yet. Use + Team above to group people. Workload, standups and agent access follow the team.",
        teams_note: "Teams drive three things: who appears in Workload and Team, which projects a new member gets, and how far an agent's access reaches. Nothing else depends on teams.",
        template_carries: "What a project template can carry",
        template_never_copies: "Members, comments and time logs are never copied.",
        templates_empty: "No templates in this category.",
        templates_empty_yours: "No templates of your own yet. Create one by hand or from a description.",
        tfa_digit: "Digit {n}",
        tfa_key_copied: "Key copied",
        tfa_lost_1: "Sign in with your password, then use one of your recovery codes instead of the app code. Each code works once.",
        tfa_lost_2: "Out of codes? A workspace owner can turn 2FA off for your account from Members, after confirming it's you.",
        tfa_lost_3: "Owners keep a password fallback so a workspace can never lock itself out.",
        tfa_lost_title: "If you lose the device",
        tfa_off: "Off",
        tfa_off_hint: "Turn it on to protect this account with an authenticator app.",
        tfa_on: "On",
        tfa_on_hint: "Your account asks for a code at every password sign-in.",
        tfa_owner_fallback: "Owner keeps a password fallback",
        tfa_qr_alt: "QR code for your authenticator app",
        tfa_qr_missing: "QR unavailable — enter the key by hand.",
        tfa_recovery_warn: "Ten single-use codes, the only way back in if you lose the device. We can't recover them for you — a self-hosted instance has no support desk behind it.",
        tfa_recovery_warn_title: "Save your recovery codes now.",
        tfa_saved_them: "I've saved them",
        tfa_set_up: "Set up 2FA",
        tfa_step_key: "Or enter this key by hand:",
        tfa_step_scan: "Scan with any authenticator app.",
        tfa_subtitle: "A second code from your phone every time you sign in with a password.",
        tfa_title: "Two-factor authentication",
        tfa_turn_off: "Turn off 2FA",
        tfa_turn_on: "Turn on 2FA",
        theme: "Theme",
        theme_dark: "Dark",
        theme_hint: "System follows your device setting.",
        theme_light: "Light",
        theme_system: "System",
        contrast: "Contrast",
        contrast_hint: "High contrast makes text and borders darker, or lighter in the dark theme, and draws a thick focus ring. Match system follows your device's contrast setting.",
        contrast_auto: "Match system",
        contrast_standard: "Standard",
        contrast_high: "High",
        accent: "Accent colour",
        accent_hint: "The colour of buttons, links, selected items and the focus ring. Kept on this browser.",
        accent_high_contrast: "High contrast uses its own colours. Your accent comes back when contrast is set to Standard.",
        accent_indigo: "Indigo (default)",
        accent_blue: "Blue",
        accent_purple: "Purple",
        accent_teal: "Teal",
        accent_green: "Green",
        accent_orange: "Orange",
        accent_pink: "Pink",
        nav_mode: "How much to show",
        nav_mode_hint: "This only changes what is on the menu. Every page stays open to you, from search and from More.",
        nav_mode_simple: "Simple",
        nav_mode_simple_hint: "Five places: Home, My work, Projects, Inbox and Ask. A place you open joins them.",
        nav_mode_full: "Full",
        nav_mode_full_hint: "Every place on the menu, all the time.",
        nav_mode_failed: "Your choice could not be saved. Try again.",
        look_title: "Look",
        look_note: "Dense is the default. The other looks are a preview on this browser only: nothing is saved to your account and nobody else sees it.",
        variant_dense: "Dense (default)",
        variant_b_hint: "Tighter rows, smaller type and flat surfaces, for a lot on screen.",
        variant_regular: "Regular",
        variant_regular_hint: "Taller rows and larger controls, with spacing and type sizes evened out.",
        variant_c: "Airy",
        variant_c_hint: "More whitespace, larger type, soft shadows and rounder corners.",
        variant_classic: "Classic",
        variant_classic_hint: "The look before Dense became the default.",
        variant_default: "Back to the default look",
        keyboard_title: "Keyboard",
        keyboard_hint: "Move around and create without the mouse. The button below lists every shortcut.",
        single_keys: "Single-key shortcuts",
        single_keys_hint: "Keys like c, / and g h. Turn them off if they get in the way of speech input or other assistive tools. Shortcuts with Cmd or Ctrl keep working.",
        single_keys_failed: "Couldn't save the shortcut setting. Try again.",
        show_shortcuts: "Show keyboard shortcuts",
        this_device: "this device",
        unknown_device: "Unknown device",
        view: "View",
        webhook: "Webhook",
        working_hours: "Working hours",
        working_hours_hint: "Used by Planner, Workload and agent nudges",
        workload_capacity: "Workload capacity",
        workload_capacity_hint: "What Workload counts as a full load when it measures points or tasks. Set for this workspace only.",
        your_templates: "{company}'s templates",
        agents_title: "AI agents",
        agents_hint: "How agents write for you and how much they ask you to look at.",
        agents_loading: "Loading…",
        agents_tone: "Tone",
        agents_tone_concise: "Concise",
        agents_tone_detailed: "Detailed",
        agents_review_depth: "Review",
        agents_depth_summary: "Summary",
        agents_depth_every_change: "Every change",
        agents_no_preference: "No preference",
        agents_notify: "Notify me",
        agents_notify_hint: "When an agent finishes a run or needs a decision.",
        agents_save: "Save",
        agents_saving: "Saving…",
        agents_saved: "AI agent preferences saved.",
        agents_save_failed: "AI agent preferences were not saved.",
        agents_load_failed: "Could not load AI agent preferences.",
        agents_candidates: "Suggested from your declines",
        agents_candidate_count: "{n} declines",
        agents_accept: "Accept",
        agents_dismiss: "Dismiss",
        agents_retry: "Try again",
        agents_candidate_too_many_changes: "Prefers fewer changes per proposal",
        agents_candidate_wrong_tone: "Prefers a different tone — ask before rewriting",
        agents_candidate_needs_person: "Wants a person to handle this kind of work",
        agents_candidate_not_now: "Prefers proposals batched, not one at a time",
        phone_invalid: "Enter a valid phone number.",
        phone_placeholder: "eg. 000-000-0000",
        company_profile: "Company Profile",
        image_dimensions: "{width}x{height}px",
    },
    // One plain sentence per permission, shown under its name on the Security & Permissions
    // screen. Kept here rather than in the seeded `desc` field so companies that already exist
    // get them without a backfill. A key with no entry simply shows no description.
    PermissionDesc: {
        project: "Everything to do with projects. Turning this off hides projects entirely.",
        task: "Everything to do with tasks inside a project.",
        settings: "The company settings area — members, teams, roles and company details.",
        sheet_settings: "Timesheets and the milestone report.",
        artificial_intelligence: "AI features. These use paid credits, so grant with care.",
        chat: "Messaging — channels and direct messages.",

        project_list: "See the list of projects.",
        public_projects: "See projects that are open to the whole company.",
        private_projects: "See private projects. Own means only the ones they are a member of.",
        project_create: "Start a new project.",
        project_name_edit: "Rename a project.",
        project_sprint_create: "Add a new list inside a project.",
        project_folder_create: "Add a folder to group lists together.",
        project_folder_name_edit: "Rename a folder.",
        project_sprint_name_edit: "Rename a list.",
        project_delete: "Delete a whole project and everything in it.",
        folder_archive: "Move a folder out of the way without deleting it.",
        folder_delete: "Delete a folder.",
        folder_restore: "Bring an archived folder back.",
        sprint_archive: "Move a list out of the way without deleting it.",
        sprint_delete: "Delete a list.",
        sprint_restore: "Bring an archived list back.",
        sprint_type_change: "Switch a list between a plain list and a sprint.",
        project_details: "Open the project details panel.",
        project_status_change: "Change whether a project is open, on hold, or finished.",
        project_assignee: "Choose who is on a project.",
        project_category: "Set the project category.",
        project_source: "Set where the project came from.",
        project_type: "Set the project type.",
        project_currency: "Set the currency used for project money fields.",
        project_amount: "See and change the project budget.",
        project_start_date: "Set when the project starts.",
        project_end_date: "Set when the project should finish.",
        project_due_date: "Set the project deadline.",
        project_close: "Close a finished project.",
        project_description: "Write and edit the project description.",
        project_checklist: "Use the project checklist.",
        project_checklist_assign_remove: "Assign checklist items to people, or take them off.",
        project_attachments: "Add and remove files on a project.",
        project_milestone: "Manage project milestones and their amounts.",
        view_list: "Add, rename and remove project views such as Board, Table and Calendar.",
        project_custom_field: "Manage the extra fields on a project.",

        task_list: "See the tasks in a project. Turning this off hides all of them.",
        task_create: "Create a task.",
        sub_task_create: "Create a subtask under an existing task.",
        task_name_edit: "Rename a task.",
        task_total_estimate: "See and change a task's total estimated time.",
        task_status: "Move a task between statuses, such as To Do and Done.",
        task_assignee: "Choose who works on a task.",
        task_priority: "Set how urgent a task is.",
        task_due_date: "Set a task deadline.",
        task_estimated_hours: "See estimated hours. Own means only on their own tasks.",
        task_description: "Write and edit the task description.",
        task_checklist: "Use the checklist inside a task.",
        task_checklist_assign_remove: "Assign checklist items to people, or take them off.",
        task_attachments: "Add and remove files on a task.",
        show_tasks: "Which tasks are visible. Own shows only their own; Everyone shows the team's.",
        task_custom_field: "Manage the extra fields on a task.",
        task_tag: "Add and remove tags.",
        task_start_date: "Set when work on a task begins.",
        task_activity_log: "See the history of what changed on a task and who changed it.",
        task_convert_to_list: "Turn a task into its own list.",
        task_convert_to_subtask: "Make a task a subtask of another one.",
        task_duplicate: "Make a copy of a task.",
        task_merge: "Combine two tasks into one.",
        task_move: "Move a task to another list or project.",
        task_archive: "Move a task out of the way without deleting it.",
        task_delete: "Delete a task.",
        task_comment: "Write comments on tasks.",
        task_details: "Open the full task view.",
        queue_list: "Use the personal queue to line up what to work on next.",
        advance_search: "Use the advanced search and filters.",
        list_view_column: "Choose which columns appear in the list view.",
        task_type: "Set the task type, such as Task, Bug or Design.",
        convert_to_task: "Turn a subtask back into a normal task.",

        settings_edit_company: "Change the company name, logo and details.",
        settings_task_priority: "Set up the priority levels everyone uses.",
        settings_file_extensions: "Choose which file types can be uploaded.",
        settings_project_milestone_status: "Set up the milestone statuses.",
        settings_invite_member: "Invite new people into the company.",
        settings_member_list: "See everyone in the company.",
        settings_create_team: "Create a team.",
        settings_team_list: "See the list of teams.",
        settings_project_list: "See and manage all projects from settings.",
        settings_security_permissions: "Change what every role is allowed to do — this screen.",
        settings_role_management: "Create, rename and remove roles.",
        settings_designation: "Manage job titles.",
        milestone_weekly_range: "Set the weekly hour ranges used for milestones.",
        settings_custom_field: "Create and manage the extra fields used across the company.",

        user_timesheet: "See time logged by people. Own means only their own.",
        project_timesheet: "See time logged against projects. Own means only their own.",
        workload_timesheet: "See how busy people are. Own means only their own.",
        tracker_timesheet: "See time-tracker recordings. Own means only their own.",
        milestone_report: "See the milestone and billing report.",

        one_to_one_chat: "Send direct messages to individual people.",
        chat_category: "Create and manage chat categories.",
        chat_channel: "Create and manage chat channels.",

        per_user_generate_limit: "How many AI credits each person in this role may use.",
    },
    EmptyState: {
        learn_more: "Learn more",
        say_label: "Or say it:",
        say_copy: "Copy",
        say_copied: "Copied",
        say_ask: "Ask it here",
        say_today: "Add a task for me, due today: reply to the client.",
        say_tasks: "Add five starter tasks to this project, with owners and dates.",
        say_list_tasks: "Add five starter tasks to this list, with owners and dates.",
        say_list: "Add a list called Backlog to this folder.",
        say_goal: "Create a goal for this quarter: ship the new website.",
        say_project: "Set up a project for a product launch, with tasks, owners and dates.",
        say_time: "Log one hour today on the task I last worked on.",
        say_automation: "When a task is marked done, tell the project lead.",
        no_projects_title: "No projects yet",
        no_projects_msg: "A project is where your team's work lives — its tasks, files and discussion in one place. Create your first one to get started.",
        no_projects_action: "Create project",
        no_tasks_title: "This project has no tasks yet",
        no_tasks_msg: "Tasks are the individual pieces of work your team picks up. Add the first one and it will appear here.",
        no_tasks_action: "Create task",
        no_match_title: "Nothing matches your filters",
        no_match_msg: "No task here matches the search, assignee or filter you have on. Clear them to see everything this view holds.",
        no_match_action: "Clear filters",
        no_visible_tasks_title: "No tasks to show here",
        no_visible_tasks_msg: "A task was created in this project at some point and nothing is narrowing this view, so we cannot tell you why it is empty. The tasks may have been archived or deleted, or this view may have failed to load them — reloading rules that last one out.",
        empty_list_title: "{list} has no tasks yet",
        empty_list_msg: "Tasks are the individual pieces of work your team picks up. Add the first one to this list and it will appear here.",
        empty_lists_title: "These lists have no tasks yet",
        empty_lists_msg: "Tasks are the individual pieces of work your team picks up. Add the first one and it will appear here.",
        no_archived_title: "No archived tasks to show",
        no_archived_msg: "Archiving keeps a task out of the way without deleting it. Nothing archived is showing here — if a search or a filter is on, clear it to be sure the archive is really empty.",
        no_sprints_title: "No lists yet",
        no_sprints_msg: "Lists group related tasks together: a phase, a week of work, or simply a heading. Add one to organise this project.",
        no_sprints_action: "Create list",
        no_lists_in_folder_title: "{folder} has no lists yet",
        no_lists_in_folder_msg: "Tasks live in lists. Add the first list to this folder and its tasks will show here.",
        folder_gone_title: "This folder is gone",
        folder_gone_msg: "It was deleted, here or by someone else, and its lists went with it. Whoever deleted it can bring it back from the Trash.",
        folder_gone_action: "Open {project}",
        no_calendar_title: "Nothing scheduled",
        no_calendar_msg: "Tasks with a due date in this range will show up here.",
    },
    Members: {
        // Descriptions for the four roles every company is created with. Keyed by roleType, so
        // a company's own renamed or custom roles simply have no entry and show no description.
        role_desc: {
            0: "Can look around and comment. Cannot create or change anything.",
            1: "Full control, including billing and deleting the company.",
            2: "Can do everything except billing and deleting the company.",
            3: "Works on projects and tasks day to day.",
        },
        all_members: "All members",
        removed_members: "Removed members",
        name: "Name",
        role: "Role",
        last_active: "Last Active",
        time_tracker: "Time Tracker",
        settings: "Settings",
        removeuser: "Remove User",
        adduser: "Add User",
        invite_user: "Invite User",
        remove_request: "Remove Request",
        resend_invitation: "Resend Invitation",
        cancel_invitation: "Cancel Invitation",
        Invitation_mail_sent_sucessfully: "Invitation mail sent successfully",
        confirm_change_user_designation:
            "Are you sure you want to change this user's designation to",
        confirm_change_user_role:
            "Are you sure you want to change this user's role to",
        Import_users_from_csv: "Import users from CSV",
        members: "Members",
        seats: "{count} · {plan}",
        unlimited: "UNLIMITED",
        invite: "Invite",
        invite_emails: "Invite by email",
        invite_emails_ph: "name{'@'}company.com, add more…",
        invite_send: "Send",
        invite_sending: "Sending…",
        invite_role: "Role",
        invite_designation: "Designation",
        invite_designation_optional: "Designation (optional)",
        invite_mail_failed: "Couldn't email this invite. Copy the join link instead.",
        dismiss_notice: "Dismiss",
        invite_or_link: "Or share a join link:",
        invite_link_hint: "Anyone with the link joins as the role on the invite.",
        no_link_yet: "Send an invite to get a join link for it.",
        copy_link: "Copy link",
        copied: "Copied",
        col_person: "PERSON",
        col_role: "ROLE",
        col_signin: "SIGN-IN",
        col_last_active: "LAST ACTIVE",
        sso_short: "SSO",
        signin_password: "Password",
        signin_sso: "{name} SSO",
        last_active_now: "now",
        agent_tag: "Agent",
        agent_connected_by: "Connected by {name}",
        agent_last_worked: "Last worked {when} ago",
        agent_last_worked_now: "Last worked just now",
        agent_no_seat: "Takes no seat and has no role of its own",
        agent_hand_where: "You can hand it a task from the assignee list in any project where the project manager is on.",
        invited_on: "invited {date}",
        invite_pending: "Invitation pending",
        resend: "resend",
        remove: "Remove",
        search_ph: "Search by name or email",
        tab_all: "All members",
        tab_removed: "Removed",
        empty_all: "Nobody here yet. Invite someone by email above.",
        empty_search: "No member matches that search.",
        err_email: "Enter a valid email address.",
        err_duplicate: "That address is already on the list.",
        err_role: "Pick a role for the invite.",
        err_designation: "Pick a designation for the invite.",
        forbidden: "You cannot manage members in this workspace.",
        change_role: "Change role",
        role_of: "Role of {name}",

        subtasks: "Subtasks",
        subtasks_count: "{done} OF {total}",
        subtasks_hours: "{done}H OF {total}H",
        add_subtask: "Add subtask",
        add_subtask_hint: "to indent,",
        add_subtask_hint_end: "for the next",
        collapse: "Collapse",
        expand: "Expand",
        no_subtasks: "No subtasks yet. Break the work down as you go.",
        suggest_subtasks: "Suggest subtasks",
        relations: "Relations",
        add_link: "Link",
        no_relations: "Nothing linked. Link the task that blocks this one.",
        relation_blocks: "BLOCKS",
        relation_blocked_by: "WAITS ON",
        relation_duplicates: "DUPLICATES",
        relation_duplicated_by: "DUPLICATED",
        relation_relates_to: "RELATED",
        relations_note: "Gantt draws only blocks and waits on. Related is a reading aid and never moves a date.",
        blocked_warning: "Blocked by {count} open task(s):",
        remove_link: "Remove link",
        search_task_ph: "Search a task to link",
        searching: "Searching…",
        no_task_found: "No task matches that.",
        cancel: "Cancel",
        quick_menu: "QUICK MENU · RIGHT-CLICK",
        ask_ai: "Ask AI about this task",
        admin_only: "admin",
        watching: "Watching",
        not_watching: "Watch",
        watchers: "Watchers",
        watch_all: "All activity",
        watch_participating: "Participating and mentions",
        watch_ignore: "Ignore",
        watch_note: "You can only change your own notifications.",
        no_watchers: "No one matches that search.",

        sprints: "Lists & folders",
        new_sprint: "List",
        close_sprint: "Close sprint",
        start_sprint: "Start sprint",
        sprint_points: "{done}/{total} pts",
        sprint_tasks: "{count} task | {count} tasks",
        close_title: "Close {name}",
        close_lead: "{done} of {total} points done.",
        close_unfinished: "{count} task is unfinished | {count} tasks are unfinished",
        close_decide: "— decide where they go before the sprint closes.",
        close_all_done: "Everything in this sprint is done.",
        dest_next: "Move them to {name}",
        dest_next_new: "Move them to a new sprint",
        dest_next_hint: "Keeps points and history",
        dest_backlog: "Send them back to the backlog for re-grooming",
        dest_pick: "Move them into another sprint",
        dest_pick_hint: "{count} to review",
        close_confirm: "Close and move the work",
        close_working: "Closing…",
        close_reversible: "Closing is final — the sprint report is saved and the sprint cannot be reopened.",
        moving_these: "Moving these",
        stranded_note: "Open work under a parent that is already done stays where it is.",
        loading: "Loading…",

        recurring: "Recurring tasks",
        rules_count: "{rules} RULES",
        new_rule: "Rule",
        rule_name_ph: "Rule name",
        rule_task_ph: "Task created each time",
        every: "Every",
        on_day: "on",
        at_time: "at",
        assign_to: "assign",
        assign_nobody: "nobody",
        unit_days: "days",
        unit_weeks: "weeks",
        unit_months: "months",
        day_of_month: "day {day}",
        ends: "ends",
        ends_never: "never",
        next_occurrences: "NEXT OCCURRENCES",
        no_occurrences: "This rule has no occurrences left.",
        missed_head: "IF THE LAST ONE ISN'T DONE",
        missed_skip: "Skip and note it",
        missed_create: "Create anyway",
        missed_roll: "Roll the date forward",
        copy_template: "Copy the checklist and description each time",
        rule_paused: "Paused",
        run_now: "Run now",
        delete_rule: "Delete rule",
        save_rule: "Save",
        create_rule: "Create rule",
        no_rules: "No rules yet. Add one to have a task created on a schedule.",
        next_run: "next {when}",
        rule_needs_name: "Give the rule a name and a task title.",

        people: "People",
        people_count: "{count} · {teams} TEAMS",
        people_search_ph: "Search skills…",
        org_chart: "Org chart",
        loaded: "loaded",
        open_tasks: "open tasks",
        in_projects: "projects",
        message: "Message",
        their_work: "Their work",
        book_time: "Book time",
        reports_to: "reports to {name}",
        on_pto: "PTO until {date}",
        find_someone: "FIND SOMEONE WHO KNOWS…",
        skills_note: "Skills come from the projects each person actually works on. Nobody is ranked.",
        privacy_note: "Guests never appear here, and load figures are hidden from anyone who cannot already see timesheets.",
        no_people: "Nobody matches that search.",
        no_people_title: "Nobody to show yet",
        no_people_msg: "Everyone who joins this workspace is listed here, with their team, their skills and what they are working on.",
        clear_search: "Clear search",
        no_skills: "No skills recorded yet.",
        clear_filter: "Clear"
    },
    Upgrades: {
        take_next_step: "Take the next step with your work",
        you_are_on: "You are currently on the",
        per_year: "Per Year",
        per_month: "Per Month",
        current_plane: "Current Plan",
        per_member: "Per Member",
        and_much_more: "and much more",
        upgrade_to: "Upgrade to",
        select_payment_method: "Select Payment Method",
        plan: "Plan",
        plane_upgrade: "Plan upgrade successfully",
        plane_upgrade_msg:
            "Plan Upgrade Successful! Your subscription has been upgraded. Please allow 2 to 3 minutes for the changes to take effect everywhere, ensuring you can fully enjoy the expanded features and improvements!",
        something_wrong: "Something went wrong Please try Again",
        unsucessfull_msg:
            "Plan Upgrade Unsuccessful. We encountered an issue while upgrading your plan. Please try again or contact support for assistance.",
        upgrade_your_plan: "Upgrade Your Plan",
        to_unlock_custom_field: "To Unlock Custom Field",
        unlimited: "Unlimited",
        the_feature_not_available:
            "That feature isn’t available on your current plan",
        unlock_project_permission: "To Unlock Project Permissions",
        unlock_custom_field: "To Unlock Custom Field",
        to_unlock_milestone: "To Unlock Milestone",
        to_unlock_milestone_report: "To Unlock Milestone Report",
        to_unlock_project_timesheet: "To Unlock Project Timesheet",
        to_unlock_security: "To Unlock Security & Permissions",
        to_unlock_team: "To Unlock Team",
        to_unlcok_project: "To Unlock Project",
        You_have_reached_the_free_plan_limit:
            "You've reached the limit of your plan",
        require_upgrade_message:
            "Your plan has a limit on how many projects you can create. Upgrade your plan to create more.",
        are_you_sure_you_want_to_update: "Are you sure you want to update?",
        find_out_whats_included_in_this_update:
            "Find out what’s included in this update",
        improved_performance: "Improved Performance",
        install_now: "Install Now",
        later: "Later",
        please_see_below_for_a_list_of_changes_to_the_features:
            "Please see below for a list of changes to the features.",
        to_integrate_new_services_into_an_alian_hub:
            "To integrate new services into an Alian hub.",
        whats_new: "What’s new?",
        check_to_agree_with_above_points: "Check to agree with above points",
        general_notes: "General Notes",
        update_now: "Update Now",
        unlock_channel: "To Unlock Channel",
        unlock_chat: "To Unlock Chat",
        unlock_one_chat: "To Unlock One to One Chat",
        public_private_creation_time_limit_reached:
            "You have reached the limit for project creation. If you want to create a project, please upgrade your plan.",
        public_creation_time_limit_reached:
            "You have reached the limit for public project creation. You can only create private projects. If you want to create a public project, please upgrade your plan.",
        private_creation_time_limit_reached:
            "You have reached the limit for private project creation. You can only create public projects. If you want to create a private project, please upgrade your plan.",
    },
    Permissions: {
        Write: "Write",
        advanced_permission: "Advanced Permissions",
        allow_admins: "Allow admins to manage private Spaces",
        when_admin_enable:
            "When enabled, admins will be able to add/remove people and transfer ownership of all Spaces.",
        show_all_projects: "Show all projects",
        when_user_enable:
            "When enabled, users will be able to see all the global projects.",
        show_all_task: "Show all tasks",
        when_user_enable_sprint:
            "When enabled, users will be able to see all the tasks in the lists.",
        own: "Own",
        select: "Select",
        Member: "Member",
        Guest: "Guest",
        None: "None",
        Read: "Read",
        add_new_team: "Add New Team",
        "Read & Write": "Read & Write",
        Support: "Support",
        select_priorities: "Select Priorities",
        apply_permission: "Apply Permission",
        project_permission_description:
            "To override the global permissions, it is disabled by default. After it is enabled, you can manage project and task permissions. If it is disabled, the global permissions are then applied",
        project_permission_title_disable:
            "The ability to grant custom permissions for this project will be disabled",
        project_permission_title_enable:
            "The ability to grant custom permissions for this project will be enabled",
        reset_permission: "Reset Permission",
    },
    subProjectRulesNames: {
        Project_List: "Project List",
        Project_Create: "Project Create",
        Project_Name_Edit: "Project Name Edit",
        Project_Sprint_Create: "Project List Create",
        Project_folder_Create: "Project folder Create",
        Project_folder_Name_Edit: "Project folder Name Edit",
        Project_sprint_Name_Edit: "Project List Name Edit",
        Project_Details: "Project Details",
        Project_Status_Change: "Project Status Change",
        Project_Assignee: "Project Assignee",
        Project_Category: "Project Category",
        Proejct_Source: "Project Source",
        Project_Type: "Project Type",
        Project_Currency: "Project Currency",
        Project_Amount: "Project Amount",
        "Project_Start Date": "Project Start Date",
        "Project_End Date": "Project End Date",
        "Project_Due Date": "Project Due Date",
        Project_Close: "Project Close",
        Project_Description: "Project Description",
        Project_Checklist: "Project Checklist",
        "Project_Checklist_Assign/remove": "Project Checklist Assign/remove",
        Project_Attachments: "Project Attachments",
        Project_Milestone: "Project Milestone",
        Task_list: "Task list",
        Task_Create: "Task Create",
        Sub_Task_Create: "Sub Task Create",
        Task_Name_Edit: "Task Name Edit",
        Task_Status: "Task Status",
        Task_Assignee: "Task Assignee",
        Task_Priority: "Task Priority",
        Task_Due_Date: "Task Due Date",
        Task_Estimated_Hours: "Task Estimated Hours",
        Task_Description: "Task Description",
        Task_Checklist: "Task Checklist",
        "Task_Checklist_Assign/remove": "Task Checklist Assign/remove",
        Task_Attachments: "Task Attachments",
        Show_Tasks: "Show Tasks",
        Custom_Field: "Custom Field",
        Edit_Company: "Edit Company",
        File_Extensions: "File Extensions",
        Project_Milestone_Status: "Project Milestone Status",
        Invite_Member: "Invite Member",
        Member_list: "Member list",
        Create_Team: "Create Team",
        Team_List: "Team List",
        "Security_&_Permissions": "Security & Permissions",
        Role_Management: "Role Management",
        Designation: "Designation",
        Milestone_Weekly_Range: "Milestone Weekly Range",
        User_Timesheet: "User Timesheet",
        Project_Timesheet: "Project Timesheet",
        Workload__Timesheet: "Workload Timesheet",
        Milestone_Report: "Milestone Report",
        Project: "Project",
        Task: "Task",
        Company_Settings: "Company Settings",
        Sheet_Settings: "Sheet Settings",
        Team_Color: "Team Color",
        Team_Name: "Team Names",
        Add_Member: "Add Member",
        Add_New_Designation: "Add New Designation",
    },
    Notification: {
        Notification: "Notification",
        docs: "Docs",
        doc_mention: "Docs I'm {'@'}mentioned in",
        goals: "Goals",
        goal_target_reached: "Targets reached on my goals",
        goal_reached: "Goals reached",
        comment_reply: "Replies to my comments",
        comment_assigned: "Comments assigned to me",
        doc_comment_mention: "Doc comments I'm {'@'}mentioned in",
        doc_comment_reply: "Replies to my doc comments",
        doc_comment_assigned: "Doc comments assigned to me",
        doc_shared: "Docs shared with me",
        notification_setting: "Notification Settings",
        browser: "Browser",
        mobile: "Mobile",
        before: "Before",
        chat: "Chat",
        project: "Project",
        tasks: "Tasks",
        before_project_due_date: "Project Due Date",
        before_project_end_date: "Project End Date",
        before_task_due_date: "Task Due Date",
        before_task_end_date: "Task End Date",
        message_create: "Message Create",
        project_create: "Project Create",
        project_name: "Project Name",
        project_status_change: "Project Status Change",
        project_assignee: "Project Assignee",
        project_lead: "Project Lead",
        project_category: "Project Category",
        project_source: "Project Source",
        project_type: "Project Type",
        project_currency: "Project Currency",
        project_amount: "Project Amount",
        project_start_date: "Project Start Date",
        project_end_date: "Project End Date",
        project_due_date: "Project Due Date",
        project_close: "Project Close",
        project_description: "Project Description",
        project_checklist: "Project Checklist",
        project_checklist_assign: "Project Checklist Assign",
        project_checklist_remove: "Project Checklist Remove",
        project_attachments: "Project Attachments",
        project_milestone: "Project Milestone",
        project_milestone_status_change: "Project Milestone Status Change",
        project_sprint_create: "Project List Create",
        project_folder_create: "Project Folder Create",
        "comments_im_@mentioned_in": "Comments I'm {'@'}mentioned In",
        task_notification: "Task Notification",
        task_create: "Task Create",
        task_edit: "Task Edit",
        task_status: "Task Status",
        task_assignee: "Task Assignee",
        task_priority: "Task Priority",
        task_type: "Task Type",
        task_due_date: "Task Due Date",
        task_description: "Task Description",
        task_checklist: "Task Checklist",
        task_checklist_assign: "Task Checklist Assign",
        task_checklist_remove: "Task Checklist Remove",
        task_attachments: "Task Attachments",
        "comments_Im_@mentioned_in": "Comments I'm {'@'}mentioned In",
        logged_hours_notification: "Logged Hours Notification",
        after_3_hours_today_pending_hours:
            "After 3 hours Today Pending Hours Log Notification",
        task_estimated_hours: "Task Estimated Hours",
    },
    TimeTracker: {
        unlock: "Unlock the Universe with Alianhub Tracker on Your Desktop!",
        smooth: "Smoothly track hours spent by users working on projects or tasks with time tracking.",
        no_builds: "No desktop tracker download is available on this server yet.",
        click: "click",
        No_Record_Found: "No Record Found",
        total: "Total",
        tracked: "Tracked",
        manual: "Manual",
        hours_value: "{time} hrs",
        screenshot_preview: "Screenshot Preview",
        log_time_found_no_screenshot:
            "Log time was found, but no screenshot was captured for this duration.",
    },
    settingslider: {
        "Time Tracking": "Time Tracking",
        Notifications: "Notifications",
        Company: "Company",
        "My Settings": "My Settings",
        "Security & Permissions": "Security & Permissions",
        SSO: "SSO",
        "Audit Log": "Audit Log",
        SCIM: "SCIM",
        "Time Off": "Time Off",
        Upgrade: "Upgrade",
        "Custom Field Manager": "Custom Field Manager",
        "Language & Region": "Language & Region",
        Templates: "Templates",
        Projects: "Projects",
        Teams: "Teams",
        Members: "Members",
        Settings: "Settings",
        "Change Password": "Change Password",
        "Two-Factor Authentication": "Two-Factor Authentication",
        "Integrations": "Integrations",
    },
    Sso: {
        provider: "Provider",
        provider_oidc: "OIDC (OpenID Connect)",
        provider_saml: "SAML 2.0",
        discovery_url: "Discovery URL",
        discovery_url_ph: "https://idp/.well-known/openid-configuration",
        client_id: "Client ID",
        client_secret: "Client secret",
        scopes: "Scopes",
        scopes_ph: "openid email profile",
        entry_point: "Identity provider sign-in URL",
        entry_point_ph: "https://idp/sso/saml",
        entity_id: "IdP entity ID",
        idp_cert: "IdP signing certificate",
        idp_cert_ph: "-----BEGIN CERTIFICATE-----",
        attributes_list: "email · firstName · lastName",
        auto_provision: "Auto-provision new users on first login",
        saving: "Saving…",
    },
    Scim: {
        title: "SCIM Provisioning",
        subtitle: "Let your identity provider create, update, and deactivate members automatically (Okta, Azure AD, OneLogin…).",
        enabled: "Enabled",
        disabled: "Disabled",
        default_role: "Default role for provisioned users",
        default_role_hint: "New users created by your IdP get this role.",
        role_admin: "Admin",
        role_member: "Member",
        role_guest: "Guest",
        connect_hint: "Set these in your identity provider's user sync (SCIM) settings:",
        base_url: "SCIM base URL",
        token_label: "Access token",
        token_hidden: "hidden for security",
        no_token: "Not generated yet",
        token_once: "Copy this token now — it will not be shown again.",
        copy: "Copy",
        copied: "Copied!",
        generate: "Generate token",
        rotate: "Regenerate token",
        working: "Working…",
        saved: "Saved",
        failed: "Failed",
    },
    Audit: {
        subtitle: "An immutable record of sensitive actions in this workspace — role changes, SSO updates, and more.",
        refresh: "Refresh",
        f_action: "Action",
        f_action_ph: "e.g. member.update",
        f_entity: "Entity type",
        f_from: "From",
        f_to: "To",
        apply: "Apply",
        clear: "Clear",
        col_action: "Action",
        col_entity: "Entity",
        col_ip: "IP",
        col_details: "Details",
        empty: "No audit events match these filters.",
        showing: "Showing {from}–{to} of {total}",
        prev: "Prev",
        next: "Next",
        title: "Audit log",
        today_events: "Today · {n} {unit}",
        event_one: "event",
        event_other: "events",
        export_csv: "Export CSV",
        tab_all: "All",
        tab_agents: "Agents only",
        tab_outside_agents: "Outside agents",
        outside_agent_for: "{client} (outside agent) for {person}",
        an_outside_agent: "Unnamed client",
        a_member: "a member",
        tab_gated: "Gated actions",
        tab_undone: "Undone",
        search: "Search actor, action or reason",
        clear_filter: "Clear filter",
        this_project: "This project",
        loading: "Loading…",
        none: "Nothing has been recorded yet.",
        none_msg: "This is the record of who changed what in this workspace, and when.",
        none_match: "Nothing recorded matches that search",
        none_filtered: "Nothing recorded matches this filter",
        clear_filters: "Clear filters",
        clear_search: "Clear search",
        failed: "The audit log could not be loaded.",
        col_time: "Time",
        col_actor: "Actor",
        col_event: "Event",
        col_reason: "Reason / run",
        agent: "AGENT",
        an_agent: "An agent",
        someone: "Someone",
        blocked_by_policy: "blocked by policy ·",
        nothing_ran: "attempt logged · nothing ran",
        cost: "{tokens} tokens · ${usd}",
        run_n: "#{n}",
        undo: "Undo",
        undoing: "Undoing…",
        undone_at: "undone {t}",
        undone_toast: "Reverted, and logged as you.",
        undo_failed: "That could not be undone.",
        undo_until: "Undo until {t}",
        undo_window_passed: "The undo window has passed.",
        export_failed: "The export did not download.",
        load_more: "Load more",
        retention: "Retained 400 days. Undo replays the inverse action and logs it as you.",
        tab_refusals: "Refusals",
        integrity_verified: "Verified",
        integrity_verified_hint: "This row and every chained row before it are intact.",
        integrity_broken: "Broken at #{seq}",
        integrity_broken_hint: "The chain does not verify from row #{seq} on: a row was changed, removed or reordered.",
        integrity_unverified: "Not verified yet",
        integrity_unverified_hint: "Not checked yet. It is checked the next time the audit log opens, once the chain key is available.",
        integrity_unchained: "Unchained",
        integrity_unchained_hint: "Written before the audit chain started, so it cannot be verified.",
        integrity_broken_row: "Broken",
        integrity_broken_row_hint: "This row is outside the chain but was written after the chain started, for example while the audit chain was off, or it carries a change that is not part of the chain.",
        names_not_checked: "Names aren't covered by the integrity check. The ids beside them are.",
        total_approximate: "The count is approximate: some rows it includes no longer match this filter once their recorded changes are checked.",
        tainted: "Read external content",
        tainted_reason: "This run took in content from outside the workspace, so its risky changes need a person's approval.",
        taint_kind_fetch: "Web page",
        taint_kind_email: "Email",
        taint_kind_form: "Form submission",
        taint_kind_webhook: "Webhook",
        taint_kind_file: "Uploaded file",
        taint_kind_passage: "Knowledge passage",
        taint_kind_instruction: "Instruction-shaped text",
        taint_kind_connector: "Connector",
        details: "Details",
        detail_key: "Recorded as",
        detail_on: "About",
        detail_reason: "Reason as recorded",
        event_unnamed: "Other activity",
        event_with_action: "{event}: {action}",
        event_undid: "Undid: {action}",
        proposal_approved: "Approved an agent's proposal",
        proposal_declined: "Declined an agent's proposal",
        proposal_undone: "Undid an approved proposal",
        proposal_failed: "An agent's proposal could not be applied"
    },
    AuditReasons: {
        not_visible: "The person this agent works for cannot open that.",
        not_visible_task: "The person this agent works for cannot open that task.",
        not_visible_thread: "The person this agent works for cannot open the comments on that task.",
        not_visible_project: "The person this agent works for cannot open that project.",
        not_visible_list: "The person this agent works for cannot open that list.",
        permission_denied: "The person this agent works for is not allowed to do that.",
        spend_cap_exceeded: "The spending limit was reached, so the AI model was not asked.",
        budget_unavailable: "The AI budget could not be checked, so the AI model was not asked.",
        spend_cap_exceeded_detail: "The spending limit was reached: the next step would cost about ${cost}, and ${left} of the ${limit} limit is left.",
        step_credential_refused: "The workflow step this agent was working on had ended, so the change was not made.",
        external_refused: "The outside agent's step was refused.",
        external_session_closed: "The outside agent's work on this had already ended.",
        external_run_not_running: "The workflow had stopped running.",
        external_step_not_waiting: "The workflow was no longer waiting for the outside agent.",
        external_grant_not_live: "The outside agent's access was removed or has run out.",
        external_client_not_approved: "The outside app is no longer approved for this workspace.",
        undo_window_passed: "The time to undo this had passed.",
        project_not_visible: "The person cannot open the project this touched.",
        target_not_visible: "The person cannot open what this touched.",
        already_undone: "This was already undone.",
        not_undoable: "This cannot be undone.",
        action_pending: "The change was never confirmed, so it has to be checked by hand before it is undone.",
        action_failed: "The change failed, so there is nothing to undo.",
        undo_unrecordable: "The undo could not be recorded just then, so it was not run.",
        not_permitted: "Only an owner, an admin or the person who started the run can undo it.",
        run_open: "The run was still going, so it has to be stopped first.",
        already_reverted: "The run was already undone.",
        private_host: "The address is inside a private network, which agents may not reach.",
        private_address: "The address leads inside a private network, which agents may not reach.",
        unlisted: "The site is not on the list of sites agents may reach.",
        txt_record_missing: "The domain's verification record was not found.",
        denied: "Their role does not allow it.",
        no_seat: "They have no seat in this workspace.",
        role_not_allowed: "Their role does not allow it.",
        tasks_not_found: "The tasks it named were not found.",
        null_global_flag: "The project follows its own rules, and the check could not read them.",
        check_failed: "The permission check itself failed.",
        unresolvable_id: "The request named something that could not be found.",
        company_mismatch: "The request named another workspace.",
        agents_cannot: "Agents are not allowed to do this.",
        agents_never: "Agents are never allowed to do this.",
        agents_not_in_skills: "This agent has not been given that skill.",
        agents_must_propose: "An agent has to propose this and wait for a person's approval.",
        agents_cannot_fields: "Agents are not allowed to change those details.",
        agents_cannot_status: "Agents are not allowed to move a task to {status}.",
        approved_by: "Approved by {person}",
        approved_by_someone: "Approved by a person",
        always: "Done without asking, under \"Always do this\".",
        always_by: "Done without asking, under \"Always do this\" set up by {person}.",
        said_and: "{said} · {also}",
        skill_finding: "Found by the skill \"{skill}\"",
        via_rest: "Made by a connected app",
        outside_client_held: "This change {risk}, and it came from {client}, an app outside AlianHub, so a person has to approve it"
    },
    AuditEvents: {
        agent_action: "An agent made a change",
        agent_action_refused: "An agent's change was blocked",
        agent_action_undone: "An agent's change was undone",
        agent_proposal_decided: "Decided an agent's proposal",
        agent_created: "Created an agent",
        agent_deleted: "Deleted an agent",
        agent_run_reverted: "Undid everything an agent run changed",
        agent_revision_promoted: "Put a version of an agent live",
        agent_revision_rolled_back: "Went back to an earlier version of an agent",
        agent_project_policy_changed: "Changed what agents may do in a project",
        agent_workspace_policy_changed: "Changed what agents may do in the workspace",
        agent_budget_changed: "Changed the AI budget",
        agent_role_playbook_changed: "Changed the playbook of an agent role",
        agent_standing_approval_made: "Turned on \"Always do this\" for an agent",
        agent_standing_approval_ended: "Ended an \"Always do this\" approval",
        agent_egress_refused: "Blocked an agent from reaching a site",
        agent_egress_allowlist: "Changed the sites agents may reach",
        audit_amended: "Added to an earlier record",
        audit_person_redacted: "Removed a person's details from the audit log",
        instance_audit_redact_person: "Asked to remove a person's details from the audit log",
        permission_refused: "Tried something their role does not allow",
        permission_enforcement_mode: "Changed how permissions are enforced",
        ai_instruction_pattern_added: "Added a pattern for spotting hidden instructions",
        ai_instruction_pattern_removed: "Removed a pattern for spotting hidden instructions",
        knowledge_reindex: "Started reading the workspace again for AI search",
        knowledge_reindex_cancel: "Stopped reading the workspace again for AI search",
        knowledge_reembed: "Rebuilt what AI search knows",
        knowledge_retry_files: "Retried the files AI search could not read",
        knowledge_erase_document: "Removed a document from AI search",
        knowledge_erase_person: "Removed a person's content from AI search",
        knowledge_exclusion_remove: "Let AI search read something again",
        member_update: "Changed a member's role or details",
        api_token_renewed: "Renewed an access token",
        billing_contract_update: "Changed a project's billing contract",
        billing_milestone_create: "Added a billing milestone",
        billing_milestone_update: "Changed a billing milestone",
        billing_invoice_draft: "Drafted an invoice",
        billing_invoice_update: "Changed an invoice",
        billing_invoice_sent: "Marked an invoice as sent",
        billing_invoice_paid: "Marked an invoice as paid",
        billing_invoice_delete: "Deleted an invoice",
        goal_create: "Created a goal",
        goal_update: "Changed a goal",
        goal_archive: "Archived a goal",
        goal_restore: "Restored a goal",
        custom_field_deleted: "Deleted a custom field",
        oauth_grant_created: "Connected an outside app",
        oauth_grant_revoked: "Disconnected an outside app",
        oauth_grant_narrowed: "Reduced what an outside app may do",
        oauth_client_approval_requested: "Asked for an outside app to be approved",
        oauth_client_approved: "Approved an outside app",
        oauth_client_approval_denied: "Turned down an outside app",
        oauth_client_approval_revoked: "Withdrew the approval of an outside app",
        oauth_client_registered: "Registered an outside app",
        oauth_client_revoked: "Removed an outside app",
        connector_connect: "Connected a service",
        connector_revoke: "Disconnected a service",
        connector_broken: "A connected service stopped working",
        connector_channels_set: "Chose the Slack channels agents may use",
        connector_call: "An agent read from a connected service",
        agent_session_delegated: "Handed a task to an outside agent",
        agent_session_endpoint_saved: "Saved where an outside agent is reached",
        agent_session_completed: "An outside agent finished its work",
        agent_session_failed: "An outside agent's work failed",
        agent_session_revoked: "An outside agent's access was withdrawn",
        agent_session_unresponsive: "An outside agent stopped answering",
        sso_config_update: "Changed the single sign-on settings",
        sso_domain_verified: "Verified a sign-in domain",
        sso_domain_unverified: "A sign-in domain is no longer verified",
        sso_login_refused: "Refused a single sign-on login",
        scim_config_update: "Changed the member sync settings",
        scim_token_rotate: "Replaced the member sync access token",
        scim_user_invite: "Member sync invited a person",
        scim_user_provision: "Member sync added a person",
        scim_user_activate: "Member sync turned a person back on",
        scim_user_deactivate: "Member sync turned a person off",
        pto_create: "Asked for time off",
        pto_approved: "Approved time off",
        pto_rejected: "Turned down time off",
        pto_pending: "Set time off back to waiting",
        secret_create: "Saved a secret",
        secret_rotate: "Replaced a secret",
        secret_revoke: "Removed a secret",
        secret_orphan: "A secret is no longer used by anything",
        secret_resolve_failed: "A secret could not be read",
        secret_reencrypt: "Encrypted the saved secrets again",
        automation_task_update: "An automation changed a task",
        automation_task_comment: "An automation added a comment",
        automation_task_create: "An automation created a task",
        automation_task_create_subtask: "An automation added a subtask",
        automation_task_assign: "An automation changed who a task is assigned to",
        automation_task_notify: "An automation sent a notification",
        automation_task_set_status: "An automation changed the status",
        automation_task_set_priority: "An automation changed the priority",
        workflow_add_comment: "A workflow added a comment",
        workflow_assign: "A workflow changed who a task is assigned to",
        workflow_create_subtask: "A workflow added a subtask",
        workflow_notify: "A workflow sent a notification",
        workflow_run_agent: "A workflow ran an agent",
        workflow_set_priority: "A workflow changed the priority",
        workflow_set_status: "A workflow changed the status",
        dispatcher_routed: "The dispatcher routed a task",
        dispatcher_settings_changed: "Changed the dispatcher of a project",
        dispatcher_rule_added: "Added a routing rule",
        dispatcher_pack_applied: "Turned on a team pack",
        dispatcher_pack_undone: "Undid a team pack"
    },
    AuditActions: {
        model_call: "Ask the AI model",
        run_start: "Start an agent run",
        run_revert: "Undo everything a run changed",
        undo: "Undo a change",
        session_taken_up: "Take up work handed to an outside agent",
        session_activity: "Report progress on handed-over work",
        session_complete: "Finish handed-over work",
        session_fail: "Give up handed-over work",
        workflow_agent_run: "Workflow step: run an agent",
        workflow_tool_call: "Workflow step: make a change",
        workflow_human_approval: "Workflow step: ask a person to approve",
        workflow_fan_out: "Workflow step: split into side-by-side steps",
        workflow_fan_in: "Workflow step: wait for the side-by-side steps",
        workflow_condition: "Workflow step: check a condition",
        workflow_wait: "Workflow step: wait",
        workflow_timer: "Workflow step: wait until a set time",
        workflow_loop: "Workflow step: repeat",
        workflow_external_agent: "Workflow step: hand over to an outside agent",
        workflow_automation_rule: "Workflow step: run an automation",
        workflow_loop_run_limit: "Run an agent again in a repeating workflow",
        workflow_approval_decide: "Decide a workflow approval",
        workflow_approval_reassign: "Pass a workflow approval to someone else",
        workflow_template_install: "Add a ready-made workflow",
        workflow_role_handoff: "Workflow step: hand over to a role",
        workflow_role_handoff_queued: "A workflow put a task in a role's queue",
        workflow_role_handoff_finished: "A role finished a task a workflow handed over",
        workflow_role_handoff_released: "A role gave back a task a workflow handed over",
        workflow_role_handoff_timed_out: "A workflow took a task back from a role",
        workflow_role_handoff_withdrawn: "A workflow took a task back from a role when its step ended",
        workflow_definition_create: "Create a workflow",
        workflow_definition_update: "Edit a workflow",
        workflow_definition_enable: "Turn a workflow on or off",
        workflow_definition_delete: "Delete a workflow",
        workflow_step_retry: "Retry a workflow step",
        workflow_step_skip: "Skip a workflow step",
        workflow_step_resume: "Resume a workflow step",
        workflow_step_compensate: "Undo a workflow step",
        workflow_run_start: "Start a workflow",
        task_delete: "Delete a task",
        tasks_unknown: "Change a task in a way that has no name",
        tasks_import: "Import tasks",
        tasks_cascade: "Change a task and the tasks under it",
        task_relation_unknown: "Change a task's links in a way that has no name",
        project_delete: "Delete or close a project",
        project_status_set: "Change a project's status",
        project_agent_policy_edit: "Change what agents may do in a project",
        project_agent_limits_edit: "Change the limits for agents in a project",
        project_agent_manager_edit: "Change a project's project manager settings",
        project_standing_approval_end: "End an \"Always do this\" approval",
        workspace_agent_policy_edit: "Change what agents may do in the workspace",
        member_remove: "Change who is a member",
        member_seat: "Change who may use the time tracker",
        member_invite: "Invite a member",
        permissions_edit: "Change roles and permissions",
        billing: "Change anything to do with billing",
        deploy_production: "Deploy to the live site",
        token_manage: "Manage access tokens",
        goal_create: "Create a goal",
        goal_update: "Edit a goal",
        goal_archive: "Archive a goal",
        goal_restore: "Restore a goal",
        goal_write: "Change a goal",
        goal_target_add: "Add a target to a goal",
        goal_target_edit: "Edit a goal's target",
        goal_target_remove: "Remove a goal's target",
        proposal_approve: "Approve a proposal",
        proposal_decline: "Decline a proposal",
        proposal_undo: "Undo an approved proposal",
        queue_hand_over: "Hand work over to an agent",
        queue_take_back: "Take work back from an agent",
        agent_create: "Create an agent",
        agent_update: "Edit an agent",
        agent_delete: "Delete an agent",
        agent_pause: "Pause an agent",
        agent_resume: "Resume an agent",
        agent_pause_all: "Pause all agents",
        agent_workspace_guide_add: "Add the Workspace Guide",
        agent_settings_edit: "Change the AI settings",
        agent_routing_policy_edit: "Change how work is shared out to agents",
        agent_role_playbook_edit: "Edit the playbook of an agent role",
        agent_role_playbook_restore: "Restore the built-in playbook of an agent role",
        agent_skill_create: "Create a skill",
        agent_skill_update: "Edit a skill",
        agent_skill_retire: "Retire a skill",
        agent_memory_add: "Add to what agents remember",
        agent_memory_update: "Edit what agents remember",
        agent_preferences_edit: "Change a person's AI preferences",
        agent_run_stop: "Stop an agent run",
        agent_run_revert: "Undo everything a run changed",
        agent_account_link: "Link an AI account",
        agent_account_unlink: "Unlink an AI account",
        agent_schedule_create: "Add a schedule for an agent",
        agent_schedule_update: "Edit an agent's schedule",
        agent_schedule_delete: "Delete an agent's schedule",
        agent_revision_create: "Save a new version of an agent",
        agent_revision_promote: "Put a version of an agent live",
        agent_revision_rollback: "Go back to an earlier version of an agent",
        agent_change_undo: "Undo an agent's change",
        automation_draft: "Draft an automation with AI",
        automation_update: "Edit an automation",
        automation_enable: "Turn an automation on or off",
        automation_delete: "Delete an automation",
        automation_apply: "Run an automation on the tasks already there",
        assignment_suggestion_accept: "Accept a suggested assignee",
        assignment_suggestion_dismiss: "Dismiss a suggested assignee",
        assignment_suggestion_undo: "Undo a suggested assignee",
        dispatcher_suggestion_accept: "Accept a suggested role",
        dispatcher_suggestion_dismiss: "Dismiss a suggested role",
        dispatcher_suggestion_route: "Send a task to a role",
        timesheet_review: "Review a timesheet",
        pto_decide: "Approve or turn down time off",
        integration_connect: "Connect an integration",
        integration_update: "Change an integration",
        integration_disconnect: "Disconnect an integration",
        app_connection_projects: "Link an app to projects",
        app_connection_connected: "Connect an app through its sign-in",
        app_connection_repo: "Pick the repository an app reads",
        app_connection_repo_added: "Link a GitHub repository to a project",
        app_connection_repo_removed: "Unlink a GitHub repository from a project",
        app_connection_sync: "Check a connected app for changes",
        app_connection_task_linked: "Link a pull request to a task",
        app_connection_task_moved: "Note a merged pull request on a task",
        app_connection_error: "A connected app could not be read",
        page_comment: "Comment on a doc",
        page_share: "Share a doc",
        page_ai: "Write in a doc with AI",
        page_version_save: "Save a version of a doc",
        page_version_restore: "Restore a version of a doc",
        page_version_rename: "Rename a version of a doc",
        page_review: "Mark a doc as reviewed",
        page_approve: "Approve a doc",
        page_restore: "Restore a doc",
        page_image: "Add an image to a doc",
        timelog_capture: "Add a screenshot to a timer",
        share_public: "Share with a public link",
        intake_review: "Review what a form sent in",
        sprint_scrum: "Make a list a sprint",
        sprint_start: "Start a sprint",
        sprint_complete: "Complete a sprint",
        sprint_create: "Create a list",
        sprint_update: "Edit a list",
        folder_update: "Edit a folder",
        trash_restore: "Restore from the trash",
        sample_data_remove: "Remove the sample data",
        account_security: "Change sign-in or password settings",
        agent_run_start: "Start an agent on a task",
        agent_session_delegate: "Hand a task to an outside agent",
        agent_session_endpoint: "Set where an outside agent is reached",
        ai_answer_post: "Post an AI answer in a conversation",
        ai_memory_edit: "Change what the AI remembers about a person",
        ai_spend: "Ask the workspace AI for an answer",
        billing_entries: "Mark time as billable or not",
        billing_project: "Change a project's billing details",
        billing_rates: "Change billing rates",
        calendar_feed: "Make or change a calendar feed",
        chat_channel: "Read or write in a channel",
        chat_direct: "Read or write a direct message",
        dashboard_manage: "Make or change a dashboard",
        email_send: "Send an email",
        email_in_manage: "Change how email comes in as tasks",
        export_workspace: "Export the workspace",
        fields_delete: "Delete a custom field",
        file_delete: "Delete a file",
        form_manage: "Make or change a form",
        notification_send: "Send a notification",
        portfolio_edit: "Change a portfolio",
        project_settings: "Change a project's settings",
        project_tags_edit: "Change a project's tags",
        pto_request: "Ask for time off",
        recurring_manage: "Set a task to repeat",
        reminder_manage: "Make or change a reminder",
        report_schedule: "Schedule a report",
        task_types_edit: "Change the task types",
        template_apply: "Use a task template",
        template_import: "Import settings from a template",
        template_save: "Save a project as a template",
        template_update: "Change a saved project template",
        timelog_delete: "Delete logged time",
        timesheet_submit: "Send a timesheet for approval",
        unread_reset: "Clear unread counts",
        webhook_manage: "Make or change a webhook",
        workload_move: "Move planned work",
        workspace_create: "Make a workspace",
        workspace_settings: "Change the workspace's settings",
        aifield_apply: "Apply AI suggestions to a field",
        comment_assign: "Assign a comment",
        comment_resolve: "Resolve a comment",
        epic_assign: "Put a task in an epic",
        epic_create: "Make an epic",
        epic_update: "Change an epic",
        project_comment: "Comment on a project",
        project_update: "Change a project's details",
        reaction_set: "React to a comment or a task",
        sprint_favourite: "Star a list",
        task_fields_compute: "Work out the calculated fields of tasks",
        task_reorder: "Change the order of tasks",
        time_plan: "Plan time on a task",
        timelog_edit: "Change logged time",
        whiteboard_update: "Change a whiteboard"
    },
    QuickCreate: {
        title: "New task",
        name_label: "Task name",
        name_placeholder: "Task name",
        project: "Project",
        personal_list: "Personal List",
        list: "List",
        loading: "Loading…",
        no_projects: "No project you can add tasks to",
        properties: "Task properties",
        status: "Status",
        assignee: "Assignee",
        unassigned: "Unassigned",
        due_date: "Due date",
        priority: "Priority",
        create_another: "Create another",
        hint_create: "create",
        hint_open: "create and open",
        key_ctrl_enter: "Ctrl+↵",
        cancel: "Cancel",
        create: "Create task",
        creating: "Creating…",
        created: "Task created",
        open: "Open",
        name_too_short: "Give the task a name of at least 3 characters.",
        no_list: "This project has no list to add the task to yet.",
        create_failed: "Couldn't create the task. Try again.",
        rail_label: "New task",
        rail_title: "New task (C)",
        template: "Template",
        no_template: "No template"
    },
    Shortcuts: {
        title: "Keyboard shortcuts",
        close: "Close",
        then: "then",
        single_keys_off: "Single-key shortcuts are off, so only the shortcuts with Cmd or Ctrl work. You can turn them back on in My settings.",
        group_general: "General",
        group_navigation: "Go to",
        group_task: "Task panel",
        group_inbox: "Inbox",
        group_create: "New task dialog",
        palette: "Search or run a command",
        search: "Search this page, or open search",
        create_task: "New task",
        help: "Show keyboard shortcuts",
        undo: "Undo, while the undo notice shows",
        go_home: "Home",
        go_inbox: "Inbox",
        go_projects: "Projects",
        go_time: "Time",
        task_next: "Next task",
        task_prev: "Previous task",
        task_close: "Close the panel",
        inbox_next: "Next item",
        inbox_prev: "Previous item",
        inbox_open: "Open the item",
        inbox_clear: "Clear the item",
        inbox_snooze: "Snooze the item",
        inbox_reply: "Reply to a mention",
        inbox_send_reply: "Send the reply",
        create_submit: "Create the task",
        create_another: "Create and start another",
        create_open: "Create and open the task",
        group_palette: "Search and commands",
        group_docs: "Docs",
        palette_next: "Next result",
        palette_prev: "Previous result",
        palette_run: "Open the result, or run the command",
        palette_new_tab: "Open the result in a new tab",
        palette_actions: "Move to the actions of the result",
        palette_close: "Close search",
        doc_save: "Save the doc",
        key_ctrl: "Ctrl",
        key_shift: "Shift",
        key_enter: "Enter",
        key_escape: "Esc",
        key_tab: "Tab",
        with_keys: "{label} ({keys})",
        search_ph: "Search shortcuts",
        search_label: "Search keyboard shortcuts",
        none_title: "No shortcut matches",
        none_msg: "Try the name of an action, or a single key.",
        clear_search: "Clear search"
    },
    Pto: {
        add_title: "Request time off",
        type: "Type",
        types: { casual: "Casual Leave", privilege: "Privilege Leave", sick: "Sick Leave", vacation: "Vacation", holiday: "Holiday", personal: "Personal", unpaid: "Unpaid" },
        start: "Start date",
        end: "End date",
        hours_per_day: "Hours per day",
        duration: "Duration",
        full_day: "Full day",
        half_day: "Half day",
        custom_hours: "Custom hours",
        reason: "Reason",
        reason_ph: "Optional note",
        request: "Request",
        saving: "Saving…",
        requested: "Time off requested.",
        dates_required: "Start and end dates are required.",
        date_order: "End date must be on or after the start date.",
        failed: "Could not save.",
        capacity_title: "My capacity this month",
        cap_total: "Working hours",
        cap_pto: "Time off",
        cap_avail: "Available",
        team_title: "Team time off",
        my_title: "My time off",
        refresh: "Refresh",
        search_member: "Search member…",
        all_status: "All statuses",
        all_types: "All types",
        prev: "Prev",
        next: "Next",
        page: "Page",
        col_created: "Created",
        col_dates: "Dates",
        col_member: "Member",
        col_type: "Type",
        col_hours: "Hours",
        col_status: "Status",
        col_reason: "Reason",
        col_days: "Total Days",
        total_days: "Total days",
        working_days: "working days",
        status: { pending: "Pending", approved: "Approved", rejected: "Rejected" },
        approve: "Approve",
        reject: "Reject",
        delete: "Delete",
        delete_locked: "An approved leave can't be deleted",
        empty: "No time-off entries.",
        loading: "Loading…",
    },
    Inbox: {
        doc_mention: "mentioned you in {doc}",
        doc_shared: "shared {doc} with you",
        doc_comment_mention: "mentioned you in a comment on {doc}: {text}",
        doc_comment_reply: "replied to a comment on {doc}: {text}",
        doc_comment_assigned: "on {doc}: {text}",
        goal_target_reached: "The target {target} of the goal {goal} is reached.",
        goal_target_reached_by: "reached the target {target} of the goal {goal}.",
        goal_reached: "The goal {goal} is reached.",
        goal_reached_by: "brought the goal {goal} to 100%.",
        agent_report: "{agent} delivered your {report}.",
        agent_session_assigned: "{task} had no assignee, so it is now yours while {agent} works on it for you.",
        automation_notify: "{rule}: {text}",
        automation_unnamed: "Automation",
        oauth_client_approval: "{client} asks to act for people in this workspace. An owner or admin can approve or deny it in Settings, Agent clients.",
        unnamed_client: "An outside agent",
        credential_expiring_token: "Your token {name} ends on {date}. Renew it under Accounts to keep its settings and get a new secret.",
        credential_expiring_connection: "The access you gave {name} ends on {date}. Connect it again from the app to keep it.",
        title: "Inbox",
        tab_all: "All",
        tab_notifications: "Notifications",
        tab_mentions: "Mentions",
        tab_archive: "Archive",
        tab_hint_all: "Everything unread, notifications and mentions together.",
        tab_hint_notifications: "Unread notifications.",
        tab_hint_mentions: "Where someone mentioned you.",
        tab_hint_archive: "Everything you have already read.",
        source_all: "All",
        source_notifications: "Notifications",
        source_mentions: "Mentions",
        customize: "Customize Inbox",
        opt_showAllTab: "Show All tab",
        opt_groupByDate: "Group by date",
        opt_newestFirst: "Sort by newest first",
        mark_read: "Mark as read",
        mark_unread: "Mark as unread",
        no_task: "General",
        today: "Today",
        yesterday: "Yesterday",
        loading: "Loading…",
        retry: "Try again",
        load_more: "Load more",
        load_failed: "Could not load your inbox.",
        action_failed: "That didn't go through.",
        all_read_toast: "All marked as read.",
        zero: "You're all caught up",
        zero_archive: "Nothing read yet",
        zero_sub: "Nothing here needs you right now.",
        tab_primary: "Primary",
        tab_later: "Later",
        tab_done: "Done",
        tab_other: "Other",
        tab_cleared: "Cleared",
        tabs_label: "Inbox sections",
        zero_other: "Nothing from things you watch",
        zero_sub_other: "Updates on items you only watch land here. Anything assigned to you or mentioning you stays in Primary.",
        zero_cleared: "Nothing cleared",
        zero_sub_cleared: "Rows you clear stay here for 30 days, then they are deleted.",
        zero_sub_later_snooze: "Press S on a row, or choose Snooze, to set it aside until the time you pick.",
        footer_cleared: "Cleared items are deleted after 30 days.",
        keys_hint_full: "j and k or the arrow keys move, Enter opens, r replies, e clears, s snoozes",
        snooze: "Snooze",
        snooze_menu: "Snooze until",
        snooze_later_today: "Later today",
        snooze_tomorrow: "Tomorrow",
        snooze_next_week: "Next week",
        snooze_until_change: "Until it changes",
        snooze_until_change_hint: "on new activity",
        snooze_custom: "Pick a date and time",
        snooze_pick_label: "Snooze until",
        snooze_save: "Snooze",
        snooze_pick_past: "Pick a time in the future.",
        snoozed_until: "Snoozed until {when}",
        snoozed_until_change: "Snoozed until it changes",
        unsnooze: "Unsnooze",
        undo_snoozed: "Snoozed until {when}.",
        undo_snoozed_change: "Snoozed until it changes.",
        clear: "Clear",
        clear_all: "Clear all",
        cleared_on: "Cleared {when}",
        cleared_all: "Cleared {n}. They stay in Cleared for 30 days.",
        undo_cleared: "Cleared.",
        restore: "Restore",
        restored: "Back in Primary.",
        later_migrated: "Moved {n} saved-for-later rows to the server. They come back tomorrow at 9:00.",
        filter_label: "Filter",
        kind_all: "Everything",
        kind_mention: "Mentions",
        kind_approval: "Approvals",
        kind_reminder: "Reminders",
        kind_update: "Updates",
        kind_assigned: "Assigned comments",
        assigned_you_comment: "assigned you a comment",
        replied_in_thread: "replied in a thread you're in",
        mark_all_read: "Mark all read",
        marked_all_read: "Marked {n} as read.",
        zero_primary: "You're all caught up",
        zero_sub_primary: "Nothing here needs you right now.",
        zero_later: "Nothing saved for later",
        zero_done: "Nothing done yet",
        zero_sub_done: "Rows you mark done or open land here.",
        back_to_primary: "Back to Primary",
        someone: "Someone",
        requested_off: "requested {range} off",
        wants_to: "wants to",
        changes_n: "{n} change(s)",
        open_ai_inbox: "Open in AI Inbox",
        needs_your_approval: "needs your approval",
        tab_approval: "Needs your approval",
        zero_approval: "Nothing waits for your approval",
        zero_sub_approval: "When an agent proposes a change, or someone asks for time off, it lands here.",
        queue_for: "{agent}, for {person}",
        queue_system_for: "The system, for {project}",
        queue_locked: "Needs an owner or admin",
        queue_locked_rights: "Needs someone who may make this change",
        queue_locked_retry: "Waits for the person who approved the plan",
        queue_locked_plan: "Cannot be made through this plan",
        queue_plan_locked: "Nothing in this plan can be made through it. Decline it. An owner or admin can add the status in Settings, or ask their own AI.",
        queue_retry_locked: "Only the person who approved this plan can try these parts again.",
        queue_retry_note: "This was not made the first time, so you can try it once more. Why it was not made: {why}",
        queue_left_waiting: "What you may not approve stays waiting for someone who may.",
        queue_left_retry: "What was not made is listed again, so you can try it once more.",
        queue_changes_label: "What changes",
        queue_select_all: "Select all",
        queue_select_one: "Select: {what}",
        queue_selected: "{n} selected",
        queue_review: "Approve selected",
        queue_review_title: "Approve this one? | Approve these {n}?",
        queue_review_lead: "Each one is approved in turn, exactly as listed here. Nothing outside this list is approved.",
        queue_parts_kept: "Only what you left ticked: {parts}.",
        queue_approve_n: "Approve {n}",
        queue_approving: "Approving…",
        queue_bulk_done: "Approved {ok} of {n}.",
        queue_bulk_failed: "{n} was not approved; the reason is on its row. | {n} were not approved; the reason is on each row.",
        queue_approve_named: "Approve: {what}",
        queue_edit: "Edit",
        queue_edit_named: "Edit before approving: {what}",
        queue_decline_named: "Decline: {what}",
        queue_drop_named: "Drop this change: {change}",
        queue_approved: "Approved. | Approved {n}.",
        queue_declined: "Declined.",
        queue_undone: "Approval undone.",
        queue_undo_left: "Not everything was undone: {why}",
        always: "Always do this",
        always_named: "Always do this: {what}",
        always_title: "Always do this?",
        always_body: "From now on {agent} makes this kind of change in this project without asking: {kind}. Each one is listed here as done, with Undo.",
        always_limits: "It ends after {days} days. You, an owner or an admin can remove it sooner, under \"Always do this\" in the project's details.",
        always_confirm: "Approve and always do this",
        always_made: "Approved. {agent} will not ask for this kind of change in this project again.",
        always_done_title: "Done without asking",
        always_done_lead: "Changes that \"Always do this\" let through for you. Each can be undone for a short while.",
        always_did: "did this without asking:",
        always_undo_named: "Undo: {what}",
        always_undone: "Change undone.",
        queue_open_named: "Open in the Inbox: {what}",
        reminder: "Reminder",
        due_now: "due now",
        done: "Done",
        mentioned_you: "mentioned you",
        mentioned_you_chat: "mentioned you in chat",
        reply_placeholder: "Reply to {name}…",
        reply_empty: "Write something before sending.",
        reply_sent: "Reply posted.",
        reply_mentions: "Mentions {name}, so the reply reaches their Inbox.",
        send: "Send",
        approve: "Approve",
        decline: "Decline",
        open_reminders: "Open reminders",
        review_ai_inbox: "Review in AI Inbox",
        reply_here: "Reply here",
        open_task: "Open task",
        open_chat: "Open chat",
        open: "Open",
        mark_done: "Mark done",
        undo: "Undo",
        open_made: "Open it",
        undo_approved: "Approved {who}'s time off.",
        undo_declined: "Declined {who}'s time off.",
        search_placeholder: "Search or ask AI…",
        search_idle: "Type to search tasks, projects, pages and people — or pick a place to go.",
        search_nothing: "Nothing matched \"{q}\"",
        search_nothing_sub: "Searched {n} sources. Try a shorter word, or ask AI instead.",
        searching_sources: "Searching {n} sources",
        ask_ai: "Ask AI",
        ask_query: "Ask: \"{q}\"",
        clear_search: "Clear search",
        group_recent: "Recent",
        group_navigation: "Navigation",
        group_records: "Records",
        group_people: "People",
        group_apps: "From connected apps",
        group_ask: "Ask AI",
        group_commands: "Commands",
        hint_move: "move",
        hint_open: "open",
        hint_command: "command",
        app_connected: "Connected app · open its settings",
        edited_by: "edited by {who}",
        nav_teams: "Teams",
        nav_notifications: "Notification settings",
        agent_tag: "AGENT",
        nav_time_tracking: "Time tracking",
        nav_security: "Security & permissions",
        cmd_new_task: "New task",
        cmd_new_project: "New project",
        cmd_start_timer: "Start timer",
        state_offline_title: "You're offline",
        state_offline_body: "You can keep working. Changes are saved on this device and sync when you're back.",
        state_offline_primary: "Retry now",
        state_unreachable_title: "Can't reach the server",
        state_unreachable_body: "Your changes are saved locally and will sync when it's back.",
        state_unreachable_primary: "Retry now",
        state_unreachable_secondary: "Status page",
        state_forbidden_title: "You don't have access",
        state_forbidden_body: "This is visible to its members only. Ask its owner to add you.",
        state_forbidden_primary: "Request access",
        state_forbidden_secondary: "Go home",
        state_denied_title: "You don't have access to this screen",
        state_denied_body: "Your role can't open it. Ask a workspace owner or admin if you need it.",
        state_denied_primary: "Go home",
        state_notfound_title: "This doesn't exist any more",
        state_notfound_body: "It was deleted, moved, or never existed. Anything it held is in the audit log.",
        state_notfound_primary: "Go home",
        state_notfound_secondary: "Audit log",
        state_route_notfound_title: "We can't find that page",
        state_route_notfound_body: "The link may be mistyped, or what it pointed to was moved or deleted.",
        state_retrying: "retrying in {s}s · attempt {n}",
        off_title: "Offline",
        off_keep_working: "you can keep working.",
        off_syncing: "Syncing {n} change… | Syncing {n} changes…",
        off_queued: "{n} change queued. | {n} changes queued.",
        off_conflicts_n: "{n} to resolve",
        off_review_queue: "Review queue",
        off_hide_queue: "Hide",
        off_still_works: "Still works",
        off_still_works_list: "Open any task you've visited · edit titles, descriptions, statuses · check subtasks · start and stop the timer · write comments · take notes",
        off_needs_server: "Needs the server",
        off_needs_server_list: "Search · chat and calls · AI and agents · reports · invoices · anything you haven't opened before",
        off_queued_changes: "Queued changes",
        off_oldest: "OLDEST {t}",
        off_queue_empty: "Nothing waiting. Everything you did is on the server.",
        off_attempt: "attempt {n}",
        off_more_changes: "{n} more queued change | {n} more queued changes",
        off_conflicts_title: "{n} conflict(s) to resolve on reconnect",
        off_conflict_line: "You set {task} to {mine} at {mineAt}. {who} set it to {theirs} at {theirsAt} on the server.",
        off_someone: "Someone",
        off_theirs: "theirs",
        off_keep_mine: "Keep mine",
        off_keep_theirs: "Keep {who}'s",
        off_open_decide: "Open and decide",
        off_conflict_hint: "Time logs and comments never conflict — they're additive and both get kept. Only single-value fields can clash.",
        off_retry_every: "Retrying every {s} seconds.",
        off_stored_on_device: "Queue is stored on this device and survives a reload or a browser restart.",
        off_retry_now: "Retry now",
        chg_title: "What's new",
        chg_on_version: "You're on v{v}.",
        chg_available: "v{v} is available.",
        chg_up_to_date: "You're up to date.",
        chg_upgrade_guide: "Upgrade guide",
        chg_what_shipped: "What shipped",
        chg_for_self_hosters: "For self-hosters",
        chg_selfhost_none: "Nothing to do beyond pulling the release and restarting.",
        chg_upgrade_steps: "git pull · npm install · restart",
        chg_upgrade_needed: "UPGRADE NEEDS A HAND",
        chg_upgrade_plain: "PULL AND RESTART",
        chg_upgrade_needed_q: "Upgrade needed?",
        chg_footer: "Every release lists its data updates and whether a restart is needed. Follow releases by email or RSS. Nothing is tracked either way."
    },
    AutomationPreview: {
        heading: "New automation",
        wants: "add the automation “{title}”",
        line_start: "Starts when",
        line_rule: "Rule",
        line_step: "Step {n}",
        line_reach: "Works on",
        reach: "Tasks of this project, each time one meets the rule after it is switched on. It does not run on what happened before.",
        line_state: "Once approved",
        state_on: "Saved in your name and switched on straight away",
        state_off: "Saved in your name, switched off until you turn it on",
        line_runs: "Last {days} day | Last {days} days",
        runs: "Matches {n} task you can open | Matches {n} tasks you can open",
        runs_none: "Matches no task you can open",
        line_examples: "For example",
        line_problem: "Cannot be made",
    },
    IntentPreview: {
        new_task: "New task",
        new_subtask: "New subtask",
        summary: "{kind}: {title}",
        wants_task: "create the task “{title}”",
        wants_subtask: "add the subtask “{title}”",
        line_place: "Where",
        line_parent: "Under",
        line_assignees: "For",
        line_due: "Due",
        line_start: "Starts",
        line_priority: "Priority",
        line_status: "Status",
        line_type: "Type",
        line_estimate: "Estimate",
        line_description: "Description",
        line_links: "Links",
        place_in_list: "{list}, in {project}",
        people_and_more: "{names} and {n} more",
        people_not_shown: "{n} person not shown | {n} people not shown",
        priority_urgent: "Urgent",
        priority_high: "High",
        priority_medium: "Medium",
        priority_low: "Low",
        estimate_hours_minutes: "{h} h {m} min",
        estimate_hours: "{h} h",
        estimate_minutes: "{m} min",
        description_more: "{text}…",
        links_count: "{n} link | {n} links",
        new_fields: "New fields",
        new_view: "New view",
        wants_fields: "add the fields “{title}”",
        wants_view: "add the view “{title}”",
        new_setup: "Project setup",
        wants_setup: "set up the project “{title}”",
        new_project: "New project",
        wants_project: "create the project “{title}”",
        new_project_copy: "Project copy",
        wants_project_copy: "copy a project as “{title}”",
        line_copy_of: "Copy of",
        line_copy_parts: "Copied",
        copy_parts: "Its folders, lists, statuses, fields, views and settings. Its automations come too, switched off, where you may manage them.",
        line_copy_tasks: "Tasks",
        copy_tasks_none: "None. Only the setup is copied.",
        copy_tasks_zero: "None: it has no task you can open.",
        copy_tasks_count: "{n} task you can open, without its assignees | {n} tasks you can open, without their assignees",
        copy_tasks_too_many: "{n} tasks, and a copy made this way takes at most {limit}. Approving it makes nothing: decline it, then ask for the copy without its tasks or duplicate the project yourself.",
        line_copy_dates: "Dates",
        copy_dates_kept: "Kept as they are in the project",
        new_folder: "New folder",
        wants_folder: "create the folder “{title}”",
        new_tag: "New tag",
        wants_tag: "add the tag “{title}” to the project",
        line_inside: "Inside",
        line_subfolder: "Subfolder",
        line_moved_lists: "Lists moved in",
        lists_not_shown: "{n} list you cannot open | {n} lists you cannot open",
        lists_and_hidden: "{names}, and {hidden}",
        line_members: "On it",
        members_only_approver: "Only the person who approves it, at first. It starts private; add people in the project afterwards.",
        batch_kind: "Several tasks",
        batch_kind_one: "One change",
        batch_tasks: "{n} task | {n} tasks",
        batch_changes: "{n} change | {n} changes",
        wants_batch_tasks: "change {n} task | change {n} tasks",
        wants_batch_changes: "make {n} change | make {n} changes",
        batch_value_on: "{value}, on {tasks}",
        batch_mixed_on: "Different on each of {tasks}",
        batch_what_title: "Title",
        batch_what_assignees: "Assignees",
        batch_what_move: "Moved",
        batch_what_archive: "Archived",
        batch_what_restore: "Restored",
        batch_what_comment: "Comment",
        batch_what_other: "Other changes",
        batch_what_relation_add: "Linked to",
        batch_what_relation_remove: "Link removed",
        batch_what_list_add: "Added to list",
        batch_what_list_remove: "Taken out of list",
        batch_item_on: "{value}, on “{task}”",
        reply_to: "replying to {name}: {text}",
        batch_assign_set: "Set to {people}",
        batch_assign_add: "Add {people}",
        batch_assign_remove: "Remove {people}",
        batch_assign_none: "Nobody",
        line_batch_tasks: "Tasks",
        line_moves_not_shown: "Also moves later",
        tasks_and_more: "and {n} more",
        tasks_not_shown: "{n} task you cannot open | {n} tasks you cannot open",
        tasks_show_all: "Show all {n} tasks",
        tasks_show_fewer: "Show fewer",
        pick_hint: "Untick anything you do not want. Only what is ticked is made.",
        pick_also_out: "{names} is left out too: it needs “{name}”. | {names} are left out too: they need “{name}”.",
        pick_also_kept: "{names} is kept too: “{name}” needs it. | {names} are kept too: “{name}” needs them.",
        pick_locked: "An owner or admin approves this part",
        pick_locked_rights: "Someone whose role may make this approves this part",
        pick_locked_plan: "This cannot be made through this plan. An owner or admin can add the status in Settings, or ask their own AI.",
        pick_hidden: "{n} part of this plan has nothing to show, so it is left out. | {n} parts of this plan have nothing to show, so they are left out.",
        pick_also_back: "{names} is back too: it was left out with “{name}”. | {names} are back too: they were left out with “{name}”.",
        pick_named: "“{name}”",
        pick_kept: "Ticked: {parts}.",
        kept_statuses: "{kept} of {total} status | {kept} of {total} statuses",
        kept_lists: "{kept} of {total} list | {kept} of {total} lists",
        kept_fields: "{kept} of {total} field | {kept} of {total} fields",
        kept_views: "{kept} of {total} view | {kept} of {total} views",
        kept_rules: "{kept} of {total} automation | {kept} of {total} automations",
        kept_dashboards: "{kept} of {total} dashboard | {kept} of {total} dashboards",
        kept_tasks: "{kept} of {total} first task | {kept} of {total} first tasks",
        line_fields: "Fields",
        line_rules: "Automations",
        line_first_tasks: "First tasks",
        line_rule: "Automation",
        rule_starts_off: "{rule} (starts switched off)",
        rule_problem: "Cannot be made as written: {problem}",
        line_first_task: "First task",
        line_agent: "Agent",
        agent_guide: "{project} Guide, which answers when mentioned on a task",
        task_with: "{name} ({details})",
        task_in_list: "list: {list}",
        task_in_status: "status: {status}",
        task_for: "for {person}",
        task_due: "due {date}",
        line_new_statuses: "New statuses",
        line_new_lists: "New lists",
        line_view: "New view",
        view_named: "{name}: {layout}",
        line_field: "Field",
        line_layout: "Layout",
        line_group: "Grouped by",
        line_sort: "Sorted by",
        line_shows: "Shows",
        line_search: "Search",
        line_columns: "Columns",
        field_named: "{name}: {type}",
        field_with_options: "{name}: {type} ({options})",
        field_type_text: "Text",
        field_type_textarea: "Long text",
        field_type_number: "Number",
        field_type_money: "Money",
        field_type_date: "Date",
        field_type_dropdown: "Dropdown",
        field_type_checkbox: "Checkbox",
        field_type_email: "Email",
        field_type_phone: "Phone",
        field_type_url: "Link",
        field_type_people: "People",
        field_type_rating: "Rating",
        field_type_progress: "Progress",
        rollup_sum: "the total of {source} on the subtasks under each task",
        rollup_avg: "the average of {source} on the subtasks under each task",
        rollup_min: "the lowest {source} on the subtasks under each task",
        rollup_max: "the highest {source} on the subtasks under each task",
        rollup_count: "how many subtasks are under each task",
        rollup_count_filled: "how many subtasks under each task have {source} filled in",
        formula_worked_out: "worked out as {expression}",
        new_dashboard_card: "New dashboard card",
        wants_dashboard_card: "add a card to the dashboard “{title}”",
        line_dashboard: "Dashboard",
        dashboard_new: "{name}: a new dashboard, private to its owner",
        line_new_dashboard: "New dashboard",
        dashboard_with_cards: "{name}: {cards}",
        line_card: "Card",
        card_over: "{card} · {period}",
        new_timesheet_week: "Timesheet week to send for approval",
        wants_timesheet_week: "send your timesheet week {title} for approval",
        line_timesheet_week: "Week",
        timesheet_week_span: "{from} to {to}",
        line_timesheet_note: "Note",
        layout_list: "List",
        layout_board: "Board",
        layout_table: "Table",
        layout_calendar: "Calendar",
        layout_workload: "Workload",
        group_status: "Status",
        group_assignee: "Assignee",
        group_priority: "Priority",
        group_due_date: "Due date",
        sort_due: "Due date",
        sort_priority: "Priority",
        sort_created: "Created",
        sort_updated: "Updated",
        sort_name: "Name",
        sort_status: "Status",
        sort_assignee: "Assignee",
        sort_points: "Points",
        sort_estimate: "Estimate",
        sort_ascending: "{by}, ascending",
        sort_descending: "{by}, descending",
        shows_mine: "Only the tasks of the person looking",
        fields_not_shown: "{n} field not shown | {n} fields not shown",
        due_today: "Today",
        due_tomorrow: "Tomorrow",
        due_this_week: "This week",
        due_next_week: "Next week",
        due_next_7_days: "The next 7 days",
        due_this_month: "This month",
        due_overdue: "Before today",
        due_range: "{from} to {to}",
        line_value: "Value",
        value_on_task: "{field} on “{task}”: {value}",
        value_yes: "Yes",
        value_no: "No",
        value_empty: "Empty",
        values_hidden: "{n} value on a task you cannot open | {n} values on tasks you cannot open"
    },
    Integrations: {
        title: "Integrations",
        desc: "Send task events to Slack, Discord, or any HTTPS address via outgoing webhooks.",
        copied: "Copied to clipboard",
        // AHE-3838 — cloud storage for attachments
        cloud_title: "Cloud storage for attachments",
        cloud_desc: "Optional, and entirely your own. Attach files straight from Google Drive or Dropbox instead of uploading them. Your credentials and your connected account are private to you — nobody else in the workspace can see or change them, and two people can link the same drive account independently. Nobody has to set this up: uploading from your computer works exactly as before.",
        cloud_redirect_uri: "Redirect URI",
        cloud_redirect_hint: "Needed by Google Drive only. Paste this exact value into the provider's console as an authorised redirect URI. It differs per environment, so add the staging and production ones too. Dropbox does not use one.",
        cloud_show_steps: "Setup steps ({count})",
        cloud_hide_steps: "Hide setup steps",
        cloud_ready: "Ready",
        cloud_not_setup: "Not set up for you",
        cloud_setup: "Set up",
        cloud_connect: "Connect my account",
        cloud_disconnect: "Disconnect my account",
        cloud_connected: "Connected",
        cloud_not_connected: "You have not connected your account yet.",
        cloud_your_account: "Your account",
        cloud_reauth: "Your access expired — connect again.",
        cloud_no_signin_needed: "Ready to use. No sign-in needed — you choose files inside the provider's own picker.",
        cloud_secret_set: "•••••••• (leave blank to keep)",
        cloud_saved: "Your {provider} credentials were saved",
        cloud_removed: "Your {provider} credentials were removed",
        cloud_confirm_remove: "Remove your {provider} credentials? This disconnects your {provider} account. Nobody else is affected.",
        cloud_disconnected: "Disconnected from {provider}",
        cloud_connected_toast: "Account connected",
        secret_title: "Save your signing secret",
        secret_desc: "Use it to verify the X-AlianHub-Signature header. It is shown only once.",
        copy: "Copy",
        done: "Done",
        add_webhook: "Add a webhook",
        edit_webhook: "Edit webhook",
        destination: "Destination",
        name: "Name",
        name_ph: "e.g. Team Slack channel",
        url: "Webhook URL",
        slack_url: "Slack Incoming Webhook URL",
        discord_url: "Discord Webhook URL",
        slack_hint: "In Slack: Apps → Incoming Webhooks → Add to a channel → copy the webhook URL.",
        discord_hint: "In Discord: Channel → Edit → Integrations → Webhooks → New Webhook → copy the URL.",
        events: "Events",
        all_events: "All task events",
        ev_created: "Task created",
        ev_updated: "Task updated",
        ev_deleted: "Task deleted",
        ev_archived: "Task archived",
        ev_restored: "Task restored",
        send_to_slack: "Send to Slack",
        create: "Create webhook",
        save: "Save changes",
        cancel: "Cancel",
        your_webhooks: "Your webhooks",
        empty: "No webhooks yet. Add one above to start sending task events.",
        active: "Active — events are delivered",
        paused: "Paused — no events delivered",
        logs: "Logs",
        edit: "Edit",
        delete: "Delete",
        no_logs: "No deliveries recorded yet.",
        load_more: "Load more",
        loading: "Loading…",
        event: "Event",
        status: "Status",
        duration: "Duration",
        when: "When",
        retry: "retry",
        last: "Last",
        no_deliveries: "No deliveries yet",
        needs_attention: "Needs attention",
        needs_attention_hint: "The signing secret is revoked or unavailable, so nothing is delivered. Delete this webhook and add it again.",
        err_name: "A name is required.",
        err_url: "A valid web address starting with http:// or https:// is required.",
        err_events: "Select at least one event.",
        confirm_delete: "Delete this webhook? Its delivery history will also be removed.",
        secret_copied: "Signing secret copied to clipboard.",
    },
    Chat: {
        welcome_message: "Welcome to BRAND_NAME",
        msg2: "This is a brand-new Group. Here are some steps to help you get started. For more, check out our Getting Started guide",
        chats: "Chats",
        favorites: "Favorites",
        CHANNELS: "CHANNELS",
        back_to_chat: "Back to chat",
        meeting_notes: "Meeting notes",
        loading_notes: "Loading notes…",
        notes_not_found: "Those notes are not available, or you were not in that call.",
        notes_private: "Only participants see these notes until you share them.",
        live_notes: "Live notes",
        transcript: "Transcript",
        transcript_empty: "No transcript was captured for this call.",
        summary_so_far: "Summary so far",
        no_action_items: "No action items were picked up.",
        create_tasks_from_items: "Create tasks from action items",
        from_timestamp: "from {at}",
        title: "Chat",
        search: "Search channels and people",
        direct: "Direct messages",
        channels: "Channels",
        new_channel: "New channel",
        new_message: "New message",
        no_channels: "No channels yet. Create one to get your team talking.",
        no_direct: "No direct messages yet. Pick a person to start one.",
        no_matches: "Nothing matches",
        members_count: "{count} members",
        member_one: "1 member",
        summarize: "Summarize thread",
        summarizing: "Summarizing…",
        summary_title: "Thread summary",
        summary_empty: "Nothing to summarize yet.",
        summary_failed: "Could not summarize this thread.",
        summary_ai_off: "AI is turned off, so this thread cannot be summarized.",
        close_summary: "Close summary",
        action_items: "Action items",
        create_task: "Create task",
        created: "created",
        make_task: "Make a task",
        save_later: "Save for later",
        saved_later: "Saved for later",
        unsaved_later: "Removed from saved",
        reply: "Reply",
        agent: "AGENT",
        agent_unavailable: "This agent is not available to message.",
        review_inbox: "Review in AI Inbox",
        pick_up: "Pick up where you left off",
        members: "Members",
        pinned: "Pinned",
        files: "Files",
        no_pinned: "Nothing pinned yet. Pin a message to keep it here.",
        no_files: "No files shared yet. Attach one from the composer.",
        no_members: "No members yet.",
        open_details: "Channel details",
        close_details: "Close details",
        back_to_list: "Back to conversations",
        message_channel: "Message #{name}",
        message_person: "Message {name}",
        message: "Message",
        attach: "Attach",
        clip: "Clip",
        talk_to_text: "Talk to text",
        ask_ai: "Ask AI",
        voice_note: "Voice note",
        send: "Send",
        send_options: "Send options",
        send_enter: "Send",
        send_and_task: "Send and make a task",
        commands: "Commands",
        command_hint: "Type / for commands",
        cmd_task: "Make a task from this message",
        cmd_summarize: "Summarize this thread",
        cmd_clip: "Record a clip",
        cmd_voice: "Record a voice note",
        recording: "Recording · Esc to cancel",
        transcription_note: "Transcription runs on your server",
        max_note: "Max 5 min per note",
        transcribe: "Transcribe",
        transcribing: "Transcribing…",
        transcribe_failed: "Could not transcribe this note.",
        copy_text: "Copy text",
        copied: "Copied",
        lightbox_hint: "Click to open the lightbox · arrow keys move between files · attach any of these to a task",
        more_files: "+{count}",
        media_files: "Media & files",
        task_name: "Task name",
        project: "Project",
        sprint: "List",
        select_project: "Select a project",
        select_sprint: "Select a list",
        no_project_ready: "No project is set up for tasks yet.",
        name_length: "Task name must be 3–250 characters.",
        pick_both: "Pick a project and a list.",
        task_created: "Task created",
        task_link_text: "Made a task from this message",
        from_chat: "From chat",
        creating: "Creating…",
        create: "Create",
        cancel: "Cancel",
        from_call: "From the call",
        setup_title: "New channel",
        setup_name: "Name",
        setup_name_placeholder: "channel-name",
        setup_purpose: "Purpose",
        setup_purpose_placeholder: "One line, shown in the header",
        setup_project: "Belongs to",
        setup_project_none: "No project",
        setup_project_hint: "Project members join automatically. Tasks created here land in its backlog.",
        setup_visibility: "Visibility",
        vis_project: "Project members",
        vis_project_hint: "{count} people · guests excluded",
        vis_workspace: "Anyone in the workspace",
        vis_invite: "Invite only",
        vis_invite_hint: "· pick people",
        setup_slack: "Mirror to Slack",
        setup_create: "Create channel",
        setup_name_required: "Give the channel a name (at least 3 characters).",
        setup_limit: "You have reached the channel limit for your plan.",
        setup_no_project: "Chat is not set up for channels yet.",
        call_title: "Call with {name}",
        call_in: "{count} in call",
        notetaker_on: "Notetaker on",
        notetaker_off: "Notetaker off",
        notetaker_hint: "Everyone was told the notetaker is on. Recording is off — notes only. Ends into a doc you can edit before sharing.",
        notetaker_announce: "{name} turned the notetaker on",
        auto: "AUTO",
        live_notes_empty: "Notes appear here as people speak.",
        live_notes_unsupported: "Live captions are not available in this browser. The recording is transcribed when the call ends.",
        presenting: "{name} is presenting",
        screen_share: "SCREEN SHARE · {name}",
        you: "You",
        muted: "muted",
        camera_off: "camera off",
        ringing: "Ringing…",
        connecting: "Connecting…",
        minimize: "Minimize",
        expand: "Expand",
        end_call: "End call",
        writing_notes: "Writing meeting notes…",
        notes_title: "Meeting notes",
        notes_summary: "SUMMARY",
        notes_summary_so_far: "SUMMARY SO FAR",
        notes_tab_notes: "Notes",
        notes_tab_transcript: "Transcript",
        notes_tab_actions: "Action items",
        notes_no_summary: "No summary yet. The AI provider may be unavailable — the transcript is kept below.",
        notes_no_transcript: "Nothing was transcribed. Turn the notetaker on during the call to capture one.",
        notes_no_actions: "No action items were found.",
        notes_save_post: "Save · post recap in {channel}",
        notes_save: "Save",
        notes_posted: "Recap posted",
        notes_discard: "Discard",
        notes_discarded: "Notes discarded",
        notes_back: "Back to chat",
        notes_participants: "Participants",
        notes_duration: "Duration",
        notes_transcribing: "Transcribing the recording…",
        notetaker_note: "Notetaker is transcribing. Only participants see notes until you share.",
        recap_heading: "Meeting recap",
        linked_to: "linked to",
        owner_due: "{owner} · {due}",
        from_at: "from {at}",
        details_purpose: "Purpose",
        details_project: "Belongs to",
        details_slack: "Mirrored to Slack",
        load_failed: "Could not load. Try again.",
        something_wrong: "Something went wrong. Try again.",
        dnd_short: "DND",
    },
    Comments: {
        unread_message: "Unread messages",
        more: "more",
        less: "less",
        edited: "edited",
        edit: "Edit",
        create_task: "Create Task",
        add_to_checklist: "Add to Checklist",
        copy_message: "Copy Message",
        message_actions: "Message actions",
        reply: "Reply",
        message: "Message",
        mark_unread: "Mark as Unread",
        This_message_is_deleted: "This message is deleted",
        You_deleted_this_message: "You deleted this message",
        no_user_found: "No User Found",
        mention_suggestions: "People to mention",
        mention_agents: "Agents",
        unlock_comment_view: "To Unlock Comment View",
        agent_tag: "AGENT",
        an_agent: "An agent",
        ai_assistant: "AI assistant",
        automation_tag: "AUTOMATION",
        an_automation: "An automation",
        cited_page: "page",
        cited_page_hidden: "a page you cannot open",
        send_failed: "Couldn't send your comment. Your text is still here.",
        attachment_send_failed: "Couldn't send your attachment. It's still here to try again.",
        assigned_to: "Assigned to {name}",
        resolved_by_assignee: "Resolved · {name}",
        resolve: "Resolve",
        reopen: "Reopen",
        assign: "Assign",
        reassign: "Reassign",
        assign_to: "Assign to",
        unassign: "Unassign",
        search_people: "Search people",
        no_people_found: "No one found",
        someone: "Someone",
        hide_replies: "Hide replies",
        replies_count: "{n} reply | {n} replies",
        reply_in_thread: "Reply in thread",
        thread_label: "Replies",
        loading_replies: "Loading replies…",
        replies_failed: "Replies could not be loaded.",
        reply_placeholder: "Write a reply. Enter sends, Shift+Enter adds a line.",
        send_reply: "Send reply",
        reply_failed: "The reply could not be sent.",
    },
    PlaceHolder: {
        enter_task_type: "Enter Task Type",
        enter_task_status: "Enter Task Status",
        enter_project_status: "Enter Project Status",
        Enter_Project_Name: "Enter Project Name",
        Enter_Key_Name: "Enter Key Name",
        Enter_Proposal_Id: "Enter Proposal ID",
        Select_Category: "Select Category",
        Select_Project_Due_Date: "Select Project Due Date",
        search: "Search",
        search_here: "Search Here",
        Type_here: "Type here",
        Task_name: "Task name",
        Add_description: "Add description",
        Enter_Duplicate_Task_Name: "Enter Duplicate Task Name",
        Enter_Text: "Enter Text",
        Enter_Amount: "Enter Amount",
        Select: "Select",
        Enter_Refund_Amount: "Enter Refund Amount",
        Enter_Milestone_Name: "Enter Milestone Name",
        Enter_sprint_name: "Enter list name",
        Enter_directory_name: "Enter folder name",
        Rename_Tag: "Rename Tag",
        Enter_Team_Name: "Enter Team Name",
        Duration_only_hours: "Duration only hours",
        Enter_option: "Enter option",
        Enter_View_Name: "Enter View Name",
        Enter_URL: "Enter URL",
        Enter_HTML: "Enter HTML",
        Enter_item_name: "+ Enter item name",
        Add_an_item: "+ Add an item",
        Enter_Company_Name: "Enter Company Name",
        Select_Country: "Select Country",
        Enter_Template: "Enter Template",
        Enter_Template_Name: "Enter Template Name",
        Project_key_must_be_unique: "Project key must be unique",
        Enter_zip: "Enter Zip",
        Enter_GST_Number: "Enter GST Number",
        Enter_Milestone_Status: "Enter Milestone Status",
        Enter_Priority_Name: "Enter Priority Name",
        Enter_File_Extensions_Name: "Enter File Extensions Name",
        Enter_Skill_Name: "Enter Skill Name",
        Select_Skills: "Select skills",
        Enter_Task_Name: "Enter Task Name",
        Select_State: "Select State",
        No_States: "No States",
        Select_City: "Select City",
        No_Cities: "No Cities",
        enter_category_name: "Enter Category Name",
        enter_channel_name: "Enter Channel Name",
        Pinned_messages: "Pinned Messages",
        Search: "Search",
        Search_by_name_or_email: "Search by name or email",
        Invite_by_email: "Invite by email",
        Select_Designation: "Select Designation",
        Select_Role: "Select Role",
        Enter_designation: "Enter Designation",
        Enter_Description: "Enter Description",
        Add_New_Role: "Add New Role",
        Enter_role: "Enter role",
        Enter_Field_Label: "Enter Field Label",
        Enter_Placeholder: "Enter Placeholder",
        field_label: "Field Label",
        placeholder: "Placeholder",
        Enter_Number: "Enter Number",
    },
    DuplicateTask: {
        duplicate_task_name: "Duplicate Task Name",
        what_do_you_copy: "What do you want to copy",
        everything: "Everything",
        no_assignee: "No Assignee",
        no_watcher: "No Watcher",
        move_task: "Move Task",
        mearge_task_into: "Merge Task Into",
    },
    Converttolist: {
        confirm_convert: "Turn this task into a list?",
        important: "Important",
        you_will_lose:
            "You will lose all threaded comments. This action can't be undone",
        convert_to_list: "Convert to list",
    },
    Billing: {
        billing_details: "Billing Details",
        plan_details: "Plan Details",
        next_msg: "The Next Payable Amount is",
        upgrade_plan: "Upgrade Plan",
        cancel_subscription: "Cancel Subscription",
        reactivate_subscription: "Reactivate Subscription",
        biling_info: "Billing Info",
        update_billing_info: "Update Billing Info",
        contact_support: "Contact Support",
        for_help_msg:
            "For help and support with your billing questions, contact our support team and they'll be happy to help.",
        payment_methods: "Payment Methods",
        update_payment_method: "Update Payment Method",
        add_payment_method: "Add Payment Method",
        ending_in: "ending in",
        payment_method_update: "Payment method updated successfully.",
        waiting_msg:
            "Your recent payment method update will take effect with your next bill and will be used for all future payments..",
        error_updating:
            "Payment method update Unsuccessful. We encountered an issue while updating your payment method. Please try again or contact support for assistance.",
        card_expires: "Card expires at",
        billing_address: "Billing Address",
        subscription_plan: "Subscription Plan",
        next_renew_date: "Next Renew Date",
        storage_use: "Storage Use",
        address: "Address",
        address_line: "Address Line",
        zip_code: "Zip Code",
        zip: "Zip",
        "Save_&_Continue": "Save & Continue",
        billing_history: "billing_history",
        Invoices: "Invoices",
        credit_notes: "Credit Notes",
        download: "Download",
        id: "Id",
        type: "Type",
        date: "Date",
        description: "Description",
        no_of_users: "No. of Users",
        amount: "Amount",
        status: "Status",
        pay_now: "Pay Now",
        cancelling_subscription_message:
            "Cancelling subscription means your subscription ends on",
        reactivate_anytime: "Reactivate anytime before then!",
        reactivate_confirmation:
            "Are you sure you want to reactivate subscription? By selecting 'Yes,' you will reactivate and resume your billing schedule.",
        amounting_to: "amounting to",
        insufficient_funds: "Insufficient Funds",
        payment_successful: "Payment successful.",
        payment_successful_details:
            "Payment Successful! Your invoice is paid. Please allow 2 to 3 minutes for the changes to take effect everywhere, ensuring you can fully enjoy the expanded features and improvements!",
        payment_unsuccessful:
            "Payment Unsuccessful. We encountered an issue while upgrading your plan. Please try again or contact support for assistance.",
        plan_upgrade_unsuccessful:
            "Plan Upgrade Unsuccessful. We encountered an issue while upgrading your plan. Please make sure the card has sufficient balance.",
        proceed_with_payment:
            "Do you want to proceed with the payment for invoice number",
        attention_needed: "We need your attention!",
        avoid_service_disruption: "to avoid service disruption",
        subscription_renewal_failed: "Subscription auto-renewal failed due to",
        update_payment_method_please: "Please update your payment method",
        click_here_for_update_payment_method:
            "Click Here for Update Payment Method",
        credit_balance: "Credit Balance",
        this_balance_will_be_used_for_a_future_payment:
            "This balance will be used for a future payment.",
        paymnet_failed_subscription_canceled:
            "We wanted to inform you that your previous subscription has been canceled. Your account has now been transitioned to our default subscription, which has some features disabled. To enable these features, please upgrade your plan.",
        promotional_credit_balance: "Promotional Credit",
        balance: "Balance",
        created_on: "Created On",
        no_promotional_found: "No Promotional Credit History Found",
        title: "Billing",
        tab_contract: "Contract",
        tab_invoices: "Invoices",
        tab_client_view: "Client view",
        loading: "Loading billing…",
        load_failed: "Billing could not be loaded. Refresh to try again.",
        no_client: "No client set",
        set_client: "Set the client",
        mode_fixed: "Fixed price per milestone",
        mode_fixed_help: "Client pays an agreed amount when a milestone is signed off. Hours are tracked but not billed.",
        mode_hourly: "Hourly with a cap",
        mode_hourly_help: "Billed from approved timesheets at each person's rate, up to a monthly ceiling.",
        col_milestone: "MILESTONE",
        col_due: "DUE",
        col_amount: "AMOUNT",
        col_signoff: "SIGN-OFF",
        col_state: "STATE",
        col_person: "PERSON",
        col_rate: "RATE",
        col_approved: "APPROVED",
        col_value: "VALUE",
        col_line: "LINE",
        col_qty: "QTY",
        tasks_count: "{count} task | {count} tasks",
        hours_logged: "{hours}h logged",
        percent_done: "{percent}% done",
        not_started: "not started",
        no_tasks_linked: "no tasks in range",
        scope_window: "Counted from tasks due inside this milestone's dates",
        scope_explicit: "Counted from the tasks linked to this milestone",
        state_paid: "Paid",
        state_invoiced: "Invoiced",
        state_ready: "Ready to invoice",
        state_in_progress: "In progress",
        state_not_due: "Not due",
        state_cancelled: "Cancelled",
        add_milestone: "Add milestone",
        milestone_name: "Milestone name",
        milestone_amount: "Amount",
        milestone_due: "Due date",
        milestone_name_required: "Give the milestone a name.",
        milestone_amount_required: "Enter an amount of 0 or more.",
        save: "Save",
        cancel: "Cancel",
        no_milestones: "No milestones yet. Add the first one to start the contract.",
        rules: "Rules",
        rule_tasks_done: "A milestone can't be invoiced until every task in it is Done",
        rule_signoff_task: "Sign-off is a task assigned to the named client contact",
        rule_warn_hours: "Warn me when logged hours exceed the milestone's value at blended rate",
        contract_total: "CONTRACT TOTAL",
        contract_span: "{count} milestones · {from} → {to}",
        contract_span_undated: "{count} milestones",
        paid: "Paid",
        invoiced_unpaid: "Invoiced, unpaid",
        remaining: "Remaining",
        profitability: "PROFITABILITY SO FAR",
        hours_logged_label: "Hours logged",
        cost_at_blended: "Cost at blended {rate}",
        billed_to_date: "Billed to date",
        margin: "Margin",
        no_cost_rate: "No blended cost rate set, so margin can't be worked out.",
        set_cost_rate: "Set a rate",
        cost_rate_label: "Blended cost rate per hour",
        cost_rate_hint: "Your own average cost of an hour of work. Used only for margin.",
        watch: "Watch:",
        watch_body: "{name} is {done}% done but has burned {burn}% of its value in hours. At this rate it lands at {margin}% margin.",
        hourly_title: "Hourly billing",
        rates: "Rates",
        rates_hint: "Per person, overridable per project",
        no_rates: "No rates configured. Set them in Timesheet settings before billing hourly.",
        no_rate_for_person: "no rate set",
        pending_approval: "Pending timesheet approval",
        monthly_cap: "Monthly cap",
        no_cap: "No monthly cap set.",
        set_cap: "Set a cap",
        cap_label: "Monthly cap",
        legend_approved: "approved {amount}",
        legend_pending: "pending {amount}",
        headroom: "{amount} headroom",
        over_cap: "{amount} over the cap",
        cap_warning_title: "Cap nearly reached.",
        cap_warning_body: "Approving the pending {hours}h leaves {left} of billable value for the rest of the month. Work continues either way — it just stops being billable.",
        generate_month_invoice: "Generate {month} invoice",
        approve_first: "Approve {hours}h first",
        non_billable_excluded: "Non-billable time excluded",
        no_hourly_data: "No time logged on this project in {month}.",
        invoices_title: "Invoices",
        new_from_milestone: "Draft from a milestone",
        new_from_month: "Draft from this month",
        no_invoices: "No invoices yet. Draft one from a signed-off milestone or from a month of time.",
        invoice_draft: "DRAFT",
        invoice_sent: "SENT",
        invoice_paid: "PAID",
        invoice_meta: "{client} · {project} · net {days}",
        period: "{from} → {to}",
        subtotal: "Subtotal",
        tax: "Tax",
        tax_named: "{label} {percent}%",
        total_due: "Total due",
        send_to_client: "Send to client",
        pdf: "PDF",
        export_stripe: "Export to Stripe",
        stripe_disabled: "No Stripe connection is configured for this workspace.",
        mark_paid: "Mark paid",
        every_line_links: "Every line links back",
        line_expand: "Show what's behind this line",
        line_collapse: "Hide the detail",
        line_tasks: "{count} task | {count} tasks",
        line_timelogs: "{count} time logs",
        line_nothing: "This line was entered by hand, so there is nothing to trace.",
        add_line: "Add a line",
        line_kind: "Kind",
        kind_change_request: "Out-of-scope change request",
        kind_expense: "Expense",
        kind_adjustment: "Adjustment",
        line_label: "Description",
        line_label_required: "Describe what this line is for.",
        line_unit: "Unit price",
        line_amount: "Amount",
        line_unit_hint: "Leave the unit price blank for a flat amount.",
        task_done: "Done",
        task_open: "Open",
        pick_milestone: "Pick a milestone",
        milestone_not_invoiceable: "Already invoiced",
        client_view_title: "Client view",
        client_view_note: "This is exactly what a guest sees. Internal hours, estimates, salaries and team chat are never sent to it.",
        copy_link: "Copy the client link",
        link_copied: "Link copied",
        link_failed: "The link could not be created.",
        progress: "Progress",
        milestones_complete: "{done} OF {total} MILESTONES COMPLETE",
        done_on: "DONE {date}",
        due_on: "DUE {date}",
        percent_due: "{percent}% · DUE {date}",
        waiting_on_you: "Waiting on you",
        nothing_waiting: "Nothing needs the client right now.",
        review: "Review",
        open_item: "Open",
        needed_by: "Needed by {date}",
        waiting_since: "Waiting since {date}",
        recent_updates: "Recent updates",
        no_updates: "No updates to share yet.",
        client_invoices: "Invoices",
        pay_invoice: "Pay {number}",
        due_net: "due {date}",
        paid_on: "paid {date}",
        ask_us: "Ask us something",
        message_placeholder: "Message the project team…",
        message_hint: "Goes to the project channel.",
        message_sent: "Message sent to the project channel.",
        message_empty: "Write a message first.",
        send: "Send",
        client_privacy: "You see milestones, sign-offs, invoices and updates. Internal hours, estimates, salaries and team chat stay private — that's what the Guest role means here.",
        shared_by: "SHARED BY {name}",
        client_badge: "CLIENT VIEW",
        settings: "Contract settings",
        client_name: "Client name",
        vendor_name: "Shown to the client as",
        tax_label_field: "Tax label",
        tax_rate_field: "Tax rate %",
        payment_terms: "Payment terms (days)",
        client_contacts: "Client contacts",
        client_contacts_hint: "Whoever is listed here gets the sign-off tasks and sees the client view.",
        saved: "Saved",
        save_failed: "That could not be saved.",
        views_nav: "Billing views",
    },
    Tour: {
        Tag_name_required: "Tag name is required.",
        tour_completed: "Tour Completed",
        watch_video: "Watch Video",
    },
    TaskStatus: {
        To_Do: "To Do",
    },
    AI: {
        generate: "Generate",
        ai_button: "Write with AI",
        ai_title: "Ask AI to find or create anything",
        write_with_ai: "Write with AI",
        suggest_tasks: "Suggest Tasks",
        suggest_subtasks: "Suggest Subtasks",
        ai_sidebar_placeholder: "What would you like AI to write about?",
        ai_chat_placeholder: "Tell AI What to do next",
        ai_available_on_paid_plans_upgrade_now:
            "AI is only available for purchase on our paid plans. Upgrade and add AI now!",
        please_upgrade_plan_to_use_ai: "Please upgrade your plan to use AI.",
        read_less: "Read Less",
        read_more: "Read More",
        to_unlock_ai: "To Unlock AI",
        copy: "Copy",
        generating_results: "Generating Results",
        hub_ai: "HubAi",
        regenerate: "Regenerate",
        title: "Title",
        error_occurred_engine_issue:
            "An error occurred. Either the engine you requested does not exist or there was another issue processing your request",
        ai_not_integrated: "AI is not integrated in your system",
        limit_reached: "You have reached your limit",
        ai_write_description: "Write with AI",
        ai_desc_intent_placeholder: "What should this description cover? (optional)",
        ai_desc_intent_hint: "Leave blank to generate from the title.",
        ai_desc_mode_add: "Add to description",
        ai_desc_mode_rewrite: "Rewrite",
        ai_desc_add_placeholder: "What should I add — and where? (e.g. add acceptance criteria, or a note under What to do)",
        ai_desc_add_hint: "AI places your addition where you ask, keeps everything else, and shows the full result to review before applying.",
        ai_generate: "Generate",
        ai_regenerate: "Regenerate",
        ai_use_this: "Use this",
        ai_answer_questions: "Answer a couple of quick questions so the description is accurate:",
        ai_generating: "Generating…",
        ai_failed: "Couldn't generate a description. Please try again.",
        ai_optional: "— optional",
        ai_skills_hint: "Skills this project needs. The AI also suggests skills from your description — you can adjust them on the review step.",
        ai_proposal_id_hint: "The won proposal this project came from. Used to tie the project back to the bid it originated from.",
        you: "You",
    },
    ScreenshotRetention: {
        heading: "Auto-delete old screenshots",
        subtitle: "When enabled, time-tracker screenshots older than the retention window are permanently deleted every night.",
        toggle_label: "Enable auto-deletion",
        toggle_hint: "Existing screenshots older than the window are removed on the next nightly run.",
        window_label: "Retention window",
        window_hint: "How long screenshots are kept before they're eligible for deletion.",
        months_option: "{n} month | {n} months",
        confirm_title: "Permanently delete old screenshots?",
        confirm_body: "Enabling this will delete approximately <b>{count}</b> screenshots older than {months} months on the next nightly run. This cannot be undone.",
        confirm_yes: "Enable and delete",
        saved: "Screenshot retention saved",
        save_failed: "Could not save retention settings",
        last_run: "Last run {when} — deleted {deleted} screenshots.",
        not_run_yet: "First cleanup runs tonight at 00:30 UTC.",
        today: "today",
        yesterday: "yesterday",
        days_ago: "{n} day ago | {n} days ago",
        months_ago: "{n} month ago | {n} months ago",
    },
    TimeReminder: {
        heading: "Daily \"log your time\" reminder",
        subtitle: "When enabled, AlianHub emails a daily reminder to the selected members who haven't logged time that day.",
        toggle_label: "Enable daily reminder",
        toggle_hint: "Off by default. Turn on to send the reminder for this company.",
        recipients_label: "Send to",
        recipients_hint: "Only the selected members receive the reminder. If none are selected, no email is sent.",
        select_all: "Select all",
        search_placeholder: "Search members by name or email",
        no_members: "No members with an email address were found.",
        no_results: "No members match your search.",
        selected_count: "{n} selected",
        save: "Save recipients",
        saved: "Reminder settings saved",
        save_failed: "Could not save reminder settings",
        recipients_saved: "Recipients updated",
        enabled_toast: "Daily reminder enabled",
        disabled_toast: "Daily reminder disabled",
    },
    Toast: {
        offline_change_not_saved: "A change you made while offline was not saved.",
        offline_change_not_saved_reason: "A change you made while offline was not saved: {reason}",
        Assignee_not_updated: "Assignee not updated",
        Skill_added_successfully: "Skill added successfully",
        Skill_deactivated_successfully: "Skill deactivated successfully",
        Skill_restored_successfully: "Skill restored successfully",
        Your_card_is_expired: "Your card is expired.",
        Password_set_new_has_been_successfully:
            "New password set has been successfully",
        task_created_successfully: "Task created successfully",
        please_remove_the_advanced_filter_to_view_newly_created_projects:
            ", Please remove the advanced filter to view newly created projects.",
        create_task_plan_limit_message:
            "Upgrade your plan. You have reached the limit for creating tasks in the TASK_SPRINT list.",
        something_went_wrong: "Something went wrong.",
        file_size_is_larger_than_maxFileSize:
            "file size is larger than maxFileSize",
        Select_image_only_and_image_file_format_should_be_FILE_FORMATS:
            "Select image only and image file format should be FILE_FORMATS",
        Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS:
            "Select file only image and image file format should be FILE_FORMATS",
        Multiple_files_not_allowed: "Multiple files not allowed.",
        Please_select_valid_file: "Please select valid file.",
        require_image_format_message:
            "File format is not supported or not added in Company settings, you can add file format in Settings.",
        You_have_to_add_extension_in_setting:
            "You have to add extension in setting.",
        Something_went_wrong_Please_try_again:
            "Something went wrong. Please try again.",
        Company_is_disable: "Company is disable",
        advance_search_feature_upgrade_message:
            "That feature Advance Search isn’t available on your current plan.To Unlock Advance Search Upgrade Your Plan.",
        Access_Denied: "Access Denied",
        notification_permission:
            "To receive notifications, please allow Notification permission in site settings and reload page again.",
        Link_is_Copied_to_clipboard: "Link is Copied to clipboard",
        Task_Key_is_Copied_to_clipboard: "Task Key is Copied to clipboard",
        At_least_one_field_is_required: "At least one field is required.",
        Task_name_updated_successfully: "Task name updated successfully",
        Watcher_added_successfully: "Watcher added successfully",
        Watcher_removed_successfully: "Watcher removed successfully",
        Nothing_to_update: "Nothing to update",
        "Sprint created successfully": "List created successfully",
        "Sprint restored successfully": "List restored successfully",
        "Sprint closed successfully": "List closed successfully",
        "Sprint archived successfully": "List archived successfully",
        "Sprint deleted successfully": "List deleted successfully",
        Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints:
            "Upgrade your plan. You have reached the limit for creating lists.",
        "Folder created successfully": "Folder created successfully",
        "Folder updated successfully": "Folder updated successfully",
        Folder_moved_successfully: "Folder moved successfully",
        "Folder restored successfully": "Folder restored successfully",
        "Folder closed successfully": "Folder closed successfully",
        "Folder archived successfully": "Folder archived successfully",
        "Folder deleted successfully": "Folder deleted successfully",
        Status_changed_successfully: "Status changed successfully",
        Due_date_updated_successfully: "Due date updated successfully",
        Due_date_not_updated: "Due date not updated",
        "Assignee changed_ uccessfully": "Assignee changed successfully",
        "Assignee added successfully": "Assignee added successfully",
        "Assignee removed successfully": "Assignee removed successfully",
        "Assignee not updated": "Assignee not updated",
        Created_by_updated_successfully: "Created by updated successfully",
        Created_by_not_updated: "Created by not updated",
        Task_updated_successfully: "Task updated successfully",
        Task_restored_successfully: "Task restored successfully",
        Task_archived_successfully: "Task archived successfully",
        Task_deleted_successfully: "Task deleted successfully",
        Task_was_moved: "This task was moved to another list.",
        Task_became_subtask: "This task is now a subtask of another task.",
        Subtask_became_task: "This subtask is now a task of its own.",
        Task_became_list: "This task was turned into a list.",
        Tag_Deleted_successfully: "Tag Deleted successfully",
        Log_time_added_successfully: "Log time added successfully..",
        Filter_saved_successfully: "Filter saved successfully.",
        Filter_update_successfully: "Filter updated successfully.",
        Filter_deleted_successfully: "Filter deleted successfully.",
        checklist_created_successfully: "Checklist created successfully",
        Please_select_checklist: "Please select checklist.",
        already_exists: "EXIST_VALUE is already exists",
        Converted_sucessfully: "Converted successfully",
        create_task_limit_in_sprint_upgrade_task_message:
            "Upgrade your plan. You have reached the limit for creating tasks in the SELECTED_SPRINT_DATA list.",
        Please_Select_Task_Type: "Please Select Task Type",
        Please_Select_Task: "Please Select Task",
        Task_moved_sucessfully: "Task moved successfully",
        Task_not_moved: "Task not moved",
        Task_duplicate_sucessfully: "Task duplicated successfully",
        Task_not_duplicated: "Task not duplicated",
        Convert_in_to_task_sucessfully: "Converted to a task successfully",
        Company_name_already_exists: "Company name already exists",
        Company_has_been_created_Successfully:
            "Company has been created Successfully.",
        Custom_field_updated_successfully: "Custom field updated successfully",
        No_assignee_found: "No assignee found",
        No_due_date_found: "No due date found",
        No_self_assignee_found: "No self assignee found",
        Estimated_time_updated_successfully:
            "Task Planning updated successfully",
        Estimated_time_not_updated:
            "Couldn't save the task planning. Try again.",
        Description_updated_successfully: "Description updated successfully",
        Description_not_updated: "Description not updated",
        Copied: "Copied!",
        User_removed_successfully: "User removed successfully",
        Invitation_cancelled_successfully: "Invitation cancelled successfully",
        User_role_changed_successfully: "User role changed successfully",
        User_designation_changed_successfully:
            "User designation changed successfully.",
        Please_upgrade_your_plan_to_use_Time_Tracker:
            "Please upgrade your plan to use Time Tracker.",
        Request_remove_successfully: "Request remove successfully",
        Upgrade_Your_Plan: "Upgrade Your Plan",
        Updated_successfully: "Updated successfully",
        Deleted_successfully: "Deleted successfully",
        View_Pinned: "View Pinned",
        View_Unpinned: "View Unpinned",
        View_Already_Added: "View Already Added",
        Company_details_saved_successfully:
            "Company details saved successfully.",
        Currency_added_successfully: "Currency added successfully",
        Currency_removed_successfully: "Currency removed successfully",
        File_extension_remove_successfully:
            "File extension FILE_EXTENSION remove successfully",
        File_extension_update_successfully:
            "File extension update successfully.",
        Status_updated_successfully: "Status updated successfully",
        Project_milestone_status_Deleted_successfully:
            "Project milestone status deleted successfully.",
        Milestone_weekly_range_updated_successfully:
            "Milestone weekly range updated successfully.",
        Image_dimensions_should_not_exceed_ImageDimensions_pixels:
            "Image dimensions should not exceed ImageDimensions pixels.",
        error_in_uploading_image_please_try_it_again:
            "error in uploading image please try it again",
        Task_priority_updated_successfully:
            "Task priority updated successfully.",
        Task_priority_Remove_successfully: "Task priority Remove successfully.",
        Priority_updated_successfully: "Priority updated successfully",
        Priority_not_updated: "Priority not updated",
        error_in_deleting_priority_please_try_it_again:
            "error in deleting priority please try it again",
        Field_Enable_Successfully: "Field Enable Successfully",
        Field_Disable_Successfully: "Field Disable Successfully",
        Field_Added_Successfully: "Field Added Successfully",
        Field_Updated_Successfully: "Field Updated Successfully",
        Added_to_favourite: "Added to favourite",
        Removed_from_favourite: "Removed from favourite",
        Tag_Created_successfully: "Tag Created successfully",
        "Queue list added successfully": "Queue list added successfully",
        "Queue list removed successfully": "Queue list removed successfully",
        "Queue list not updated": "Queue list not updated",
        Attachments_uploaded_successfully: "Attachments uploaded successfully",
        Attachment_removed_successfully: "Attachment removed successfully",
        Attachment_not_removed: "Attachment not removed",
        Please_try_again: "Please try again",
        Task_name_copied: "Task name copied",
        Status_already_exists: "Status already exists",
        Status_added_sucessfully: "Status added successfully",
        Task_Type_already_exists: "Task Type already exists",
        Task_Type_added_sucessfully: "Task Type added successfully",
        Image_size_must_be_less_than_ImageDimensions_pixels:
            "Image size must be less than ImageDimensions pixels.",
        Data_deleted_successfully: "Data deleted successfully.",
        Category_created_successfully: "Category created successfully",
        Category_updated_successfully: "Category updated successfully",
        Please_select_an_image_file: "Please select an image file",
        Channel_created_successfully: "Channel created successfully",
        Channel_updated_successfully: "Channel updated successfully",
        Channel_deleted_successfully: "Channel deleted successfully",
        Folder_not_found: "Folder not found",
        Sprint_not_found: "List not found",
        "Template_&_Project_data_has_been_added_successfully":
            "Template & Project data has been added successfully.",
        Project_data_has_been_added_successfully:
            "Project data has been added successfully{filterMessage}",
        Error_in_creating_project: "Error in creating project",
        Milestone_deleted_successfully: "Milestone deleted successfully",
        Error_in_deleting_milestone: "Error in deleting milestone",
        Milestone_added_successfully: "Milestone added successfully",
        Error_in_adding_milestone: "Error in adding milestone",
        Milestone_update_successfully: "Milestone update successfully",
        Error_in_updating_milestone: "Error in updating milestone",
        Milestone_status_update_successfully:
            "Milestone status update successfully",
        Error_in_updating_milestone_status:
            "Error in updating milestone status",
        Milestone_refund_amount_update_successfully:
            "Milestone refund amount update successfully",
        Error_in_updating_milestone_refund_amount:
            "Error in updating milestone refund amount",
        The_project_not_found: "The project not found.",
        project_not_available: "This project isn't available to you.",
        The_project_is_archived: "The project is archived.",
        tracker_not_opened: "AlianHub Tracker didn't open. Please make sure it's installed or updated to the latest version.",
        Start_date_of_project_should_be_smaller_than_current_date:
            "Start date of project should be smaller than current date",
        All_the_range_is_included_in_milestone:
            "All the range is included in milestone",
        Please_enter_start_date_of_project:
            "Please enter start date of project",
        Project_name_updated_successfully: "Project name updated successfully",
        "Project restored successfully": "Project restored successfully",
        "Project closed successfully": "Project closed successfully",
        "Project archived successfully": "Project archived successfully",
        "Project deleted successfully": "Project deleted successfully",
        Enter_valid_project_source: "Enter valid project source",
        Please_select_sub_task: "Please select sub task.",
        Status_not_updated: "Status not updated",
        Checklist_not_saved: "The checklist was not saved. Try again.",
        Start_date_updated_successfully: "Start date updated successfully",
        Start_date_not_updated: "Start date not updated",
        Task_converted_sucessfully: "Task converted successfully",
        Task_merged_sucessfully: "Task merged successfully",
        Can_not_create_template_name_Custom:
            "Can not create template name Custom",
        Template_name_updated_successfully:
            "Template name updated successfully.",
        Template_has_been_created_Successfully:
            "Template has been created Successfully.",
        Template_deleted_successfull: "Template deleted successfully.",
        Template_has_been_deleted_successfully:
            "Template has been deleted successfully.",
        Storage_exceeded_Upgrade_your_plan:
            "Storage exceeded. Upgrade your plan",
        max_filesize_messages: "The max file size is FILE_SIZE MB.",
        Password_reset_email_has_been_sent_successfully:
            "Password reset email has been sent successfully",
        Invalid_username_or_password: "Invalid username or password.",
        Email_Not_Verified: "Email Not Verified.",
        Verification_mail_has_been_send_successfully:
            "Verification mail has been send successfully",
        Invalid_url: "Invalid url",
        User_already_registered: "User already registered.",
        User_has_been_registered_successfully:
            "User has been registered successfully.",
        The_email_address_is_already_in_use:
            "The email address is already in use",
        User_has_been_registered_successfully_Please_verify_your_email_to_continue:
            "User has been registered successfully, Please verify your email to continue.",
        Password_reset_has_been_successfully:
            "Password reset has been successfully",
        Your_email_has_been_verify_successfully:
            "Your email has been verify successfully",
        Invitation_accepted_successfully: "Invitation accepted successfully",
        Only_product_owner_can_create_a_company:
            "Only product owner can create a company",
        Company_name_must_be_unique: "Company name must be unique.",
        Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere:
            "Subscription cancelled successfully. Please allow 2 to 3 minutes for the changes to take effect everywhere.",
        Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere:
            "Subscription reactivated successfully. Please allow 2 to 3 minutes for the changes to take effect everywhere.",
        View_name_is_required: "View name is required",
        name_should_be_at_least_3_characters_long:
            "name should be at least 3 characters long",
        View_name_already_exists: "View name already exists",
        View_added_successfully: "View added successfully",
        View_Deleted_Successfully: "View Deleted Successfully",
        Link_copied_to_clipboard_successfully:
            "Link copied to clipboard successfully",
        Project_avatar_updated_successfully:
            "Project avatar updated successfully",
        "Message pinned successfully": "Message pinned successfully",
        "Message unpinned successfully": "Message unpinned successfully",
        Message_copied: "Message copied",
        Item_cannot_be_empty: "Item cannot be empty",
        Maximum_MAX_CHAR_characters_are_allowed:
            "Maximum MAX_CHAR characters are allowed",
        Item_added_to_checklist: "Item added to checklist",
        Maximum_10_files_can_be_uploaded_at_once:
            "Maximum 10 files can be uploaded at once",
        file_type_is_not_supported: "file type is not supported!",
        ERROR_in_file_upload: "ERROR in file upload",
        file_size_is_larger_than_FILE_SIZE_mb:
            "file size is larger than FILE_SIZE mb!",
        Mark_as_favorite_successfully: "Mark as favorite successfully",
        Start_and_Due_date_updated_successfully:
            "Start and Due date updated successfully",
        Start_and_Due_date_not_updated: "Start and Due date not updated",
        Attchments_deleted_successfully: "Attachments deleted successfully",
        Designation_is_required: "Designation is required",
        Designation_already_exists: "Designation already exists",
        Designation_added_successfully: "Designation added successfully",
        Designation_updated_successfully: "Designation updated successfully",
        Role_is_required: "Role is required",
        Role_already_exists: "Role already exists",
        Role_added_successfully: "Role added successfully",
        Role_updated_successfully: "Role updated successfully",
        Please_provide_an_email_id: "Please provide an email id",
        Please_provide_a_designation: "Please provide a designation",
        Please_provide_a_role: "Please provide a role",
        Designation_deleted_successfully: "Designation deleted successfully",
        "The_role_is_already_in_use_so_it_can't_be_deleted":
            "The role is already in use, so it can't be deleted.",
        Role_deleted_successfully: "Role deleted successfully",
        Language_not_updated: "Language not updated!",
        Profile_updated_successfully: "Profile updated successfully.",
        two_factor_enabled: "Two-factor authentication enabled.",
        two_factor_disabled: "Two-factor authentication disabled.",
        two_factor_invalid: "That code is not valid.",
        two_factor_codes_copied: "Recovery codes copied to clipboard.",
        webhook_created: "Webhook created.",
        webhook_updated: "Webhook updated.",
        webhook_deleted: "Webhook deleted.",
        Notification_Settings_Update_successfully:
            "Notification Settings Update successfully",
        Permission_updated_successfully: "Permission updated successfully",
        Per_User_Generate_Limit_value_is_not_valid:
            "Per User Generate Limit value is not valid",
        Team_name_is_required: "Team name is required",
        Minimum_3_character_required: "Minimum 3 character required",
        Team_name_already_exist: "Team name already exist",
        Template_has_been_added_successfully:
            "Template has been added successfully.",
        Billing_details_has_been_updated_successfully:
            "Billing details has been updated successfully",
        Billing_details_not_updated: "Billing details not updated",
        Invalid_Card_Details_Please_check_and_try_again:
            "Invalid Card Details.Please check and try again.",
        Expired_Card_Please_check_and_try_again:
            "Expired Card.Please check and try again.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again":
            "Invalid card verification code (CVC).Please check and try again.",
        You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again:
            "You have cancel your current subscription at term end please reactivate subscription and try again.",
        Plan_not_purchased_Please_try_again:
            "Plan not purchased. Please try again.",
        Please_fill_out_billing_details_first:
            "Please fill out billing details first.",
        Please_check_your_credential: "Please check your credentials.",
        File_type_not_supported: "file type is not supported",
        Are_you_sure_to_delete_this_file: "Are you sure to delete this file?",
        Select_Project_Type: "Select Project Type",
        Tracker_user_added_successfully: "Tracker user added successfully",
        Tracker_user_removed_successfully: "Tracker user removed successfully",
        queue_list_not_updated: "QueueList non mis à jour.",
        upgrade_plan_folder_limit_reached:
            "Upgrade your plan. You have reached the limit for creating folders",
        View_updated_successfully: "View updated successfully",
        The_designation_is_already_in_use_so_it_cant_be_deleted:
            "The designation is already in use, so it can't be deleted",
        Sprint_already_exists: "List already exists",
        Folder_already_exists: "Folder already exists",
        "Sprint updated successfully": "List updated successfully",
        Project_milestone_status_updated_successfully:
            "Project milestone status updated successfully.",
        Invalid_email: "Your email is invalid. Please check and try again",
        Invalid_password:
            "Your password is invalid. Please check and try again",
        Too_many_request: "Too many requests. Please try again later",
        Password_reset_link:
            "Password expiry email sent successfully! Please check your inbox to proceed with resetting your password.",
        Project_milestone_status_added_successfully:
            "Project milestone status added successfully.",
        Please_select_start_end_date: "Please select both start and end date",
        Invitation_canceled:
            "Invitation canceled: You can no longer use this link",
        Ai_limit_reached: "Your daily limit has been reached",
        You_have_reached_the_maximum_limit_of_guest_users:
            "Upgrade your Plan.You have reached the maximum limit of guest users",
        Upgrade_for_import: "Upgrade your plan to access Import functionality.",
        Upgrade_for_export: "Upgrade your plan to access Export functionality.",
        import_task_success: "Your Tasks have been Imported Successfully.",
        export_task_success: "Tasks exported successfully",
        export_task_error: "There are no tasks to export.",
        invalid_file_error: "Invalid file type. Please upload a .csv file.",
        free_company_limit_reached:
            "You've reached the maximum limit for creating free companies.",
        Import_users_successfully: "Users imported successfully",
        date_range: "Please select a date range before applying.",
        Task_total_estimate_update_succesfull:
            "Task total estimate updated successfully.",
    },
    SecurityAndPermission: {
        project: "Project",
        project_list: "Project List",
        project_create: "Project Create",
        project_name_edit: "Project Name Edit",
        project_sprint_create: "Project List Create",
        project_folder_create: "Project folder Create",
        project_folder_name_edit: "Project folder Name Edit",
        project_sprint_name_edit: "Project List Name Edit",
        project_details: "Project Details",
        project_status_change: "Project Status Change",
        project_assignee: "Project Assignee",
        project_category: "Project Category",
        project_source: "Project Source",
        project_type: "Project Type",
        project_currency: "Project Currency",
        project_amount: "Project Amount",
        project_start_date: "Project Start Date",
        project_end_date: "Project End Date",
        project_due_date: "Project Due Date",
        project_close: "Project Close",
        project_description: "Project Description",
        project_checklist: "Project Checklist",
        project_checklist_assign_remove: "Project Checklist Assign/remove",
        project_attachments: "Project Attachments",
        project_milestone: "Project Milestone",
        task: "Task",
        task_list: "Task list",
        task_create: "Task Create",
        sub_task_create: "Sub Task Create",
        task_name_edit: "Task Name Edit",
        task_total_estimate: "Task Total Estimate",
        task_status: "Task Status",
        task_assignee: "Task Assignee",
        task_priority: "Task Priority",
        task_due_date: "Task Due Date",
        task_estimated_hours: "Task Estimated Hours",
        task_description: "Task Description",
        task_checklist: "Task Checklist",
        task_checklist_assign_remove: "Task Checklist Assign/remove",
        task_attachments: "Task Attachments",
        show_tasks: "Show Tasks",
        task_custom_field: "Custom Field",
        settings: "Company Settings",
        settings_edit_company: "Edit Company",
        settings_task_priority: "Task Priority",
        settings_file_extensions: "File Extensions",
        settings_project_milestone_status: "Project Milestone Status",
        settings_invite_member: "Invite Member",
        settings_member_list: "Member list",
        settings_create_team: "Create Team",
        settings_team_list: "Team List",
        settings_project_list: "Project List",
        settings_security_permissions: "Security & Permissions",
        settings_role_management: "Role Management",
        settings_designation: "Designation",
        milestone_weekly_range: "Milestone Weekly Range",
        settings_custom_field: "Custom Field",
        sheet_settings: "Sheet Settings",
        user_timesheet: "User Timesheet",
        project_timesheet: "Project Timesheet",
        workload_timesheet: "Workload Timesheet",
        milestone_report: "Milestone Report",
        artificial_intelligence: "Artificial Intelligence",
        per_user_generate_limit: "Per User Token Limit",
        project_custom_field: "Custom Field",
        public_projects: "Public Project List",
        private_projects: "Private Project List",
        tracker_timesheet: "Tracker Timesheet",
        view_list: "View List",
        project_delete: "Project Delete",
        chat: "Chat",
        folder_archive: "Folder Archive",
        folder_delete: "Folder Delete",
        folder_restore: "Folder Restore",
        sprint_archive: "List Archive",
        sprint_delete: "List Delete",
        sprint_restore: "List Restore",
        sprint_type_change: "List Type Change",
        one_to_one_chat: "One To One Chat",
        chat_category: "Chat Category Create",
        chat_channel: "Chat Channel Create",
        task_tag: "Task Tag",
        task_start_date: "Task Start Date",
        task_activity_log: "Task Activity Log",
        task_convert_to_list: "Task Convert to List",
        task_convert_to_subtask: "Task Convert to Subtask",
        task_duplicate: "Task Duplicate",
        task_merge: "Task Merge",
        task_move: "Task Move",
        task_archive: "Task Archive",
        task_delete: "Task Delete",
        task_comment: "Task Comment",
        task_details: "Task Details",
        queue_list: "Queue List",
        advance_search: "Advance Search",
        list_view_column: "List View Column",
        task_type: "Task Type",
        import_tasks: "Import Tasks",
        export_tasks: "Export Tasks",
        convert_to_task: "Convert to Task",
    },
    general: {
        Continue: "Continue",
        New_Status: "New Status",
        Old_Status: "Old Status",
        Old_Task_Type: "Old Task Type",
        New_Task_Type: "New Task Type",
        New_Task_Assignee: "New Task Assignee",
        Old_Task_Assignee: "Old Task Assignee",
        New_Task_Watchers: "New Task Watchers",
        Old_Task_Watchers: "Old Task Watchers",
        Select_Status: "Select Status",
        Select_Task_Type: "Select Task Type",
        No_Assignee: "No Assignee",
        No_Watchers: "No Watchers",
        Different_Statuses: "Different Statuses",
        Please_Select_Status: "Please Select Status",
        Tomorrow: "Tomorrow",
        Yesterday: "Yesterday",
        Project: "Project",
        Team: "Team",
        User: "User",
        Copy_Assignees: "Copy Assignees",
        Copy_Watchers: "Copy Watchers",
        apply: "Apply",
        current_month: "Current Month",
        current_week: "Current Week",
        keyboard: "Keyboard",
        mouse: "Mouse",
        Create: "Create",
        unassigned: "Unassigned",
        entries: "entries",
        showing: "Showing",
        page_not_found: "Oops, page not found",
        page_not_found_description:
            "We are very sorry for the inconvenience. It looks like you’re trying to access a page that has been deleted or never even existed.",
        note: "Note",
        settings_change_no_effect:
            "The change of below settings won't affect current field values if not empty",
        advanced: "Advanced",
        general: "General",
        limits: "Limits",
        message_deleted: "Message Deleted",
        company_individual: "Company/Individual Name",
        enter_company_individual: "Enter Company/Individual Name",
    },
    monthName: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec",
    },
    timeLog: {
        start_time_field_required: "The start time field is required",
        end_time_field_required: "The end time field is required",
        select_valid_time_duration: "Please select valid time duration",
    },
    weekName: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        fridays: "Fridays",
        mondays: "Mondays",
        saturdays: "Saturdays",
        sundays: "Sundays",
        thursdays: "Thursdays",
        tuesdays: "Tuesdays",
        wednesdays: "Wednesdays",
    },
    tooltipText: {
        enable_app_manage_priority:
            "By enabling this app you will be able to manage <b>Priority</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_manage_multiple_assignee:
            "By enabling this app you will be able to manage <b>Multiple Assignee</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_manage_time_estimates:
            "By enabling this app you will be able to manage <b>Time Estimates</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_manage_tags:
            "By enabling this app you will be able to manage <b>Tags</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_use_milestones:
            "By enabling this app you will be able to use <b>Milestones</b> for this <b>project</b>",
        enable_app_use_ai_operations:
            "By enabling this app you will be able to use <b>AI operations</b> for this <b>project</b>",
        enable_app_manage_time_log:
            "By enabling this app you will be able to manage <b>Time log</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_manage_custom_fields:
            "By enabling this app you will be able to manage <b>Custom Fields</b> for this <b>project</b>",
        read_more: "Read more",
    },
    Company: {
        select_default_country: "Select the Default Country",
        freelimitreachedstart:
            "You have already created a free company, To create a new company, you need to upgrade",
        freelimitreachedend:
            "to a paid plan first. Once upgraded, you will be all set to add another free company.",
    },
    alertBox: {
        valid_csv_title: "No File Uploaded",
        valid_csv_text: "Please upload a valid .csv file in order to proceed.",
        ok: "OK",
        cancel: "Cancel",
        go_back_title: "Go Back?",
        go_back_text: "Are you sure you want to return to the previous step?",
        close_modal_title: "Close Modal?",
        close_modal_text:
            "Are you sure you want to close the modal? All your data until this step will be lost.",
        no: "No",
        yes: "Yes",
        confirm: "Confirm",
        improper_header_selection_title: "Inappropriate Selection",
        improper_header_selection_text:
            "Selected row contains values that are not text. Please select a different row.",
        missing_fields_title: "Missing Required Fields",
        missing_fields_text:
            "The following required fields must be mapped & confirmed before proceeding",
        incomplete_mapping_title: "Incomplete Mapping",
        incomplete_mapping_text:
            "Kindly map all the unique values to at least one Alian Hub value in order to Proceed.",
    },
    importTaskButton: {
        import_title: "Import Tasks",
        import_button: "Import Tasks From CSV",
        back_button: "Go Back",
        next_button: "Proceed",
        export_button: "Export as CSV",
        import_processing: "Your Tasks are bring Imported.",
    },
    importCsvAndSetHeader: {
        download: "Download",
        demo_csv: "Demo CSV",
        down_demo_text:
            "file and compare it to your import file to ensure you have the perfect file for import.",
        upload_button: "Upload your CSV File Here",
        upload_instructions:
            "You can upload any .csv file with any set of columns as long as it has 1 record per row. The next step will allow you to map your spreadsheet columns to the right data points. You'll be able to clean up or remove any corrupted data before finalizing your report.",
        header_row_question: "Does the selected row contain column headers?",
        select_another_button: "Select Another Row",
        confirm_row_btt: "Confirm",
    },
    headerMapping: {
        title: "Header Mapping",
        confirmed_text: "Confirmed",
        ignored_text: "Ignored",
        edit_button: "Edit",
        no_match_title: "No Match",
        no_match: "No Match Found",
        no_match_description:
            "This field doesn't match with any of our headers. Kindly ignore this or include it as custom field.",
        custom_field_button: "Include as Custom Field",
        ignore_field_button: "Ignore this Field",
        matched_to_field: "Matched to the field:",
        duplication_warning:
            "This field is a duplicate and cannot be confirmed. Please choose a different field.",
        confirm_map_button: "Confirm Mapping",
        clear_selection: "Clear the matched field",
    },
    valueMapping: {
        user_dropdown_text: "Select a user",
        status_dropdown_text: "Select a Status",
    },
    Affiliate: {
        refferal_code_placeholder: "Enter Referral Code",
        refferal_code_error: "Refferal code is not valid",
    },
    UsersByCategory: {
        config_text: "Open this card's settings (the ⚙ icon) and assign your task types to categories (Development, Marketing, UI/UX, QA) to see the task count per person.",
        user_count: "{n} user | {n} users",
        loading: "Loading…",
        total_title: "Total {n} task | Total {n} tasks",
        segment_title: "{label}: {n} task ({pct}%) | {label}: {n} tasks ({pct}%)",
        col_user: "User",
        total: "Total",
    },
    IconPicker: {
        all: "All",
        loading: "Loading icons…",
        no_results: "No icons found.",
        truncated: "Showing first {n} — refine your search.",
    },
    dashboardCard: {
        task_type: "Task type",
        project_scope_all: "All projects",
        project_scope_include: "Include",
        project_scope_exclude: "Exclude",
        tasks_by_status_card_title: "Tasks by Status",
        tasks_by_status_card_description: "Count of tasks grouped by status",
        tasks_by_project_card_title: "Tasks by Project",
        tasks_by_project_card_description: "Count of tasks grouped by project",
        total_tasks_card_title: "Total Tasks",
        total_tasks_card_description: "A single total count of tasks",
        active_projects_card_title: "Active Projects",
        active_projects_card_description: "Count of active projects (status is not closed)",
        task_status_summary_card_title: "Tasks Summary by Status",
        task_status_summary_card_description: "A counter per task status for the selected period, broken down per person. Click any count in the table to list that person's tasks in that status. Owner/Admin see the whole company; everyone else sees their own tasks",
        tss_no_status: "No task statuses are configured yet.",
        tss_no_tasks: "No tasks in this status for the selected period.",
        tss_loading_tasks: "Loading tasks…",
        tss_total: "{n} task in the selected period | {n} tasks in the selected period",
        tss_scope_company: "Company-wide",
        tss_scope_self: "My tasks",
        tss_unknown_status: "Unknown status",
        tss_capped: "Showing the first {n} tasks.",
        tss_col_user: "Username",
        tss_col_planned: "Planned Hours",
        tss_col_logged: "Logged Hours",
        tss_col_overdue: "Overdue Hours",
        tss_overdue_hint: "How far the period is on course to run past its plan. Finished tasks count what they actually logged; unfinished ones count their plan, or the time already spent if that is more. The result is netted across the row, so a task brought in early offsets one that overran.",
        tss_col_other: "Other",
        tss_other_hint: "Tasks with hours in this period that sit in a status this card is not showing. The hours columns count them, so this is where they are.",
        tss_open_other: "Show {user}'s tasks outside the selected statuses",
        tss_search_user_placeholder: "Search user…",
        tss_no_users: "Nobody has tasks in the selected period.",
        tss_no_user_match: "No user matches “{q}”.",
        tss_users_capped: "Showing the first {n} users.",
        tss_unassigned: "Unassigned",
        tss_open_cell: "Show {user}'s tasks in {status}",
        tss_close_list: "Close",
        milestone_report_card_title: "Milestone Report",
        milestone_report_card_description: "Company-wide billing-milestone receivables consolidated to USD, with a received/outstanding split by period (Owner/Admin only)",
        milestone_management_only: "Only available to Owner/Admin",
        milestones: "milestones",
        milestone_by_status: "By Status",
        recent_milestones: "Recent Milestones",
        view_full_report: "View full report",
        no_milestones: "No milestones found",
        milestone_receivable: "Receivable",
        milestone_received: "Received",
        milestone_outstanding: "Outstanding",
        milestone_all_time: "All-time total",
        milestone_rates_approx: "approx. rates",
        milestone_none_in_period: "No milestones due in this period",
        milestone_timeline: "Milestone Timeline",
        milestone_col_name: "Milestone",
        milestone_col_date: "Date",
        milestone_col_amount: "Amount",
        milestone_open_project: "Open project details",
        milestone_project_closed: "Closed",
        milestone_project_closed_hint: "This project is closed, so it can no longer be opened. The milestone still counts — closed is not the same as paid.",
        milestone_project_closed_toast: "This project is closed, so it can no longer be opened from here.",
        milestone_overdue: "Overdue",
        milestone_past: "Past",
        milestone_due_today: "Due today",
        milestone_upcoming: "Upcoming",
        projects_by_type_card_title: "Projects by Type",
        projects_by_type_card_description: "Active projects grouped by type",
        project_progress: "Project Progress",
        running_projects_card_title: "Running Projects",
        running_projects_card_description: "Active projects with logged time in the selected period",
        live_work_card_title: "Active Time Trackers",
        live_work_card_description: "Who has a time tracker running right now, on what, and their tracker note",
        no_live_work: "No one is tracking time right now",
        no_data_available: "No data available",
        users_by_category_card_title: "Work by Category",
        users_by_category_card_description: "Number of tasks per user, grouped into your work categories (Development, Marketing, UI/UX, QA)",
        users_by_category_hint: "Each number is the count of tasks a person worked on in the selected period, per category.",
        category_template: "Category template",
        category_template_hint: "Pick a category, then tick the task types that belong to it. Each type belongs to one category.",
        search_task_types: "Search task types…",
        no_task_types: "No task types found for this company.",
        tasks_by_assignee_bar_chart_description:
            "Display a bar graph of your total tasks by Assignee",
        tasks_by_assignee_bar_chart_title: "Tasks by Assignee",
        task_list_description:
            "Create a List view using tasks from any location",
        tasks_list_title: "Task List",
        tasks_by_assignee_stack_bar_chart_description:
            "Display a battery of your total tasks by Assignee",
        tasks_by_assignee_stack_bar_chart_title: "Tasks by Assignee",
        workload_by_status_stack_bar_chart_description:
            "Display a breakdown of your statuses across locations",
        workload_by_status_stack_bar_chart_title: "Workload by Status",
        tasks_by_assignee_pie_chart_description:
            "Display a pie chart of your total tasks by Assignee",
        tasks_by_assignee_pie_chart_title: "Tasks by Assignee",
        workload_by_status_pie_chart_description:
            "Display a pie chart of your statuses usage across locations",
        workload_by_status_pie_chart_title: "Workload by Status",
        workload_by_status_bar_chart_description:
            "Display a bar chart of your statuses usage across locations",
        workload_by_status_bar_chart_title: "Workload by Status",
        queue_list_title: "Queue List",
        queue_list_description:
            "View a list of your tasks along with their statuses.",
        card_name: "card name",
        location: "project",
        group_by: "group by",
        show_assignees: "show assignees",
        include_subtasks: "include subtasks",
        display_labels_as_percent: "display labels as percent",
        show_legend: "show legend",
        show_Data_Labels: "show data labels",
        select: "select",
        add_card: "add card",
        back: "back",
        error_assignees: "The show assignees field is required",
        error_location: "The location field is required",
        empty_layout_container:
            "Your Dashboard is empty. Click 'Add Card' to begin.",
        status: "Status",
        edit_card: "edit card",
        calendar_card_title: "Calendar",
        calendar_card_description: "This is calendar view for task",
        measure: "measure",
        calculation: "calculation",
        total_urgent_tasks: "Total Urgent Tasks",
        total_urgent_tasks_description:
            "Display the total amount of Urgent tasks by location",
        time_tracker: "Time Tracker",
        time_estimate: "Time Estimate",
        range: "Range",
        max: "Max",
        min: "Min",
        median: "Median",
        average: "Average",
        sum: "Sum",
        workload_estination_title: "Time Reporting",
        workload_estination_description:
            "See tasks that have time tracked and estimated.",
        workload_only_estination_title: "Time Estimated",
        workload_only_estination_description: "See time estimated.",
        time_only_estination_title: "Time Tracked",
        time_only_estination_description: "See time tracked.",
        today: "Today",
        yesterday: "Yesterday",
        this_week: "This Week",
        last_week: "Last Week",
        this_month: "This Month",
        last_month: "Last Month",
        this_year: "This Year",
        last_30_days: "Last 30 Days",
        task_label: "task label",
        task: "Task Count",
        both: "Show both",
        manual_time: "Show manual time only",
        track_time: "Show tracked time only",
        logtype: "Time logs",
        timerange: "Time period",
        priority: "Priority",
        due_date: "Due Date",
        none: "None",
        total_time_track_description: "Display the total time track",
        total_time_track_tasks: "Total Time Track",
        total_tasks_count_description: "Display the total task count",
        total_tasks_count: "Total Number of Tasks",
        assignees: "Task Assignees",
        feature: "Feature",
        workload: "Workload",
        time_tracking: "Time Reporting",
        task_card: "Tasks",
        resource_utilization: "Resource Utilization",
        member: "My Workspace",
        me_option: "Me",
        next_up_card_title: "Next Up",
        next_up_card_description: "Your open tasks, ordered by due date then priority — what to do next.",
        next_up_empty: "You're all caught up — no open tasks.",
        next_up_limit: "How many tasks",
        due_soon_card_title: "Due Soon",
        due_soon_card_description: "Your tasks due within the next few days, soonest first.",
        due_soon_days: "Days ahead",
        due_soon_empty: "Nothing due in this window.",
        my_time_card_title: "My Time",
        my_time_card_description: "Your planned vs logged hours for the period.",
        mt_planned: "Planned",
        mt_over_plan: "Over Plan",
        mt_empty: "No planned or logged time in this period.",
        my_achievements_card_title: "My Achievements",
        my_achievements_card_description: "Your completion scorecard — tasks completed, within-estimate rate, on-time rate, and current streak.",
        ach_completed: "Completed",
        ach_on_estimate: "On estimate",
        ach_on_time: "On time",
        ach_streak: "Streak",
        ach_empty: "No completed tasks in this period.",
        ach_tab_wins: "Achievements",
        ach_tab_overdue: "Overdue",
        ach_tab_needs: "Over Estimate",
        ach_tab_wins_empty: "No clean deliveries yet — on time and within estimate show here.",
        ach_tab_overdue_empty: "Nothing delivered late this period. 🎉",
        ach_tab_needs_empty: "Nothing on-time went over estimate. 👍",
        color: "Color",
        icon_library: "Library",
        icon_upload: "Upload",
        my_leave_card_title: "My Leave",
        my_leave_card_description: "Your leave requests and their current status.",
        my_leave_setup_hint: "Pick your company's leave project in this card's settings to see your requests.",
        my_leave_empty: "You have no leave requests.",
        project_pulse_card_title: "Project Pulse",
        project_pulse_card_description: "Active projects, projects worked in the period, and the In House / Fixed / Hourly mix.",
        active_projects: "Active Projects",
        working_projects: "Working Projects",
        project_type_mix: "Project Type Mix",
        live_work_table_card_title: "Live Work",
        live_work_table_card_description: "Who is working on what right now (live trackers).",
        free_resources_card_title: "Free Resources",
        free_resources_card_description: "Team members with little planned work or nothing logged today (excludes those on leave).",
        worked_tasks_table_card_title: "Worked Tasks",
        worked_tasks_table_card_description: "Per user and project, how many tasks were worked on and where each currently sits, for the selected date range.",
        no_one_working_now: "No one is currently working on a task.",
        no_free_resources: "Everyone is currently allocated.",
        frc_reason: "Reason",
        lwt_user: "User",
        lwt_task: "Task",
        lwt_logged_today: "Logged Today",
        lwt_task_logged: "This Task",
        lwt_project: "Project",
        lwt_working_on: "Working on",
        lwt_tracking_now: "Tracking now",
        lwt_users_tracking: "{count} user tracking | {count} users tracking",
        lwt_project_count: "{count} project | {count} projects",
        lwt_no_user_match: "No users match “{search}”.",
        wtt_total_worked: "Tasks",
        wtt_in_progress: "In Progress",
        wtt_in_review: "In Review",
        wtt_backlog: "Backlog",
        wtt_complete: "Complete",
        team_category_breakdown_card_title: "Team Effort Breakdown",
        team_category_breakdown_card_description: "Where team energy goes — logged time by team, split by task type, effort nature (new/backlog/rework), work category, or billable, drilling to the members.",
        dim_type: "By Type",
        dim_effort_nature: "Effort Nature",
        dim_work_category: "Work Category",
        dim_billable: "Billable",
        team_logged_vs_eta_card_title: "Team Logged vs ETA",
        team_logged_vs_eta_card_description: "Per team, time logged versus the estimated time of the tasks worked.",
        tle_eta: "ETA",
        tle_logged: "Logged",
        tle_pct_hint: "% = Logged ÷ ETA · red = over estimate",
        free_threshold_hours: "Planned threshold (hours)",
        logged_threshold_hours: "Logged threshold (hours)",
        add_filter: "Add filter",
        on_leave_card_title: "On Leave",
        on_leave_card_description: "Approved leave tickets from your HR project for the selected period, with absent (AB) and present (PR) headcounts.",
        on_leave_setup_hint: "Pick the project that holds your leave tickets (and the approved status) in the card settings.",
        on_leave_absent: "Absent (AB)",
        on_leave_present: "Present (PR)",
        on_leave_tickets: "Leave Tickets",
        on_leave_ticket: "Ticket",
        on_leave_period: "Period",
        on_leave_no_one: "No one is on leave in this period.",
        auto_range: "Auto (dashboard range)",
        dashboard_range: "Date range",
        dashboard_range_hint: "Cards set to “Auto” follow this range",
        enable_date_range: "Enable date range filter",
        tasklist_date_range: "Date range",
        plm_type: "Type",
        plm_worked_in_period: "Worked in period",
        plm_yes: "Yes",
        plm_no: "No",
        plm_click_hint: "Click to see the projects behind this number",
        dashboard_settings: "Dashboard options",
        export_dashboard: "Export dashboard",
        import_dashboard: "Import dashboard",
        export_empty: "Your dashboard has no cards to export.",
        import_invalid: "That file isn't a valid AlianHub dashboard export.",
        import_confirm_title: "Import dashboard",
        import_confirm_body: "This file has {n} cards. Merge adds them below your current {m}; Replace swaps your dashboard for them (can't be undone).",
        import_merge: "Merge (append)",
        import_replace: "Replace",
        import_success: "Dashboard imported successfully.",
        import_success_dropped: "Dashboard imported ({n} unsupported cards skipped).",
        import_merge_success: "{n} cards added to your dashboard.",
        dashboard_updated: "Dashboard updated successfully",
        employee_workload_report_title: "Employee Workload & Activity Report",
        employee_workload_report_description: "See who is working on what, with workload distribution, overdue flags, and learning vs actual breakdown.",
        active_within_minutes: "Active within (minutes)",
        idle_after_minutes: "Idle after (minutes)",
        overload_capacity_per_day: "Overload capacity / day (minutes)",
        tasks_per_employee_limit: "Tasks per employee",
        refresh_interval_seconds: "Refresh interval (seconds)",
        show_ai_summary: "Show AI summary",
        show_workload_chart: "Show workload chart",
        show_task_type_chart: "Show task-type chart",
        show_logged_hours: "Show Logged Hours",
        show_planned_hours: "Show Planned Hours",
        show_estimate_hours: "Show Estimate Hours",
        recently_added_projects: "Recently Added Projects",
        recently_added_projects_hint: "New projects from the last 2 days — tick one to add it to this card.",
        new_badge: "New",
        dismiss_recent_project: "Remove from suggestions",
        Today: "Today",
        Yesterday: "Yesterday",
        Tomorrow: "Tomorrow",
        overdue_days: "{n}d overdue",
        This_week: "This week",
        Next_week: "Next week",
        Next_seven_days: "Next 7 days",
        Last_seven_days: "Last 7 days",
        Last_month: "Last month",
        This_month: "This month",
        Next_month: "Next month",
        Date_range: "Date range",
        me_mode: "me",
        data: "Data",
        display: "Display",
        fields: "Fields",
        ewr_user_count: "{n} user | {n} users",
        ewr_refreshing: "Refreshing…",
        ewr_current: "Current",
        ewr_search_placeholder: "Search employee…",
        ewr_clear_search: "Clear search",
        ewr_legend_title: "Logged Hours colour meaning",
        ewr_over_estimate: "Over estimate",
        ewr_over_planned: "Over planned",
        ewr_col_employee: "Employee",
        ewr_col_project: "Project",
        ewr_col_estimate: "Estimate Hours",
        ewr_no_planned: "No planned hours",
        ewr_no_estimate: "No estimate set",
        ewr_no_tasks: "No tasks for this employee in current filter.",
        ewr_over_estimate_by: "Over estimate by {time}",
        ewr_subtask: "Sub task",
        ewr_running_title: "Tracker is currently running",
        ewr_running: "Running",
        ewr_total: "Total",
        ewr_project_count: "{n} project | {n} projects",
        ewr_logged_over_estimate: "{time} over estimate",
        ewr_logged_over_planned: "{time} over planned",
        ewr_empty_search: "No employees match \"{query}\".",
        ewr_empty_current: "No one is currently working on a task.",
        ewr_empty_filter: "No employees match this filter.",
        lwt_people_working_now: "{n} person working now | {n} people working now",
        lwt_tracker_running: "Tracker running",
        no_data_found: "No data found",
        milestone_clear_status_filter: "Clear status filter",
        tcb_group_logged_time_by: "Group logged time by",
    },
    designationMapping: {
        title: "Designation Mapping",
        description:
            "Kindly Map the Designations in your CSV to the existing Designations in AlianHub.",
    },
    roleMapping: {
        title: "Role Mapping",
        description:
            "Kindly Map the Roles in your CSV to the existing Roles in AlianHub.",
    },
    importUserKeywords: {
        user_email_description: "Email ID of the user",
        user_role_description:
            "The role or job title assigned to the user within the organization.",
    },
    userSelection: {
        title: "User Selection",
        user_limit_error:
            "Maximum user limit reached. Please upgrade your plan to import more users.",
        description: "Select all the users that you want to import.",
        duplicate_email_error:
            "This Email ID already exists in AlianHub. You cannot import it.",
        invalid_fields:
            "You have one of more Invalid fields. Kindly check the highlighted fields.",
        user_limit_100: "You can import a maximum of 100 users at once.",
    },
    importUserButton: {
        import_users: "Import Users",
    },
    Changelog: {
        whats_new: "What's New",
        view_whats_new: "See what's new in this version",
        installed: "Installed",
        new_badge: "NEW",
        self_host_badge: "SELF-HOST",
        rss: "RSS",
        compare_changes: "Compare changes",
        no_releases: "No release notes available yet.",
        load_failed: "Couldn't load the changelog.",
        retry: "Retry",
    },
    Reminders: {
        title: "Reminder",
        header_tooltip: "Reminders",
        close: "Close",
        name_placeholder: "Reminder name",
        add_description: "Add description",
        description_placeholder: "Add more detail…",
        set_date: "Set date",
        today: "Today",
        tomorrow: "Tomorrow",
        next_week: "Next week",
        done: "Done",
        for_me: "For me",
        me_initial: "M",
        notify_me: "Notify me",
        on_due_date: "On due date",
        ten_minutes_before: "10 minutes before",
        one_hour_before: "1 hour before",
        custom: "Custom…",
        minutes_before: "minutes before",
        apply: "Apply",
        dont_notify: "Don't notify",
        attach: "Attach files",
        attachments: "Attachments",
        drag_files: "Drag and drop files to attach or",
        browse: "browse",
        remove: "Remove",
        create: "Create Reminder",
        creating: "Creating…",
        created: "Reminder created",
        failed: "Could not create the reminder. Try again.",
        invalid_date: "Pick a valid date and time.",
        panel_title: "Reminders",
        add: "Add reminder",
        loading: "Loading your reminders…",
        empty: "No reminders yet. Click \"Add reminder\" to create one.",
        filter_upcoming: "Upcoming",
        filter_done: "Completed",
        filter_all: "All",
        filter_assigned: "Assigned by me",
        for_user: "For {name}",
        another_user: "another user",
        pending: "Pending",
        mark_done: "Mark as done",
        mark_undone: "Mark as not done",
        options: "Options",
        delete: "Delete",
        deleted: "Reminder deleted",
        delete_failed: "Could not delete the reminder.",
        update_failed: "Could not update the reminder.",
        sent: "Sent",
        uploading: "Uploading files…",
        upload_failed: "Some files could not be uploaded.",
        edit: "Edit",
        edit_title: "Edit reminder",
        save: "Save changes",
        updated: "Reminder updated",
        snooze: "Snooze",
        snooze_10m: "10 minutes",
        snooze_1h: "1 hour",
        snooze_1d: "Tomorrow",
        snoozed: "Reminder snoozed",
        file_open_failed: "Could not open the file.",
    },
    Notepad: {
        title: "Notepad",
        add: "New note",
        loading: "Loading your notes…",
        empty: "No notes yet. Create one to get started.",
        editor_placeholder: "Write your note…",
        title_placeholder: "Untitled note",
        untitled: "Untitled note",
        no_content: "No content",
        back: "Back to notes",
        search: "Search notes",
        search_placeholder: "Search notes…",
        no_results: "No notes match your search.",
        show_archived: "Show archived",
        show_active: "Show active notes",
        empty_archived: "No archived notes.",
        sort_recent: "Sort by Recent",
        edit: "Open note",
        archive: "Archive",
        restore: "Restore",
        archived_toast: "Note archived",
        restored_toast: "Note restored",
        saving: "Saving…",
        saved: "All changes saved",
        confirm_delete_title: "Are you sure you want to delete this note?",
        confirm_delete_desc: "This action cannot be undone.",
        options: "Options",
        delete: "Delete note",
        convert_action: "Convert to task",
        convert_title: "Convert note to task",
        task_name: "Task name",
        select_project: "Project",
        select_project_placeholder: "Select a project",
        select_sprint: "List",
        select_sprint_placeholder: "Select a list",
        loading_sprints: "Loading lists…",
        cancel: "Cancel",
        converting: "Converting…",
        name_length_error: "Task name must be between 3 and 250 characters.",
        select_project_required: "Please select a project.",
        select_sprint_required: "Please select a list.",
        project_not_ready: "This project has no default status or task type configured.",
    },
    Demo: {
        banner: "You're on the AlianHub live demo — data may reset periodically.",
        login_with: "Log in with",
        star: "Star on GitHub",
        deploy: "Deploy your own",
        try_demo: "Try the demo",
        simulated: "Simulated",
        simulated_hint: "Written for this demo to show how the agent works. No AI model ran.",
        industry_it: "IT and software",
        industry_finance: "Finance and accounting",
        industry_logistics: "Logistics and supply chain",
        industry_hr: "People operations",
        industry_manufacturing: "Manufacturing",
        industry_agency: "Marketing agency",
        industry_ecommerce: "E-commerce",
        industry_construction: "Construction",
        industry_education: "Schools and education",
        industry_healthcare: "Healthcare clinic",
        industry_services: "Professional services",
        switch_industry: "Switch industry",
        guide: "Guide",
    },
    Setup: {
        guide_link: "Admin guide",
        open_guide: "Open the admin guide",
        checking: "Checking this instance…",
        server_unreachable: "The server did not answer. Is it running?",
        retry: "Check again",
        version: "AlianHub {version}",
        db_title: "The database is not reachable",
        db_lead: "AlianHub needs MongoDB before anything else can be set up.",
        db_step_env: "Set the database address in .env or the environment:",
        db_step_restart: "Restart the server.",
        db_step_retry: "Come back here and check again.",
        title: "Set up AlianHub",
        lead: "Create the owner account and the first workspace. Takes under a minute.",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        password: "Password",
        show_password: "Show password",
        hide_password: "Hide password",
        company: "Workspace name",
        focus: "What does your team mainly do?",
        focus_hint: "Picks the sample project and which templates come first. Changeable later.",
        focus_unsure: "Not sure yet",
        focus_software: "Software",
        focus_marketing: "Marketing",
        focus_design: "Design / creative",
        focus_support: "Support",
        focus_hiring: "Hiring",
        focus_other: "Something else",
        sample_title: "Start with a sample project",
        sample_hint: "A small project that explains the product by being read. Remove it any time from Home.",
        create: "Create workspace",
        working: "Setting up…",
        owner_note: "This account owns the instance: it can configure mail, storage, backups and upgrades under Settings › Instance.",
        progress_title: "Setting up your instance",
        progress_lead: "Seeding defaults and creating the workspace.",
        progress_seeds: "Seeding defaults",
        progress_account: "Creating the owner account",
        progress_company: "Creating the workspace",
        progress_settings: "Applying workspace settings",
        progress_sample: "Adding the sample project",
        failed_title: "Setup did not finish",
        failed_lead: "Nothing you typed was lost. Fix the cause and try again; the log has the details.",
        failed_generic: "The server could not complete setup.",
        done_title: "All set",
        done_lead: "Taking you to your workspace…",
        err_required: "Required.",
        err_invalid: "That does not look right.",
    },
    Providers: {
        nav: "AI providers",
        title: "Providers and models",
        refresh: "Refresh",
        scope_note: "Health and breakers are tracked in this server process ({node}) over the last {minutes} minutes. Another node keeps its own counts.",
        router_on: "The model router is on: a failing or rate-limited provider fails over to the next configured one.",
        router_off: "The model router is off, so the configured provider answers every call and nothing fails over. Health below is observation only.",
        col_provider: "Provider",
        col_model: "Model",
        col_state: "Health",
        col_breaker: "Breaker",
        col_calls: "Calls",
        col_latency: "Latency p50 / p95",
        col_last_error: "Last error",
        col_rate_limit: "Rate limit",
        chip_unconfigured: "No key",
        chip_unpriced: "No price",
        unpriced_warning: "No price is on file for {models}. Those calls book zero cost, so every budget, cap and alert stops working silently. Add a price for the model under AI settings (Model prices), or pin a priced model.",
        health_ok: "Healthy",
        health_degraded: "Degraded",
        health_untested: "No calls yet",
        health_unconfigured: "Not configured",
        breaker_closed: "Closed",
        breaker_open: "Open",
        breaker_half_open: "Half-open",
        breaker_retry: "Probes again {when}",
        calls: "{ok} of {total} succeeded",
        no_calls: "No calls in the window",
        rate_none: "No budget set",
        rate_budget: "{available} of {limit} per minute left",
        rate_blocked: "Paused until {when}",
        policy_title: "Breaker policy",
        policy_body: "A breaker opens when {volume} or more calls in the last {minutes} minutes are at least {percent}% provider failures. It stays open for {cooldown}s, then lets one probe through: the probe closes it on success, or re-opens it for twice as long, up to {ceiling}s. A rate-limit answer alone never opens a breaker — the token bucket answers that — and a malformed prompt or an over-long context is never counted, because another provider would refuse it too.",
    },
    ContentSecurity: {
        title: "Content security policy",
        lead: "The response header that tells the browser what the app may load. Report only blocks nothing and records what it would block; enforce blocks it.",
        mode_off: "Off",
        mode_report: "Report only",
        mode_enforce: "Enforce",
        mode_help: "Set in the environment, then restart the server. Variable:",
        off_note: "The policy is off, so browsers send no reports.",
        empty: "No reports in the last {days} days.",
        total: "{n} reports in the last {days} days",
        col_source: "Blocked source",
        col_directive: "Directive",
        col_reports: "Reports",
        col_last_seen: "Last report",
        rollout: "Run report only until this list stays empty, then switch to enforce. A host you trust goes in the variable for its directive:",
        policy: "Policy",
    },
    Enforcement: {
        nav: "Enforcement",
        default_title: "Instance default",
        default_lead: "How the server treats a browser session that its permission rules would refuse. API tokens are always enforced. Each workspace inherits this default unless it sets its own mode below.",
        default_label: "Permission checks for browser sessions",
        default_help: "Off lets browser sessions through as before; report lets them through and records what would have been refused; enforce refuses. Settings key:",
        source_env: "Set in the environment",
        source_saved: "Set from this console",
        source_default: "Built-in default",
        locked_help: "The environment sets this value, so the console cannot change it. Change it there and restart the server.",
        cache_note: "A mode change applies on this server at once and on every other server within {seconds} seconds.",
        cache_note_now: "A mode change applies on every server at once.",
        kill_switch: "Permission enforcement is switched off for the whole server by an emergency setting in its environment: every workspace set to enforce runs in report until that setting is turned off.",
        workspaces_title: "Workspaces",
        readiness_rule: "A workspace in report is ready to enforce once its would-be-denial log has been empty for {days} days in a row. Nothing switches by itself: you choose when.",
        col_workspace: "Workspace",
        col_mode: "Mode",
        col_effective: "Effective",
        col_rows: "Rows, 30 days",
        col_last_row: "Last row",
        col_in_report: "In report",
        col_readiness: "Readiness",
        mode_inherit: "Inherit",
        mode_off: "Off",
        mode_report: "Report",
        mode_enforce: "Enforce",
        mode_for: "Enforcement mode for {name}",
        days: "{n} day | {n} days",
        ready: "Ready to enforce",
        not_in_report: "Not in report",
        no_streak_yet: "No rows yet; the count starts at the first row or when the mode is set here",
        quiet_days: "{n} of {of} quiet days",
        show_rows: "Rows",
        instance_bucket: "No workspace",
        instance_bucket_help: "Requests that named no valid workspace, kept in the global database",
        rows_title: "Would-be denials: {name}",
        close: "Close",
        filter_reason: "Reason",
        all_reasons: "All reasons",
        filter_key: "Permission key",
        key_placeholder: "e.g. task.task_priority",
        filter_days: "Window",
        apply: "Apply",
        known_difference_lead: "One row per day, mode, route, key, role, scope and reason. Nothing here comes from a request body, a path or a query string. A row marked as a known difference is the server judging a project whose global-rules flag is not set; the web app allows it, so it is not a real denial.",
        no_rows: "No rows in this window.",
        col_day: "Day",
        col_route: "Route",
        col_key: "Key",
        col_role: "Role",
        col_scope: "Scope",
        col_reason: "Reason",
        col_count: "Count",
        col_seen: "First / last seen",
        col_users: "Users",
        scope_global: "Global",
        known_difference: "Known difference",
        known_difference_help: "The project's global-rules flag is not set. The web app reads that as the project's own rules and allows the request; the server would refuse it. Tracked as #740.",
        reason_denied: "Denied",
        reason_no_seat: "No seat",
        reason_role_not_allowed: "Role not allowed",
        reason_tasks_not_found: "Tasks not found",
        reason_null_global_flag: "Global flag not set",
        reason_check_failed: "Check failed",
        reason_unresolvable_id: "Unresolvable id",
        reason_company_mismatch: "Company mismatch",
        role_guest: "Guest",
        role_owner: "Owner",
        role_admin: "Admin",
        role_member: "Member",
        role_none: "No seat",
        mode_saved: "Mode set for {name}. Other servers pick it up within {seconds} seconds.",
        mode_saved_now: "Mode set for {name}. Every server applies it at once.",
        default_saved: "Instance default set. Other servers apply it when they next start.",
    },
    Egress: {
        nav: "Egress",
        title: "Agent egress allowlist",
        lead: "The hosts each workspace's agents may fetch. A workspace with no hosts listed fetches as before: public hosts allowed, private, metadata and link-local hosts refused. Once a host is listed, its agents fetch listed hosts only, on every redirect hop, and a listed name that resolves to a private address is still refused.",
        flag_on: "The gateway is on:",
        flag_off: "The gateway is off, so agents fetch as before and there is no list to show. Set this and restart the server:",
        format_help: "An exact hostname such as docs.example.com, or *.example.com for every subdomain, with an optional port such as api.example.com:8443. Addresses, private names, schemes and paths are refused.",
        cache_note: "A change applies on this server at once and on every other server within {seconds} seconds.",
        hosts_title: "Allowed hosts",
        no_hosts: "No hosts listed: this workspace fetches as before.",
        add_label: "Add a host",
        add_placeholder: "docs.example.com or *.example.com",
        add: "Add",
        remove_host: "Remove this host",
        clear_confirm: "This is the last host on the list for {name}. With no hosts listed, its agents can fetch every public host again, as they did before the list existed. Remove it?",
        refused_count: "{n} refused in the last {days} days",
        updated: "Last set by",
        saved: "Egress allowlist for {name} saved.",
        error_invalid: "That is not a hostname.",
        error_address: "List a hostname, not an address.",
        error_private: "Private, local and internal hosts cannot be listed.",
        error_scheme: "Leave the scheme off: agents fetch http and https only.",
        error_path: "List the host only, without a path, a query or a range.",
        error_wildcard: "A pattern is *.example.com: one leading wildcard on a domain with at least two labels.",
        error_public_suffix: "That suffix is shared: anyone can register a name under it, so a wildcard there would allow every site on it. List the exact hosts, or a wildcard on your own name such as *.acme.co.uk.",
        error_port: "A port is between 1 and 65535.",
        error_too_many: "A workspace can list at most {max} hosts.",
        error_duplicate: "That host is already listed.",
        error_wildcard_dns: "That domain answers every name under it with whatever address the name spells out, private ones included, so a wildcard there would allow any address. List the exact host instead.",
        port_help: "An entry without a port allows that host on any port, over plain http as well as https. Add :443 to allow https on its usual port only.",
        updated_by_admin_key: "the instance admin key",
        page_prev: "Previous",
        page_next: "Next",
        page_status: "Page {page} of {pages} · {total} workspaces",
        code_flag_off: "The gateway is off, so there is no list to change.",
        code_invalid_company_id: "That is not a workspace id.",
        code_hosts_not_list: "The save did not carry a list of hosts.",
        code_version_required: "The save did not say which version of the list it was made from. Reload the page and try again.",
        code_stale_version: "Someone changed this list since you opened it. The page now shows the current list; make your change again.",
        code_unknown_workspace: "That workspace no longer exists.",
        code_server_error: "The list could not be read or saved. Try again; if it keeps failing, the server log has the cause.",
    },
    InstructionPatterns: {
        nav: "Instruction guard",
        title: "Instruction guard patterns",
        lead: "Text from outside a workspace can carry lines addressed to the AI. The instruction guard looks for them before an agent remembers something and when a project brief is drafted. The built-in patterns always apply; add patterns here to catch phrasing you see in your own mail and form traffic.",
        cache_note: "A change applies on this server at once and on every other server within {seconds} seconds.",
        format_help: "A regular expression, matched without regard to case. Keep it flat: a repeated group cannot hold another repeat, an optional part or alternatives, and back-references and lookarounds are refused. Up to {repeats} repeats, each counted repeat up to {bound}, and {length} characters.",
        builtin_title: "Built-in patterns",
        builtin_help: "Part of the release. They cannot be removed or changed here.",
        builtin_locked: "Built in",
        added_title: "Added patterns",
        no_added: "No patterns added: only the built-in patterns apply.",
        added_by: "Added by",
        added_by_admin_key: "the instance admin key",
        add_title: "Add a pattern",
        source_label: "Pattern",
        source_placeholder: "\\bexample phrase\\b",
        note_label: "Note (optional)",
        note_placeholder: "Where you saw it",
        add: "Add",
        remove: "Remove this pattern",
        remove_confirm: "Remove this pattern? Text it matches will no longer be flagged once every server has picked up the change.",
        added: "Pattern added.",
        removed: "Pattern removed.",
        history_title: "Recent changes",
        history_added: "Added by",
        history_removed: "Removed by",
        reason_empty: "Enter a pattern.",
        reason_too_short: "A pattern needs at least 3 characters.",
        reason_too_long: "A pattern can be at most {length} characters.",
        reason_invalid: "That is not a valid regular expression.",
        reason_backreference: "Back-references such as \\1 are not allowed.",
        reason_lookaround: "Lookahead and lookbehind are not allowed.",
        reason_nested_repeat: "A repeated group cannot contain another repeat, an optional part or alternatives: that shape can take minutes to fail on long text.",
        reason_too_many_repeats: "A pattern can have at most {repeats} repeats (*, + or a counted repeat).",
        reason_repeat_too_large: "A counted repeat can go up to {bound}.",
        reason_matches_empty: "That pattern matches empty text, so it would flag everything.",
        reason_builtin: "That pattern is already on the built-in list.",
        reason_duplicate: "That pattern is already on the list.",
        code_too_many: "The list holds at most {max} added patterns. Remove one first.",
        code_builtin_locked: "Built-in patterns cannot be removed.",
        code_unknown_pattern: "That pattern was already removed. The page now shows the current list.",
        code_invalid_id: "That is not a pattern id.",
        code_server_error: "The patterns could not be read or saved. Try again; if it keeps failing, the server log has the cause.",
    },
    Knowledge: {
        nav: "Knowledge",
        title: "Knowledge sources",
        lead: "What each workspace's knowledge index holds: chunks and sources per type, how far the backfill has got, how fresh the index is, the embedding model, and why files were left out. Open a workspace to see its figures and controls.",
        no_text_note: "Counts, sizes, times, reasons and ids only: no text from the index is shown here.",
        indexer_on: "The indexer is on:",
        indexer_tenant: "The indexer runs only for workspaces that turn it on, as each card below shows:",
        indexer_off: "The indexer is off, so nothing is indexed and nothing here can be changed. To turn it on, set this and restart the server:",
        indexer_label: "Indexer",
        retrieval_label: "Retrieval",
        mode_off: "off",
        mode_on: "on",
        mode_hybrid: "hybrid",
        open: "Show figures",
        close: "Hide figures",
        backfill_not_started: "not started",
        backfill_running: "backfilling",
        backfill_catching_up: "catching up",
        backfill_complete: "complete",
        backfill_failed: "failed",
        reindex: "Re-index",
        reindex_running: "re-indexing",
        reindex_complete: "last re-index complete",
        reindex_failing: "the last batch failed and will be retried",
        reindex_failed: "last re-index given up after repeated failures",
        reindex_cancelled: "last re-index cancelled",
        cancel_reindex: "Cancel re-index",
        cancel_reindex_confirm: "Cancel the re-index of {source} in {name}? What it has already rewritten stays; everything else stays as it was.",
        reindex_cancel_done: "Re-index of {source} cancelled.",
        cached_at: "Figures from {at}",
        refresh_figures: "Read again",
        col_source: "Source",
        col_chunks: "Chunks",
        col_sources: "Sources",
        col_size: "Text size",
        col_last_indexed: "Last indexed",
        col_backfill: "Backfill",
        col_freshness: "Freshness",
        col_reindex: "Re-index",
        tombstones: "{n} tombstoned",
        progress: "{done} of {total}",
        fresh: "fresh",
        stale: "stale",
        behind_minutes: "heartbeat {n} min ago",
        catch_up_behind: "catching up on {n} min of changes",
        total: "Total",
        embeddings_title: "Embeddings",
        model: "Model",
        no_key: "no embedding key configured",
        by_model: "Chunks per model",
        no_vector: "no vector",
        pending_label: "Not on the current model",
        pending_chunks: "{n} chunks",
        spend: "Embedding spend",
        spend_value: "{usd} USD over {calls} calls and {tokens} tokens in {month}",
        budget: "Workspace budget",
        budget_value: "{usedUsd} of {budgetUsd} USD used this month",
        budget_none: "{usedUsd} USD used this month, no monthly cap",
        breaker: "Breaker",
        breaker_closed: "closed: embedding runs",
        breaker_open_budget: "open until {until}: the workspace budget is spent",
        breaker_open_failures: "open until {until}: the provider kept failing",
        vector_store: "Vector store",
        vector_store_local: "In the workspace database, cosine over the newest chunks of each source",
        vector_store_atlas: "Atlas Vector Search",
        vector_index_ready: "index ready",
        vector_index_building: "index building: questions use full-text search until it is ready",
        vector_index_missing: "index missing: it is created on the next check",
        vector_index_failed: "index failed to build",
        vector_index_unsupported: "this MongoDB server has no Atlas Search",
        vector_index_unreachable: "Atlas Search cannot be reached",
        vector_index_mismatch: "index size does not match the embedding model: check the embedding size set in the server's environment",
        vector_index_timeout: "the index check timed out; it is tried again on the next check",
        vector_index_unknown: "index state unknown",
        vector_store_paused: "vector search paused until {until}",
        reembed: "Re-embed",
        reembed_help: "Embeds the chunks that are not on the current model, within the workspace budget; the recurring job carries on with the rest.",
        reembed_confirm: "Re-embed {n} chunks with {model}? This spends from the workspace's AI budget.",
        reembed_started: "Re-embedding {n} chunks.",
        files_title: "Files left out",
        files_pending: "{n} file waiting for extraction. | {n} files waiting for extraction.",
        col_reason: "Reason",
        col_files: "Files",
        col_exhausted: "Out of retries",
        no_file_reasons: "No file has been left out.",
        retry_files: "Retry failed files",
        retry_help: "Gives files that failed to extract (a crash, a timeout, too much memory) their retries back. Files skipped for their type, size or storage stay skipped.",
        retry_confirm: "Retry every file in {name} that failed to extract?",
        retry_done: "{n} file queued for extraction again. | {n} files queued for extraction again.",
        reindex_confirm: "Re-index {source} in {name}? Every row is read again; what is indexed now stays searchable until the re-index is done.",
        reindex_started: "Re-index of {source} started.",
        erase_title: "Erasure",
        erase_lead: "Removes chunks from the knowledge index for good and keeps them out of every later backfill or re-index. The app's own records are not touched. This cannot be undone.",
        erase_type: "Document type",
        erase_id: "Document id",
        erase_document: "Erase document",
        erase_user: "Person (user id)",
        erase_person: "Erase person",
        erase_person_rule: "Erasing a person removes their private pages and the comments they wrote. Their shared pages stay, and so do call transcripts, which hold other people's words.",
        erase_document_confirm: "Erase {type} {id} from the knowledge index? This cannot be undone.",
        erase_person_confirm: "Erase the private pages and comments of {id} from the knowledge index of {name}? This cannot be undone.",
        erase_type_user_id: "Type the person's user id to confirm",
        erase_type_id: "Type the document id to confirm",
        erase_now: "Erase for good",
        cancel: "Cancel",
        erased: "Erased {n} chunks from the knowledge index.",
        page_prev: "Previous",
        page_next: "Next",
        page_status: "Page {page} of {pages} · {total} workspaces",
        source_page: "Pages",
        source_comment: "Comments",
        source_transcript: "Call transcripts",
        source_guide: "Project guides",
        source_file: "Files",
        source_task: "Task",
        reason_skipped_linked: "Linked from a cloud drive",
        reason_skipped_unsupported: "Unsupported type",
        reason_skipped_too_large: "Too large",
        reason_skipped_empty: "No text",
        reason_skipped_unreadable: "Unreadable",
        reason_skipped_foreign_key: "Not stored by the app",
        reason_skipped_type_mismatch: "Content does not match its type",
        reason_skipped_inflated_too_large: "Too large once unpacked",
        reason_extract_failed: "Extraction failed",
        reason_extract_timed_out: "Extraction timed out",
        reason_extract_too_much_memory: "Extraction used too much memory",
        code_indexer_off: "The indexer is off, so nothing can be changed.",
        code_workspace_indexer_off: "The indexer is off for this workspace, so there is nothing to run.",
        code_invalid_company_id: "That is not a workspace id.",
        code_unknown_workspace: "That workspace no longer exists.",
        code_invalid_source_type: "That is not a source type this index knows.",
        code_invalid_document_id: "That is not an id of that document type.",
        code_invalid_user_id: "That is not a user id.",
        code_confirmation_mismatch: "The confirmation did not match, so nothing was erased.",
        code_backfill_pending: "This source has not been backfilled yet; the backfill job builds it first.",
        code_backfill_running: "This source is still being backfilled or caught up; re-index it once that is done.",
        code_reindex_running: "A re-index of this source is already running.",
        code_not_hybrid: "Re-embedding needs the workspace in hybrid retrieval mode.",
        code_embedding_unconfigured: "No embedding key is configured for the instance.",
        code_embedding_paused: "Embedding is paused for this workspace: its budget is spent or the provider kept failing.",
        code_ai_off: "AI is turned off for this instance or workspace, so nothing is embedded.",
        code_reembed_running: "A re-embed of this workspace is already running.",
        code_server_error: "The index could not be read or changed. Try again; if it keeps failing, the server log has the cause.",
        code_reindex_not_running: "No re-index of this source is running.",
        code_nothing_erased: "Nothing in the index matched, so nothing was removed. The exclusion is recorded, so it stays out if it is indexed later.",
        code_figures_timed_out: "Reading the figures took too long. Try again later, or raise the time limit for reading these figures in the server's environment.",
        code_not_found: "Nothing by that id exists in this workspace, so nothing was erased and no exclusion was recorded.",
        code_invalid_exclusion_id: "That is not an exclusion id.",
        exclusions_title: "Exclusions",
        exclusions_lead: "What erasure keeps out of the index for good. Removing one lets the item be indexed again at its next change or re-index; it does not bring back what was erased.",
        exclusions_shown: "Showing the latest {n} of {total}.",
        no_exclusions: "Nothing has been erased from this workspace's index.",
        col_kind: "Kind",
        col_id: "Id",
        col_when: "When",
        col_who: "Who",
        col_kept_out: "Chunks removed",
        exclusion_kind_document: "Document",
        exclusion_kind_task: "Task",
        exclusion_kind_author: "Person",
        exclusion_remove: "Remove",
        exclusion_type_id: "Type the id this exclusion names to confirm",
        exclusion_remove_confirm: "Remove the exclusion for {id}? It can be indexed again from its next change or re-index.",
        exclusion_remove_now: "Remove exclusion",
        exclusion_removed: "Exclusion removed.",
        by_admin_key: "the instance admin key",
    },
    Instance: {
        built_at: "Updated {at}",
        group: "Instance",
        nav_health: "Health",
        nav_settings: "Settings",
        nav_backups: "Backups",
        nav_upgrade: "Upgrade",
        nav_logs: "Logs",
        nav_stats: "Stats",
        guide: "Admin guide",
        loading: "Loading…",
        refresh: "Refresh",
        error: "Error",
        detail: "Detail",
        ok: "OK",
        on: "On",
        off: "Off",
        yes: "Yes",
        no: "No",
        never: "Never",
        size: "Size",
        cancel: "Cancel",
        download: "Download",
        this_instance: "this instance",
        status_ok: "Healthy",
        status_degraded: "Degraded",
        uptime: "up {t}",
        maintenance_on: "Enter maintenance",
        maintenance_off: "Leave maintenance",
        maintenance_confirm: "Every API call except health and this console answers 503 until you leave maintenance. Continue?",
        maintenance_banner: "Maintenance mode is on: members see a banner and cannot use the app until you leave it.",
        maintenance_public: "Maintenance in progress — changes will not save for a few minutes. This page refreshes itself when the service is back.",
        maintenance_card_title: "AlianHub is under maintenance",
        maintenance_card_body: "We'll be back shortly. This page reloads when it's ready.",
        card_db: "Database",
        card_storage: "Storage",
        card_mail: "Mail",
        card_migrations: "Migrations",
        card_queue: "Automation queue",
        card_backup: "Backups",
        card_cron: "Scheduled jobs ({tz})",
        latency: "Latency",
        driver: "Driver",
        free_space: "Free space",
        provider: "Provider",
        not_configured: "not configured",
        test_mail: "Test mail",
        test_done: "Test finished.",
        configure: "Configure",
        applied: "Applied",
        pending: "Pending",
        failed: "Failed",
        open_upgrade: "Open Upgrade",
        open_backups: "Open Backups",
        last_backup: "Last backup",
        cron_disabled: "Scheduled jobs are turned off in this server's environment. Reminders, recurring tasks and retention will not run.",
        cron_none_yet: "No job has run since the server started.",
        job: "Job",
        last_run: "Last run",
        result: "Result",
        ready_mail: "Mail configured",
        ready_mail_cta: "Set up mail",
        ready_storage: "Storage chosen",
        ready_storage_cta: "Choose storage",
        ready_backup: "First backup taken",
        ready_backup_cta: "Back up now",
        ready_https: "Public URL uses HTTPS",
        ready_https_cta: "Set the web URL",
        ready_migrations: "Migrations up to date",
        ready_migrations_cta: "Run migrations",
        settings_lead: "A value set in the environment (.env or Docker) always wins and shows as locked. Everything else applies on save; a few settings need a restart.",
        group_general: "General",
        group_mail: "Mail",
        group_storage: "Storage",
        group_ai: "AI",
        group_auth: "Sign-in",
        group_calling: "Calling",
        group_security: "Security",
        test: "Test",
        test_ok: "Test passed.",
        test_connection: "Test connection",
        test_models: "That address serves {n} model: | That address serves {n} models:",
        save: "Save",
        saving: "Saving…",
        saved: "Settings saved.",
        restart: "restart",
        restart_needed: "Restart the server to apply: {keys}.",
        locked: "env",
        locked_help: "Set in the environment; change it there.",
        secret_set: "•••••••• (set — type to replace)",
        secret_unset: "not set",
        clear_secret: "Clear this secret on save",
        using_default: "Using the default.",
        err_unknown: "Unknown setting.",
        err_number: "Enter a whole number.",
        err_boolean: "Use on or off.",
        err_option: "Pick one of the listed options.",
        err_url: "Enter a full URL, such as http://localhost:11434/v1.",
        err_protocol: "The URL must start with http:// or https://.",
        err_credentials: "Leave the user name and password out of the URL; put the key in the API key field.",
        err_query: "Leave the query string and fragment out of the URL.",
        err_allowlist: "Use exact hostnames or CIDR ranges, such as hooks.lan or 192.168.10.0/24, separated by commas or new lines.",
        err_allowlist_reserved: "Cloud metadata and link-local addresses can never be allowed: 169.254.0.0/16, fe80::/10, fd00:ec2::/64, 100.100.100.200, fd20:ce::254 and fd00:c1::a9fe:a9fe. Remove the entry that is or includes one of them, or list a narrower range.",
        err_allowlist_broad: "That range is too wide. Use /8 or narrower for IPv4 and /32 or narrower for IPv6, and list 0.0.0.0/8, 127.0.0.0/8 or :: only as exactly that block.",
        f_WEBHOOK_ALLOWED_PRIVATE_HOSTS: "Private webhook hosts",
        h_WEBHOOK_ALLOWED_PRIVATE_HOSTS: "Webhooks refuse loopback, private and internal hosts. List the exact hostnames or CIDR ranges on your network they may post to. Removing an entry stops deliveries to it. Cloud metadata addresses stay blocked.",
        f_AGENT_TAINT_ROUTING: "Hold risky AI writes for approval",
        h_AGENT_TAINT_ROUTING: "A risky change by an AI that read outside content, or by an outside AI app, waits until a person approves it. On by default while the AI tools are on. Shown here only: it is set in .env.",
        f_MCP_OAUTH: "Connect an AI app by address",
        h_MCP_OAUTH: "Lets people connect Claude or ChatGPT by address, with a consent screen. \"only\" refuses personal tokens. Needs an https public API URL.",
        f_MCP_TOOLS_DATA: "AI data tools",
        h_MCP_TOOLS_DATA: "Projects, lists, docs, comments and time for a connected AI.",
        f_MCP_TOOLS_MANAGE: "AI management tools",
        h_MCP_TOOLS_MANAGE: "Changing, moving and archiving tasks and writing docs, for a connection given the manage permission.",
        f_MCP_TOOLS_WORK: "AI everyday work tools",
        h_MCP_TOOLS_WORK: "Tags, links, lists, doc comments, goals and project setup for a connected AI.",
        err_readonly: "This is set in .env and cannot be changed here.",
        err_mcp_issuer: "Connecting by address needs a public API URL that starts with https. Set that first.",
        allowlist_placeholder: "hooks.lan\n192.168.10.0/24",
        include_files:"Include uploaded files (server storage only)",
        backup_now: "Back up now",
        backing_up: "Backing up…",
        backups_lead: "Archives are written to {dir}. Each one holds every database as JSON lines plus a manifest.",
        no_backups: "No backups yet.",
        backup: "Backup",
        created: "Created",
        backup_done: "{name} written ({size}).",
        restore: "Restore",
        restore_title: "Restore {name}",
        restore_lead: "This replaces every collection in the archive with what the archive holds. A safety backup is taken first and the API is unavailable while it runs.",
        restore_type: "Type {name} to confirm",
        restore_go: "Restore this backup",
        restoring: "Restoring…",
        restore_done: "Restored {docs} documents in {colls} collections. Safety backup: {safety}.",
        delete_confirm: "Delete {name}? This cannot be undone.",
        restore_orphans: "{n} company database(s) have no company after the restore. They were kept; review them below.",
        orphans_title: "Company databases with no company",
        orphans_lead: "No company or user on this instance refers to these databases, usually because a restore went back to before the company was created. Nothing drops them automatically. If a restore left them, the safety backup taken just before it still holds them.",
        orphan_database: "Database",
        orphan_drop: "Drop",
        orphan_drop_go: "Drop this database",
        orphan_dropped: "Dropped {name} ({size}).",
        taken: "Taken",
        databases: "Databases",
        files: "Files",
        version_card: "Version",
        version_short: "Version",
        channel_beta: "beta",
        channel_release: "release",
        channel_dev: "development",
        channel_unknown: "version unresolved",
        builds_since: "Builds since v{v}",
        next_release: "Next release: v{v}",
        builds_show_all: "Show all {n}",
        builds_show_fewer: "Show fewer",
        update_available: "Version {v} is available.",
        release_notes: "Release notes",
        up_to_date: "You are on the latest release.",
        latest_unknown: "Could not check GitHub for the latest release. {err}",
        step_backup: "Take a backup (Backups tab).",
        step_verify: "Open Health and confirm the database, storage and migrations are green.",
        auto: "Run at boot",
        run_pending: "Run pending migrations",
        migrations_done: "Applied {n} migration(s).",
        migration: "Migration",
        applied_at: "Applied",
        newer_releases: "{n} newer release(s) in the changelog",
        needs_hands: "needs attention",
        breaking: "breaking",
        plain_upgrade: "Pull and restart; nothing else to do.",
        log_error: "Errors",
        log_combined: "Everything",
        log_track: "Warnings",
        last_lines: "Last {n} lines",
        log_reading: "Reading {file} ({size}).",
        log_none: "No log file of this kind yet.",
        log_empty: "Nothing logged.",
        log_files: "Log files",
        file: "File",
        modified: "Modified",
        companies: "Companies",
        company: "Company",
        users: "Users",
        audit_csv: "Audit CSV",
        redact_open: "Redact a person",
        redact_title: "Redact a person in the audit rows of {name}",
        redact_lead: "Rewrites one person's name, IP address, email and browser details in this workspace's audit rows with a pseudonym. Their user account is not changed, and user ids and free text that the audit chain protects stay as they are.",
        redact_user: "Person's user id",
        redact_continue: "Continue",
        redact_confirm: "This permanently rewrites the name, IP address, email and browser details of user {id} in every audit row of {name}. It cannot be undone.",
        redact_type_user_id: "Type the person's user id to confirm",
        redact_now: "Redact permanently",
        redact_cancel: "Cancel",
        redact_done: "Redacted {rows} audit rows ({fields} fields) as {pseudonym}.",
        redact_nothing: "Nothing left to redact for that person in this workspace.",
        redact_code_invalid_user_id: "That is not a user id.",
        redact_code_invalid_company_id: "That is not a workspace id.",
        redact_code_unknown_workspace: "That workspace no longer exists.",
        redact_code_confirmation_mismatch: "The id you typed does not match the person's user id.",
        redact_code_redaction_running: "Another run is already redacting this person in this workspace. Try again once it ends.",
        redact_code_server_error: "The audit rows could not be redacted. Running it again resumes where it stopped.",
        agents_title: "AI agents",
        agents_lead: "Company-wide limits for AI spend. Every feature that calls a model counts here, not only agent runs. Provider keys live in the fields above; nothing here stores a key.",
        agent_undo_hours: "Undo window (hours)",
        agent_undo_help: "How long after a run finishes it can still be reverted as a whole.",
        agent_budget: "Monthly budget (USD)",
        agent_budget_help: "The most AI calls may spend in one UTC month, counting every AI feature. A call that would pass it is refused before it is made. 0 means no cap.",
        agent_daily_budget: "Daily budget (USD)",
        agent_daily_budget_help: "The most AI calls may spend in one UTC day, counted with the monthly budget. A call that would pass either is refused before it is made. 0 means no daily limit.",
        agent_usage_today: "Today (UTC)",
        agent_usage_daily_uncapped: "${used} · no daily limit",
        agent_usage: "This month",
        agent_usage_line: "${used} of ${cap} · {percent}%",
        agent_usage_uncapped: "${used} · no cap",
        agent_alert_sent: "{threshold}% alert sent {at}",
        agent_alert_quiet: "{threshold}% alert not reached",
        agent_features: "By feature",
        agent_features_help: "Where this month's spend went, largest first.",
        agent_features_none: "No AI spend booked yet this month.",
        agent_feature_line: "${usd} · {share}% · {calls} calls",
        feature_agent_run: "Agent runs",
        feature_project_plan: "Project plan",
        feature_project_tasks: "Tasks into a project",
        feature_clarifier: "Brief and clarifying questions",
        feature_meeting_notes: "Meeting notes",
        feature_task_summary: "Task summary",
        feature_goal_summary: "Goal summary",
        feature_description: "Description writer",
        feature_task_category: "Task category",
        feature_task_estimate: "Task estimate",
        feature_workload_summary: "Workload summary",
        feature_ask: "Ask",
        feature_assist: "AI assist",
        feature_project_template: "Project templates",
        feature_portfolio_summary: "Portfolio summary",
        feature_page_compose: "Pages",
        feature_guide: "Project guide",
        feature_mcp_brief: "MCP brief",
        feature_action_items: "Notes to tasks",
        feature_task_assist: "Next steps and research",
        feature_writing_assist: "Improve and split text",
        feature_assignment_rules: "Assignment rules",
        feature_automation_draft: "Automation drafts",
        feature_ai_field: "AI fields",
        feature_agent_builder: "Agent builder",
        feature_transcription: "Talk to Text",
        feature_unknown: "Untagged",
        agent_provider: "Model provider",
        agent_provider_none: "No provider configured",
        agent_region: "Region: {region}",
        agent_region_any: "Region: any",
        agent_key_set: "Key set",
        agent_model_priced: "Priced",
        agent_model_unpriced: "No price on file",
        agent_model_unpriced_help: "Runs on this model are refused until a price is added under AI settings (Model prices).",
        f_LLM_PRICING: "Model prices (USD per 1M tokens)",
        f_AI_ENABLED: "AI features",
        h_AI_ENABLED: "Off stops every AI call on this instance: nothing is sent to any model, AI screens say AI is turned off, and background AI work is skipped. Each workspace can also turn AI off for itself.",
        f_OPENAI_BASE_URL: "OpenAI base URL",
        h_OPENAI_BASE_URL: "Empty uses OpenAI's own API. Set it only to reach OpenAI through a proxy or a regional address.",
        f_OPENAI_COMPATIBLE_BASE_URL: "OpenAI-compatible base URL",
        h_OPENAI_COMPATIBLE_BASE_URL: "A server that speaks the OpenAI API on your own network, such as http://localhost:11434/v1 (Ollama), http://host:8000/v1 (vLLM) or http://host:1234/v1 (LM Studio). Private and loopback addresses are allowed here; link-local and cloud metadata addresses are not.",
        f_OPENAI_COMPATIBLE_API_KEY: "OpenAI-compatible API key",
        h_OPENAI_COMPATIBLE_API_KEY: "Leave it empty when the server needs none, as with Ollama or LM Studio.",
        f_OPENAI_COMPATIBLE_MODEL: "OpenAI-compatible chat model",
        h_OPENAI_COMPATIBLE_MODEL: "The model name the server knows, such as llama3.1:8b. Test connection lists the names it serves.",
        f_OPENAI_COMPATIBLE_EMBEDDINGS_MODEL: "OpenAI-compatible embeddings model",
        h_OPENAI_COMPATIBLE_EMBEDDINGS_MODEL: "Used for knowledge search, such as nomic-embed-text. After changing it, re-embed each workspace under Instance > Knowledge. Without it, knowledge search stays keyword-only and nothing is sent to OpenAI.",
        o_LLM_PROVIDER_openai: "OpenAI",
        o_LLM_PROVIDER_anthropic: "Anthropic",
        o_LLM_PROVIDER_deepseek: "DeepSeek",
        o_LLM_PROVIDER_openai_compatible: "OpenAI-compatible (self-hosted)",
        err_json: "Enter JSON like {\"model-id\":{\"input\":2,\"output\":8}} with non-negative numbers.",
        agent_key_missing: "No key",
        agent_saved: "AI agent settings saved.",
        agent_save_failed: "AI agent settings were not saved.",
        agent_load_failed: "Could not load AI agent settings.",
        latency_ms: "{ms} ms",
    },
    AiMention: {
        option: "Ask AI",
        option_hint: "Answers in the thread",
        author: "AI",
        answered_for: "answered for {name}",
        answering: "AI is answering…",
        failed: "AI could not answer this.",
        off: "AI is turned off, so nobody will answer @ai.",
        unconfigured: "No AI model is set up yet, so @ai was not answered.",
        rate_limited: "You have asked AI a lot just now. Try again in a few minutes.",
        question_required: "Add a question after @ai.",
        ask_channel: "Ask about this channel",
        ask_label: "Your question",
        ask_placeholder: "What did we decide about the launch?",
        private_note: "Only you see the answer.",
        ask: "Ask",
        asking: "Asking…",
        post_to_channel: "Post to channel",
        posted: "Posted to the channel.",
        ask_again: "Ask again to post this answer.",
        not_shared: "This answer uses items some members can't see, so it was not posted.",
        close: "Close",
    },
    AgentChat: {
        replying: "The agent is replying…",
        could_not_reply: "The agent could not reply to this.",
        asked_own_ai: "Asked {name}",
        asked_their_ai: "Asked their AI",
        asked_own_ai_hint: "That AI gets the question when it next asks for work.",
        own_ai_manager_off: "Your AI is not listed here because the project manager is off in this project.",
        change_done: "DONE",
        change_proposed: "WAITING FOR APPROVAL",
        change_refused: "NOT ALLOWED",
        change_failed: "FAILED",
    },
    AiAvailability: {
        off_title: "AI is turned off",
        off_instance: "The instance owner has turned AI off, so no AI features run here and nothing is sent to an AI model.",
        off_workspace_manager: "AI is turned off for this workspace, so no AI features run and nothing is sent to an AI model. You can turn it back on in Settings.",
        off_workspace_member: "An owner or admin has turned AI off for this workspace, so no AI features run and nothing is sent to an AI model.",
        unconfigured_title: "Set up an AI provider",
        unconfigured_owner: "No AI provider is configured on this instance yet. Add an API key, or point AlianHub at your own OpenAI-compatible server (Ollama, vLLM, LM Studio), under Instance settings.",
        unavailable_title: "AI is not available",
        unconfigured_member: "AI is not available on this workspace yet. The instance owner can set it up.",
        open_instance_settings: "Open Instance settings",
        open_workspace_settings: "Open workspace settings",
        notice_owner: "No AI provider is set up yet, so AI answers are not available. Sources and everything else here still work.",
        notice_member: "AI answers aren't available yet. Sources and everything else here still work.",
        notice_setup: "Set up a provider",
        switch_heading: "AI features",
        switch_lead: "Turn AI off to stop every AI feature in this workspace. While it is off, nothing from this workspace is sent to an AI model and background AI work is skipped.",
        switch_label: "AI in this workspace",
        switch_hint_on: "On: members can use AI features.",
        switch_hint_off: "Off: AI features are hidden and nothing is sent to an AI model.",
        switch_on: "On",
        switch_off: "Off",
        switch_instance_off: "AI is also turned off for the whole instance, so it stays off here until the instance owner turns it on.",
        switch_saved_on: "AI is on for this workspace.",
        switch_saved_off: "AI is off for this workspace.",
        switch_failed: "The AI setting was not saved. Try again.",
    },
    ConnectAi: {
        title: "Connect your AI",
        welcome_kicker: "One last step",
        lead: "AlianHub works with the AI app you already use. Connect Claude or ChatGPT once, then ask it to set up and run your projects. It sees and changes only what you can.",
        sign_checking: "Checking whether your AI app is connected…",
        sign_waiting: "Not connected yet. This line changes by itself when your AI app makes its first call.",
        sign_connected: "Connected. Your AI app was last seen here around {when}.",
        first_title: "Say this to it first",
        first_sentence: "Set up my project",
        first_note: "It asks a few questions and shows you a plan. Nothing is made until you say yes.",
        copy: "Copy",
        copied: "Copied",
        claude_title: "Claude",
        claude_open: "In Claude, open Settings, then Connectors, and choose Add custom connector.",
        claude_allow: "Claude opens AlianHub and asks what it may do: read your tasks, projects, docs and time, and add tasks, comments and time entries. You choose. If the workspace has not approved Claude yet, the same screen lets you ask an owner or admin.",
        chatgpt_title: "ChatGPT",
        chatgpt_open: "In ChatGPT, open Settings, then Apps & Connectors. Turn on Developer mode under Advanced settings, then create a connector. ChatGPT offers this on some plans only.",
        chatgpt_allow: "ChatGPT opens AlianHub and asks what it may do, the same way. You choose.",
        paste_address: "Paste this address:",
        reach_note: "Your AI app reaches AlianHub over the internet, so this address must be reachable from outside your network.",
        apps_off: "Connecting an app by its address is switched off on this install. The person who runs the server can switch it on. Until then, use a token: that works today.",
        setting_label: "Setting to switch on:",
        token_title: "Claude Code and other tools",
        token_body: "Create a token, then run the command the page gives you. The token is shown once, when you create it.",
        token_link: "Create a token",
        tokens_off: "This install takes connected apps only, so tokens are switched off.",
        tools_title: "What your AI can do here",
        tools_base: "Find and read tasks, add tasks and subtasks, comment, and change a task's status.",
        tools_data: "Read projects, lists, statuses, comments, docs and timesheets, and log time.",
        tools_manage: "Change tasks (assign, move, set fields, archive) and write docs, when you allow it.",
        tools_work: "Work with tags, links between tasks, lists, comments on docs, and goals.",
        tools_off_title: "Switched off on this install",
        tools_admin: "The person who runs the server can switch these on. Your AI works without them; it just does less.",
        limit: "Your AI works in AlianHub while its app is open or running on a schedule. Agents that work round the clock with nobody's app open need a server key.",
        server_key_optional: "Optional extra: a server key. It is needed only for AI that runs inside AlianHub with nobody's AI app open: the Ask card, AI fields and agents on a schedule.",
        server_key_link: "Add a server key",
        skip: "Skip for now",
        skip_note: "You can connect later under AI, Connect your AI.",
        go_home: "Go to Home",
        hint: "Connect your AI and ask it instead",
        card_no_model: "No AI model is set up on this server, so this question is not answered here. Connect your AI (under AI, Connect your AI) and ask it instead.",
    },
    Routing: {
        nav: "Routing policy",
        loading: "Loading…",
        save: "Save",
        saving: "Saving…",
        title: "Model routing policy",
        lead: "Which model each kind of AI work prefers in this workspace, and what it has to clear.",
        flag_off: "The model router is off on this instance, so a saved policy changes nothing until an operator turns it on.",
        no_models: "No configured provider has a priced model, so a policy cannot name one yet.",
        model: "Preferred model",
        model_inherit: "No preference — use the configured provider",
        quality_floor: "Quality floor",
        latency_target: "Latency target (ms)",
        input_budget: "Input budget: {tokens} tokens",
        quality_basic: "Basic",
        quality_standard: "Standard",
        quality_high: "High",
        quality_frontier: "Frontier",
        class_classify: "Short classification",
        class_classify_help: "Category, estimate and clarifier calls: small prompts answered in a moment.",
        class_assist: "Interactive assist",
        class_assist_help: "Ask, assist, summaries and guides, where someone is waiting for the answer.",
        class_agent: "Agent run",
        class_agent_help: "Agent runs and project planning, where the answer turns into changes.",
        class_long_context: "Long context",
        class_long_context_help: "Meeting notes, workload and portfolio reads over a lot of text at once.",
        saved: "Routing policy saved.",
        save_failed: "The routing policy was not saved.",
        load_failed: "Could not load the routing policy.",
    },
    AgentPolicy: {
        title: "Agents in this project",
        lead: "What an AI agent may do here. A project can be stricter than the workspace, never looser.",
        loading: "Loading…",
        load_failed: "These settings could not be loaded.",
        save_failed: "The change was not saved.",
        saved: "Saved.",
        read_only: "An owner or admin changes these settings.",
        workspace_wins: "The workspace has a person check an agent's work before Done, so a person closes every task here whatever is chosen below.",
        done_label: "Agents and Done",
        done_never: "Never",
        done_never_about: "No agent closes a task here. A person does.",
        done_approval: "With approval",
        done_approval_about: "An agent's close waits in the approval queue until a person approves it.",
        done_yes: "Yes, marked unchecked",
        done_yes_about: "An agent closes a task at once, and the task stays marked unchecked until a person checks it.",
        connected_label: "Connected agents",
        connected_propose_all: "Propose everything",
        connected_propose_all_about: "Every change a connected agent makes here waits for a person's approval.",
        connected_single_task: "Act on single tasks, propose anything wider",
        connected_single_task_about: "A change to one task is applied at once and can be undone. Anything the workspace holds for approval still waits.",
    },
    StandingApprovals: {
        title: "Always do this",
        lead: "Changes a connected agent makes here without asking, because a person chose \"Always do this\" on an approval. Each one ends after {days} days.",
        loading: "Loading…",
        load_failed: "This list could not be loaded.",
        empty: "None yet. Choose \"Always do this\" on an approval in the Inbox to add one.",
        about: "Made by {maker} · ends {date} · not used yet | Made by {maker} · ends {date} · used once | Made by {maker} · ends {date} · used {n} times",
        someone: "someone",
        remove: "Remove",
        remove_named: "Remove \"Always do this\" for {agent}: {what}",
        removed: "Removed. The agent asks again.",
        remove_failed: "It was not removed.",
    },
    AgentWork: {
        mark_label: "{name} is working on this, since {time}",
        mark_label_no_time: "{name} is working on this",
        filter: "Agent working",
        filter_hint: "Show only the tasks an agent is working on now",
        group: "Who is working",
        group_none: "No agent",
        at_work: "{n} agent at work | {n} agents at work",
        at_work_open: "Show the tasks agents are working on now",
        paused: "Agents paused",
    },
    AgentLimits: {
        title: "Agents working at the same time",
        lead: "How many AI agents may work in this project at once, and a way to stop them all. Neither changes what people can do.",
        loading: "Loading…",
        load_failed: "These settings could not be loaded.",
        save_failed: "The change was not saved.",
        saved: "Saved.",
        at_once_label: "Agents at work at once",
        at_once_about: "When this many are at work, the next agent waits and gets work when one finishes.",
        direct_tasks_label: "Tasks a connected agent changes on its own",
        direct_tasks_about: "A connected agent changes up to this many different tasks in {minutes} minutes without asking. Its change to one more task waits for a person's approval. New tasks and docs count too.",
        pause: "Pause all agents",
        pause_about: "Agents stop taking work and changing things in this project right away. People carry on as usual.",
        paused_note: "Agents are paused in this project. They take no work and change nothing here until someone resumes them.",
        workspace_paused_note: "Connected agents are paused in the whole workspace. They take no work in any project, this one too, until an owner or an admin resumes them under AI.",
        resume: "Resume agents",
        resume_about: "Agents can take work and make changes here again.",
        read_only: "Only an owner or an admin can change these.",
    },
    ProjectManager: {
        title: "Project manager",
        lead: "On each working day AlianHub looks at this project and lists what needs attention: slipping dates, blocked work, tasks nobody owns. The look follows fixed rules and uses no AI. When AI is set up on the server, it also suggests a priority, an estimate and a likely duplicate for new tasks, and a person accepts each one.",
        switch_label: "Look at this project every working day",
        level_label: "Level:",
        level_suggest: "Suggest. It only proposes, and a person approves every change.",
        loading: "Loading…",
        load_failed: "This could not be loaded.",
        save_failed: "The change was not saved.",
        turned_on: "The project manager is on.",
        turned_off: "The project manager is off.",
        read_only: "An owner or admin turns this on or off.",
        findings_title: "What needs attention",
        empty: "Nothing needs attention right now.",
        review: "Review in Inbox",
        someone: "Someone",
        rule_slipping: "Date slipping",
        rule_blocked: "Blocked",
        rule_overloaded: "Too much planned",
        rule_untriaged: "New, not sorted",
        rule_stale: "Gone quiet",
        rule_no_owner: "No owner",
        rule_no_estimate: "No estimate",
        rule_triage: "Suggested by AI",
        reason_slipping: "Due {n} day ago | Due {n} days ago",
        reason_slipping_waits: "Waits on {blocker}, which now ends {n} day after this task starts | Waits on {blocker}, which now ends {n} days after this task starts",
        reason_blocked: "Waits on {blocker}, which has not changed for {n} working day | Waits on {blocker}, which has not changed for {n} working days",
        reason_overloaded: "{planned} hours planned this week, and the week holds {capacity}",
        reason_stale: "No change for {n} working day | No change for {n} working days",
        reason_untriaged: "Came in by {origin} and has no owner and no estimate",
        reason_no_owner: "Nobody owns this task",
        reason_no_estimate: "This task has no estimate",
        reason_triage_priority: "AI suggests priority {priority} from the task text",
        reason_triage_estimate: "AI suggests an estimate of {n} minute from the task text | AI suggests an estimate of {n} minutes from the task text",
        reason_triage_duplicate: "AI thinks this may duplicate {other}",
        origin_email: "email",
        origin_form: "a form",
        offer_slipping: "Choose a new date.",
        offer_slipping_waits: "Move it later by the same days.",
        offer_blocked: "Ask what the task it waits on needs.",
        offer_overloaded: "Give {task} to someone else, or move it.",
        offer_stale: "Ask for an update.",
        offer_untriaged: "Give it an owner, a priority and an estimate.",
        offer_no_owner: "Give it an owner.",
        offer_no_estimate: "Add an estimate.",
        offer_triage_priority: "Accept the suggested priority, or leave it.",
        offer_triage_estimate: "Accept the suggested estimate, or leave it.",
        offer_triage_duplicate: "Add a note about the likely duplicate, or leave it.",
        fix_slipping_waits: "move {task} {n} day later | move {task} {n} days later",
        fix_blocked: "ask what {blocker} needs to move",
        fix_stale: "ask for an update on {task}",
        fix_triage_priority: "set the priority of {task} to {priority}",
        fix_triage_estimate: "estimate {task} at {n} minute | estimate {task} at {n} minutes",
        fix_triage_duplicate: "note that {task} may duplicate {other}",
        rule_handed_over: "Handed to an agent",
        reason_handed_over: "A person handed this task to an agent",
        offer_handed_over: "The agent that takes it does what the task asks.",
        claimed_by: "{name} is working on this",
        waiting_for_agent: "Waiting for an agent to take it",
        handed_to: "Handed to {name}. It starts when that AI next asks for work.",
        take_back: "Take it back",
        taken_back: "You took it back. No agent will pick it up.",
        take_back_failed: "It could not be taken back.",
        hand_over: "Hand to an agent",
        hand_over_failed: "It could not be handed to an agent.",
    },
    Memory: {
        title: "What the agents remember",
        lead: "Decisions, constraints and past runs the agents read before they plan for this project.",
        loading: "Loading…",
        load_failed: "Could not load what the agents remember.",
        save_failed: "That was not saved.",
        retry: "Try again",
        empty: "Nothing stored yet. The first approved brief and the first agent run fill this in.",
        guide: "Guide",
        guide_essentials: "Essentials to flag",
        guide_escalations: "Escalate to a person when",
        guide_markdown: "Show the full guide",
        assumptions: "Assumptions",
        rows: "Decisions and constraints",
        no_rows: "No decisions or constraints yet.",
        kind: "Kind",
        kind_decision: "Decision",
        kind_constraint: "Constraint",
        kind_declined: "Declined change",
        source_declined: "a person's reason",
        declined_for: "for {agent}",
        remove: "Remove",
        source_brief: "from the brief",
        source_approved: "approved proposal",
        source_owner: "owner",
        source_run: "agent run",
        source_other: "agent",
        seen_n: "Seen {n} times",
        add: "Add",
        add_text: "Text",
        add_placeholder: "e.g. Ship the first release on the current design system",
        edit: "Edit",
        edit_text: "Edit text",
        save: "Save",
        saving: "Saving…",
        cancel: "Cancel",
        retire: "Retire",
        restore: "Restore",
        retired: "Retired",
        show_retired: "Show retired ({n})",
        hide_retired: "Hide retired",
        recent_runs: "Recent runs",
    },
    AiHealth: {
        nav: "Health",
        title: "AI health",
        lead: "Error rate, approval rate and cost per agent, model and feature, read from stored runs and refreshed every minute.",
        window_label: "Time window",
        window_1h: "1h",
        window_24h: "24h",
        window_7d: "7d",
        window_30d: "30d",
        agents_title: "Agents",
        models_title: "Models",
        features_title: "Cost by feature",
        no_agents: "No agent ran in this window.",
        col_agent: "Agent",
        col_runs: "Runs",
        col_error_rate: "Error rate",
        col_approval_rate: "Approval rate",
        col_p95: "p95 duration",
        col_cost: "Cost",
        col_trend: "Runs over time",
        col_model: "Model",
        col_calls: "Calls",
        col_tokens: "Tokens",
        col_feature: "Feature",
        chip_error_high: "High error rate",
        chip_approval_low: "Low approval",
        spark_label: "{n} run in this window | {n} runs in this window",
        percent: "{n}%",
        duration_ms: "{n} ms",
        duration_s: "{n} s",
        duration_min: "{n} min",
        usd: "US$ {n}",
        none: "–",
        unnamed_agent: "Unnamed agent",
        empty_title: "No runs yet",
        empty_body: "Once an agent runs or a feature calls a model in this window, its health shows here.",
        owner_only_title: "Owners and admins only",
        owner_only_body: "Ask an owner or admin of this workspace for the AI health figures.",
        load_failed: "The health figures could not be loaded.",
        retry: "Retry",
        thresholds_button: "Alert thresholds",
    },
    AiFeedback: {
        label: "Rate this answer",
        up: "Good answer",
        down: "Bad answer",
        thanks: "Thanks for the feedback.",
        failed: "The feedback could not be saved.",
        reasons_title: "What was wrong?",
        reason_wrong: "Wrong",
        reason_missing_sources: "Missing sources",
        reason_too_long: "Too long",
        reason_not_asked: "Not what I asked",
        reason_other: "Other",
        note_label: "Anything else about this answer",
        note_placeholder: "Tell us more (optional)",
        share: "Include the answer so an admin can review it",
        send: "Send feedback",
        skip: "Skip",
    },
    AiQuality: {
        nav: "Quality",
        title: "AI quality",
        lead: "How people rate AI answers, previews and agent proposals, the held-out question set's pass rate, and what each feature cost this month. No names are shown.",
        window_label: "Time window",
        window_days: "{n} day | {n} days",
        owner_only_title: "For owners and admins",
        owner_only_body: "Ask an owner or an admin of this workspace to look at AI quality.",
        load_failed: "The quality figures could not be loaded.",
        retry: "Retry",
        ratings_title: "Ratings",
        no_ratings: "Nobody has rated an AI answer in this window yet.",
        summary: "{up} up · {down} down · {liked} liked",
        trend_label: "Ratings per day over the last {days} days: {up} up and {down} down in total.",
        legend_up: "Thumbs up",
        legend_down: "Thumbs down",
        by_feature: "By feature",
        by_model: "By model",
        col_feature: "Feature",
        col_model: "Model",
        col_up: "Up",
        col_down: "Down",
        col_liked: "Liked",
        col_calls: "Calls",
        col_cost: "Cost",
        model_unknown: "Unknown model",
        none: "—",
        percent: "{n}%",
        usd: "US$ {n}",
        disliked_title: "Most disliked",
        disliked_privacy: "An answer appears here only when the person who rated it chose to include it.",
        no_disliked: "Nothing has been rated down in this window.",
        down_count: "{n} down",
        shared_answer: "Shared answer",
        sources: "Sources:",
        held_out_title: "Held-out question set",
        held_out_lead: "Structured Ask questions with known answers, checked against the live question reader without a model.",
        held_out_run: "Run now",
        held_out_running: "Running…",
        held_out_never: "Not run yet in this workspace.",
        held_out_result: "passed ({pct}%)",
        held_out_ran: "run {when}",
        held_out_expected: "Expected: {list}",
        held_out_got: "Got: {list}",
        held_out_nothing: "nothing",
        held_out_failed: "The held-out set could not be run.",
        cost_title: "Cost per feature, {month}",
        cost_total: "Total",
        no_cost: "No model calls were billed to this workspace this month.",
        cost_unavailable: "This month's AI spend could not be read right now. Try again in a moment.",
        kind_ask_turn: "Ask answer",
        kind_preview: "Preview",
        kind_proposal: "Agent proposal",
        feature_agent_run: "Agent runs",
        feature_project_plan: "Project plan",
        feature_project_tasks: "Project tasks",
        feature_clarifier: "Clarifying questions",
        feature_meeting_notes: "Meeting notes",
        feature_task_summary: "Task summary",
        feature_goal_summary: "Goal summary",
        feature_description: "Write with AI",
        feature_task_category: "Task category",
        feature_task_estimate: "Time estimate",
        feature_workload_summary: "Workload summary",
        feature_ask: "Ask",
        feature_assist: "Assist",
        feature_project_template: "Project template",
        feature_portfolio_summary: "Portfolio summary",
        feature_page_compose: "Page compose",
        feature_guide: "Guide",
        feature_mcp_brief: "MCP brief",
        feature_knowledge_embed: "Knowledge embeddings",
        feature_ai_field: "AI fields",
        feature_assignment_rules: "Assignment rules",
        feature_automation_draft: "Automation drafts",
        feature_agent_builder: "Agent builder",
        feature_task_assist: "Next steps and research",
        feature_writing_assist: "Improve and split text",
    },
    AiAlerts: {
        section_title: "AI alerts",
        section_lead: "Rate alerts reach your inbox when an agent or the AI budget crosses a workspace threshold, and again when it clears.",
        edit_thresholds: "Edit thresholds in AI health",
        toggle_label: "Send me {name} alerts",
        disabled_note: "Rate alerts are switched off for this workspace, so none are sent until an owner or admin turns them on in AI health.",
        save_failed: "Could not save your AI alert choice.",
        type_agent_error_rate: "Agent error rate",
        type_approval_rate_falling: "Approval rate falling",
        type_cost_forecast: "Cost against forecast",
        type_queue_age: "Queue age",
        explain_agent_error_rate: "When an agent fails {pct}% or more of at least {runs} runs in an hour.",
        explain_approval_rate_falling: "When approvals over 24 hours fall below {floor}%, or {drop} points under the 7-day rate.",
        explain_cost_forecast: "When this month's spend is on course for {pct}% of the monthly budget.",
        explain_queue_age: "When the oldest queued or running run has waited {minutes} minutes.",
        thresholds_title: "Alert thresholds",
        thresholds_lead: "Apply to the whole workspace. Each owner and admin chooses which alerts reach them in their notification settings.",
        enabled_label: "Rate alerts for this workspace",
        enabled_on: "Alerts on",
        enabled_off: "Alerts off",
        field_error_rate: "Error rate (%)",
        field_error_rate_help: "Share of an agent's finished runs in the last hour that failed.",
        field_error_min_runs: "Minimum runs",
        field_error_min_runs_help: "An agent with fewer finished runs in the hour never alerts.",
        field_approval_floor: "Approval floor (%)",
        field_approval_floor_help: "Alert when approval over 24 hours falls below this.",
        field_approval_drop: "Drop against 7 days (points)",
        field_approval_drop_help: "Alert when approval over 24 hours is this far under the 7-day rate.",
        field_cost_forecast: "Forecast share of budget (%)",
        field_cost_forecast_help: "Month-to-date spend projected to month end. Without a budget there is no alert.",
        field_queue_age: "Queue age (minutes)",
        field_queue_age_help: "Oldest queued or running agent run, or pending automation run.",
        error_range: "Enter a number from {min} to {max}.",
        error_whole_range: "Enter a whole number from {min} to {max}.",
        save: "Save thresholds",
        saving: "Saving…",
        saved: "Saved",
        cancel: "Close",
        save_error: "The thresholds could not be saved.",
        load_settings_failed: "The alert thresholds could not be loaded.",
        open_title: "Open alerts",
        open_count: "{n} open",
        open_none: "No open alerts.",
        opened_at: "Open since {at}",
        load_failed: "Open alerts could not be loaded.",
        unnamed_agent: "An agent",
        incident_agent_error_rate: "{agent} is failing {value}% of its runs (threshold {threshold}%)",
        incident_approval_rate_falling: "Approval over 24 hours is {value}% (threshold {threshold}%)",
        incident_cost_forecast: "Spend is on course for {value}% of the budget (threshold {threshold}%)",
        incident_queue_age: "The oldest run has waited {value} minutes (threshold {threshold})",
        notice_open_agent_error_rate: "AI alert: {agent} failed {value}% of its runs in the last hour (threshold {threshold}%).",
        notice_open_approval_rate_falling: "AI alert: approval of agent proposals is {value}% over 24 hours (threshold {threshold}%).",
        notice_open_cost_forecast: "AI alert: spend is on course for {value}% of this month's budget (threshold {threshold}%).",
        notice_open_queue_age: "AI alert: the oldest waiting run has waited {value} minutes (threshold {threshold}).",
        notice_resolved_agent_error_rate: "Resolved: {agent} is back under its error-rate threshold.",
        notice_resolved_approval_rate_falling: "Resolved: approval of agent proposals is back within its threshold.",
        notice_resolved_cost_forecast: "Resolved: spend is back under its forecast threshold.",
        notice_resolved_queue_age: "Resolved: the run queue is moving again.",
    },
    Workflows: {
        run_title: "Workflow run",
        refresh: "Refresh",
        loading: "Loading the run…",
        load_failed: "The workflow run could not be loaded.",
        control_failed: "The control could not be applied.",
        engine_off_title: "The workflow engine is not running",
        engine_off_body: "Workflows are switched off on this server, so there is nothing to show here. The person who runs the server can switch them on.",
        not_found_title: "No such workflow run",
        not_found_body: "The run has been removed, or it belongs to a project you cannot open.",
        read_only: "Only an Owner or an Admin can act on a step.",
        run_totals: "{settled} of {total} steps finished",
        cost_usd: "${usd}",
        cost_none: "—",
        duration_unstarted: "Not started",
        duration_ms: "{n} ms",
        duration_s: "{n} s",
        duration_m: "{n} min",
        status_queued: "Queued",
        status_pending: "Pending",
        status_running: "Running",
        status_success: "Succeeded",
        status_failed: "Failed",
        status_skipped: "Skipped",
        status_stopped: "Stopped",
        status_blocked: "Blocked",
        type_agent_run: "Agent run",
        type_tool_call: "Tool call",
        type_human_approval: "Approval",
        type_fan_out: "Fan-out",
        type_fan_in: "Fan-in",
        type_condition: "Condition",
        type_wait: "Wait",
        type_timer: "Timer",
        type_loop: "Loop",
        type_automation_rule: "Automation rule",
        type_external_agent: "Outside agent",
        type_role_handoff: "Hand to a role",
        handoff_finished_by: "Finished by {name}",
        type_unknown: "Unknown step",
        blocked_title: "This run is blocked",
        blocked_at_step: "At step {stepId}",
        blocked_deadline_exceeded: "Out of time",
        blocked_budget_exhausted: "Out of budget",
        blocked_loop_depth_exceeded: "Too deep",
        blocked_unknown_step_type: "Unknown step type",
        blocked_contract_mismatch: "Result did not match the contract",
        blocked_run_limit: "Hourly run limit reached",
        blocked_unknown: "Blocked",
        waiting_title: "This run is waiting",
        waiting_also: "And {n} more step is waiting. | And {n} more steps are waiting.",
        waiting_approval_person: "Waiting for {name} to approve",
        waiting_approval_role: "Waiting for whoever holds {role} to approve",
        waiting_approval_anyone: "Waiting for an approval",
        waiting_role_finish: "Waiting for {role} to finish",
        waiting_role_agents_off: "Waiting for agents to be switched back on before {role} gets the task",
        waiting_role_agents_off_held: "Waiting for agents to be switched back on; {role} holds the task",
        fan_tally: "{n} children · {parts}",
        fan_expand: "Show all ({n} more)",
        fan_collapse: "Show fewer",
        tally_separator: ", ",
        tally_success: "{n} succeeded",
        tally_failed: "{n} failed",
        tally_running: "{n} running",
        tally_pending: "{n} pending",
        tally_skipped: "{n} skipped",
        tally_stopped: "{n} stopped",
        failure_title: "What went wrong",
        failure_deterministic: "Deterministic",
        failure_transient: "Transient",
        failure_no_message: "The step failed without an error message.",
        failure_deterministic_why: "This step will fail the same way on another attempt, so retrying it is not offered. Skip it, or fix the definition and start a new run.",
        failure_transient_why: "This looks like a passing fault, so another attempt may well succeed.",
        failure_attempts: "Attempts",
        failure_attempts_of: "{n} of {max}",
        failure_backoff: "Backoff",
        backoff_s: "{n} s",
        backoff_m: "{n} min",
        backoff_at: "{wait} — next attempt {at}",
        control_retry: "Retry the step",
        control_skip: "Skip the step",
        control_resume: "Resume the step",
        control_compensate: "Undo what it did",
        control_hint_retry: "A retry starts a fresh attempt budget.",
        control_hint_skip: "Skipping lets the steps behind this one run.",
        control_hint_resume: "Nobody is working this step, so it can be taken back.",
        control_hint_none: "There is nothing to do to this step.",
        applied_retry: "The step will run again.",
        applied_skip: "The step was skipped.",
        applied_resume: "The step was resumed.",
        applied_compensate: "What the step did was undone.",
        loop_title: "Iterations",
        loop_running: "Going round",
        loop_stopped: "Stopped",
        loop_iterations: "Iteration {n} of at most {max}",
        loop_iterations_uncapped: "Iteration {n}",
        loop_iterations_label: "Iterations used of the maximum",
        loop_budget: "${used} of ${cap} spent",
        loop_budget_uncapped: "${used} spent",
        loop_budget_label: "Budget used of the cap",
        loop_stop: "Stop the loop",
        loop_stop_reason: "Stopped by a person from the run view",
        loop_stopped_iteration_cap: "Stopped at its iteration cap.",
        loop_stopped_budget: "Stopped because its budget was spent.",
        loop_stopped_condition: "Stopped because its condition stopped holding.",
        loop_stopped_body_failed: "Stopped because a step in its body failed.",
        loop_stopped_run_limit: "Stopped at the hourly run limit of an agent in its body.",
        loop_stopped_run_limit_detail: "Stopped at the hourly run limit: {used} of {limit} runs used, and the hour resets at {at}.",
        approvals_tab: "Approvals",
        approvals_load_failed: "The workflow approvals could not be loaded.",
        approvals_empty_title: "No workflow is waiting on you",
        approvals_empty_body: "An approval step hands its question to a person. When one is asked of you, it appears here.",
        approval_pick_one: "Pick an approval to read what it is asking.",
        approval_untitled: "An approval",
        approval_step: "Step {stepId}",
        approval_owner: "Owner",
        approval_owner_none: "Nobody",
        approval_owner_role: "Whoever holds {role}",
        approval_owner_unknown: "A person who has left (…{id})",
        approval_deadline: "Deadline",
        approval_deadline_none: "No deadline",
        approval_deadline_at: "{at} — {away}",
        approval_deadline_overdue: "Overdue since {at}",
        approval_due: "Due {away}",
        approval_overdue: "Overdue",
        approval_escalation: "Escalates to",
        approval_escalation_none: "Nobody — it waits for its owner",
        approval_escalation_someone: "somebody else",
        approval_escalation_to: "{who}",
        approval_escalation_at: "{who}, at {at}",
        approval_escalation_done: "{who} — escalated {at}",
        approval_escalated: "Escalated",
        approval_handovers: "Who moved it",
        approval_handover_line: "{by} handed it from {from} to {to} — {at}",
        approval_handover_system: "The engine",
        approval_approve: "Approve",
        approval_reject: "Reject",
        approval_approved: "Approved. The run carries on.",
        approval_rejected: "Rejected. The run skips what came after it.",
        approval_reassign: "Reassign",
        approval_reassigned: "The approval was handed on.",
        approval_reassign_title: "Hand this approval to somebody else",
        approval_reassign_lead: "Who moved it and to whom is recorded on the request.",
        approval_reassign_to: "The person who takes it on",
        approval_reassign_pick: "Pick a person",
        approval_reassign_reason: "Why (optional)",
        approval_read_only: "Only the owner of this approval, an Owner or an Admin can decide it.",
        decide_failed: "The decision could not be recorded.",
        reassign_failed: "The approval could not be handed on.",
        lineage_title: "Workflow lineage",
        lineage_open: "Lineage",
        lineage_back_to_run: "Back to the run",
        lineage_lead: "{n} handoffs, in the order the run makes them",
        lineage_read_only: "Lineage is a reading of the run. Act on a step from the run itself.",
        lineage_starts_here: "Starts the run",
        lineage_edge_handoff: "handed over",
        lineage_edge_field: "{field}",
        lineage_edge_value: "{field}: {value}",
        lineage_edge_missing: "{field} — not produced yet",
        lineage_agent: "{agent}",
        lineage_agent_for: "{agent}, for {person}",
        lineage_an_agent: "An agent",
        lineage_automation: "The rule {rule}",
        lineage_a_rule: "an automation rule",
        lineage_by_deadline: "Decided by the deadline",
        lineage_decided_by: "Decided by {person}",
        lineage_owned_by: "Waiting on {person}",
        lineage_owned_by_role: "Waiting on whoever holds {role}",
        lineage_unowned: "Waiting on nobody in particular",
        lineage_run_by: "{person} started the run",
        lineage_run_unowned: "Started by the system",
        lineage_somebody: "somebody",
    },
    Secrets: {
        title: "Stored secrets",
        count: "{n} stored",
        lead: "Integration and webhook secrets kept by handle in this workspace's secrets store. A value is never shown; rotate it by entering a new one, or revoke it so nothing can use it again.",
        empty: "No secrets are stored yet. Connecting an integration or adding a webhook stores its secret here.",
        col_name: "Name",
        col_kind: "Kind",
        col_key: "Key id",
        col_created: "Created",
        col_rotated: "Rotated",
        col_resolved: "Last resolved",
        col_status: "Status",
        col_actions: "Actions",
        kind_integration: "Integration",
        kind_webhook: "Webhook",
        key_previous: "Older key",
        never: "Never",
        status_active: "Active",
        status_revoked: "Revoked",
        rotate: "Rotate",
        revoke: "Revoke",
        cancel: "Cancel",
        save: "Save new value",
        new_value: "New value for {name}",
        new_value_ph: "Paste the new secret",
        err_value: "A new value is required.",
        confirm_revoke: "Revoke {name}? Anything that uses it stops working at once, and it cannot be undone.",
        rotated_toast: "{name} rotated.",
        revoked_toast: "{name} revoked.",
        kind_skill_read: "Skill read",
        sent_to: "Sent only to {hosts}",
        add_read: "Add a read credential",
        add_read_lead: "A token a skill sends when it reads a declared host. It is sent only to the hosts named here, and only while they are on the workspace egress allowlist.",
        read_name: "Name",
        read_name_ph: "GitHub read token",
        read_value: "Value",
        read_value_ph: "Paste the token",
        read_hosts: "Hosts it may be sent to",
        read_hosts_ph: "api.github.com, one per line",
        read_hosts_hint: "Exact host names, with a port if not 443. No wildcards.",
        read_header: "Header",
        read_header_ph: "authorization",
        read_header_hint: "Leave empty to send it as a bearer token in Authorization.",
        err_name: "A name is required.",
        err_hosts: "Name at least one host.",
        create: "Add credential",
        created_toast: "{name} added.",
    },
    ProviderKeys: {
        title: "Workspace provider keys",
        lead: "Each provider bills this workspace's own key while one is set, or the instance key otherwise. A value is never shown; set it again to replace it, or clear it to go back to the instance key.",
        loading: "Loading…",
        load_failed: "Could not load provider keys.",
        flag_off: "Workspace provider keys are off for this install, so every call bills the instance key.",
        resolved: "last used {when}",
        never: "Never",
        status_instance: "Instance key",
        status_stale: "Needs attention",
        set: "Set",
        replace: "Replace",
        clear: "Clear",
        save: "Save key",
        cancel: "Cancel",
        new_value: "New {name} key",
        new_value_ph: "Paste the provider key",
        err_value: "A key value is required.",
        confirm_clear: "Clear the {name} key? Calls bill the instance key again.",
        saved_toast: "{name} key saved.",
        cleared_toast: "{name} key cleared.",
    },
    SlackConnector: {
        title: "Slack messages from agents",
        lead: "An agent can propose a message to a channel you allow here. Nothing is posted until an owner or admin approves the exact channel and text in the AI Inbox.",
        loading: "Loading…",
        failed: "Slack could not be reached. Try again.",
        off_title: "The Slack connector is asked for in this server's settings but stays off, because:",
        problem_secrets_store_off: "The server's secrets store is turned off, so there is nowhere safe to keep the bot token.",
        problem_secrets_key_invalid: "The key that seals the server's secrets store is missing or shorter than 32 characters.",
        problem_taint_routing_off: "The safeguard that sends an agent's risky changes for approval after it has read outside content is turned off on the server.",
        broken: "Slack no longer accepts the bot token ({reason}, {when}). Nothing is posted until you replace it.",
        team: "Connected to the Slack workspace {name}.",
        secret_bot_token: "Bot token",
        secret_signing_secret: "Signing secret",
        set_on: "Set on {when}",
        not_set: "Not set",
        revoked: "Revoked from the stored secrets list. Set it again.",
        never: "never",
        set: "Set",
        replace: "Replace",
        remove: "Remove",
        cancel: "Cancel",
        save: "Save",
        saving: "Checking with Slack…",
        new_bot_token: "Bot User OAuth Token (starts with xoxb-)",
        new_signing_secret: "Signing Secret (from the Slack app's Basic Information page)",
        value_note: "The value is checked with Slack, sealed in the secrets store and never shown again.",
        err_value: "Paste the value first.",
        confirm_remove_bot_token: "Remove the bot token? Agents can no longer propose Slack messages, and the channel list is cleared.",
        confirm_remove_signing_secret: "Remove the signing secret?",
        channels_heading: "What agents may do in each channel",
        read_lead: "Tick Read to let an agent run read a channel's recent messages as plain text. A run that has read a channel is marked, makes no web fetch after that, and can still only propose a message. Private channels and direct messages are never read.",
        read: "Read",
        post: "Post",
        read_label: "Agents may read #{name}",
        post_label: "Agents may propose messages to #{name}",
        channels_lead: "Only public channels Slack listed for this app. A message to any other channel is refused, both when it is proposed and when it is approved.",
        channels_none: "Slack listed no public channels for this app.",
        not_member: "the app is not in this channel yet: invite it in Slack",
        channels_save: "Save allowed channels",
        channels_refresh: "Read the list again",
        channels_read: "List read {when}",
    },
    GoogleConnection: {
        title: "My connections",
        lead: "Connect your own Google account. Only you can use your connection: nobody else, whatever their role, can read or act through it.",
        loading: "Loading…",
        completing: "Finishing the connection…",
        failed: "That did not work. Try again.",
        name_google_calendar: "Google Calendar",
        grants_google_calendar: "Asks Google for a calendar AlianHub creates for your tasks, reading your events, and creating or changing events on calendars you own. Nothing reads or writes your calendar yet.",
        not_connected: "Not connected",
        connected_as: "Connected as {email}",
        connected_unnamed: "Connected",
        connected_on: "connected on {when}",
        state_broken: "Reconnect needed: Google stopped accepting this connection ({when}).",
        never: "never",
        connect: "Connect",
        connecting: "Opening Google…",
        reconnect: "Reconnect",
        disconnect: "Disconnect",
        confirm_disconnect: "Disconnect your Google account? Its access is revoked with Google and the stored tokens are deleted.",
        connected_now: "Your Google account is connected.",
        off_title: "This connector is asked for in this server's settings but stays off, because:",
        off_member: "Not available on this server yet. Ask an owner or admin of the workspace.",
        problem_secrets_store_off: "The server's secrets store is turned off, so there is nowhere safe to keep the tokens.",
        problem_secrets_key_invalid: "The key that seals the server's secrets store is missing or shorter than 32 characters.",
        problem_taint_routing_off: "The safeguard that sends an agent's risky changes for approval after it has read outside content is turned off on the server.",
        problem_google_client_missing: "The Google client ID or client secret for connectors is not set on the server.",
        error_access_denied: "Access was not allowed in Google, so nothing was connected.",
        error_state: "That connection attempt expired or was already used. Start again.",
        error_generic: "Google did not complete the connection. Try again.",
        members_title: "Members' Google connections",
        members_lead: "Who has connected a Google account. You can end a connection; you cannot use it or see whose Google account it is.",
        members_none: "No member has connected a Google account.",
        member_unknown: "Member {id}",
        member_broken: "reconnect needed",
        member_disconnect_label: "End the Google connection of {name}",
        confirm_member_disconnect: "End the Google connection of {name}? Its access is revoked with Google and the stored tokens are deleted. They can connect again.",
    },
    OAuthConsent: {
        loading: "Loading the request…",
        title_before: "Allow",
        title_after: "to act for you?",
        published_by: "Published at",
        returns_to: "Sends you back to",
        loopback_warning: "This app runs on your own computer and receives the answer there. Only approve it if you just started signing in from an app on this computer.",
        scopes_lead: "It asks to:",
        workspace_lead: "Choose the one workspace it may use:",
        no_workspace: "None of your workspaces has approved this app yet. It is waiting for your admin.",
        waiting_for_admin: "Waiting for your admin",
        ask_admin: "Ask an admin",
        ask_failed: "The request could not be sent. Try again.",
        scope_ceiling: "Approved for fewer permissions than this app asks for",
        other_workspace: "Registered to another workspace",
        approve: "Approve",
        deny: "Deny",
        revoke_hint: "You can revoke this at any time under Accounts, Connected apps.",
        signed_in_as: "Signed in as",
        switch_account: "Not you? Switch account",
        expired: "This sign-in request has expired or is not valid. Start again from the app that sent you here.",
        other_browser: "This sign-in request was started in another browser. Start again from the app that sent you here.",
        error_title: "This sign-in can't continue",
        back_to_app: "Back to AlianHub",
        scope_tasks_read: "Read tasks you can see",
        scope_tasks_write: "Create and change tasks for you",
        scope_projects_read: "Read projects you can see",
        scope_docs_read: "Read pages and documents you can see",
        scope_time_read: "Read time logs you can see",
        scope_time_write: "Log time for you",
        scope_name_tasks_read: "Read tasks",
        scope_name_tasks_write: "Write tasks",
        scope_name_projects_read: "Read projects",
        scope_name_docs_read: "Read documents",
        scope_name_time_read: "Read time",
        scope_name_time_write: "Log time",
        scope_tasks_manage: "Edit, assign, move, archive and close your tasks, several at a time",
        scope_docs_manage: "Create docs and change the ones you can edit",
        scope_name_tasks_manage: "Manage tasks",
        scope_name_docs_manage: "Write docs",
        scope_chat_read: "Read messages in channels you are in",
        scope_name_chat_read: "Read chat",
        manage_lead: "It also asks for more. Tick only what you want it to do:",
        manage_not_approved: "An owner or admin has not approved this for the workspace you chose.",
    },
    AgentClients: {
        lead: "Outside agents sign in with OAuth. Nobody in this workspace can connect one until an owner or admin approves it here, for the permissions you choose.",
        loading: "Loading agent clients…",
        load_failed: "Agent clients could not be loaded.",
        action_failed: "That did not work. Try again.",
        off: "Outside agent sign-in is off on this server.",
        empty: "No agent has asked to connect yet.",
        pending_title: "Waiting for approval",
        approved_title: "Approved",
        past_title: "Denied or revoked",
        requested_by: "Asked by",
        approved_by: "Approved by",
        scopes_legend: "Allow at most:",
        private_label: "May be delegated tasks in private lists",
        private_on: "Private lists allowed",
        private_off: "No private lists",
        approve: "Approve",
        deny: "Deny",
        revoke: "Revoke",
        revoke_confirm: "Revoke {name}? Everyone's connection to it in this workspace ends now.",
        status_denied: "Denied",
        status_revoked: "Revoked",
        manage_legend: "Wider permissions, given only if you tick them:",
        asked_for: "Asked for",
        change: "Change permissions",
        save: "Save",
        cancel: "Cancel",
    },
    ConnectedApps: {
        title: "Connected apps",
        lead: "Outside agents you allowed to act for you. Revoking one ends its access at once.",
        loading: "Loading connected apps…",
        load_failed: "Connected apps could not be loaded.",
        empty: "You have not connected any app.",
        workspace: "Workspace",
        last_used: "Last used",
        never_used: "Not used yet",
        ends: "Access ends {d}. To keep it after that, connect again from the app: it asks for your approval here, as it did the first time.",
        revoke: "Revoke",
        revoke_confirm: "Revoke {name}? It loses access at once.",
        revoke_failed: "The app could not be revoked.",
        withdraw: "Withdraw",
        withdraw_failed: "The permission could not be withdrawn.",
    },
    Favourites: {
        add: "Add to favourites",
        remove: "Remove from favourites",
        toggle: "Favourite {name}",
        remove_named: "Remove {name} from favourites",
        reorder_named: "Move {name}",
        reorder_hint: "Drag, or use the up and down arrow keys, to reorder.",
        moved: "{name} moved to position {n} of {total}",
    },
    TaskLists: {
        label: "Lists",
        home: "Home",
        home_hint: "The task lives in this list. Its home decides who can see it.",
        cannot_open: "A list you cannot open",
        add: "Add to another list",
        add_confirm: "Add",
        add_note: "The task stays in {project}. Only people who can open {project} will see it in the other list.",
        remove: "Remove from {list}",
        added: "Added to {list}.",
        removed: "Removed from {list}.",
        convert_note: "This task is also in other lists. As a subtask it will be removed from them.",
        menu_remove_here: "Remove from this list",
        removed_here: "Removed from this list.",
        added_back: "Added back to the list.",
        lives_in: "Lives in {list}",
        lives_in_project: "Lives in {list}, in {project}",
        lives_in_another_list: "Lives in another list",
        lives_in_another_project: "Lives in a list in another project",
        another_list: "Another list",
        another_project: "Another project",
        order_kept_at_home: "This task's place is kept by the list it lives in. Reorder it there.",
        other_projects: "From other projects",
        other_projects_more: "This list holds more tasks from other projects than are shown here.",
        also_in: "Also in {lists}",
        list_in_project: "{list}, in {project}",
        more_lists: "+{n}",
        bulk_add: "Add to another list",
        bulk_add_note: "Each task stays where it lives. Only people who can open a task's own project will see it in the other list.",
        bulk_added: "{n} added to {list}.",
        bulk_skipped: "{n} not added: {reason}",
        bulk_subtasks_hint: "Only top-level tasks can be added to another list.",
        refusal_chat_row: "A chat conversation cannot be added to a list.",
        refusal_subtask: "Only a top-level task can be added to another list. A subtask shows under its parent.",
        refusal_task_not_live: "An archived or deleted task cannot be added to a list.",
        refusal_home_project_not_open: "A task in a closed or archived project cannot be added to a list.",
        refusal_home_personal_list: "A task in a personal list cannot be added to another list.",
        refusal_personal_list: "A task cannot be added to a personal list.",
        refusal_scrum_list: "A task cannot be added to a Scrum sprint or a backlog.",
        refusal_list_not_live: "That list is archived or deleted.",
        refusal_project_not_open: "That project is closed or archived.",
        refusal_home_list: "The task already lives in that list.",
        refusal_already_in_list: "The task is already in that list.",
        refusal_too_many_lists: "A task can be in at most {max} other lists.",
        refusal_task_not_found: "This task no longer exists, or you can no longer open it.",
        refusal_list_not_found: "That list no longer exists, or you cannot open it.",
        refusal_not_in_list: "The task is no longer in that list.",
        refusal_not_permitted: "You do not have permission to change this task's lists.",
        refusal_task_changed: "The task changed while it was being added. Try again.",
        refusal_unknown: "The task's lists could not be changed. Try again.",
    },
    ProjectTree: {
        label: "Projects and lists",
        show: "Show the project tree",
        hide: "Hide the project tree",
        close: "Close the project tree",
        tasks: "{n} task | {n} tasks",
        folder_actions: "Actions for {folder}",
        rename_folder: "Rename {folder}",
        list_actions: "Actions for {list}",
        rename_list: "Rename {list}",
    },
    TaskTemplates: {
        save_as: "Save as template",
        apply_menu: "Apply template",
        save_title: "Save as template",
        apply_title: "Apply a template",
        name: "Template name",
        name_required: "Give the template a name.",
        scope: "Who can use it",
        scope_project: "This project ({project})",
        scope_workspace: "Every project in the workspace",
        scope_workspace_admin: "Only owners and admins can save a template for the whole workspace.",
        scope_project_short: "Project",
        scope_workspace_short: "Workspace",
        title_pattern: "Task name",
        title_pattern_hint: "Use {title} for the name typed when creating and {date} for the day the template is applied.",
        include: "Include",
        part_description: "Description",
        part_checklist: "Checklist",
        part_subtasks: "Subtasks",
        part_subtaskAssignees: "Subtask assignees",
        part_type: "Task type",
        part_priority: "Priority",
        part_tags: "Tags",
        part_estimate: "Estimate",
        part_points: "Story points",
        part_customFields: "Custom fields",
        part_dates: "Start and due dates",
        dates_hint: "Dates are kept as days after the day the task was created, and counted from the day the template is applied.",
        loading: "Loading templates…",
        none: "No templates yet. Use Save as template on a task to make one.",
        choose: "Template",
        template: "Template",
        no_template: "No template",
        checking: "Checking what the template would change…",
        conflicts: "These fields already have a value. Tick the ones the template should replace.",
        no_conflicts: "The template only fills empty fields and adds items to this task.",
        replace_field: "Replace {field}: {from} → {to}",
        replace_custom_fields: "Replace {n} custom field value(s)",
        empty: "empty",
        field_title: "task name",
        field_description: "description",
        field_type: "task type",
        field_priority: "priority",
        field_tags: "tags",
        field_estimate: "estimate",
        field_points: "story points",
        field_customFields: "custom fields",
        field_startDate: "start date",
        field_dueDate: "due date",
        field_checklist: "checklist",
        field_subtasks: "subtasks",
        save: "Save",
        saving: "Saving…",
        saved: "Template “{name}” saved.",
        save_failed: "Couldn't save the template. Try again.",
        apply: "Apply",
        applying: "Applying…",
        applied: "Template applied.",
        applied_skipped: "Template applied. You can't change these here, so they were left as they were: {fields}.",
        apply_failed: "Couldn't apply the template. Try again.",
        load_failed: "Couldn't load the templates.",
        cancel: "Cancel",
        rename: "Rename",
        rename_label: "Rename {name}",
        rename_failed: "Couldn't rename the template.",
        delete: "Delete",
        delete_label: "Delete {name}",
        delete_confirm: "Delete for good",
        delete_failed: "Couldn't delete the template.",
        default_title: "Default task template",
        default_hint: "Chosen for you when someone creates a task in this project. They can still change or clear it.",
        default_none: "No default",
        default_empty: "This project has no task templates yet.",
        default_saved: "Default template saved.",
        default_cleared: "Default template cleared.",
        default_failed: "Couldn't change the default template.",
        settings_nav: "Task templates",
        settings_title: "Task templates",
        settings_hint: "Templates saved from tasks, for one project or the whole workspace. Save a new one from a task's menu.",
        settings_empty: "No task templates yet.",
        summary: "{checklist} checklist items, {subtasks} subtasks",
    },
    Teams: {
        engineering: "Engineering",
        design: "Design",
        product: "Product",
        support: "Support",
        sales: "Sales",
        sales_orders: "Sales and orders",
        planning: "Planning",
        purchasing: "Purchasing",
        production: "Production",
        quality: "Quality",
        maintenance: "Maintenance",
        logistics: "Logistics",
        hse: "Health and safety",
        client_services: "Client services",
        creative: "Creative",
        delivery: "Delivery",
        finance: "Finance",
        strategy: "Strategy",
        catalogue: "Catalogue",
        operations: "Operations",
        marketing: "Marketing",
        business_development: "Business development",
        engagement: "Engagement",
        compliance: "Compliance",
        commercial: "Commercial",
        procurement: "Procurement",
        site: "Site",
        admissions: "Admissions",
        teaching: "Teaching",
        pastoral: "Pastoral care",
        curriculum: "Curriculum",
        staffing: "Staffing",
        school_life: "School life",
        assessment: "Assessment",
        communications: "Communications",
        timetable: "Timetable and rooms",
        front_office: "Front office",
        people: "People",
        analytics: "Analytics",
        leadership: "Leadership",
        administration: "Administration",
        front_desk: "Front desk",
        billing: "Billing",
        facilities: "Facilities",
        patient_experience: "Patient experience",
        supplies: "Supplies",
        management: "Management",
        staff_rosters: "Staff rosters",
    },
    TeamPacks: {
        nav: "Team packs",
        title: "Team packs",
        lead: "Turn on a team's role agents in your projects with one click. A project whose dispatcher is off starts suggesting a role; nothing is assigned by itself, and you can undo the pack.",
        loading: "Loading…",
        load_failed: "Could not load the team packs.",
        retry: "Retry",
        dispatcher_off: "The dispatcher is off on this server, so team packs cannot be turned on here.",
        blueprint_label: "Company blueprint",
        teams_label: "Teams",
        projects_label: "Projects",
        projects_hint: "You need to be a workspace admin, or allowed to change each project's details.",
        no_projects: "There are no projects to choose.",
        projects_cap: "You can pick up to {n} projects at a time.",
        why_no_permission: "You may not change this project's details.",
        why_own_roles: "This project has its own roles: a workspace admin turns packs on here.",
        apply: "Turn on one role | Turn on {n} roles",
        applying: "Turning on…",
        nothing_runs: "Nothing runs until someone sends it work.",
        create_agents: "Create the team's agents",
        create_agents_paused_hint: "One agent per role, limited to these projects. Each starts paused: it answers no mention and takes no routed work until a person switches it on in Agents.",
        agents_paused_note: "The new agents are paused. Switch each one on in Agents when you want it to work.",
        agents_made: "Created one agent. Reused {reused} that already existed. | Created {n} agents. Reused {reused} that already existed.",
        agents_undone: "The agents the pack made are removed.",
        agent_kept: "{name} stays: it has done work or reaches other projects.",
        agent_kept_running: "{name} stays: it has runs in progress. Stop them in Agents, then remove it there.",
        agent_kept_edited: "{name} stays: a person has changed it since the pack made it.",
        agents_undone_some_kept: "One agent stays. | {n} agents stay.",
        applied: "Turned on one role. | Turned on {n} roles.",
        nothing_new: "Every role in this pack was already on.",
        roles_were_on: "The roles were already on.",
        starter_rules: "Also add the roles' starter routing rules",
        starter_rules_hint: "One starter rule, by task type, tag or priority. It is never added twice, and undo removes only the rules this pack added. | {n} starter rules, by task type, tag or priority. A rule is never added twice, and undo removes only the rules this pack added.",
        starter_rules_type_hint: "A rule by task type that a project lacks routes on the role's tag of the same name instead.",
        tags_hint: "These roles hand work on with the tags {names}. The tags a project lacks are proposed to you as one approval per project; nothing is created until you approve.",
        rules_added: "Added one routing rule. | Added {n} routing rules.",
        rules_waiting: "One starter rule waits for a tag or task type this project lacks. | {n} starter rules wait for a tag or task type this project lacks.",
        rules_await_tags: "One starter rule waits for its tag to be approved; it is added when the tag is approved. | {n} starter rules wait for their tags to be approved; they are added when the tags are approved.",
        tags_proposed: "Proposed one tag for approval: {names}. | Proposed {n} tags for approval: {names}.",
        fields_hint: "These roles fill the fields {names}. The fields a project lacks are proposed to you as one approval per project; nothing is created until you approve.",
        fields_proposed: "Proposed one field for approval: {names}. | Proposed {n} fields for approval: {names}.",
        rule_on_tag: "{role} will route on tag {tag}, because the project has no {type} type.",
        fields_kept: "Fields already approved stay in the project; undo only withdrew the approvals still waiting.",
        project_on: "{project}: the dispatcher is in {mode} mode.",
        mode_suggest: "suggest",
        mode_apply: "apply",
        mode_switched: "Its dispatcher was off, so it now suggests a role; undo turns it off again.",
        undo: "Undo",
        undoing: "Undoing…",
        undone: "The pack's roles are off again.",
        failed: "Could not turn on the pack. Please try again.",
        undo_failed: "Could not undo the pack. Please try again.",
    },
    Dispatcher: {
        title: "Dispatcher",
        lead: "Sends each new or changed task to the agent role that should take it, by this project's routing rules.",
        mode_label: "Mode",
        mode_off: "Off",
        mode_suggest: "Suggest a role",
        mode_apply: "Send to the role's queue",
        counts: "{roles} roles on, {rules} routing rules",
        suggests: "Dispatcher suggests {role}",
        needs_routing: "Needs routing",
        routed_to: "Routed to {role} by the dispatcher",
        routed_by: "Routed to {role} by {person}",
        accepted_by: "{role} · accepted by {person}",
        someone: "someone",
        roles_title: "Roles on in this project",
        roles_group: "{blueprint} ({on} of {total} on)",
        rules_title: "Routing rules, first match wins",
        rules_empty: "No routing rules yet. Tasks wait in Needs routing until a lead picks a role.",
        rules_incomplete: "Finish or remove the incomplete rules to save.",
        rule_condition: "Condition",
        rule_field: "Custom field id",
        rule_value: "Value",
        rule_role: "Role",
        rule_up: "Move rule up",
        rule_down: "Move rule down",
        rule_remove: "Remove rule",
        rule_add: "Add a rule",
        condition_type: "Task type is",
        condition_tag: "Has tag",
        condition_priority: "Priority is",
        condition_status: "Status is",
        condition_list: "List is",
        condition_field: "Field equals",
        save: "Save roles and rules",
        needs_routing_empty: "Nothing is waiting for a role.",
        by_rule: "rule {n}",
        by_model: "AI guess, {confidence}% sure",
        model_reason: "Model's reason:",
        accept: "Accept",
        dismiss: "Dismiss",
        pick_role: "Choose a role",
        send: "Send",
        offer_rule: "You sent this task type to {role} {times} times. Always send it there?",
        offer_add: "Add rule",
        offer_added: "Routing rule added.",
        failed: "Could not update the routing. Please try again.",
        settings_changed: "These settings were changed elsewhere and have been reloaded. Make your change again and save.",
    },
    CompanyView: {
        nav: "Company view",
        title: "Company view",
        lead: "The roles switched on across your projects, who supervises them, and how work is moving between them. You see only the projects you can open.",
        loading: "Loading…",
        load_failed: "Could not load this part of the company view.",
        retry: "Retry",
        off_title: "The dispatcher is off",
        off_body: "The company view shows the roles the dispatcher routes work to. Ask an owner to switch the dispatcher on.",
        org_title: "Org chart",
        org_empty: "No role is switched on in a project you can open. Switch roles on in a project's dispatcher settings.",
        org_projects: "{n} project | {n} projects",
        org_no_agents: "No agent plays this role yet",
        org_paused: "Paused",
        org_supervised_by: "Supervised by {name}",
        org_set_up_by: "Set up by {name}",
        org_no_supervisor: "No supervisor yet",
        org_unknown_person: "an unknown person",
        org_agents_label: "Agents",
        flow_title: "Flow board",
        flow_lead: "Tasks per role. Stuck means no activity for {days} days.",
        flow_empty: "No role is switched on in a project you can open.",
        flow_unrouted: "Needs routing",
        flow_unrouted_hint: "Waiting for a lead to pick a role",
        flow_waiting: "Waiting for a lead",
        flow_queued: "In queue",
        flow_held: "Held",
        flow_stuck: "Stuck",
        flow_none: "Nothing here",
        flow_more: "and {n} more",
        held_approval: "Waiting for approval",
        held_claimed: "With an agent",
    },
    Blueprints: {
        it_company: "IT company",
        manufacturing: "Manufacturing",
        agency: "Agency",
        ecommerce: "E-commerce",
        professional_services: "Professional services",
        education: "Education",
        construction: "Construction",
        clinic: "Clinic administration",
    },
    CompanyBlueprint: {
        title: "Company blueprint",
        lead: "Choose your industry and size to see which teams, roles and seats usually fit, then turn on the first three roles in your projects.",
        loading: "Loading…",
        load_failed: "Could not load the company blueprints.",
        industry_label: "Industry",
        size_label: "Company size",
        size_small: "Small",
        size_medium: "Medium",
        size_large: "Large",
        people: "{from} to {to} people",
        counts: "About {roles} roles and {from} to {to} seats",
        seats_hint: "A seat is one connected AI working a role. Plan one person to supervise every 3 to 5 seats.",
        teams_title: "Teams",
        roles_title: "Roles",
        starter: "Starts first",
        not_written: "Not written yet",
        none_written: "None of this industry's first three roles are written yet, so there is nothing to turn on.",
        some_written: "{n} of the first {total} roles are written yet; only those are turned on.",
        no_projects: "There are no projects to choose yet. Create a project, then come back to AI, Team packs.",
        apply: "Turn on one starter role | Turn on {n} starter roles",
        suggest_only: "Roles only suggest. A project whose dispatcher is off is switched to suggesting a role, and undo switches it back.",
        welcome_link: "Set up your teams (optional)",
        welcome_kicker: "Optional step",
        welcome_title: "Set up your teams",
        welcome_continue: "Continue to Home",
        welcome_note: "You can do this later under AI, Team packs.",
    },
    AssignmentRules: {
        title: "Assignment rules",
        lead: "Tell AI when to assign specific people in this project. A task that nobody is assigned to gets a suggestion, with the rule that matched.",
        ai_unavailable: "AI is off or no model is configured, so nothing is decided. Rules are kept until AI is back, and the fallback is not used on its own either.",
        loading: "Loading assignment rules…",
        load_failed: "Could not load the assignment rules.",
        retry: "Retry",
        empty: "No one has a rule yet. Add a person and say when they should get a task.",
        when_placeholder: "When should this person get a task? For example: frontend bugs and anything about the UI",
        when_label: "When {name} gets a task",
        remove: "Remove",
        remove_person: "Remove {name}",
        add_person: "Add a person",
        everyone_added: "Everyone who can open this project has a rule",
        add: "Add",
        unknown_person: "Former member",
        suggest: "Suggest rules",
        suggesting: "Suggesting…",
        suggest_hint: "Drafts a sentence for each person from tasks they recently worked on here. Nothing is saved until you choose.",
        suggest_failed: "Could not suggest rules.",
        drafts_title: "Suggested sentences",
        drafts_empty: "No suggestions: these people have no recent tasks you can see in this project.",
        use_drafts: "Use these sentences",
        discard_drafts: "Discard",
        fallback: "Fallback",
        no_assignee: "No assignee",
        fallback_hint: "Used when the model matches no rule, or picks someone it may not.",
        on_create: "Autofill when tasks are created",
        on_change: "Auto update when a task's title, description, type or tags change",
        mode: "What happens",
        mode_suggest: "Suggest",
        mode_suggest_hint: "Show the suggestion on the task; someone assigns or dismisses it.",
        mode_apply: "Assign",
        mode_apply_hint: "Assign straight away, with the reason and an undo on the task.",
        save: "Save for project",
        saving: "Saving…",
        saved: "Assignment rules saved",
        save_failed: "Could not save the assignment rules.",
        chip_suggests: "AI suggests {name}",
        chip_assigned_by_rule: "{name} assigned by rule",
        chip_fallback: "(fallback)",
        chip_assign: "Assign",
        chip_dismiss: "Dismiss",
        chip_undo: "Undo",
        chip_failed: "Could not update the suggestion.",
    },
    AiFields: {
        dialog_title: "Fill {field} with AI",
        dialog_single: "Check the proposed value before it is written.",
        dialog_bulk: "{n} tasks. Check a few proposed values first; the rest are filled the same way.",
        ai_off: "AI is turned off, so this field cannot be filled.",
        previewing: "Asking AI for a proposal…",
        preview_note: "Showing {shown} of {n}. The rest are filled in the background, one task at a time.",
        spend_note: "Each task is one AI call, counted in the workspace's AI spend.",
        apply: "Apply",
        fill_n: "Fill {n} task | Fill {n} tasks",
        cancel: "Cancel",
        close: "Close",
        job_progress_label: "Fill progress",
        job_progress: "{processed} of {total} tasks",
        job_done: "Done: {filled} filled, {skipped} skipped.",
        stop_ai_off: "Stopped: AI was turned off.",
        stop_daily_limit: "Stopped: the workspace reached today's limit for AI field fills.",
        stop_budget: "Stopped: the workspace's AI budget for this month is reached.",
        stop_no_provider: "No AI provider is configured.",
        stop_interrupted: "The fill was interrupted. Start it again to finish the rest.",
        stop_error: "The fill stopped because of an error.",
        fill_failed: "The field could not be filled.",
        preview_expired: "This preview has expired. Open it again to get a fresh one.",
        empty_no_fit: "None of the options fits, so it stays empty.",
        empty_no_source: "The task has nothing for AI to read yet.",
        empty_no_answer: "AI had no answer for this task.",
        empty_not_found: "Task not found, or not open to you.",
        empty_forbidden: "You cannot edit this field on this task.",
        empty_not_in_project: "This field is not used in this task's project.",
        empty_not_for_task_type: "This field is not used for this task's type.",
        fill_with_ai: "Fill with AI",
        ai_field_hint: "AI field, not filled yet",
        filled_by_ai: "Filled by AI · {date}",
        refilled_by_ai: "Refilled by AI · {date}",
        column_menu: "{field}: AI options",
        fill_all: "Fill all tasks in this view ({n})",
        fill_empty: "Fill only empty ones ({n})",
        bulk_fill: "Fill {field} for {n} task | Fill {field} for {n} tasks",
        output: "Output",
        output_textarea: "Long text",
        output_dropdown: "Dropdown",
        template: "What AI fills in",
        template_summary: "Summary",
        template_summary_hint: "What the task is and where it stands",
        template_progress_update: "Progress update",
        template_progress_update_hint: "Done, in progress, next and blockers",
        template_translation: "Translation",
        template_translation_hint: "The task's content in another language",
        template_action_items: "Action items",
        template_action_items_hint: "The next actions, one per line",
        template_category: "Category",
        template_category_hint: "One of the dropdown's options",
        template_custom: "Custom",
        template_custom_hint: "Your own instructions",
        language: "Translate into",
        language_placeholder: "For example French",
        prompt_required: "Tell AI how to fill out this field",
        prompt_optional: "Extra instructions (optional)",
        prompt_placeholder: "For example: keep it under 20 words and name the customer.",
        options: "Options",
        options_hint: "AI picks one of these, or leaves the field empty when none fits.",
        option_label: "Option {n}",
        option_remove: "Remove option {n}",
        option_add: "Add option",
        reads: "Reads from the task",
        read_title: "Title",
        read_description: "Description",
        read_comments: "Comments",
        read_subtasks: "Subtasks",
        auto_refill: "Refill when the task changes",
        auto_refill_hint: "Off by default. Only tasks already filled are refilled, after a part the field reads changes; each refill is one AI call.",
        builder_note: "AI reads only tasks the person filling can open, and a first fill shows a preview before anything is written.",
        error_title: "Give the field a name.",
        error_template: "Choose what AI fills in.",
        error_language: "Name the language to translate into.",
        error_prompt: "Tell AI how to fill out this field.",
        error_options: "Add at least one option.",
        error_reads: "Choose at least one part of the task to read.",
        output_labels: "Labels",
        output_number: "Number",
        output_rating: "Rating",
        output_date: "Date",
        template_labels: "Labels",
        template_labels_hint: "Every option that describes the task",
        labels_hint: "AI picks every option that applies and drops any answer that is not one of them.",
        number_settings: "Number",
        min: "Minimum",
        max: "Maximum",
        no_limit: "No limit",
        decimals: "Decimal places",
        decimals_any: "Any",
        out_of_range: "When AI answers outside the range",
        out_of_range_clamp: "Use the nearest limit",
        out_of_range_reject: "Don't fill",
        out_of_range_clamp_hint: "An answer below the minimum or above the maximum is stored as that limit.",
        out_of_range_reject_hint: "An answer outside the range is not stored, and the task shows it couldn't be filled.",
        rating_hint: "AI answers with a whole number from 1 to {max}. Any other answer is not stored.",
        date_rule: "Date rule",
        date_rule_none: "Any date",
        date_rule_after_start: "On or after the task's start date",
        date_rule_not_past: "Today or later",
        date_hint: "AI answers with one date, read in the time zone of the person filling. An answer that is not a date, or breaks the rule, is not stored.",
        error_range: "Enter numbers, with the minimum no higher than the maximum.",
        error_decimals: "Use 0 to {max} decimal places.",
        empty_invalid: "Couldn't fill: AI's answer is not a valid value for this field.",
        empty_out_of_range: "Couldn't fill: AI's answer is outside the field's range.",
        empty_date_rule: "Couldn't fill: AI's date breaks the field's date rule.",
        retry: "Retry",
        retry_fill: "Retry filling with AI",
        fill_failed_on: "Couldn't fill with AI · {date}",
        rating_value: "{n} out of {max}",
        job_done_failed: "Done: {filled} filled, {skipped} skipped, {failed} couldn't be filled.",
    },
    WhoCanSee: {
        title: "Who can see this",
        menu_project: "Who can see this project",
        menu_sprint: "Who can see this list",
        menu_doc: "Who can see this doc",
        close: "Close",
        loading: "Working out who can see this…",
        failed: "Could not load who can see this. Try again in a moment.",
        people_count: "People who can see this: {count}",
        unknown_person: "Former member",
        show_all: "Show all {count}",
        show_fewer: "Show fewer",
        enforced_note: "Worked out from the same access rules the server checks, so this list matches who can really open it.",
        kind_project: "Project",
        kind_sprint: "List",
        kind_page: "Doc",
        can_view: "Can view",
        can_edit: "Can edit",
        can_manage: "Can manage",
        can_project_view: "Can open the project and read its tasks.",
        can_project_edit: "Can add and change tasks.",
        can_project_manage: "Can change the project's details and settings.",
        can_sprint_view: "Can open the list and read its tasks.",
        can_sprint_edit: "Can add and change tasks.",
        can_sprint_manage: "Can rename, share or archive the list.",
        can_page_view: "Can read the doc.",
        can_page_edit: "Can edit, share and delete the doc.",
        reason_personal: "Owner of this personal list",
        reason_personal_hint: "A personal list belongs to one person, so nobody else can open it.",
        reason_author: "Only the author",
        reason_author_hint: "This doc is private, so only the person who wrote it and the people they share it with can see it. Owners and admins cannot open it either.",
        reason_named: "Shared by name",
        reason_named_hint: "This doc was shared with them by name. They can open this doc and nothing else in its project.",
        reason_admin: "Owners and admins",
        reason_admin_hint: "Owners and admins can see every project, list and shared doc in the company.",
        reason_sprint_member: "Shared with them",
        reason_sprint_member_hint: "This list is private and was shared with them by name.",
        reason_sprint_team: "Shared with their team",
        reason_sprint_team_hint: "This list is private and was shared with their team: {teams}.",
        reason_member: "Project members",
        reason_member_hint: "They were added to the project by name.",
        reason_team: "Through a team",
        reason_team_hint: "Their team was added to the project: {teams}.",
        reason_guest: "Guests with access",
        reason_guest_project_hint: "Guests who were added to this project, by name or through a team.",
        reason_guest_sprint_hint: "Guests who were given this list or its project, by name or through a team.",
        reason_guest_page_hint: "Guests who were added to this doc's project, by name or through a team.",
        reason_role: "Their role sees every private project",
        reason_role_hint: "They are not on the project, but their role lets them open every private project.",
        reason_everyone: "Everyone in the company",
        reason_everyone_project_hint: "This project is public, so every member of the company can open it.",
        reason_everyone_sprint_hint: "This list is not private and its project is public, so every member of the company can open it.",
        reason_everyone_page_hint: "This doc is shared and is in a public project or in no project, so every member of the company can open it.",
        link_client_view: "Anyone with the client link",
        link_client_view_hint: "Can see a read-only summary of the project without signing in.",
        link_sprint: "Anyone with the public link",
        link_sprint_hint: "Can see this list's tasks, read only, without signing in.",
        link_page: "Anyone with the public link",
        link_page_hint: "Can read this doc without signing in.",
        link_from_parent: "Through a public link on a doc above this one",
        link_password: "Password protected",
        link_expires: "Expires {date}",
    },
};
